(function(){ try {var elementStyle = document.createElement('style'); elementStyle.appendChild(document.createTextNode("@charset \"UTF-8\";:root{--zws-el-color-white: #ffffff;--zws-el-color-black: #000000;--zws-el-color-primary-rgb: 64, 158, 255;--zws-el-color-success-rgb: 103, 194, 58;--zws-el-color-warning-rgb: 230, 162, 60;--zws-el-color-danger-rgb: 245, 108, 108;--zws-el-color-error-rgb: 245, 108, 108;--zws-el-color-info-rgb: 144, 147, 153;--zws-el-font-size-extra-large: 20px;--zws-el-font-size-large: 18px;--zws-el-font-size-medium: 16px;--zws-el-font-size-base: 14px;--zws-el-font-size-small: 13px;--zws-el-font-size-extra-small: 12px;--zws-el-font-family: \"Helvetica Neue\", Helvetica, \"PingFang SC\", \"Hiragino Sans GB\", \"Microsoft YaHei\", \"微软雅黑\", Arial, sans-serif;--zws-el-font-weight-primary: 500;--zws-el-font-line-height-primary: 24px;--zws-el-index-normal: 1;--zws-el-index-top: 1000;--zws-el-index-popper: 2000;--zws-el-border-radius-base: 4px;--zws-el-border-radius-small: 2px;--zws-el-border-radius-round: 20px;--zws-el-border-radius-circle: 100%;--zws-el-transition-duration: .3s;--zws-el-transition-duration-fast: .2s;--zws-el-transition-function-ease-in-out-bezier: cubic-bezier(.645, .045, .355, 1);--zws-el-transition-function-fast-bezier: cubic-bezier(.23, 1, .32, 1);--zws-el-transition-all: all var(--zws-el-transition-duration) var(--zws-el-transition-function-ease-in-out-bezier);--zws-el-transition-fade: opacity var(--zws-el-transition-duration) var(--zws-el-transition-function-fast-bezier);--zws-el-transition-md-fade: transform var(--zws-el-transition-duration) var(--zws-el-transition-function-fast-bezier), opacity var(--zws-el-transition-duration) var(--zws-el-transition-function-fast-bezier);--zws-el-transition-fade-linear: opacity var(--zws-el-transition-duration-fast) linear;--zws-el-transition-border: border-color var(--zws-el-transition-duration-fast) var(--zws-el-transition-function-ease-in-out-bezier);--zws-el-transition-box-shadow: box-shadow var(--zws-el-transition-duration-fast) var(--zws-el-transition-function-ease-in-out-bezier);--zws-el-transition-color: color var(--zws-el-transition-duration-fast) var(--zws-el-transition-function-ease-in-out-bezier);--zws-el-component-size-large: 40px;--zws-el-component-size: 32px;--zws-el-component-size-small: 24px}:root{color-scheme:light;--zws-el-color-primary: #409eff;--zws-el-color-primary-light-3: rgb(121.3, 187.1, 255);--zws-el-color-primary-light-5: rgb(159.5, 206.5, 255);--zws-el-color-primary-light-7: rgb(197.7, 225.9, 255);--zws-el-color-primary-light-8: rgb(216.8, 235.6, 255);--zws-el-color-primary-light-9: rgb(235.9, 245.3, 255);--zws-el-color-primary-dark-2: rgb(51.2, 126.4, 204);--zws-el-color-success: #67c23a;--zws-el-color-success-light-3: rgb(148.6, 212.3, 117.1);--zws-el-color-success-light-5: rgb(179, 224.5, 156.5);--zws-el-color-success-light-7: rgb(209.4, 236.7, 195.9);--zws-el-color-success-light-8: rgb(224.6, 242.8, 215.6);--zws-el-color-success-light-9: rgb(239.8, 248.9, 235.3);--zws-el-color-success-dark-2: rgb(82.4, 155.2, 46.4);--zws-el-color-warning: #e6a23c;--zws-el-color-warning-light-3: rgb(237.5, 189.9, 118.5);--zws-el-color-warning-light-5: rgb(242.5, 208.5, 157.5);--zws-el-color-warning-light-7: rgb(247.5, 227.1, 196.5);--zws-el-color-warning-light-8: rgb(250, 236.4, 216);--zws-el-color-warning-light-9: rgb(252.5, 245.7, 235.5);--zws-el-color-warning-dark-2: rgb(184, 129.6, 48);--zws-el-color-danger: #f56c6c;--zws-el-color-danger-light-3: rgb(248, 152.1, 152.1);--zws-el-color-danger-light-5: rgb(250, 181.5, 181.5);--zws-el-color-danger-light-7: rgb(252, 210.9, 210.9);--zws-el-color-danger-light-8: rgb(253, 225.6, 225.6);--zws-el-color-danger-light-9: rgb(254, 240.3, 240.3);--zws-el-color-danger-dark-2: rgb(196, 86.4, 86.4);--zws-el-color-error: #f56c6c;--zws-el-color-error-light-3: rgb(248, 152.1, 152.1);--zws-el-color-error-light-5: rgb(250, 181.5, 181.5);--zws-el-color-error-light-7: rgb(252, 210.9, 210.9);--zws-el-color-error-light-8: rgb(253, 225.6, 225.6);--zws-el-color-error-light-9: rgb(254, 240.3, 240.3);--zws-el-color-error-dark-2: rgb(196, 86.4, 86.4);--zws-el-color-info: #909399;--zws-el-color-info-light-3: rgb(177.3, 179.4, 183.6);--zws-el-color-info-light-5: rgb(199.5, 201, 204);--zws-el-color-info-light-7: rgb(221.7, 222.6, 224.4);--zws-el-color-info-light-8: rgb(232.8, 233.4, 234.6);--zws-el-color-info-light-9: rgb(243.9, 244.2, 244.8);--zws-el-color-info-dark-2: rgb(115.2, 117.6, 122.4);--zws-el-bg-color: #ffffff;--zws-el-bg-color-page: #f2f3f5;--zws-el-bg-color-overlay: #ffffff;--zws-el-text-color-primary: #303133;--zws-el-text-color-regular: #606266;--zws-el-text-color-secondary: #909399;--zws-el-text-color-placeholder: #a8abb2;--zws-el-text-color-disabled: #c0c4cc;--zws-el-border-color: #dcdfe6;--zws-el-border-color-light: #e4e7ed;--zws-el-border-color-lighter: #ebeef5;--zws-el-border-color-extra-light: #f2f6fc;--zws-el-border-color-dark: #d4d7de;--zws-el-border-color-darker: #cdd0d6;--zws-el-fill-color: #f0f2f5;--zws-el-fill-color-light: #f5f7fa;--zws-el-fill-color-lighter: #fafafa;--zws-el-fill-color-extra-light: #fafcff;--zws-el-fill-color-dark: #ebedf0;--zws-el-fill-color-darker: #e6e8eb;--zws-el-fill-color-blank: #ffffff;--zws-el-box-shadow: 0px 12px 32px 4px rgba(0, 0, 0, .04), 0px 8px 20px rgba(0, 0, 0, .08);--zws-el-box-shadow-light: 0px 0px 12px rgba(0, 0, 0, .12);--zws-el-box-shadow-lighter: 0px 0px 6px rgba(0, 0, 0, .12);--zws-el-box-shadow-dark: 0px 16px 48px 16px rgba(0, 0, 0, .08), 0px 12px 32px rgba(0, 0, 0, .12), 0px 8px 16px -8px rgba(0, 0, 0, .16);--zws-el-disabled-bg-color: var(--zws-el-fill-color-light);--zws-el-disabled-text-color: var(--zws-el-text-color-placeholder);--zws-el-disabled-border-color: var(--zws-el-border-color-light);--zws-el-overlay-color: rgba(0, 0, 0, .8);--zws-el-overlay-color-light: rgba(0, 0, 0, .7);--zws-el-overlay-color-lighter: rgba(0, 0, 0, .5);--zws-el-mask-color: rgba(255, 255, 255, .9);--zws-el-mask-color-extra-light: rgba(255, 255, 255, .3);--zws-el-border-width: 1px;--zws-el-border-style: solid;--zws-el-border-color-hover: var(--zws-el-text-color-disabled);--zws-el-border: var(--zws-el-border-width) var(--zws-el-border-style) var(--zws-el-border-color);--zws-el-svg-monochrome-grey: var(--zws-el-border-color)}.fade-in-linear-enter-active,.fade-in-linear-leave-active{transition:var(--zws-el-transition-fade-linear)}.fade-in-linear-enter-from,.fade-in-linear-leave-to{opacity:0}.zws-el-fade-in-linear-enter-active,.zws-el-fade-in-linear-leave-active{transition:var(--zws-el-transition-fade-linear)}.zws-el-fade-in-linear-enter-from,.zws-el-fade-in-linear-leave-to{opacity:0}.zws-el-fade-in-enter-active,.zws-el-fade-in-leave-active{transition:all var(--zws-el-transition-duration) cubic-bezier(.55,0,.1,1)}.zws-el-fade-in-enter-from,.zws-el-fade-in-leave-active{opacity:0}.zws-el-zoom-in-center-enter-active,.zws-el-zoom-in-center-leave-active{transition:all var(--zws-el-transition-duration) cubic-bezier(.55,0,.1,1)}.zws-el-zoom-in-center-enter-from,.zws-el-zoom-in-center-leave-active{opacity:0;transform:scaleX(0)}.zws-el-zoom-in-top-enter-active,.zws-el-zoom-in-top-leave-active{opacity:1;transform:scaleY(1);transition:var(--zws-el-transition-md-fade);transform-origin:center top}.zws-el-zoom-in-top-enter-active[data-popper-placement^=top],.zws-el-zoom-in-top-leave-active[data-popper-placement^=top]{transform-origin:center bottom}.zws-el-zoom-in-top-enter-from,.zws-el-zoom-in-top-leave-active{opacity:0;transform:scaleY(0)}.zws-el-zoom-in-bottom-enter-active,.zws-el-zoom-in-bottom-leave-active{opacity:1;transform:scaleY(1);transition:var(--zws-el-transition-md-fade);transform-origin:center bottom}.zws-el-zoom-in-bottom-enter-from,.zws-el-zoom-in-bottom-leave-active{opacity:0;transform:scaleY(0)}.zws-el-zoom-in-left-enter-active,.zws-el-zoom-in-left-leave-active{opacity:1;transform:scale(1);transition:var(--zws-el-transition-md-fade);transform-origin:top left}.zws-el-zoom-in-left-enter-from,.zws-el-zoom-in-left-leave-active{opacity:0;transform:scale(.45)}.collapse-transition{transition:var(--zws-el-transition-duration) height ease-in-out,var(--zws-el-transition-duration) padding-top ease-in-out,var(--zws-el-transition-duration) padding-bottom ease-in-out}.zws-el-collapse-transition-leave-active,.zws-el-collapse-transition-enter-active{transition:var(--zws-el-transition-duration) max-height ease-in-out,var(--zws-el-transition-duration) padding-top ease-in-out,var(--zws-el-transition-duration) padding-bottom ease-in-out}.horizontal-collapse-transition{transition:var(--zws-el-transition-duration) width ease-in-out,var(--zws-el-transition-duration) padding-left ease-in-out,var(--zws-el-transition-duration) padding-right ease-in-out}.zws-el-list-enter-active,.zws-el-list-leave-active{transition:all 1s}.zws-el-list-enter-from,.zws-el-list-leave-to{opacity:0;transform:translateY(-30px)}.zws-el-list-leave-active{position:absolute!important}.zws-el-opacity-transition{transition:opacity var(--zws-el-transition-duration) cubic-bezier(.55,0,.1,1)}.zws-el-icon-loading{animation:rotating 2s linear infinite}.zws-el-icon--right{margin-left:5px}.zws-el-icon--left{margin-right:5px}@keyframes rotating{0%{transform:rotate(0)}to{transform:rotate(360deg)}}.zws-el-icon{--color: inherit;height:1em;width:1em;line-height:1em;display:inline-flex;justify-content:center;align-items:center;position:relative;fill:currentColor;color:var(--color);font-size:inherit}.zws-el-icon.is-loading{animation:rotating 2s linear infinite}.zws-el-icon svg{height:1em;width:1em}.zws-el-textarea{--zws-el-input-text-color: var(--zws-el-text-color-regular);--zws-el-input-border: var(--zws-el-border);--zws-el-input-hover-border: var(--zws-el-border-color-hover);--zws-el-input-focus-border: var(--zws-el-color-primary);--zws-el-input-transparent-border: 0 0 0 1px transparent inset;--zws-el-input-border-color: var(--zws-el-border-color);--zws-el-input-border-radius: var(--zws-el-border-radius-base);--zws-el-input-bg-color: var(--zws-el-fill-color-blank);--zws-el-input-icon-color: var(--zws-el-text-color-placeholder);--zws-el-input-placeholder-color: var(--zws-el-text-color-placeholder);--zws-el-input-hover-border-color: var(--zws-el-border-color-hover);--zws-el-input-clear-hover-color: var(--zws-el-text-color-secondary);--zws-el-input-focus-border-color: var(--zws-el-color-primary);--zws-el-input-width: 100%}.zws-el-textarea{position:relative;display:inline-block;width:100%;vertical-align:bottom;font-size:var(--zws-el-font-size-base)}.zws-el-textarea__inner{position:relative;display:block;resize:vertical;padding:5px 11px;line-height:1.5;box-sizing:border-box;width:100%;font-size:inherit;font-family:inherit;color:var(--zws-el-input-text-color, var(--zws-el-text-color-regular));background-color:var(--zws-el-input-bg-color, var(--zws-el-fill-color-blank));background-image:none;-webkit-appearance:none;box-shadow:0 0 0 1px var(--zws-el-input-border-color, var(--zws-el-border-color)) inset;border-radius:var(--zws-el-input-border-radius, var(--zws-el-border-radius-base));transition:var(--zws-el-transition-box-shadow);border:none}.zws-el-textarea__inner::placeholder{color:var(--zws-el-input-placeholder-color, var(--zws-el-text-color-placeholder))}.zws-el-textarea__inner:hover{box-shadow:0 0 0 1px var(--zws-el-input-hover-border-color) inset}.zws-el-textarea__inner:focus{outline:none;box-shadow:0 0 0 1px var(--zws-el-input-focus-border-color) inset}.zws-el-textarea .zws-el-input__count{color:var(--zws-el-color-info);background:var(--zws-el-fill-color-blank);position:absolute;font-size:12px;line-height:14px;bottom:5px;right:10px}.zws-el-textarea.is-disabled .zws-el-textarea__inner{box-shadow:0 0 0 1px var(--zws-el-disabled-border-color) inset;background-color:var(--zws-el-disabled-bg-color);color:var(--zws-el-disabled-text-color);cursor:not-allowed}.zws-el-textarea.is-disabled .zws-el-textarea__inner::placeholder{color:var(--zws-el-text-color-placeholder)}.zws-el-textarea.is-exceed .zws-el-textarea__inner{box-shadow:0 0 0 1px var(--zws-el-color-danger) inset}.zws-el-textarea.is-exceed .zws-el-input__count{color:var(--zws-el-color-danger)}.zws-el-input{--zws-el-input-text-color: var(--zws-el-text-color-regular);--zws-el-input-border: var(--zws-el-border);--zws-el-input-hover-border: var(--zws-el-border-color-hover);--zws-el-input-focus-border: var(--zws-el-color-primary);--zws-el-input-transparent-border: 0 0 0 1px transparent inset;--zws-el-input-border-color: var(--zws-el-border-color);--zws-el-input-border-radius: var(--zws-el-border-radius-base);--zws-el-input-bg-color: var(--zws-el-fill-color-blank);--zws-el-input-icon-color: var(--zws-el-text-color-placeholder);--zws-el-input-placeholder-color: var(--zws-el-text-color-placeholder);--zws-el-input-hover-border-color: var(--zws-el-border-color-hover);--zws-el-input-clear-hover-color: var(--zws-el-text-color-secondary);--zws-el-input-focus-border-color: var(--zws-el-color-primary);--zws-el-input-width: 100%}.zws-el-input{--zws-el-input-height: var(--zws-el-component-size);position:relative;font-size:var(--zws-el-font-size-base);display:inline-flex;width:var(--zws-el-input-width);line-height:var(--zws-el-input-height);box-sizing:border-box;vertical-align:middle}.zws-el-input::-webkit-scrollbar{z-index:11;width:6px}.zws-el-input::-webkit-scrollbar:horizontal{height:6px}.zws-el-input::-webkit-scrollbar-thumb{border-radius:5px;width:6px;background:var(--zws-el-text-color-disabled)}.zws-el-input::-webkit-scrollbar-corner{background:var(--zws-el-fill-color-blank)}.zws-el-input::-webkit-scrollbar-track{background:var(--zws-el-fill-color-blank)}.zws-el-input::-webkit-scrollbar-track-piece{background:var(--zws-el-fill-color-blank);width:6px}.zws-el-input .zws-el-input__clear,.zws-el-input .zws-el-input__password{color:var(--zws-el-input-icon-color);font-size:14px;cursor:pointer}.zws-el-input .zws-el-input__clear:hover,.zws-el-input .zws-el-input__password:hover{color:var(--zws-el-input-clear-hover-color)}.zws-el-input .zws-el-input__count{height:100%;display:inline-flex;align-items:center;color:var(--zws-el-color-info);font-size:12px}.zws-el-input .zws-el-input__count .zws-el-input__count-inner{background:var(--zws-el-fill-color-blank);line-height:initial;display:inline-block;padding-left:8px}.zws-el-input__wrapper{display:inline-flex;flex-grow:1;align-items:center;justify-content:center;padding:1px 11px;background-color:var(--zws-el-input-bg-color, var(--zws-el-fill-color-blank));background-image:none;border-radius:var(--zws-el-input-border-radius, var(--zws-el-border-radius-base));cursor:text;transition:var(--zws-el-transition-box-shadow);transform:translateZ(0);box-shadow:0 0 0 1px var(--zws-el-input-border-color, var(--zws-el-border-color)) inset}.zws-el-input__wrapper:hover{box-shadow:0 0 0 1px var(--zws-el-input-hover-border-color) inset}.zws-el-input__wrapper.is-focus{box-shadow:0 0 0 1px var(--zws-el-input-focus-border-color) inset}.zws-el-input{--zws-el-input-inner-height: calc(var(--zws-el-input-height, 32px) - 2px)}.zws-el-input__inner{width:100%;flex-grow:1;-webkit-appearance:none;color:var(--zws-el-input-text-color, var(--zws-el-text-color-regular));font-size:inherit;height:var(--zws-el-input-inner-height);line-height:var(--zws-el-input-inner-height);padding:0;outline:none;border:none;background:none;box-sizing:border-box}.zws-el-input__inner:focus{outline:none}.zws-el-input__inner::placeholder{color:var(--zws-el-input-placeholder-color, var(--zws-el-text-color-placeholder))}.zws-el-input__inner[type=password]::-ms-reveal{display:none}.zws-el-input__inner[type=number]{line-height:1}.zws-el-input__prefix{display:inline-flex;white-space:nowrap;flex-shrink:0;flex-wrap:nowrap;height:100%;line-height:var(--zws-el-input-inner-height);text-align:center;color:var(--zws-el-input-icon-color, var(--zws-el-text-color-placeholder));transition:all var(--zws-el-transition-duration);pointer-events:none}.zws-el-input__prefix-inner{pointer-events:all;display:inline-flex;align-items:center;justify-content:center}.zws-el-input__prefix-inner>:last-child{margin-right:8px}.zws-el-input__prefix-inner>:first-child,.zws-el-input__prefix-inner>:first-child.zws-el-input__icon{margin-left:0}.zws-el-input__suffix{display:inline-flex;white-space:nowrap;flex-shrink:0;flex-wrap:nowrap;height:100%;line-height:var(--zws-el-input-inner-height);text-align:center;color:var(--zws-el-input-icon-color, var(--zws-el-text-color-placeholder));transition:all var(--zws-el-transition-duration);pointer-events:none}.zws-el-input__suffix-inner{pointer-events:all;display:inline-flex;align-items:center;justify-content:center}.zws-el-input__suffix-inner>:first-child{margin-left:8px}.zws-el-input .zws-el-input__icon{height:inherit;line-height:inherit;display:flex;justify-content:center;align-items:center;transition:all var(--zws-el-transition-duration);margin-left:8px}.zws-el-input__validateIcon{pointer-events:none}.zws-el-input.is-active .zws-el-input__wrapper{box-shadow:0 0 0 1px var(--zws-el-input-focus-color, ) inset}.zws-el-input.is-disabled{cursor:not-allowed}.zws-el-input.is-disabled .zws-el-input__wrapper{background-color:var(--zws-el-disabled-bg-color);cursor:not-allowed;box-shadow:0 0 0 1px var(--zws-el-disabled-border-color) inset}.zws-el-input.is-disabled .zws-el-input__inner{color:var(--zws-el-disabled-text-color);-webkit-text-fill-color:var(--zws-el-disabled-text-color);cursor:not-allowed}.zws-el-input.is-disabled .zws-el-input__inner::placeholder{color:var(--zws-el-text-color-placeholder)}.zws-el-input.is-disabled .zws-el-input__icon{cursor:not-allowed}.zws-el-input.is-exceed .zws-el-input__wrapper{box-shadow:0 0 0 1px var(--zws-el-color-danger) inset}.zws-el-input.is-exceed .zws-el-input__suffix .zws-el-input__count{color:var(--zws-el-color-danger)}.zws-el-input--large{--zws-el-input-height: var(--zws-el-component-size-large);font-size:14px}.zws-el-input--large .zws-el-input__wrapper{padding:1px 15px}.zws-el-input--large{--zws-el-input-inner-height: calc(var(--zws-el-input-height, 40px) - 2px)}.zws-el-input--small{--zws-el-input-height: var(--zws-el-component-size-small);font-size:12px}.zws-el-input--small .zws-el-input__wrapper{padding:1px 7px}.zws-el-input--small{--zws-el-input-inner-height: calc(var(--zws-el-input-height, 24px) - 2px)}.zws-el-input-group{display:inline-flex;width:100%;align-items:stretch}.zws-el-input-group__append,.zws-el-input-group__prepend{background-color:var(--zws-el-fill-color-light);color:var(--zws-el-color-info);position:relative;display:inline-flex;align-items:center;justify-content:center;min-height:100%;border-radius:var(--zws-el-input-border-radius);padding:0 20px;white-space:nowrap}.zws-el-input-group__append:focus,.zws-el-input-group__prepend:focus{outline:none}.zws-el-input-group__append .zws-el-select,.zws-el-input-group__append .zws-el-button,.zws-el-input-group__prepend .zws-el-select,.zws-el-input-group__prepend .zws-el-button{display:inline-block;margin:0 -20px}.zws-el-input-group__append button.zws-el-button,.zws-el-input-group__append button.zws-el-button:hover,.zws-el-input-group__append div.zws-el-select .zws-el-select__wrapper,.zws-el-input-group__append div.zws-el-select:hover .zws-el-select__wrapper,.zws-el-input-group__prepend button.zws-el-button,.zws-el-input-group__prepend button.zws-el-button:hover,.zws-el-input-group__prepend div.zws-el-select .zws-el-select__wrapper,.zws-el-input-group__prepend div.zws-el-select:hover .zws-el-select__wrapper{border-color:transparent;background-color:transparent;color:inherit}.zws-el-input-group__append .zws-el-button,.zws-el-input-group__append .zws-el-input,.zws-el-input-group__prepend .zws-el-button,.zws-el-input-group__prepend .zws-el-input{font-size:inherit}.zws-el-input-group__prepend{border-right:0;border-top-right-radius:0;border-bottom-right-radius:0;box-shadow:1px 0 0 0 var(--zws-el-input-border-color) inset,0 1px 0 0 var(--zws-el-input-border-color) inset,0 -1px 0 0 var(--zws-el-input-border-color) inset}.zws-el-input-group__append{border-left:0;border-top-left-radius:0;border-bottom-left-radius:0;box-shadow:0 1px 0 0 var(--zws-el-input-border-color) inset,0 -1px 0 0 var(--zws-el-input-border-color) inset,-1px 0 0 0 var(--zws-el-input-border-color) inset}.zws-el-input-group--prepend>.zws-el-input__wrapper{border-top-left-radius:0;border-bottom-left-radius:0}.zws-el-input-group--prepend .zws-el-input-group__prepend .zws-el-select .zws-el-select__wrapper{border-top-right-radius:0;border-bottom-right-radius:0;box-shadow:1px 0 0 0 var(--zws-el-input-border-color) inset,0 1px 0 0 var(--zws-el-input-border-color) inset,0 -1px 0 0 var(--zws-el-input-border-color) inset}.zws-el-input-group--append>.zws-el-input__wrapper{border-top-right-radius:0;border-bottom-right-radius:0}.zws-el-input-group--append .zws-el-input-group__append .zws-el-select .zws-el-select__wrapper{border-top-left-radius:0;border-bottom-left-radius:0;box-shadow:0 1px 0 0 var(--zws-el-input-border-color) inset,0 -1px 0 0 var(--zws-el-input-border-color) inset,-1px 0 0 0 var(--zws-el-input-border-color) inset}.zws-el-input-hidden{display:none!important}.select[data-v-1af926f4]{width:100%}.zws-el-button{--zws-el-button-font-weight: var(--zws-el-font-weight-primary);--zws-el-button-border-color: var(--zws-el-border-color);--zws-el-button-bg-color: var(--zws-el-fill-color-blank);--zws-el-button-text-color: var(--zws-el-text-color-regular);--zws-el-button-disabled-text-color: var(--zws-el-disabled-text-color);--zws-el-button-disabled-bg-color: var(--zws-el-fill-color-blank);--zws-el-button-disabled-border-color: var(--zws-el-border-color-light);--zws-el-button-divide-border-color: rgba(255, 255, 255, .5);--zws-el-button-hover-text-color: var(--zws-el-color-primary);--zws-el-button-hover-bg-color: var(--zws-el-color-primary-light-9);--zws-el-button-hover-border-color: var(--zws-el-color-primary-light-7);--zws-el-button-active-text-color: var(--zws-el-button-hover-text-color);--zws-el-button-active-border-color: var(--zws-el-color-primary);--zws-el-button-active-bg-color: var(--zws-el-button-hover-bg-color);--zws-el-button-outline-color: var(--zws-el-color-primary-light-5);--zws-el-button-hover-link-text-color: var(--zws-el-text-color-secondary);--zws-el-button-active-color: var(--zws-el-text-color-primary)}.zws-el-button{display:inline-flex;justify-content:center;align-items:center;line-height:1;height:32px;white-space:nowrap;cursor:pointer;color:var(--zws-el-button-text-color);text-align:center;box-sizing:border-box;outline:none;transition:.1s;font-weight:var(--zws-el-button-font-weight);-webkit-user-select:none;user-select:none;vertical-align:middle;-webkit-appearance:none;background-color:var(--zws-el-button-bg-color);border:var(--zws-el-border);border-color:var(--zws-el-button-border-color)}.zws-el-button:hover{color:var(--zws-el-button-hover-text-color);border-color:var(--zws-el-button-hover-border-color);background-color:var(--zws-el-button-hover-bg-color);outline:none}.zws-el-button:active{color:var(--zws-el-button-active-text-color);border-color:var(--zws-el-button-active-border-color);background-color:var(--zws-el-button-active-bg-color);outline:none}.zws-el-button:focus-visible{outline:2px solid var(--zws-el-button-outline-color);outline-offset:1px;transition:outline-offset 0s,outline 0s}.zws-el-button>span{display:inline-flex;align-items:center}.zws-el-button+.zws-el-button{margin-left:12px}.zws-el-button{padding:8px 15px;font-size:var(--zws-el-font-size-base);border-radius:var(--zws-el-border-radius-base)}.zws-el-button.is-round{padding:8px 15px}.zws-el-button::-moz-focus-inner{border:0}.zws-el-button [class*=zws-el-icon]+span{margin-left:6px}.zws-el-button [class*=zws-el-icon] svg{vertical-align:bottom}.zws-el-button.is-plain{--zws-el-button-hover-text-color: var(--zws-el-color-primary);--zws-el-button-hover-bg-color: var(--zws-el-fill-color-blank);--zws-el-button-hover-border-color: var(--zws-el-color-primary)}.zws-el-button.is-active{color:var(--zws-el-button-active-text-color);border-color:var(--zws-el-button-active-border-color);background-color:var(--zws-el-button-active-bg-color);outline:none}.zws-el-button.is-disabled,.zws-el-button.is-disabled:hover{color:var(--zws-el-button-disabled-text-color);cursor:not-allowed;background-image:none;background-color:var(--zws-el-button-disabled-bg-color);border-color:var(--zws-el-button-disabled-border-color)}.zws-el-button.is-loading{position:relative;pointer-events:none}.zws-el-button.is-loading:before{z-index:1;pointer-events:none;content:\"\";position:absolute;left:-1px;top:-1px;right:-1px;bottom:-1px;border-radius:inherit;background-color:var(--zws-el-mask-color-extra-light)}.zws-el-button.is-round{border-radius:var(--zws-el-border-radius-round)}.zws-el-button.is-circle{width:32px;border-radius:50%;padding:8px}.zws-el-button.is-text{color:var(--zws-el-button-text-color);border:0 solid transparent;background-color:transparent}.zws-el-button.is-text.is-disabled{color:var(--zws-el-button-disabled-text-color);background-color:transparent!important}.zws-el-button.is-text:not(.is-disabled):hover{background-color:var(--zws-el-fill-color-light)}.zws-el-button.is-text:not(.is-disabled):focus-visible{outline:2px solid var(--zws-el-button-outline-color);outline-offset:1px;transition:outline-offset 0s,outline 0s}.zws-el-button.is-text:not(.is-disabled):active{background-color:var(--zws-el-fill-color)}.zws-el-button.is-text:not(.is-disabled).is-has-bg{background-color:var(--zws-el-fill-color-light)}.zws-el-button.is-text:not(.is-disabled).is-has-bg:hover{background-color:var(--zws-el-fill-color)}.zws-el-button.is-text:not(.is-disabled).is-has-bg:active{background-color:var(--zws-el-fill-color-dark)}.zws-el-button__text--expand{letter-spacing:.3em;margin-right:-.3em}.zws-el-button.is-link{border-color:transparent;color:var(--zws-el-button-text-color);background:transparent;padding:2px;height:auto}.zws-el-button.is-link:hover{color:var(--zws-el-button-hover-link-text-color)}.zws-el-button.is-link.is-disabled{color:var(--zws-el-button-disabled-text-color);background-color:transparent!important;border-color:transparent!important}.zws-el-button.is-link:not(.is-disabled):hover{border-color:transparent;background-color:transparent}.zws-el-button.is-link:not(.is-disabled):active{color:var(--zws-el-button-active-color);border-color:transparent;background-color:transparent}.zws-el-button--text{border-color:transparent;background:transparent;color:var(--zws-el-color-primary);padding-left:0;padding-right:0}.zws-el-button--text.is-disabled{color:var(--zws-el-button-disabled-text-color);background-color:transparent!important;border-color:transparent!important}.zws-el-button--text:not(.is-disabled):hover{color:var(--zws-el-color-primary-light-3);border-color:transparent;background-color:transparent}.zws-el-button--text:not(.is-disabled):active{color:var(--zws-el-color-primary-dark-2);border-color:transparent;background-color:transparent}.zws-el-button__link--expand{letter-spacing:.3em;margin-right:-.3em}.zws-el-button--primary{--zws-el-button-text-color: var(--zws-el-color-white);--zws-el-button-bg-color: var(--zws-el-color-primary);--zws-el-button-border-color: var(--zws-el-color-primary);--zws-el-button-outline-color: var(--zws-el-color-primary-light-5);--zws-el-button-active-color: var(--zws-el-color-primary-dark-2);--zws-el-button-hover-text-color: var(--zws-el-color-white);--zws-el-button-hover-link-text-color: var(--zws-el-color-primary-light-5);--zws-el-button-hover-bg-color: var(--zws-el-color-primary-light-3);--zws-el-button-hover-border-color: var(--zws-el-color-primary-light-3);--zws-el-button-active-bg-color: var(--zws-el-color-primary-dark-2);--zws-el-button-active-border-color: var(--zws-el-color-primary-dark-2);--zws-el-button-disabled-text-color: var(--zws-el-color-white);--zws-el-button-disabled-bg-color: var(--zws-el-color-primary-light-5);--zws-el-button-disabled-border-color: var(--zws-el-color-primary-light-5)}.zws-el-button--primary.is-plain,.zws-el-button--primary.is-text,.zws-el-button--primary.is-link{--zws-el-button-text-color: var(--zws-el-color-primary);--zws-el-button-bg-color: var(--zws-el-color-primary-light-9);--zws-el-button-border-color: var(--zws-el-color-primary-light-5);--zws-el-button-hover-text-color: var(--zws-el-color-white);--zws-el-button-hover-bg-color: var(--zws-el-color-primary);--zws-el-button-hover-border-color: var(--zws-el-color-primary);--zws-el-button-active-text-color: var(--zws-el-color-white)}.zws-el-button--primary.is-plain.is-disabled,.zws-el-button--primary.is-plain.is-disabled:hover,.zws-el-button--primary.is-plain.is-disabled:focus,.zws-el-button--primary.is-plain.is-disabled:active,.zws-el-button--primary.is-text.is-disabled,.zws-el-button--primary.is-text.is-disabled:hover,.zws-el-button--primary.is-text.is-disabled:focus,.zws-el-button--primary.is-text.is-disabled:active,.zws-el-button--primary.is-link.is-disabled,.zws-el-button--primary.is-link.is-disabled:hover,.zws-el-button--primary.is-link.is-disabled:focus,.zws-el-button--primary.is-link.is-disabled:active{color:var(--zws-el-color-primary-light-5);background-color:var(--zws-el-color-primary-light-9);border-color:var(--zws-el-color-primary-light-8)}.zws-el-button--success{--zws-el-button-text-color: var(--zws-el-color-white);--zws-el-button-bg-color: var(--zws-el-color-success);--zws-el-button-border-color: var(--zws-el-color-success);--zws-el-button-outline-color: var(--zws-el-color-success-light-5);--zws-el-button-active-color: var(--zws-el-color-success-dark-2);--zws-el-button-hover-text-color: var(--zws-el-color-white);--zws-el-button-hover-link-text-color: var(--zws-el-color-success-light-5);--zws-el-button-hover-bg-color: var(--zws-el-color-success-light-3);--zws-el-button-hover-border-color: var(--zws-el-color-success-light-3);--zws-el-button-active-bg-color: var(--zws-el-color-success-dark-2);--zws-el-button-active-border-color: var(--zws-el-color-success-dark-2);--zws-el-button-disabled-text-color: var(--zws-el-color-white);--zws-el-button-disabled-bg-color: var(--zws-el-color-success-light-5);--zws-el-button-disabled-border-color: var(--zws-el-color-success-light-5)}.zws-el-button--success.is-plain,.zws-el-button--success.is-text,.zws-el-button--success.is-link{--zws-el-button-text-color: var(--zws-el-color-success);--zws-el-button-bg-color: var(--zws-el-color-success-light-9);--zws-el-button-border-color: var(--zws-el-color-success-light-5);--zws-el-button-hover-text-color: var(--zws-el-color-white);--zws-el-button-hover-bg-color: var(--zws-el-color-success);--zws-el-button-hover-border-color: var(--zws-el-color-success);--zws-el-button-active-text-color: var(--zws-el-color-white)}.zws-el-button--success.is-plain.is-disabled,.zws-el-button--success.is-plain.is-disabled:hover,.zws-el-button--success.is-plain.is-disabled:focus,.zws-el-button--success.is-plain.is-disabled:active,.zws-el-button--success.is-text.is-disabled,.zws-el-button--success.is-text.is-disabled:hover,.zws-el-button--success.is-text.is-disabled:focus,.zws-el-button--success.is-text.is-disabled:active,.zws-el-button--success.is-link.is-disabled,.zws-el-button--success.is-link.is-disabled:hover,.zws-el-button--success.is-link.is-disabled:focus,.zws-el-button--success.is-link.is-disabled:active{color:var(--zws-el-color-success-light-5);background-color:var(--zws-el-color-success-light-9);border-color:var(--zws-el-color-success-light-8)}.zws-el-button--warning{--zws-el-button-text-color: var(--zws-el-color-white);--zws-el-button-bg-color: var(--zws-el-color-warning);--zws-el-button-border-color: var(--zws-el-color-warning);--zws-el-button-outline-color: var(--zws-el-color-warning-light-5);--zws-el-button-active-color: var(--zws-el-color-warning-dark-2);--zws-el-button-hover-text-color: var(--zws-el-color-white);--zws-el-button-hover-link-text-color: var(--zws-el-color-warning-light-5);--zws-el-button-hover-bg-color: var(--zws-el-color-warning-light-3);--zws-el-button-hover-border-color: var(--zws-el-color-warning-light-3);--zws-el-button-active-bg-color: var(--zws-el-color-warning-dark-2);--zws-el-button-active-border-color: var(--zws-el-color-warning-dark-2);--zws-el-button-disabled-text-color: var(--zws-el-color-white);--zws-el-button-disabled-bg-color: var(--zws-el-color-warning-light-5);--zws-el-button-disabled-border-color: var(--zws-el-color-warning-light-5)}.zws-el-button--warning.is-plain,.zws-el-button--warning.is-text,.zws-el-button--warning.is-link{--zws-el-button-text-color: var(--zws-el-color-warning);--zws-el-button-bg-color: var(--zws-el-color-warning-light-9);--zws-el-button-border-color: var(--zws-el-color-warning-light-5);--zws-el-button-hover-text-color: var(--zws-el-color-white);--zws-el-button-hover-bg-color: var(--zws-el-color-warning);--zws-el-button-hover-border-color: var(--zws-el-color-warning);--zws-el-button-active-text-color: var(--zws-el-color-white)}.zws-el-button--warning.is-plain.is-disabled,.zws-el-button--warning.is-plain.is-disabled:hover,.zws-el-button--warning.is-plain.is-disabled:focus,.zws-el-button--warning.is-plain.is-disabled:active,.zws-el-button--warning.is-text.is-disabled,.zws-el-button--warning.is-text.is-disabled:hover,.zws-el-button--warning.is-text.is-disabled:focus,.zws-el-button--warning.is-text.is-disabled:active,.zws-el-button--warning.is-link.is-disabled,.zws-el-button--warning.is-link.is-disabled:hover,.zws-el-button--warning.is-link.is-disabled:focus,.zws-el-button--warning.is-link.is-disabled:active{color:var(--zws-el-color-warning-light-5);background-color:var(--zws-el-color-warning-light-9);border-color:var(--zws-el-color-warning-light-8)}.zws-el-button--danger{--zws-el-button-text-color: var(--zws-el-color-white);--zws-el-button-bg-color: var(--zws-el-color-danger);--zws-el-button-border-color: var(--zws-el-color-danger);--zws-el-button-outline-color: var(--zws-el-color-danger-light-5);--zws-el-button-active-color: var(--zws-el-color-danger-dark-2);--zws-el-button-hover-text-color: var(--zws-el-color-white);--zws-el-button-hover-link-text-color: var(--zws-el-color-danger-light-5);--zws-el-button-hover-bg-color: var(--zws-el-color-danger-light-3);--zws-el-button-hover-border-color: var(--zws-el-color-danger-light-3);--zws-el-button-active-bg-color: var(--zws-el-color-danger-dark-2);--zws-el-button-active-border-color: var(--zws-el-color-danger-dark-2);--zws-el-button-disabled-text-color: var(--zws-el-color-white);--zws-el-button-disabled-bg-color: var(--zws-el-color-danger-light-5);--zws-el-button-disabled-border-color: var(--zws-el-color-danger-light-5)}.zws-el-button--danger.is-plain,.zws-el-button--danger.is-text,.zws-el-button--danger.is-link{--zws-el-button-text-color: var(--zws-el-color-danger);--zws-el-button-bg-color: var(--zws-el-color-danger-light-9);--zws-el-button-border-color: var(--zws-el-color-danger-light-5);--zws-el-button-hover-text-color: var(--zws-el-color-white);--zws-el-button-hover-bg-color: var(--zws-el-color-danger);--zws-el-button-hover-border-color: var(--zws-el-color-danger);--zws-el-button-active-text-color: var(--zws-el-color-white)}.zws-el-button--danger.is-plain.is-disabled,.zws-el-button--danger.is-plain.is-disabled:hover,.zws-el-button--danger.is-plain.is-disabled:focus,.zws-el-button--danger.is-plain.is-disabled:active,.zws-el-button--danger.is-text.is-disabled,.zws-el-button--danger.is-text.is-disabled:hover,.zws-el-button--danger.is-text.is-disabled:focus,.zws-el-button--danger.is-text.is-disabled:active,.zws-el-button--danger.is-link.is-disabled,.zws-el-button--danger.is-link.is-disabled:hover,.zws-el-button--danger.is-link.is-disabled:focus,.zws-el-button--danger.is-link.is-disabled:active{color:var(--zws-el-color-danger-light-5);background-color:var(--zws-el-color-danger-light-9);border-color:var(--zws-el-color-danger-light-8)}.zws-el-button--info{--zws-el-button-text-color: var(--zws-el-color-white);--zws-el-button-bg-color: var(--zws-el-color-info);--zws-el-button-border-color: var(--zws-el-color-info);--zws-el-button-outline-color: var(--zws-el-color-info-light-5);--zws-el-button-active-color: var(--zws-el-color-info-dark-2);--zws-el-button-hover-text-color: var(--zws-el-color-white);--zws-el-button-hover-link-text-color: var(--zws-el-color-info-light-5);--zws-el-button-hover-bg-color: var(--zws-el-color-info-light-3);--zws-el-button-hover-border-color: var(--zws-el-color-info-light-3);--zws-el-button-active-bg-color: var(--zws-el-color-info-dark-2);--zws-el-button-active-border-color: var(--zws-el-color-info-dark-2);--zws-el-button-disabled-text-color: var(--zws-el-color-white);--zws-el-button-disabled-bg-color: var(--zws-el-color-info-light-5);--zws-el-button-disabled-border-color: var(--zws-el-color-info-light-5)}.zws-el-button--info.is-plain,.zws-el-button--info.is-text,.zws-el-button--info.is-link{--zws-el-button-text-color: var(--zws-el-color-info);--zws-el-button-bg-color: var(--zws-el-color-info-light-9);--zws-el-button-border-color: var(--zws-el-color-info-light-5);--zws-el-button-hover-text-color: var(--zws-el-color-white);--zws-el-button-hover-bg-color: var(--zws-el-color-info);--zws-el-button-hover-border-color: var(--zws-el-color-info);--zws-el-button-active-text-color: var(--zws-el-color-white)}.zws-el-button--info.is-plain.is-disabled,.zws-el-button--info.is-plain.is-disabled:hover,.zws-el-button--info.is-plain.is-disabled:focus,.zws-el-button--info.is-plain.is-disabled:active,.zws-el-button--info.is-text.is-disabled,.zws-el-button--info.is-text.is-disabled:hover,.zws-el-button--info.is-text.is-disabled:focus,.zws-el-button--info.is-text.is-disabled:active,.zws-el-button--info.is-link.is-disabled,.zws-el-button--info.is-link.is-disabled:hover,.zws-el-button--info.is-link.is-disabled:focus,.zws-el-button--info.is-link.is-disabled:active{color:var(--zws-el-color-info-light-5);background-color:var(--zws-el-color-info-light-9);border-color:var(--zws-el-color-info-light-8)}.zws-el-button--large{--zws-el-button-size: 40px;height:var(--zws-el-button-size)}.zws-el-button--large [class*=zws-el-icon]+span{margin-left:8px}.zws-el-button--large{padding:12px 19px;font-size:var(--zws-el-font-size-base);border-radius:var(--zws-el-border-radius-base)}.zws-el-button--large.is-round{padding:12px 19px}.zws-el-button--large.is-circle{width:var(--zws-el-button-size);padding:12px}.zws-el-button--small{--zws-el-button-size: 24px;height:var(--zws-el-button-size)}.zws-el-button--small [class*=zws-el-icon]+span{margin-left:4px}.zws-el-button--small{padding:5px 11px;font-size:12px;border-radius:calc(var(--zws-el-border-radius-base) - 1px)}.zws-el-button--small.is-round{padding:5px 11px}.zws-el-button--small.is-circle{width:var(--zws-el-button-size);padding:5px}.infobox .content-wrapper[data-v-ef303c28]{border-radius:6px;box-shadow:0 0 10px 1px #0003;width:var(--8bdb8976);border:1px solid #d1d1d1;background-color:#fff;display:flex;flex-direction:column}.infobox .content-wrapper .title-bar[data-v-ef303c28]{background-image:linear-gradient(to top,#cbcbcb,#fff);display:flex;align-items:center;flex-direction:space-between;gap:20px;padding:3px 5px;border-top-left-radius:6px;border-top-right-radius:6px}.infobox .content-wrapper .title-bar .pin-box[data-v-ef303c28]{display:flex;align-items:center;flex-grow:1;width:0px;gap:4px}.infobox .content-wrapper .title-bar .pin-box .pin-icon[data-v-ef303c28]{stroke:#919191a3;fill:#cececed9}.infobox .content-wrapper .title-bar .pin-box .pin-icon[data-v-ef303c28]:hover{stroke:#f8c3cd;fill:#ff7d9e}.infobox .content-wrapper .title-bar .pin-box .pin-icon[data-v-ef303c28]:active{stroke:#ebaeb8;fill:#e46f8c}.infobox .content-wrapper .title-bar .pin-box .pin-icon-activate[data-v-ef303c28]{stroke:#7aff00a3;fill:#53d100d9}.infobox .content-wrapper .title-bar .pin-box .pin-icon-activate[data-v-ef303c28]:hover{stroke:#f8c3cd;fill:#ff7d9e}.infobox .content-wrapper .title-bar .pin-box .pin-icon-activate[data-v-ef303c28]:active{stroke:#ebaeb8;fill:#e46f8c}.infobox .content-wrapper .title-bar .pin-box .more-pin-arrow[data-v-ef303c28]:hover{stroke:#f8c3cd;fill:#ff7d9e}.infobox .content-wrapper .title-bar .pin-box .more-pin-arrow[data-v-ef303c28]:active{stroke:#ebaeb8;fill:#e46f8c}.infobox .content-wrapper .content[data-v-ef303c28]{-webkit-user-select:none;user-select:none;padding:10px}.tool-bar[data-v-37f8f129]{width:fit-content;display:flex;flex-direction:column;gap:4px;align-items:center;justify-content:center;padding:4px 6px;background-color:#92b7008a;border:1px solid #7ca10a;border-radius:4px;position:absolute;top:calc(50% - 31px);left:20px}.tool-bar .button[data-v-37f8f129]{display:flex;align-items:center;justify-content:center;background-color:#fff;border:1px solid #7ca10a;border-radius:4px;width:24px;height:24px;-webkit-user-select:none;user-select:none}.tool-bar .button[data-v-37f8f129]:hover{border:1px dashed white;background-color:#2c83dbd0}.tool-bar .button:hover img[data-v-37f8f129]{filter:brightness(600%)}.tool-bar .button.activated[data-v-37f8f129]{background-color:#2c83dbd0;border:1px dashed white}.tool-bar .button[data-v-37f8f129]:active{background-color:#1e6fc0d0}.tool-bar img.activated[data-v-37f8f129]{filter:brightness(600%);background-color:#0000}.map-display-area[data-v-6f2e5c63]{position:relative;width:100%;height:100%;display:flex;flex-direction:column;gap:20px}.map-display-area .address-search-area[data-v-6f2e5c63]{display:flex;align-items:center;gap:5px}.map-display-area .address-search-area .address-search-input[data-v-6f2e5c63]{width:0;flex-grow:1}.map-display-area .map-body[data-v-6f2e5c63]{height:0px!important;flex-grow:1}.map-display-area .map-display[data-v-6f2e5c63]{flex-grow:1;height:450px}.zws-el-tag{--zws-el-tag-font-size: 12px;--zws-el-tag-border-radius: 4px;--zws-el-tag-border-radius-rounded: 9999px}.zws-el-tag{background-color:var(--zws-el-tag-bg-color);border-color:var(--zws-el-tag-border-color);color:var(--zws-el-tag-text-color);display:inline-flex;justify-content:center;align-items:center;vertical-align:middle;height:24px;padding:0 9px;font-size:var(--zws-el-tag-font-size);line-height:1;border-width:1px;border-style:solid;border-radius:var(--zws-el-tag-border-radius);box-sizing:border-box;white-space:nowrap;--zws-el-icon-size: 14px;--zws-el-tag-bg-color: var(--zws-el-color-primary-light-9);--zws-el-tag-border-color: var(--zws-el-color-primary-light-8);--zws-el-tag-hover-color: var(--zws-el-color-primary)}.zws-el-tag.zws-el-tag--primary{--zws-el-tag-bg-color: var(--zws-el-color-primary-light-9);--zws-el-tag-border-color: var(--zws-el-color-primary-light-8);--zws-el-tag-hover-color: var(--zws-el-color-primary)}.zws-el-tag.zws-el-tag--success{--zws-el-tag-bg-color: var(--zws-el-color-success-light-9);--zws-el-tag-border-color: var(--zws-el-color-success-light-8);--zws-el-tag-hover-color: var(--zws-el-color-success)}.zws-el-tag.zws-el-tag--warning{--zws-el-tag-bg-color: var(--zws-el-color-warning-light-9);--zws-el-tag-border-color: var(--zws-el-color-warning-light-8);--zws-el-tag-hover-color: var(--zws-el-color-warning)}.zws-el-tag.zws-el-tag--danger{--zws-el-tag-bg-color: var(--zws-el-color-danger-light-9);--zws-el-tag-border-color: var(--zws-el-color-danger-light-8);--zws-el-tag-hover-color: var(--zws-el-color-danger)}.zws-el-tag.zws-el-tag--error{--zws-el-tag-bg-color: var(--zws-el-color-error-light-9);--zws-el-tag-border-color: var(--zws-el-color-error-light-8);--zws-el-tag-hover-color: var(--zws-el-color-error)}.zws-el-tag.zws-el-tag--info{--zws-el-tag-bg-color: var(--zws-el-color-info-light-9);--zws-el-tag-border-color: var(--zws-el-color-info-light-8);--zws-el-tag-hover-color: var(--zws-el-color-info)}.zws-el-tag.is-hit{border-color:var(--zws-el-color-primary)}.zws-el-tag.is-round{border-radius:var(--zws-el-tag-border-radius-rounded)}.zws-el-tag .zws-el-tag__close{flex-shrink:0;color:var(--zws-el-tag-text-color)}.zws-el-tag .zws-el-tag__close:hover{color:var(--zws-el-color-white);background-color:var(--zws-el-tag-hover-color)}.zws-el-tag.zws-el-tag--primary{--zws-el-tag-text-color: var(--zws-el-color-primary)}.zws-el-tag.zws-el-tag--success{--zws-el-tag-text-color: var(--zws-el-color-success)}.zws-el-tag.zws-el-tag--warning{--zws-el-tag-text-color: var(--zws-el-color-warning)}.zws-el-tag.zws-el-tag--danger{--zws-el-tag-text-color: var(--zws-el-color-danger)}.zws-el-tag.zws-el-tag--error{--zws-el-tag-text-color: var(--zws-el-color-error)}.zws-el-tag.zws-el-tag--info{--zws-el-tag-text-color: var(--zws-el-color-info)}.zws-el-tag .zws-el-icon{border-radius:50%;cursor:pointer;font-size:calc(var(--zws-el-icon-size) - 2px);height:var(--zws-el-icon-size);width:var(--zws-el-icon-size)}.zws-el-tag .zws-el-tag__close{margin-left:6px}.zws-el-tag--dark{--zws-el-tag-text-color: var(--zws-el-color-white);--zws-el-tag-bg-color: var(--zws-el-color-primary);--zws-el-tag-border-color: var(--zws-el-color-primary);--zws-el-tag-hover-color: var(--zws-el-color-primary-light-3)}.zws-el-tag--dark.zws-el-tag--primary{--zws-el-tag-bg-color: var(--zws-el-color-primary);--zws-el-tag-border-color: var(--zws-el-color-primary);--zws-el-tag-hover-color: var(--zws-el-color-primary-light-3)}.zws-el-tag--dark.zws-el-tag--success{--zws-el-tag-bg-color: var(--zws-el-color-success);--zws-el-tag-border-color: var(--zws-el-color-success);--zws-el-tag-hover-color: var(--zws-el-color-success-light-3)}.zws-el-tag--dark.zws-el-tag--warning{--zws-el-tag-bg-color: var(--zws-el-color-warning);--zws-el-tag-border-color: var(--zws-el-color-warning);--zws-el-tag-hover-color: var(--zws-el-color-warning-light-3)}.zws-el-tag--dark.zws-el-tag--danger{--zws-el-tag-bg-color: var(--zws-el-color-danger);--zws-el-tag-border-color: var(--zws-el-color-danger);--zws-el-tag-hover-color: var(--zws-el-color-danger-light-3)}.zws-el-tag--dark.zws-el-tag--error{--zws-el-tag-bg-color: var(--zws-el-color-error);--zws-el-tag-border-color: var(--zws-el-color-error);--zws-el-tag-hover-color: var(--zws-el-color-error-light-3)}.zws-el-tag--dark.zws-el-tag--info{--zws-el-tag-bg-color: var(--zws-el-color-info);--zws-el-tag-border-color: var(--zws-el-color-info);--zws-el-tag-hover-color: var(--zws-el-color-info-light-3)}.zws-el-tag--dark.zws-el-tag--primary,.zws-el-tag--dark.zws-el-tag--success,.zws-el-tag--dark.zws-el-tag--warning,.zws-el-tag--dark.zws-el-tag--danger,.zws-el-tag--dark.zws-el-tag--error,.zws-el-tag--dark.zws-el-tag--info{--zws-el-tag-text-color: var(--zws-el-color-white)}.zws-el-tag--plain,.zws-el-tag--plain.zws-el-tag--primary{--zws-el-tag-bg-color: var(--zws-el-fill-color-blank);--zws-el-tag-border-color: var(--zws-el-color-primary-light-5);--zws-el-tag-hover-color: var(--zws-el-color-primary)}.zws-el-tag--plain.zws-el-tag--success{--zws-el-tag-bg-color: var(--zws-el-fill-color-blank);--zws-el-tag-border-color: var(--zws-el-color-success-light-5);--zws-el-tag-hover-color: var(--zws-el-color-success)}.zws-el-tag--plain.zws-el-tag--warning{--zws-el-tag-bg-color: var(--zws-el-fill-color-blank);--zws-el-tag-border-color: var(--zws-el-color-warning-light-5);--zws-el-tag-hover-color: var(--zws-el-color-warning)}.zws-el-tag--plain.zws-el-tag--danger{--zws-el-tag-bg-color: var(--zws-el-fill-color-blank);--zws-el-tag-border-color: var(--zws-el-color-danger-light-5);--zws-el-tag-hover-color: var(--zws-el-color-danger)}.zws-el-tag--plain.zws-el-tag--error{--zws-el-tag-bg-color: var(--zws-el-fill-color-blank);--zws-el-tag-border-color: var(--zws-el-color-error-light-5);--zws-el-tag-hover-color: var(--zws-el-color-error)}.zws-el-tag--plain.zws-el-tag--info{--zws-el-tag-bg-color: var(--zws-el-fill-color-blank);--zws-el-tag-border-color: var(--zws-el-color-info-light-5);--zws-el-tag-hover-color: var(--zws-el-color-info)}.zws-el-tag.is-closable{padding-right:5px}.zws-el-tag--large{padding:0 11px;height:32px;--zws-el-icon-size: 16px}.zws-el-tag--large .zws-el-tag__close{margin-left:8px}.zws-el-tag--large.is-closable{padding-right:7px}.zws-el-tag--small{padding:0 7px;height:20px;--zws-el-icon-size: 12px}.zws-el-tag--small .zws-el-tag__close{margin-left:4px}.zws-el-tag--small.is-closable{padding-right:3px}.zws-el-tag--small .zws-el-icon-close{transform:scale(.8)}.zws-el-tag.zws-el-tag--primary.is-hit{border-color:var(--zws-el-color-primary)}.zws-el-tag.zws-el-tag--success.is-hit{border-color:var(--zws-el-color-success)}.zws-el-tag.zws-el-tag--warning.is-hit{border-color:var(--zws-el-color-warning)}.zws-el-tag.zws-el-tag--danger.is-hit{border-color:var(--zws-el-color-danger)}.zws-el-tag.zws-el-tag--error.is-hit{border-color:var(--zws-el-color-error)}.zws-el-tag.zws-el-tag--info.is-hit{border-color:var(--zws-el-color-info)}.zws-el-select-dropdown.is-multiple .zws-el-select-dropdown__item.is-selected:after{content:\"\";position:absolute;top:50%;right:20px;border-top:none;border-right:none;background-repeat:no-repeat;background-position:center;background-color:var(--zws-el-color-primary);mask:url(\"data:image/svg+xml;utf8,%3Csvg class='icon' width='200' height='200' viewBox='0 0 1024 1024' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill='currentColor' d='M406.656 706.944L195.84 496.256a32 32 0 10-45.248 45.248l256 256 512-512a32 32 0 00-45.248-45.248L406.592 706.944z'%3E%3C/path%3E%3C/svg%3E\") no-repeat;mask-size:100% 100%;-webkit-mask:url(\"data:image/svg+xml;utf8,%3Csvg class='icon' width='200' height='200' viewBox='0 0 1024 1024' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill='currentColor' d='M406.656 706.944L195.84 496.256a32 32 0 10-45.248 45.248l256 256 512-512a32 32 0 00-45.248-45.248L406.592 706.944z'%3E%3C/path%3E%3C/svg%3E\") no-repeat;-webkit-mask-size:100% 100%;transform:translateY(-50%);width:12px;height:12px}.zws-el-scrollbar{--zws-el-scrollbar-opacity: .3;--zws-el-scrollbar-bg-color: var(--zws-el-text-color-secondary);--zws-el-scrollbar-hover-opacity: .5;--zws-el-scrollbar-hover-bg-color: var(--zws-el-text-color-secondary)}.zws-el-scrollbar{overflow:hidden;position:relative;height:100%}.zws-el-scrollbar__wrap{overflow:auto;height:100%}.zws-el-scrollbar__wrap--hidden-default{scrollbar-width:none}.zws-el-scrollbar__wrap--hidden-default::-webkit-scrollbar{display:none}.zws-el-scrollbar__thumb{position:relative;display:block;width:0;height:0;cursor:pointer;border-radius:inherit;background-color:var(--zws-el-scrollbar-bg-color, var(--zws-el-text-color-secondary));transition:var(--zws-el-transition-duration) background-color;opacity:var(--zws-el-scrollbar-opacity, .3)}.zws-el-scrollbar__thumb:hover{background-color:var(--zws-el-scrollbar-hover-bg-color, var(--zws-el-text-color-secondary));opacity:var(--zws-el-scrollbar-hover-opacity, .5)}.zws-el-scrollbar__bar{position:absolute;right:2px;bottom:2px;z-index:1;border-radius:4px}.zws-el-scrollbar__bar.is-vertical{width:6px;top:2px}.zws-el-scrollbar__bar.is-vertical>div{width:100%}.zws-el-scrollbar__bar.is-horizontal{height:6px;left:2px}.zws-el-scrollbar__bar.is-horizontal>div{height:100%}.zws-el-scrollbar-fade-enter-active{transition:opacity .34s ease-out}.zws-el-scrollbar-fade-leave-active{transition:opacity .12s ease-out}.zws-el-scrollbar-fade-enter-from,.zws-el-scrollbar-fade-leave-active{opacity:0}.zws-el-popper{--zws-el-popper-border-radius: var(--zws-el-popover-border-radius, 4px)}.zws-el-popper{position:absolute;border-radius:var(--zws-el-popper-border-radius);padding:5px 11px;z-index:2000;font-size:12px;line-height:20px;min-width:10px;overflow-wrap:break-word;visibility:visible}.zws-el-popper.is-dark{color:var(--zws-el-bg-color);background:var(--zws-el-text-color-primary);border:1px solid var(--zws-el-text-color-primary)}.zws-el-popper.is-dark>.zws-el-popper__arrow:before{border:1px solid var(--zws-el-text-color-primary);background:var(--zws-el-text-color-primary);right:0}.zws-el-popper.is-light{background:var(--zws-el-bg-color-overlay);border:1px solid var(--zws-el-border-color-light)}.zws-el-popper.is-light>.zws-el-popper__arrow:before{border:1px solid var(--zws-el-border-color-light);background:var(--zws-el-bg-color-overlay);right:0}.zws-el-popper.is-pure{padding:0}.zws-el-popper__arrow{position:absolute;width:10px;height:10px;z-index:-1}.zws-el-popper__arrow:before{position:absolute;width:10px;height:10px;z-index:-1;content:\" \";transform:rotate(45deg);background:var(--zws-el-text-color-primary);box-sizing:border-box}.zws-el-popper[data-popper-placement^=top]>.zws-el-popper__arrow{bottom:-5px}.zws-el-popper[data-popper-placement^=top]>.zws-el-popper__arrow:before{border-bottom-right-radius:2px}.zws-el-popper[data-popper-placement^=bottom]>.zws-el-popper__arrow{top:-5px}.zws-el-popper[data-popper-placement^=bottom]>.zws-el-popper__arrow:before{border-top-left-radius:2px}.zws-el-popper[data-popper-placement^=left]>.zws-el-popper__arrow{right:-5px}.zws-el-popper[data-popper-placement^=left]>.zws-el-popper__arrow:before{border-top-right-radius:2px}.zws-el-popper[data-popper-placement^=right]>.zws-el-popper__arrow{left:-5px}.zws-el-popper[data-popper-placement^=right]>.zws-el-popper__arrow:before{border-bottom-left-radius:2px}.zws-el-popper[data-popper-placement^=top]>.zws-el-popper__arrow:before{border-top-color:transparent!important;border-left-color:transparent!important}.zws-el-popper[data-popper-placement^=bottom]>.zws-el-popper__arrow:before{border-bottom-color:transparent!important;border-right-color:transparent!important}.zws-el-popper[data-popper-placement^=left]>.zws-el-popper__arrow:before{border-left-color:transparent!important;border-bottom-color:transparent!important}.zws-el-popper[data-popper-placement^=right]>.zws-el-popper__arrow:before{border-right-color:transparent!important;border-top-color:transparent!important}.zws-el-select-dropdown{z-index:calc(var(--zws-el-index-top) + 1);border-radius:var(--zws-el-border-radius-base);box-sizing:border-box}.zws-el-select-dropdown .zws-el-scrollbar.is-empty .zws-el-select-dropdown__list{padding:0}.zws-el-select-dropdown__loading,.zws-el-select-dropdown__empty{padding:10px 0;margin:0;text-align:center;color:var(--zws-el-text-color-secondary);font-size:var(--zws-el-select-font-size)}.zws-el-select-dropdown__wrap{max-height:274px}.zws-el-select-dropdown__list{list-style:none;padding:6px 0;margin:0;box-sizing:border-box}.zws-el-select-dropdown__list.zws-el-vl__window{margin:6px 0;padding:0}.zws-el-select-dropdown__header{padding:10px;border-bottom:1px solid var(--zws-el-border-color-light)}.zws-el-select-dropdown__footer{padding:10px;border-top:1px solid var(--zws-el-border-color-light)}.zws-el-select-dropdown__item{font-size:var(--zws-el-font-size-base);padding:0 32px 0 20px;position:relative;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;color:var(--zws-el-text-color-regular);height:34px;line-height:34px;box-sizing:border-box;cursor:pointer}.zws-el-select-dropdown__item.is-hovering{background-color:var(--zws-el-fill-color-light)}.zws-el-select-dropdown__item.is-selected{color:var(--zws-el-color-primary);font-weight:700}.zws-el-select-dropdown__item.is-disabled{color:var(--zws-el-text-color-placeholder);cursor:not-allowed;background-color:unset}.zws-el-select-dropdown.is-multiple .zws-el-select-dropdown__item.is-selected:after{content:\"\";position:absolute;top:50%;right:20px;border-top:none;border-right:none;background-repeat:no-repeat;background-position:center;background-color:var(--zws-el-color-primary);mask:url(\"data:image/svg+xml;utf8,%3Csvg class='icon' width='200' height='200' viewBox='0 0 1024 1024' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill='currentColor' d='M406.656 706.944L195.84 496.256a32 32 0 10-45.248 45.248l256 256 512-512a32 32 0 00-45.248-45.248L406.592 706.944z'%3E%3C/path%3E%3C/svg%3E\") no-repeat;mask-size:100% 100%;-webkit-mask:url(\"data:image/svg+xml;utf8,%3Csvg class='icon' width='200' height='200' viewBox='0 0 1024 1024' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill='currentColor' d='M406.656 706.944L195.84 496.256a32 32 0 10-45.248 45.248l256 256 512-512a32 32 0 00-45.248-45.248L406.592 706.944z'%3E%3C/path%3E%3C/svg%3E\") no-repeat;-webkit-mask-size:100% 100%;transform:translateY(-50%);width:12px;height:12px}.zws-el-select-dropdown.is-multiple .zws-el-select-dropdown__item.is-disabled:after{background-color:var(--zws-el-text-color-placeholder)}.zws-el-select-group{margin:0;padding:0}.zws-el-select-group__wrap{position:relative;list-style:none;margin:0;padding:0}.zws-el-select-group__title{box-sizing:border-box;padding:0 20px;font-size:12px;color:var(--zws-el-color-info);line-height:34px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.zws-el-select-group .zws-el-select-dropdown__item{padding-left:20px}.zws-el-select{--zws-el-select-border-color-hover: var(--zws-el-border-color-hover);--zws-el-select-disabled-color: var(--zws-el-disabled-text-color);--zws-el-select-disabled-border: var(--zws-el-disabled-border-color);--zws-el-select-font-size: var(--zws-el-font-size-base);--zws-el-select-close-hover-color: var(--zws-el-text-color-secondary);--zws-el-select-input-color: var(--zws-el-text-color-placeholder);--zws-el-select-multiple-input-color: var(--zws-el-text-color-regular);--zws-el-select-input-focus-border-color: var(--zws-el-color-primary);--zws-el-select-input-font-size: 14px;--zws-el-select-width: 100%}.zws-el-select{display:inline-block;position:relative;vertical-align:middle;width:var(--zws-el-select-width)}.zws-el-select__wrapper{display:flex;align-items:center;position:relative;box-sizing:border-box;cursor:pointer;text-align:left;font-size:14px;padding:4px 12px;gap:6px;min-height:32px;line-height:24px;border-radius:var(--zws-el-border-radius-base);background-color:var(--zws-el-fill-color-blank);transition:var(--zws-el-transition-duration);transform:translateZ(0);box-shadow:0 0 0 1px var(--zws-el-border-color) inset}.zws-el-select__wrapper.is-filterable{cursor:text}.zws-el-select__wrapper.is-focused{box-shadow:0 0 0 1px var(--zws-el-color-primary) inset}.zws-el-select__wrapper.is-hovering:not(.is-focused){box-shadow:0 0 0 1px var(--zws-el-border-color-hover) inset}.zws-el-select__wrapper.is-disabled{cursor:not-allowed;background-color:var(--zws-el-fill-color-light);color:var(--zws-el-text-color-placeholder);box-shadow:0 0 0 1px var(--zws-el-select-disabled-border) inset}.zws-el-select__wrapper.is-disabled:hover{box-shadow:0 0 0 1px var(--zws-el-select-disabled-border) inset}.zws-el-select__wrapper.is-disabled.is-focus{box-shadow:0 0 0 1px var(--zws-el-input-focus-border-color) inset}.zws-el-select__wrapper.is-disabled .zws-el-select__selected-item{color:var(--zws-el-select-disabled-color)}.zws-el-select__wrapper.is-disabled .zws-el-select__caret,.zws-el-select__wrapper.is-disabled .zws-el-tag,.zws-el-select__wrapper.is-disabled input{cursor:not-allowed}.zws-el-select__prefix,.zws-el-select__suffix{display:flex;align-items:center;flex-shrink:0;gap:6px;color:var(--zws-el-input-icon-color, var(--zws-el-text-color-placeholder))}.zws-el-select__caret{color:var(--zws-el-select-input-color);font-size:var(--zws-el-select-input-font-size);transition:var(--zws-el-transition-duration);transform:rotate(0);cursor:pointer}.zws-el-select__caret.is-reverse{transform:rotate(180deg)}.zws-el-select__clear{cursor:pointer}.zws-el-select__clear:hover{color:var(--zws-el-select-close-hover-color)}.zws-el-select__selection{position:relative;display:flex;flex-wrap:wrap;align-items:center;flex:1;min-width:0;gap:6px}.zws-el-select__selection.is-near{margin-left:-8px}.zws-el-select__selection .zws-el-tag{cursor:pointer;border-color:transparent}.zws-el-select__selection .zws-el-tag.zws-el-tag--plain{border-color:var(--zws-el-tag-border-color)}.zws-el-select__selection .zws-el-tag .zws-el-tag__content{min-width:0}.zws-el-select__selected-item{display:flex;flex-wrap:wrap;-webkit-user-select:none;user-select:none}.zws-el-select__tags-text{display:block;line-height:normal;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.zws-el-select__placeholder{position:absolute;z-index:-1;display:block;top:50%;transform:translateY(-50%);width:100%;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;color:var(--zws-el-input-text-color, var(--zws-el-text-color-regular))}.zws-el-select__placeholder.is-transparent{-webkit-user-select:none;user-select:none;color:var(--zws-el-text-color-placeholder)}.zws-el-select__popper.zws-el-popper{background:var(--zws-el-bg-color-overlay);border:1px solid var(--zws-el-border-color-light);box-shadow:var(--zws-el-box-shadow-light)}.zws-el-select__popper.zws-el-popper .zws-el-popper__arrow:before{border:1px solid var(--zws-el-border-color-light)}.zws-el-select__popper.zws-el-popper[data-popper-placement^=top] .zws-el-popper__arrow:before{border-top-color:transparent;border-left-color:transparent}.zws-el-select__popper.zws-el-popper[data-popper-placement^=bottom] .zws-el-popper__arrow:before{border-bottom-color:transparent;border-right-color:transparent}.zws-el-select__popper.zws-el-popper[data-popper-placement^=left] .zws-el-popper__arrow:before{border-left-color:transparent;border-bottom-color:transparent}.zws-el-select__popper.zws-el-popper[data-popper-placement^=right] .zws-el-popper__arrow:before{border-right-color:transparent;border-top-color:transparent}.zws-el-select__input-wrapper{flex:1}.zws-el-select__input-wrapper.is-hidden{position:absolute;opacity:0;z-index:-1}.zws-el-select__input{border:none;outline:none;padding:0;color:var(--zws-el-select-multiple-input-color);font-size:inherit;font-family:inherit;-webkit-appearance:none;-moz-appearance:none;appearance:none;height:24px;width:100%;background-color:transparent}.zws-el-select__input.is-disabled{cursor:not-allowed}.zws-el-select__input-calculator{position:absolute;left:0;top:0;max-width:100%;visibility:hidden;white-space:pre;overflow:hidden}.zws-el-select--large .zws-el-select__wrapper{gap:6px;padding:8px 16px;min-height:40px;line-height:24px;font-size:14px}.zws-el-select--large .zws-el-select__selection{gap:6px}.zws-el-select--large .zws-el-select__selection.is-near{margin-left:-8px}.zws-el-select--large .zws-el-select__prefix,.zws-el-select--large .zws-el-select__suffix{gap:6px}.zws-el-select--large .zws-el-select__input{height:24px}.zws-el-select--small .zws-el-select__wrapper{gap:4px;padding:2px 8px;min-height:24px;line-height:20px;font-size:12px}.zws-el-select--small .zws-el-select__selection{gap:4px}.zws-el-select--small .zws-el-select__selection.is-near{margin-left:-6px}.zws-el-select--small .zws-el-select__prefix,.zws-el-select--small .zws-el-select__suffix{gap:4px}.zws-el-select--small .zws-el-select__input{height:20px}.infobox[data-v-41a63fc8]{pointer-events:all;width:var(--bf3a362a)}.infobox .content-wrapper[data-v-41a63fc8]{border-radius:6px;box-shadow:0 0 10px 1px #0003;border:1px solid #d1d1d1;background-color:#fff;display:flex;flex-direction:column}.infobox .content-wrapper .title-bar[data-v-41a63fc8]{background-image:linear-gradient(to top,#cbcbcb,#fff);display:flex;align-items:center;flex-direction:space-between;gap:20px;padding:3px 5px;border-top-left-radius:6px;border-top-right-radius:6px}.infobox .content-wrapper .title-bar .pin-box[data-v-41a63fc8]{display:flex;align-items:center;flex-grow:1;width:0px;gap:4px}.infobox .content-wrapper .title-bar .pin-box .pin-icon[data-v-41a63fc8]{stroke:#919191a3;fill:#cececed9}.infobox .content-wrapper .title-bar .pin-box .pin-icon[data-v-41a63fc8]:hover{stroke:#f8c3cd;fill:#ff7d9e}.infobox .content-wrapper .title-bar .pin-box .pin-icon[data-v-41a63fc8]:active{stroke:#ebaeb8;fill:#e46f8c}.infobox .content-wrapper .title-bar .pin-box .pin-icon-activate[data-v-41a63fc8]{stroke:#7aff00a3;fill:#53d100d9}.infobox .content-wrapper .title-bar .pin-box .pin-icon-activate[data-v-41a63fc8]:hover{stroke:#f8c3cd;fill:#ff7d9e}.infobox .content-wrapper .title-bar .pin-box .pin-icon-activate[data-v-41a63fc8]:active{stroke:#ebaeb8;fill:#e46f8c}.infobox .content-wrapper .title-bar .pin-box .more-pin-arrow[data-v-41a63fc8]:hover{stroke:#f8c3cd;fill:#ff7d9e}.infobox .content-wrapper .title-bar .pin-box .more-pin-arrow[data-v-41a63fc8]:active{stroke:#ebaeb8;fill:#e46f8c}.infobox .content-wrapper .content[data-v-41a63fc8]{-webkit-user-select:none;user-select:none;padding:10px}.ol-popup{pointer-events:none;background-color:#0000!important;box-shadow:0 0 #0003!important;border:0px!important}.ol-popup:before{border-top-color:#0000!important}.ol-popup:after{border-top-color:#0000!important}.ol-popup .ol-popup-closer{display:none!important}.tool-bar[data-v-9f470fce]{width:fit-content;display:flex;flex-direction:column;gap:4px;align-items:center;justify-content:center;padding:4px 6px;background-color:#92b7008a;border:1px solid #7ca10a;border-radius:4px;position:absolute;top:calc(50% - 31px);left:20px}.tool-bar .button[data-v-9f470fce]{display:flex;align-items:center;justify-content:center;background-color:#fff;border:1px solid #7ca10a;border-radius:4px;width:24px;height:24px;-webkit-user-select:none;user-select:none}.tool-bar .button[data-v-9f470fce]:hover{border:1px dashed white;background-color:#2c83dbd0}.tool-bar .button:hover img[data-v-9f470fce]{filter:brightness(600%)}.tool-bar .button.activated[data-v-9f470fce]{background-color:#2c83dbd0;border:1px dashed white}.tool-bar .button[data-v-9f470fce]:active{background-color:#1e6fc0d0}.tool-bar img.activated[data-v-9f470fce]{filter:brightness(600%);background-color:#0000}.map-display-area[data-v-3e841eea]{position:relative;width:100%;height:100%;display:flex;flex-direction:column;gap:20px}.map-display-area .address-search-area[data-v-3e841eea]{display:flex;align-items:center;gap:5px}.map-display-area .address-search-area .address-search-input[data-v-3e841eea]{width:0;flex-grow:1}.map-display-area .map-body[data-v-3e841eea]{height:0px!important;flex-grow:1}.map-display-area .map-display[data-v-3e841eea]{flex-grow:1;height:450px}.tangram-suggestion-main{z-index:9999}.map-ctrl[data-v-16b8e0f6]{width:100%;height:400px}")); document.head.appendChild(elementStyle);} catch(e) {console.error('vite-plugin-css-injected-by-js', e);} })();var fc = Object.defineProperty;
var dc = (e, t, n) => t in e ? fc(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n;
var z = (e, t, n) => dc(e, typeof t != "symbol" ? t + "" : t, n);
import { defineComponent as q, h as Js, getCurrentInstance as We, inject as Me, onMounted as xe, onUnmounted as to, Fragment as Xe, ref as R, shallowRef as vn, computed as D, watch as Q, createVNode as Ee, Text as pa, unref as b, getCurrentScope as pc, onScopeDispose as hc, watchEffect as qs, readonly as el, nextTick as Ne, isRef as gc, warn as vc, provide as Nt, createElementBlock as X, openBlock as j, mergeProps as yn, renderSlot as J, toRef as wt, useAttrs as mc, useSlots as tl, normalizeStyle as mt, normalizeClass as Y, createCommentVNode as te, createElementVNode as Z, createBlock as ue, withCtx as ae, resolveDynamicComponent as Tt, withModifiers as nt, toDisplayString as ot, onBeforeUnmount as Bt, Transition as ha, withDirectives as st, vShow as St, reactive as Ln, onActivated as yc, onUpdated as bc, cloneVNode as Ec, Comment as Mc, Teleport as _c, onBeforeMount as wc, onDeactivated as Tc, toRaw as Cc, toRefs as ga, resolveComponent as Cn, resolveDirective as Oc, toHandlerKey as Ic, renderList as pr, createTextVNode as oi, withKeys as nr, vModelText as Nc, isVNode as Sc, useCssVars as nl } from "vue";
import { CircleClose as va, CircleCheck as Ac, Loading as rl, View as Lc, Hide as Pc, Close as Ur, ArrowDown as Dc } from "@element-plus/icons-vue";
/*!
  * shared v10.0.7
  * (c) 2025 kazuya kawaguchi
  * Released under the MIT License.
  */
const qt = typeof window < "u";
let dt, Pn;
if (process.env.NODE_ENV !== "production") {
  const e = qt && window.performance;
  e && e.mark && e.measure && e.clearMarks && // @ts-ignore browser compat
  e.clearMeasures && (dt = (t) => {
    e.mark(t);
  }, Pn = (t, n, r) => {
    e.measure(t, n, r), e.clearMarks(n), e.clearMarks(r);
  });
}
const kc = /\{([0-9a-zA-Z]+)\}/g;
function no(e, ...t) {
  return t.length === 1 && ve(t[0]) && (t = t[0]), (!t || !t.hasOwnProperty) && (t = {}), e.replace(kc, (n, r) => t.hasOwnProperty(r) ? t[r] : "");
}
const tn = (e, t = !1) => t ? Symbol.for(e) : Symbol(e), xc = (e, t, n) => Rc({ l: e, k: t, s: n }), Rc = (e) => JSON.stringify(e).replace(/\u2028/g, "\\u2028").replace(/\u2029/g, "\\u2029").replace(/\u0027/g, "\\u0027"), He = (e) => typeof e == "number" && isFinite(e), Fc = (e) => ma(e) === "[object Date]", Wr = (e) => ma(e) === "[object RegExp]", ro = (e) => ge(e) && Object.keys(e).length === 0, Ye = Object.assign, jc = Object.create, _e = (e = null) => jc(e);
let ai;
const In = () => ai || (ai = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : typeof global < "u" ? global : _e());
function ii(e) {
  return e.replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&apos;");
}
const Bc = Object.prototype.hasOwnProperty;
function Ct(e, t) {
  return Bc.call(e, t);
}
const Ue = Array.isArray, Oe = (e) => typeof e == "function", K = (e) => typeof e == "string", ke = (e) => typeof e == "boolean", ve = (e) => e !== null && typeof e == "object", $c = (e) => ve(e) && Oe(e.then) && Oe(e.catch), ol = Object.prototype.toString, ma = (e) => ol.call(e), ge = (e) => ma(e) === "[object Object]", zc = (e) => e == null ? "" : Ue(e) || ge(e) && e.toString === ol ? JSON.stringify(e, null, 2) : String(e);
function ya(e, t = "") {
  return e.reduce((n, r, o) => o === 0 ? n + r : n + t + r, "");
}
const si = 2;
function Vc(e, t = 0, n = e.length) {
  const r = e.split(/\r?\n/);
  let o = 0;
  const a = [];
  for (let i = 0; i < r.length; i++)
    if (o += r[i].length + 1, o >= t) {
      for (let s = i - si; s <= i + si || n > o; s++) {
        if (s < 0 || s >= r.length)
          continue;
        const l = s + 1;
        a.push(`${l}${" ".repeat(3 - String(l).length)}|  ${r[s]}`);
        const u = r[s].length;
        if (s === i) {
          const f = t - (o - u) + 1, c = Math.max(1, n > o ? u - f : n - t);
          a.push("   |  " + " ".repeat(f) + "^".repeat(c));
        } else if (s > i) {
          if (n > o) {
            const f = Math.max(Math.min(n - o, u), 1);
            a.push("   |  " + "^".repeat(f));
          }
          o += u + 1;
        }
      }
      break;
    }
  return a.join(`
`);
}
function En(e, t) {
  typeof console < "u" && (console.warn("[intlify] " + e), t && console.warn(t.stack));
}
const li = {};
function Uc(e) {
  li[e] || (li[e] = !0, En(e));
}
function Wc() {
  const e = /* @__PURE__ */ new Map();
  return {
    events: e,
    on(n, r) {
      const o = e.get(n);
      o && o.push(r) || e.set(n, [r]);
    },
    off(n, r) {
      const o = e.get(n);
      o && o.splice(o.indexOf(r) >>> 0, 1);
    },
    emit(n, r) {
      (e.get(n) || []).slice().map((o) => o(r)), (e.get("*") || []).slice().map((o) => o(n, r));
    }
  };
}
const Lr = (e) => !ve(e) || Ue(e);
function zr(e, t) {
  if (Lr(e) || Lr(t))
    throw new Error("Invalid value");
  const n = [{ src: e, des: t }];
  for (; n.length; ) {
    const { src: r, des: o } = n.pop();
    Object.keys(r).forEach((a) => {
      a !== "__proto__" && (ve(r[a]) && !ve(o[a]) && (o[a] = Array.isArray(r[a]) ? [] : _e()), Lr(o[a]) || Lr(r[a]) ? o[a] = r[a] : n.push({ src: r[a], des: o[a] }));
    });
  }
}
/*!
  * message-compiler v10.0.7
  * (c) 2025 kazuya kawaguchi
  * Released under the MIT License.
  */
function Hc(e, t, n) {
  return { line: e, column: t, offset: n };
}
function $o(e, t, n) {
  return { start: e, end: t };
}
const oe = {
  // tokenizer error codes
  EXPECTED_TOKEN: 1,
  INVALID_TOKEN_IN_PLACEHOLDER: 2,
  UNTERMINATED_SINGLE_QUOTE_IN_PLACEHOLDER: 3,
  UNKNOWN_ESCAPE_SEQUENCE: 4,
  INVALID_UNICODE_ESCAPE_SEQUENCE: 5,
  UNBALANCED_CLOSING_BRACE: 6,
  UNTERMINATED_CLOSING_BRACE: 7,
  EMPTY_PLACEHOLDER: 8,
  NOT_ALLOW_NEST_PLACEHOLDER: 9,
  INVALID_LINKED_FORMAT: 10,
  // parser error codes
  MUST_HAVE_MESSAGES_IN_PLURAL: 11,
  UNEXPECTED_EMPTY_LINKED_MODIFIER: 12,
  UNEXPECTED_EMPTY_LINKED_KEY: 13,
  UNEXPECTED_LEXICAL_ANALYSIS: 14,
  // generator error codes
  UNHANDLED_CODEGEN_NODE_TYPE: 15,
  // minifier error codes
  UNHANDLED_MINIFIER_NODE_TYPE: 16
}, Yc = 17, Gc = {
  // tokenizer error messages
  [oe.EXPECTED_TOKEN]: "Expected token: '{0}'",
  [oe.INVALID_TOKEN_IN_PLACEHOLDER]: "Invalid token in placeholder: '{0}'",
  [oe.UNTERMINATED_SINGLE_QUOTE_IN_PLACEHOLDER]: "Unterminated single quote in placeholder",
  [oe.UNKNOWN_ESCAPE_SEQUENCE]: "Unknown escape sequence: \\{0}",
  [oe.INVALID_UNICODE_ESCAPE_SEQUENCE]: "Invalid unicode escape sequence: {0}",
  [oe.UNBALANCED_CLOSING_BRACE]: "Unbalanced closing brace",
  [oe.UNTERMINATED_CLOSING_BRACE]: "Unterminated closing brace",
  [oe.EMPTY_PLACEHOLDER]: "Empty placeholder",
  [oe.NOT_ALLOW_NEST_PLACEHOLDER]: "Not allowed nest placeholder",
  [oe.INVALID_LINKED_FORMAT]: "Invalid linked format",
  // parser error messages
  [oe.MUST_HAVE_MESSAGES_IN_PLURAL]: "Plural must have messages",
  [oe.UNEXPECTED_EMPTY_LINKED_MODIFIER]: "Unexpected empty linked modifier",
  [oe.UNEXPECTED_EMPTY_LINKED_KEY]: "Unexpected empty linked key",
  [oe.UNEXPECTED_LEXICAL_ANALYSIS]: "Unexpected lexical analysis in token: '{0}'",
  // generator error messages
  [oe.UNHANDLED_CODEGEN_NODE_TYPE]: "unhandled codegen node type: '{0}'",
  // minimizer error messages
  [oe.UNHANDLED_MINIFIER_NODE_TYPE]: "unhandled mimifier node type: '{0}'"
};
function Jn(e, t, n = {}) {
  const { domain: r, messages: o, args: a } = n, i = process.env.NODE_ENV !== "production" ? no((o || Gc)[e] || "", ...a || []) : e, s = new SyntaxError(String(i));
  return s.code = e, t && (s.location = t), s.domain = r, s;
}
function Kc(e) {
  throw e;
}
const Xc = /<\/?[\w\s="/.':;#-\/]+>/, Qc = (e) => Xc.test(e), Ut = " ", Zc = "\r", et = `
`, Jc = "\u2028", qc = "\u2029";
function ef(e) {
  const t = e;
  let n = 0, r = 1, o = 1, a = 0;
  const i = (I) => t[I] === Zc && t[I + 1] === et, s = (I) => t[I] === et, l = (I) => t[I] === qc, u = (I) => t[I] === Jc, f = (I) => i(I) || s(I) || l(I) || u(I), c = () => n, d = () => r, h = () => o, p = () => a, g = (I) => i(I) || l(I) || u(I) ? et : t[I], E = () => g(n), v = () => g(n + a);
  function m() {
    return a = 0, f(n) && (r++, o = 0), i(n) && n++, n++, o++, t[n];
  }
  function y() {
    return i(n + a) && a++, a++, t[n + a];
  }
  function _() {
    n = 0, r = 1, o = 1, a = 0;
  }
  function T(I = 0) {
    a = I;
  }
  function N() {
    const I = n + a;
    for (; I !== n; )
      m();
    a = 0;
  }
  return {
    index: c,
    line: d,
    column: h,
    peekOffset: p,
    charAt: g,
    currentChar: E,
    currentPeek: v,
    next: m,
    peek: y,
    reset: _,
    resetPeek: T,
    skipToPeek: N
  };
}
const ln = void 0, tf = ".", ui = "'", nf = "tokenizer";
function rf(e, t = {}) {
  const n = t.location !== !1, r = ef(e), o = () => r.index(), a = () => Hc(r.line(), r.column(), r.index()), i = a(), s = o(), l = {
    currentType: 13,
    offset: s,
    startLoc: i,
    endLoc: i,
    lastType: 13,
    lastOffset: s,
    lastStartLoc: i,
    lastEndLoc: i,
    braceNest: 0,
    inLinked: !1,
    text: ""
  }, u = () => l, { onError: f } = t;
  function c(M, C, w, ...$) {
    const re = u();
    if (C.column += w, C.offset += w, f) {
      const be = n ? $o(re.startLoc, C) : null, k = Jn(M, be, {
        domain: nf,
        args: $
      });
      f(k);
    }
  }
  function d(M, C, w) {
    M.endLoc = a(), M.currentType = C;
    const $ = { type: C };
    return n && ($.loc = $o(M.startLoc, M.endLoc)), w != null && ($.value = w), $;
  }
  const h = (M) => d(
    M,
    13
    /* TokenTypes.EOF */
  );
  function p(M, C) {
    return M.currentChar() === C ? (M.next(), C) : (c(oe.EXPECTED_TOKEN, a(), 0, C), "");
  }
  function g(M) {
    let C = "";
    for (; M.currentPeek() === Ut || M.currentPeek() === et; )
      C += M.currentPeek(), M.peek();
    return C;
  }
  function E(M) {
    const C = g(M);
    return M.skipToPeek(), C;
  }
  function v(M) {
    if (M === ln)
      return !1;
    const C = M.charCodeAt(0);
    return C >= 97 && C <= 122 || // a-z
    C >= 65 && C <= 90 || // A-Z
    C === 95;
  }
  function m(M) {
    if (M === ln)
      return !1;
    const C = M.charCodeAt(0);
    return C >= 48 && C <= 57;
  }
  function y(M, C) {
    const { currentType: w } = C;
    if (w !== 2)
      return !1;
    g(M);
    const $ = v(M.currentPeek());
    return M.resetPeek(), $;
  }
  function _(M, C) {
    const { currentType: w } = C;
    if (w !== 2)
      return !1;
    g(M);
    const $ = M.currentPeek() === "-" ? M.peek() : M.currentPeek(), re = m($);
    return M.resetPeek(), re;
  }
  function T(M, C) {
    const { currentType: w } = C;
    if (w !== 2)
      return !1;
    g(M);
    const $ = M.currentPeek() === ui;
    return M.resetPeek(), $;
  }
  function N(M, C) {
    const { currentType: w } = C;
    if (w !== 7)
      return !1;
    g(M);
    const $ = M.currentPeek() === ".";
    return M.resetPeek(), $;
  }
  function I(M, C) {
    const { currentType: w } = C;
    if (w !== 8)
      return !1;
    g(M);
    const $ = v(M.currentPeek());
    return M.resetPeek(), $;
  }
  function x(M, C) {
    const { currentType: w } = C;
    if (!(w === 7 || w === 11))
      return !1;
    g(M);
    const $ = M.currentPeek() === ":";
    return M.resetPeek(), $;
  }
  function B(M, C) {
    const { currentType: w } = C;
    if (w !== 9)
      return !1;
    const $ = () => {
      const be = M.currentPeek();
      return be === "{" ? v(M.peek()) : be === "@" || be === "|" || be === ":" || be === "." || be === Ut || !be ? !1 : be === et ? (M.peek(), $()) : ee(M, !1);
    }, re = $();
    return M.resetPeek(), re;
  }
  function H(M) {
    g(M);
    const C = M.currentPeek() === "|";
    return M.resetPeek(), C;
  }
  function ee(M, C = !0) {
    const w = (re = !1, be = "") => {
      const k = M.currentPeek();
      return k === "{" || k === "@" || !k ? re : k === "|" ? !(be === Ut || be === et) : k === Ut ? (M.peek(), w(!0, Ut)) : k === et ? (M.peek(), w(!0, et)) : !0;
    }, $ = w();
    return C && M.resetPeek(), $;
  }
  function L(M, C) {
    const w = M.currentChar();
    return w === ln ? ln : C(w) ? (M.next(), w) : null;
  }
  function V(M) {
    const C = M.charCodeAt(0);
    return C >= 97 && C <= 122 || // a-z
    C >= 65 && C <= 90 || // A-Z
    C >= 48 && C <= 57 || // 0-9
    C === 95 || // _
    C === 36;
  }
  function me(M) {
    return L(M, V);
  }
  function fe(M) {
    const C = M.charCodeAt(0);
    return C >= 97 && C <= 122 || // a-z
    C >= 65 && C <= 90 || // A-Z
    C >= 48 && C <= 57 || // 0-9
    C === 95 || // _
    C === 36 || // $
    C === 45;
  }
  function ie(M) {
    return L(M, fe);
  }
  function ne(M) {
    const C = M.charCodeAt(0);
    return C >= 48 && C <= 57;
  }
  function G(M) {
    return L(M, ne);
  }
  function pe(M) {
    const C = M.charCodeAt(0);
    return C >= 48 && C <= 57 || // 0-9
    C >= 65 && C <= 70 || // A-F
    C >= 97 && C <= 102;
  }
  function he(M) {
    return L(M, pe);
  }
  function Ie(M) {
    let C = "", w = "";
    for (; C = G(M); )
      w += C;
    return w;
  }
  function je(M) {
    let C = "";
    for (; ; ) {
      const w = M.currentChar();
      if (w === "{" || w === "}" || w === "@" || w === "|" || !w)
        break;
      if (w === Ut || w === et)
        if (ee(M))
          C += w, M.next();
        else {
          if (H(M))
            break;
          C += w, M.next();
        }
      else
        C += w, M.next();
    }
    return C;
  }
  function Ge(M) {
    E(M);
    let C = "", w = "";
    for (; C = ie(M); )
      w += C;
    return M.currentChar() === ln && c(oe.UNTERMINATED_CLOSING_BRACE, a(), 0), w;
  }
  function Pe(M) {
    E(M);
    let C = "";
    return M.currentChar() === "-" ? (M.next(), C += `-${Ie(M)}`) : C += Ie(M), M.currentChar() === ln && c(oe.UNTERMINATED_CLOSING_BRACE, a(), 0), C;
  }
  function Se(M) {
    return M !== ui && M !== et;
  }
  function Be(M) {
    E(M), p(M, "'");
    let C = "", w = "";
    for (; C = L(M, Se); )
      C === "\\" ? w += O(M) : w += C;
    const $ = M.currentChar();
    return $ === et || $ === ln ? (c(oe.UNTERMINATED_SINGLE_QUOTE_IN_PLACEHOLDER, a(), 0), $ === et && (M.next(), p(M, "'")), w) : (p(M, "'"), w);
  }
  function O(M) {
    const C = M.currentChar();
    switch (C) {
      case "\\":
      case "'":
        return M.next(), `\\${C}`;
      case "u":
        return A(M, C, 4);
      case "U":
        return A(M, C, 6);
      default:
        return c(oe.UNKNOWN_ESCAPE_SEQUENCE, a(), 0, C), "";
    }
  }
  function A(M, C, w) {
    p(M, C);
    let $ = "";
    for (let re = 0; re < w; re++) {
      const be = he(M);
      if (!be) {
        c(oe.INVALID_UNICODE_ESCAPE_SEQUENCE, a(), 0, `\\${C}${$}${M.currentChar()}`);
        break;
      }
      $ += be;
    }
    return `\\${C}${$}`;
  }
  function W(M) {
    return M !== "{" && M !== "}" && M !== Ut && M !== et;
  }
  function de(M) {
    E(M);
    let C = "", w = "";
    for (; C = L(M, W); )
      w += C;
    return w;
  }
  function we(M) {
    let C = "", w = "";
    for (; C = me(M); )
      w += C;
    return w;
  }
  function $e(M) {
    const C = (w) => {
      const $ = M.currentChar();
      return $ === "{" || $ === "@" || $ === "|" || $ === "(" || $ === ")" || !$ || $ === Ut ? w : (w += $, M.next(), C(w));
    };
    return C("");
  }
  function Te(M) {
    E(M);
    const C = p(
      M,
      "|"
      /* TokenChars.Pipe */
    );
    return E(M), C;
  }
  function ze(M, C) {
    let w = null;
    switch (M.currentChar()) {
      case "{":
        return C.braceNest >= 1 && c(oe.NOT_ALLOW_NEST_PLACEHOLDER, a(), 0), M.next(), w = d(
          C,
          2,
          "{"
          /* TokenChars.BraceLeft */
        ), E(M), C.braceNest++, w;
      case "}":
        return C.braceNest > 0 && C.currentType === 2 && c(oe.EMPTY_PLACEHOLDER, a(), 0), M.next(), w = d(
          C,
          3,
          "}"
          /* TokenChars.BraceRight */
        ), C.braceNest--, C.braceNest > 0 && E(M), C.inLinked && C.braceNest === 0 && (C.inLinked = !1), w;
      case "@":
        return C.braceNest > 0 && c(oe.UNTERMINATED_CLOSING_BRACE, a(), 0), w = Ae(M, C) || h(C), C.braceNest = 0, w;
      default: {
        let re = !0, be = !0, k = !0;
        if (H(M))
          return C.braceNest > 0 && c(oe.UNTERMINATED_CLOSING_BRACE, a(), 0), w = d(C, 1, Te(M)), C.braceNest = 0, C.inLinked = !1, w;
        if (C.braceNest > 0 && (C.currentType === 4 || C.currentType === 5 || C.currentType === 6))
          return c(oe.UNTERMINATED_CLOSING_BRACE, a(), 0), C.braceNest = 0, De(M, C);
        if (re = y(M, C))
          return w = d(C, 4, Ge(M)), E(M), w;
        if (be = _(M, C))
          return w = d(C, 5, Pe(M)), E(M), w;
        if (k = T(M, C))
          return w = d(C, 6, Be(M)), E(M), w;
        if (!re && !be && !k)
          return w = d(C, 12, de(M)), c(oe.INVALID_TOKEN_IN_PLACEHOLDER, a(), 0, w.value), E(M), w;
        break;
      }
    }
    return w;
  }
  function Ae(M, C) {
    const { currentType: w } = C;
    let $ = null;
    const re = M.currentChar();
    switch ((w === 7 || w === 8 || w === 11 || w === 9) && (re === et || re === Ut) && c(oe.INVALID_LINKED_FORMAT, a(), 0), re) {
      case "@":
        return M.next(), $ = d(
          C,
          7,
          "@"
          /* TokenChars.LinkedAlias */
        ), C.inLinked = !0, $;
      case ".":
        return E(M), M.next(), d(
          C,
          8,
          "."
          /* TokenChars.LinkedDot */
        );
      case ":":
        return E(M), M.next(), d(
          C,
          9,
          ":"
          /* TokenChars.LinkedDelimiter */
        );
      default:
        return H(M) ? ($ = d(C, 1, Te(M)), C.braceNest = 0, C.inLinked = !1, $) : N(M, C) || x(M, C) ? (E(M), Ae(M, C)) : I(M, C) ? (E(M), d(C, 11, we(M))) : B(M, C) ? (E(M), re === "{" ? ze(M, C) || $ : d(C, 10, $e(M))) : (w === 7 && c(oe.INVALID_LINKED_FORMAT, a(), 0), C.braceNest = 0, C.inLinked = !1, De(M, C));
    }
  }
  function De(M, C) {
    let w = {
      type: 13
      /* TokenTypes.EOF */
    };
    if (C.braceNest > 0)
      return ze(M, C) || h(C);
    if (C.inLinked)
      return Ae(M, C) || h(C);
    switch (M.currentChar()) {
      case "{":
        return ze(M, C) || h(C);
      case "}":
        return c(oe.UNBALANCED_CLOSING_BRACE, a(), 0), M.next(), d(
          C,
          3,
          "}"
          /* TokenChars.BraceRight */
        );
      case "@":
        return Ae(M, C) || h(C);
      default: {
        if (H(M))
          return w = d(C, 1, Te(M)), C.braceNest = 0, C.inLinked = !1, w;
        if (ee(M))
          return d(C, 0, je(M));
        break;
      }
    }
    return w;
  }
  function ht() {
    const { currentType: M, offset: C, startLoc: w, endLoc: $ } = l;
    return l.lastType = M, l.lastOffset = C, l.lastStartLoc = w, l.lastEndLoc = $, l.offset = o(), l.startLoc = a(), r.currentChar() === ln ? d(
      l,
      13
      /* TokenTypes.EOF */
    ) : De(r, l);
  }
  return {
    nextToken: ht,
    currentOffset: o,
    currentPosition: a,
    context: u
  };
}
const of = "parser", af = /(?:\\\\|\\'|\\u([0-9a-fA-F]{4})|\\U([0-9a-fA-F]{6}))/g;
function sf(e, t, n) {
  switch (e) {
    case "\\\\":
      return "\\";
    case "\\'":
      return "'";
    default: {
      const r = parseInt(t || n, 16);
      return r <= 55295 || r >= 57344 ? String.fromCodePoint(r) : "�";
    }
  }
}
function lf(e = {}) {
  const t = e.location !== !1, { onError: n } = e;
  function r(v, m, y, _, ...T) {
    const N = v.currentPosition();
    if (N.offset += _, N.column += _, n) {
      const I = t ? $o(y, N) : null, x = Jn(m, I, {
        domain: of,
        args: T
      });
      n(x);
    }
  }
  function o(v, m, y) {
    const _ = { type: v };
    return t && (_.start = m, _.end = m, _.loc = { start: y, end: y }), _;
  }
  function a(v, m, y, _) {
    t && (v.end = m, v.loc && (v.loc.end = y));
  }
  function i(v, m) {
    const y = v.context(), _ = o(3, y.offset, y.startLoc);
    return _.value = m, a(_, v.currentOffset(), v.currentPosition()), _;
  }
  function s(v, m) {
    const y = v.context(), { lastOffset: _, lastStartLoc: T } = y, N = o(5, _, T);
    return N.index = parseInt(m, 10), v.nextToken(), a(N, v.currentOffset(), v.currentPosition()), N;
  }
  function l(v, m) {
    const y = v.context(), { lastOffset: _, lastStartLoc: T } = y, N = o(4, _, T);
    return N.key = m, v.nextToken(), a(N, v.currentOffset(), v.currentPosition()), N;
  }
  function u(v, m) {
    const y = v.context(), { lastOffset: _, lastStartLoc: T } = y, N = o(9, _, T);
    return N.value = m.replace(af, sf), v.nextToken(), a(N, v.currentOffset(), v.currentPosition()), N;
  }
  function f(v) {
    const m = v.nextToken(), y = v.context(), { lastOffset: _, lastStartLoc: T } = y, N = o(8, _, T);
    return m.type !== 11 ? (r(v, oe.UNEXPECTED_EMPTY_LINKED_MODIFIER, y.lastStartLoc, 0), N.value = "", a(N, _, T), {
      nextConsumeToken: m,
      node: N
    }) : (m.value == null && r(v, oe.UNEXPECTED_LEXICAL_ANALYSIS, y.lastStartLoc, 0, kt(m)), N.value = m.value || "", a(N, v.currentOffset(), v.currentPosition()), {
      node: N
    });
  }
  function c(v, m) {
    const y = v.context(), _ = o(7, y.offset, y.startLoc);
    return _.value = m, a(_, v.currentOffset(), v.currentPosition()), _;
  }
  function d(v) {
    const m = v.context(), y = o(6, m.offset, m.startLoc);
    let _ = v.nextToken();
    if (_.type === 8) {
      const T = f(v);
      y.modifier = T.node, _ = T.nextConsumeToken || v.nextToken();
    }
    switch (_.type !== 9 && r(v, oe.UNEXPECTED_LEXICAL_ANALYSIS, m.lastStartLoc, 0, kt(_)), _ = v.nextToken(), _.type === 2 && (_ = v.nextToken()), _.type) {
      case 10:
        _.value == null && r(v, oe.UNEXPECTED_LEXICAL_ANALYSIS, m.lastStartLoc, 0, kt(_)), y.key = c(v, _.value || "");
        break;
      case 4:
        _.value == null && r(v, oe.UNEXPECTED_LEXICAL_ANALYSIS, m.lastStartLoc, 0, kt(_)), y.key = l(v, _.value || "");
        break;
      case 5:
        _.value == null && r(v, oe.UNEXPECTED_LEXICAL_ANALYSIS, m.lastStartLoc, 0, kt(_)), y.key = s(v, _.value || "");
        break;
      case 6:
        _.value == null && r(v, oe.UNEXPECTED_LEXICAL_ANALYSIS, m.lastStartLoc, 0, kt(_)), y.key = u(v, _.value || "");
        break;
      default: {
        r(v, oe.UNEXPECTED_EMPTY_LINKED_KEY, m.lastStartLoc, 0);
        const T = v.context(), N = o(7, T.offset, T.startLoc);
        return N.value = "", a(N, T.offset, T.startLoc), y.key = N, a(y, T.offset, T.startLoc), {
          nextConsumeToken: _,
          node: y
        };
      }
    }
    return a(y, v.currentOffset(), v.currentPosition()), {
      node: y
    };
  }
  function h(v) {
    const m = v.context(), y = m.currentType === 1 ? v.currentOffset() : m.offset, _ = m.currentType === 1 ? m.endLoc : m.startLoc, T = o(2, y, _);
    T.items = [];
    let N = null;
    do {
      const B = N || v.nextToken();
      switch (N = null, B.type) {
        case 0:
          B.value == null && r(v, oe.UNEXPECTED_LEXICAL_ANALYSIS, m.lastStartLoc, 0, kt(B)), T.items.push(i(v, B.value || ""));
          break;
        case 5:
          B.value == null && r(v, oe.UNEXPECTED_LEXICAL_ANALYSIS, m.lastStartLoc, 0, kt(B)), T.items.push(s(v, B.value || ""));
          break;
        case 4:
          B.value == null && r(v, oe.UNEXPECTED_LEXICAL_ANALYSIS, m.lastStartLoc, 0, kt(B)), T.items.push(l(v, B.value || ""));
          break;
        case 6:
          B.value == null && r(v, oe.UNEXPECTED_LEXICAL_ANALYSIS, m.lastStartLoc, 0, kt(B)), T.items.push(u(v, B.value || ""));
          break;
        case 7: {
          const H = d(v);
          T.items.push(H.node), N = H.nextConsumeToken || null;
          break;
        }
      }
    } while (m.currentType !== 13 && m.currentType !== 1);
    const I = m.currentType === 1 ? m.lastOffset : v.currentOffset(), x = m.currentType === 1 ? m.lastEndLoc : v.currentPosition();
    return a(T, I, x), T;
  }
  function p(v, m, y, _) {
    const T = v.context();
    let N = _.items.length === 0;
    const I = o(1, m, y);
    I.cases = [], I.cases.push(_);
    do {
      const x = h(v);
      N || (N = x.items.length === 0), I.cases.push(x);
    } while (T.currentType !== 13);
    return N && r(v, oe.MUST_HAVE_MESSAGES_IN_PLURAL, y, 0), a(I, v.currentOffset(), v.currentPosition()), I;
  }
  function g(v) {
    const m = v.context(), { offset: y, startLoc: _ } = m, T = h(v);
    return m.currentType === 13 ? T : p(v, y, _, T);
  }
  function E(v) {
    const m = rf(v, Ye({}, e)), y = m.context(), _ = o(0, y.offset, y.startLoc);
    return t && _.loc && (_.loc.source = v), _.body = g(m), e.onCacheKey && (_.cacheKey = e.onCacheKey(v)), y.currentType !== 13 && r(m, oe.UNEXPECTED_LEXICAL_ANALYSIS, y.lastStartLoc, 0, v[y.offset] || ""), a(_, m.currentOffset(), m.currentPosition()), _;
  }
  return { parse: E };
}
function kt(e) {
  if (e.type === 13)
    return "EOF";
  const t = (e.value || "").replace(/\r?\n/gu, "\\n");
  return t.length > 10 ? t.slice(0, 9) + "…" : t;
}
function uf(e, t = {}) {
  const n = {
    ast: e,
    helpers: /* @__PURE__ */ new Set()
  };
  return { context: () => n, helper: (a) => (n.helpers.add(a), a) };
}
function ci(e, t) {
  for (let n = 0; n < e.length; n++)
    ba(e[n], t);
}
function ba(e, t) {
  switch (e.type) {
    case 1:
      ci(e.cases, t), t.helper(
        "plural"
        /* HelperNameMap.PLURAL */
      );
      break;
    case 2:
      ci(e.items, t);
      break;
    case 6: {
      ba(e.key, t), t.helper(
        "linked"
        /* HelperNameMap.LINKED */
      ), t.helper(
        "type"
        /* HelperNameMap.TYPE */
      );
      break;
    }
    case 5:
      t.helper(
        "interpolate"
        /* HelperNameMap.INTERPOLATE */
      ), t.helper(
        "list"
        /* HelperNameMap.LIST */
      );
      break;
    case 4:
      t.helper(
        "interpolate"
        /* HelperNameMap.INTERPOLATE */
      ), t.helper(
        "named"
        /* HelperNameMap.NAMED */
      );
      break;
  }
}
function cf(e, t = {}) {
  const n = uf(e);
  n.helper(
    "normalize"
    /* HelperNameMap.NORMALIZE */
  ), e.body && ba(e.body, n);
  const r = n.context();
  e.helpers = Array.from(r.helpers);
}
function ff(e) {
  const t = e.body;
  return t.type === 2 ? fi(t) : t.cases.forEach((n) => fi(n)), e;
}
function fi(e) {
  if (e.items.length === 1) {
    const t = e.items[0];
    (t.type === 3 || t.type === 9) && (e.static = t.value, delete t.value);
  } else {
    const t = [];
    for (let n = 0; n < e.items.length; n++) {
      const r = e.items[n];
      if (!(r.type === 3 || r.type === 9) || r.value == null)
        break;
      t.push(r.value);
    }
    if (t.length === e.items.length) {
      e.static = ya(t);
      for (let n = 0; n < e.items.length; n++) {
        const r = e.items[n];
        (r.type === 3 || r.type === 9) && delete r.value;
      }
    }
  }
}
const df = "minifier";
function $n(e) {
  switch (e.t = e.type, e.type) {
    case 0: {
      const t = e;
      $n(t.body), t.b = t.body, delete t.body;
      break;
    }
    case 1: {
      const t = e, n = t.cases;
      for (let r = 0; r < n.length; r++)
        $n(n[r]);
      t.c = n, delete t.cases;
      break;
    }
    case 2: {
      const t = e, n = t.items;
      for (let r = 0; r < n.length; r++)
        $n(n[r]);
      t.i = n, delete t.items, t.static && (t.s = t.static, delete t.static);
      break;
    }
    case 3:
    case 9:
    case 8:
    case 7: {
      const t = e;
      t.value && (t.v = t.value, delete t.value);
      break;
    }
    case 6: {
      const t = e;
      $n(t.key), t.k = t.key, delete t.key, t.modifier && ($n(t.modifier), t.m = t.modifier, delete t.modifier);
      break;
    }
    case 5: {
      const t = e;
      t.i = t.index, delete t.index;
      break;
    }
    case 4: {
      const t = e;
      t.k = t.key, delete t.key;
      break;
    }
    default:
      if (process.env.NODE_ENV !== "production")
        throw Jn(oe.UNHANDLED_MINIFIER_NODE_TYPE, null, {
          domain: df,
          args: [e.type]
        });
  }
  delete e.type;
}
const pf = "parser";
function hf(e, t) {
  const { filename: n, breakLineCode: r, needIndent: o } = t, a = t.location !== !1, i = {
    filename: n,
    code: "",
    column: 1,
    line: 1,
    offset: 0,
    map: void 0,
    breakLineCode: r,
    needIndent: o,
    indentLevel: 0
  };
  a && e.loc && (i.source = e.loc.source);
  const s = () => i;
  function l(g, E) {
    i.code += g;
  }
  function u(g, E = !0) {
    const v = E ? r : "";
    l(o ? v + "  ".repeat(g) : v);
  }
  function f(g = !0) {
    const E = ++i.indentLevel;
    g && u(E);
  }
  function c(g = !0) {
    const E = --i.indentLevel;
    g && u(E);
  }
  function d() {
    u(i.indentLevel);
  }
  return {
    context: s,
    push: l,
    indent: f,
    deindent: c,
    newline: d,
    helper: (g) => `_${g}`,
    needIndent: () => i.needIndent
  };
}
function gf(e, t) {
  const { helper: n } = e;
  e.push(`${n(
    "linked"
    /* HelperNameMap.LINKED */
  )}(`), Wn(e, t.key), t.modifier ? (e.push(", "), Wn(e, t.modifier), e.push(", _type")) : e.push(", undefined, _type"), e.push(")");
}
function vf(e, t) {
  const { helper: n, needIndent: r } = e;
  e.push(`${n(
    "normalize"
    /* HelperNameMap.NORMALIZE */
  )}([`), e.indent(r());
  const o = t.items.length;
  for (let a = 0; a < o && (Wn(e, t.items[a]), a !== o - 1); a++)
    e.push(", ");
  e.deindent(r()), e.push("])");
}
function mf(e, t) {
  const { helper: n, needIndent: r } = e;
  if (t.cases.length > 1) {
    e.push(`${n(
      "plural"
      /* HelperNameMap.PLURAL */
    )}([`), e.indent(r());
    const o = t.cases.length;
    for (let a = 0; a < o && (Wn(e, t.cases[a]), a !== o - 1); a++)
      e.push(", ");
    e.deindent(r()), e.push("])");
  }
}
function yf(e, t) {
  t.body ? Wn(e, t.body) : e.push("null");
}
function Wn(e, t) {
  const { helper: n } = e;
  switch (t.type) {
    case 0:
      yf(e, t);
      break;
    case 1:
      mf(e, t);
      break;
    case 2:
      vf(e, t);
      break;
    case 6:
      gf(e, t);
      break;
    case 8:
      e.push(JSON.stringify(t.value), t);
      break;
    case 7:
      e.push(JSON.stringify(t.value), t);
      break;
    case 5:
      e.push(`${n(
        "interpolate"
        /* HelperNameMap.INTERPOLATE */
      )}(${n(
        "list"
        /* HelperNameMap.LIST */
      )}(${t.index}))`, t);
      break;
    case 4:
      e.push(`${n(
        "interpolate"
        /* HelperNameMap.INTERPOLATE */
      )}(${n(
        "named"
        /* HelperNameMap.NAMED */
      )}(${JSON.stringify(t.key)}))`, t);
      break;
    case 9:
      e.push(JSON.stringify(t.value), t);
      break;
    case 3:
      e.push(JSON.stringify(t.value), t);
      break;
    default:
      if (process.env.NODE_ENV !== "production")
        throw Jn(oe.UNHANDLED_CODEGEN_NODE_TYPE, null, {
          domain: pf,
          args: [t.type]
        });
  }
}
const bf = (e, t = {}) => {
  const n = K(t.mode) ? t.mode : "normal", r = K(t.filename) ? t.filename : "message.intl";
  t.sourceMap;
  const o = t.breakLineCode != null ? t.breakLineCode : n === "arrow" ? ";" : `
`, a = t.needIndent ? t.needIndent : n !== "arrow", i = e.helpers || [], s = hf(e, {
    filename: r,
    breakLineCode: o,
    needIndent: a
  });
  s.push(n === "normal" ? "function __msg__ (ctx) {" : "(ctx) => {"), s.indent(a), i.length > 0 && (s.push(`const { ${ya(i.map((f) => `${f}: _${f}`), ", ")} } = ctx`), s.newline()), s.push("return "), Wn(s, e), s.deindent(a), s.push("}"), delete e.helpers;
  const { code: l, map: u } = s.context();
  return {
    ast: e,
    code: l,
    map: u ? u.toJSON() : void 0
    // eslint-disable-line @typescript-eslint/no-explicit-any
  };
};
function Ef(e, t = {}) {
  const n = Ye({}, t), r = !!n.jit, o = !!n.minify, a = n.optimize == null ? !0 : n.optimize, s = lf(n).parse(e);
  return r ? (a && ff(s), o && $n(s), { ast: s, code: "" }) : (cf(s, n), bf(s, n));
}
/*!
  * core-base v10.0.7
  * (c) 2025 kazuya kawaguchi
  * Released under the MIT License.
  */
function Mf() {
  typeof __INTLIFY_PROD_DEVTOOLS__ != "boolean" && (In().__INTLIFY_PROD_DEVTOOLS__ = !1), typeof __INTLIFY_DROP_MESSAGE_COMPILER__ != "boolean" && (In().__INTLIFY_DROP_MESSAGE_COMPILER__ = !1);
}
function It(e) {
  return ve(e) && Ea(e) === 0 && (Ct(e, "b") || Ct(e, "body"));
}
const al = ["b", "body"];
function _f(e) {
  return Mn(e, al);
}
const il = ["c", "cases"];
function wf(e) {
  return Mn(e, il, []);
}
const sl = ["s", "static"];
function Tf(e) {
  return Mn(e, sl);
}
const ll = ["i", "items"];
function Cf(e) {
  return Mn(e, ll, []);
}
const ul = ["t", "type"];
function Ea(e) {
  return Mn(e, ul);
}
const cl = ["v", "value"];
function Pr(e, t) {
  const n = Mn(e, cl);
  if (n != null)
    return n;
  throw hr(t);
}
const fl = ["m", "modifier"];
function Of(e) {
  return Mn(e, fl);
}
const dl = ["k", "key"];
function If(e) {
  const t = Mn(e, dl);
  if (t)
    return t;
  throw hr(
    6
    /* NodeTypes.Linked */
  );
}
function Mn(e, t, n) {
  for (let r = 0; r < t.length; r++) {
    const o = t[r];
    if (Ct(e, o) && e[o] != null)
      return e[o];
  }
  return n;
}
const pl = [
  ...al,
  ...il,
  ...sl,
  ...ll,
  ...dl,
  ...fl,
  ...cl,
  ...ul
];
function hr(e) {
  return new Error(`unhandled node type: ${e}`);
}
function To(e) {
  return (n) => Nf(n, e);
}
function Nf(e, t) {
  const n = _f(t);
  if (n == null)
    throw hr(
      0
      /* NodeTypes.Resource */
    );
  if (Ea(n) === 1) {
    const a = wf(n);
    return e.plural(a.reduce((i, s) => [
      ...i,
      di(e, s)
    ], []));
  } else
    return di(e, n);
}
function di(e, t) {
  const n = Tf(t);
  if (n != null)
    return e.type === "text" ? n : e.normalize([n]);
  {
    const r = Cf(t).reduce((o, a) => [...o, zo(e, a)], []);
    return e.normalize(r);
  }
}
function zo(e, t) {
  const n = Ea(t);
  switch (n) {
    case 3:
      return Pr(t, n);
    case 9:
      return Pr(t, n);
    case 4: {
      const r = t;
      if (Ct(r, "k") && r.k)
        return e.interpolate(e.named(r.k));
      if (Ct(r, "key") && r.key)
        return e.interpolate(e.named(r.key));
      throw hr(n);
    }
    case 5: {
      const r = t;
      if (Ct(r, "i") && He(r.i))
        return e.interpolate(e.list(r.i));
      if (Ct(r, "index") && He(r.index))
        return e.interpolate(e.list(r.index));
      throw hr(n);
    }
    case 6: {
      const r = t, o = Of(r), a = If(r);
      return e.linked(zo(e, a), o ? zo(e, o) : void 0, e.type);
    }
    case 7:
      return Pr(t, n);
    case 8:
      return Pr(t, n);
    default:
      throw new Error(`unhandled node on format message part: ${n}`);
  }
}
const Sf = "Detected HTML in '{source}' message. Recommend not using HTML messages to avoid XSS.";
function Af(e, t) {
  t && Qc(e) && En(no(Sf, { source: e }));
}
const Lf = (e) => e;
let Dr = _e();
function Pf(e, t = {}) {
  let n = !1;
  const r = t.onError || Kc;
  return t.onError = (o) => {
    n = !0, r(o);
  }, { ...Ef(e, t), detectError: n };
}
// @__NO_SIDE_EFFECTS__
function Df(e, t) {
  if (!__INTLIFY_DROP_MESSAGE_COMPILER__ && K(e)) {
    const n = ke(t.warnHtmlMessage) ? t.warnHtmlMessage : !0;
    process.env.NODE_ENV !== "production" && Af(e, n);
    const o = (t.onCacheKey || Lf)(e), a = Dr[o];
    if (a)
      return a;
    const { ast: i, detectError: s } = Pf(e, {
      ...t,
      location: process.env.NODE_ENV !== "production",
      jit: !0
    }), l = To(i);
    return s ? l : Dr[o] = l;
  } else {
    if (process.env.NODE_ENV !== "production" && !It(e))
      return En(`the message that is resolve with key '${t.key}' is not supported for jit compilation`), () => e;
    const n = e.cacheKey;
    if (n) {
      const r = Dr[n];
      return r || (Dr[n] = To(e));
    } else
      return To(e);
  }
}
let gr = null;
function kf(e) {
  gr = e;
}
function xf(e, t, n) {
  gr && gr.emit("i18n:init", {
    timestamp: Date.now(),
    i18n: e,
    version: t,
    meta: n
  });
}
const Rf = /* @__PURE__ */ Ff("function:translate");
function Ff(e) {
  return (t) => gr && gr.emit(e, t);
}
const Je = {
  INVALID_ARGUMENT: Yc,
  // 17
  INVALID_DATE_ARGUMENT: 18,
  INVALID_ISO_DATE_ARGUMENT: 19,
  NOT_SUPPORT_NON_STRING_MESSAGE: 20,
  NOT_SUPPORT_LOCALE_PROMISE_VALUE: 21,
  NOT_SUPPORT_LOCALE_ASYNC_FUNCTION: 22,
  NOT_SUPPORT_LOCALE_TYPE: 23
}, jf = 24;
function Xt(e) {
  return Jn(e, null, process.env.NODE_ENV !== "production" ? { messages: Bf } : void 0);
}
const Bf = {
  [Je.INVALID_ARGUMENT]: "Invalid arguments",
  [Je.INVALID_DATE_ARGUMENT]: "The date provided is an invalid Date object.Make sure your Date represents a valid date.",
  [Je.INVALID_ISO_DATE_ARGUMENT]: "The argument provided is not a valid ISO date string",
  [Je.NOT_SUPPORT_NON_STRING_MESSAGE]: "Not support non-string message",
  [Je.NOT_SUPPORT_LOCALE_PROMISE_VALUE]: "cannot support promise value",
  [Je.NOT_SUPPORT_LOCALE_ASYNC_FUNCTION]: "cannot support async function",
  [Je.NOT_SUPPORT_LOCALE_TYPE]: "cannot support locale type"
};
function Ma(e, t) {
  return t.locale != null ? pi(t.locale) : pi(e.locale);
}
let Co;
function pi(e) {
  if (K(e))
    return e;
  if (Oe(e)) {
    if (e.resolvedOnce && Co != null)
      return Co;
    if (e.constructor.name === "Function") {
      const t = e();
      if ($c(t))
        throw Xt(Je.NOT_SUPPORT_LOCALE_PROMISE_VALUE);
      return Co = t;
    } else
      throw Xt(Je.NOT_SUPPORT_LOCALE_ASYNC_FUNCTION);
  } else
    throw Xt(Je.NOT_SUPPORT_LOCALE_TYPE);
}
function $f(e, t, n) {
  return [.../* @__PURE__ */ new Set([
    n,
    ...Ue(t) ? t : ve(t) ? Object.keys(t) : K(t) ? [t] : [n]
  ])];
}
function hl(e, t, n) {
  const r = K(n) ? n : Hr, o = e;
  o.__localeChainCache || (o.__localeChainCache = /* @__PURE__ */ new Map());
  let a = o.__localeChainCache.get(r);
  if (!a) {
    a = [];
    let i = [n];
    for (; Ue(i); )
      i = hi(a, i, t);
    const s = Ue(t) || !ge(t) ? t : t.default ? t.default : null;
    i = K(s) ? [s] : s, Ue(i) && hi(a, i, !1), o.__localeChainCache.set(r, a);
  }
  return a;
}
function hi(e, t, n) {
  let r = !0;
  for (let o = 0; o < t.length && ke(r); o++) {
    const a = t[o];
    K(a) && (r = zf(e, t[o], n));
  }
  return r;
}
function zf(e, t, n) {
  let r;
  const o = t.split("-");
  do {
    const a = o.join("-");
    r = Vf(e, a, n), o.splice(-1, 1);
  } while (o.length && r === !0);
  return r;
}
function Vf(e, t, n) {
  let r = !1;
  if (!e.includes(t) && (r = !0, t)) {
    r = t[t.length - 1] !== "!";
    const o = t.replace(/!/g, "");
    e.push(o), (Ue(n) || ge(n)) && n[o] && (r = n[o]);
  }
  return r;
}
const _n = [];
_n[
  0
  /* States.BEFORE_PATH */
] = {
  w: [
    0
    /* States.BEFORE_PATH */
  ],
  i: [
    3,
    0
    /* Actions.APPEND */
  ],
  "[": [
    4
    /* States.IN_SUB_PATH */
  ],
  o: [
    7
    /* States.AFTER_PATH */
  ]
};
_n[
  1
  /* States.IN_PATH */
] = {
  w: [
    1
    /* States.IN_PATH */
  ],
  ".": [
    2
    /* States.BEFORE_IDENT */
  ],
  "[": [
    4
    /* States.IN_SUB_PATH */
  ],
  o: [
    7
    /* States.AFTER_PATH */
  ]
};
_n[
  2
  /* States.BEFORE_IDENT */
] = {
  w: [
    2
    /* States.BEFORE_IDENT */
  ],
  i: [
    3,
    0
    /* Actions.APPEND */
  ],
  0: [
    3,
    0
    /* Actions.APPEND */
  ]
};
_n[
  3
  /* States.IN_IDENT */
] = {
  i: [
    3,
    0
    /* Actions.APPEND */
  ],
  0: [
    3,
    0
    /* Actions.APPEND */
  ],
  w: [
    1,
    1
    /* Actions.PUSH */
  ],
  ".": [
    2,
    1
    /* Actions.PUSH */
  ],
  "[": [
    4,
    1
    /* Actions.PUSH */
  ],
  o: [
    7,
    1
    /* Actions.PUSH */
  ]
};
_n[
  4
  /* States.IN_SUB_PATH */
] = {
  "'": [
    5,
    0
    /* Actions.APPEND */
  ],
  '"': [
    6,
    0
    /* Actions.APPEND */
  ],
  "[": [
    4,
    2
    /* Actions.INC_SUB_PATH_DEPTH */
  ],
  "]": [
    1,
    3
    /* Actions.PUSH_SUB_PATH */
  ],
  o: 8,
  l: [
    4,
    0
    /* Actions.APPEND */
  ]
};
_n[
  5
  /* States.IN_SINGLE_QUOTE */
] = {
  "'": [
    4,
    0
    /* Actions.APPEND */
  ],
  o: 8,
  l: [
    5,
    0
    /* Actions.APPEND */
  ]
};
_n[
  6
  /* States.IN_DOUBLE_QUOTE */
] = {
  '"': [
    4,
    0
    /* Actions.APPEND */
  ],
  o: 8,
  l: [
    6,
    0
    /* Actions.APPEND */
  ]
};
const Uf = /^\s?(?:true|false|-?[\d.]+|'[^']*'|"[^"]*")\s?$/;
function Wf(e) {
  return Uf.test(e);
}
function Hf(e) {
  const t = e.charCodeAt(0), n = e.charCodeAt(e.length - 1);
  return t === n && (t === 34 || t === 39) ? e.slice(1, -1) : e;
}
function Yf(e) {
  if (e == null)
    return "o";
  switch (e.charCodeAt(0)) {
    case 91:
    case 93:
    case 46:
    case 34:
    case 39:
      return e;
    case 95:
    case 36:
    case 45:
      return "i";
    case 9:
    case 10:
    case 13:
    case 160:
    case 65279:
    case 8232:
    case 8233:
      return "w";
  }
  return "i";
}
function Gf(e) {
  const t = e.trim();
  return e.charAt(0) === "0" && isNaN(parseInt(e)) ? !1 : Wf(t) ? Hf(t) : "*" + t;
}
function Kf(e) {
  const t = [];
  let n = -1, r = 0, o = 0, a, i, s, l, u, f, c;
  const d = [];
  d[
    0
    /* Actions.APPEND */
  ] = () => {
    i === void 0 ? i = s : i += s;
  }, d[
    1
    /* Actions.PUSH */
  ] = () => {
    i !== void 0 && (t.push(i), i = void 0);
  }, d[
    2
    /* Actions.INC_SUB_PATH_DEPTH */
  ] = () => {
    d[
      0
      /* Actions.APPEND */
    ](), o++;
  }, d[
    3
    /* Actions.PUSH_SUB_PATH */
  ] = () => {
    if (o > 0)
      o--, r = 4, d[
        0
        /* Actions.APPEND */
      ]();
    else {
      if (o = 0, i === void 0 || (i = Gf(i), i === !1))
        return !1;
      d[
        1
        /* Actions.PUSH */
      ]();
    }
  };
  function h() {
    const p = e[n + 1];
    if (r === 5 && p === "'" || r === 6 && p === '"')
      return n++, s = "\\" + p, d[
        0
        /* Actions.APPEND */
      ](), !0;
  }
  for (; r !== null; )
    if (n++, a = e[n], !(a === "\\" && h())) {
      if (l = Yf(a), c = _n[r], u = c[l] || c.l || 8, u === 8 || (r = u[0], u[1] !== void 0 && (f = d[u[1]], f && (s = a, f() === !1))))
        return;
      if (r === 7)
        return t;
    }
}
const gi = /* @__PURE__ */ new Map();
function Xf(e, t) {
  return ve(e) ? e[t] : null;
}
function Qf(e, t) {
  if (!ve(e))
    return null;
  let n = gi.get(t);
  if (n || (n = Kf(t), n && gi.set(t, n)), !n)
    return null;
  const r = n.length;
  let o = e, a = 0;
  for (; a < r; ) {
    const i = n[a];
    if (pl.includes(i) && It(o))
      return null;
    const s = o[i];
    if (s === void 0 || Oe(o))
      return null;
    o = s, a++;
  }
  return o;
}
const at = {
  NOT_FOUND_KEY: 1,
  FALLBACK_TO_TRANSLATE: 2,
  CANNOT_FORMAT_NUMBER: 3,
  FALLBACK_TO_NUMBER_FORMAT: 4,
  CANNOT_FORMAT_DATE: 5,
  FALLBACK_TO_DATE_FORMAT: 6,
  EXPERIMENTAL_CUSTOM_MESSAGE_COMPILER: 7
}, Zf = 8, Jf = {
  [at.NOT_FOUND_KEY]: "Not found '{key}' key in '{locale}' locale messages.",
  [at.FALLBACK_TO_TRANSLATE]: "Fall back to translate '{key}' key with '{target}' locale.",
  [at.CANNOT_FORMAT_NUMBER]: "Cannot format a number value due to not supported Intl.NumberFormat.",
  [at.FALLBACK_TO_NUMBER_FORMAT]: "Fall back to number format '{key}' key with '{target}' locale.",
  [at.CANNOT_FORMAT_DATE]: "Cannot format a date value due to not supported Intl.DateTimeFormat.",
  [at.FALLBACK_TO_DATE_FORMAT]: "Fall back to datetime format '{key}' key with '{target}' locale.",
  [at.EXPERIMENTAL_CUSTOM_MESSAGE_COMPILER]: "This project is using Custom Message Compiler, which is an experimental feature. It may receive breaking changes or be removed in the future."
};
function Dn(e, ...t) {
  return no(Jf[e], ...t);
}
const qf = "10.0.7", oo = -1, Hr = "en-US", Yr = "", vi = (e) => `${e.charAt(0).toLocaleUpperCase()}${e.substr(1)}`;
function ed() {
  return {
    upper: (e, t) => t === "text" && K(e) ? e.toUpperCase() : t === "vnode" && ve(e) && "__v_isVNode" in e ? e.children.toUpperCase() : e,
    lower: (e, t) => t === "text" && K(e) ? e.toLowerCase() : t === "vnode" && ve(e) && "__v_isVNode" in e ? e.children.toLowerCase() : e,
    capitalize: (e, t) => t === "text" && K(e) ? vi(e) : t === "vnode" && ve(e) && "__v_isVNode" in e ? vi(e.children) : e
  };
}
let gl;
function td(e) {
  gl = e;
}
let vl;
function nd(e) {
  vl = e;
}
let ml;
function rd(e) {
  ml = e;
}
let yl = null;
const od = /* @__NO_SIDE_EFFECTS__ */ (e) => {
  yl = e;
}, ad = /* @__NO_SIDE_EFFECTS__ */ () => yl;
let bl = null;
const mi = (e) => {
  bl = e;
}, id = () => bl;
let yi = 0;
function sd(e = {}) {
  const t = Oe(e.onWarn) ? e.onWarn : En, n = K(e.version) ? e.version : qf, r = K(e.locale) || Oe(e.locale) ? e.locale : Hr, o = Oe(r) ? Hr : r, a = Ue(e.fallbackLocale) || ge(e.fallbackLocale) || K(e.fallbackLocale) || e.fallbackLocale === !1 ? e.fallbackLocale : o, i = ge(e.messages) ? e.messages : Oo(o), s = ge(e.datetimeFormats) ? e.datetimeFormats : Oo(o), l = ge(e.numberFormats) ? e.numberFormats : Oo(o), u = Ye(_e(), e.modifiers, ed()), f = e.pluralRules || _e(), c = Oe(e.missing) ? e.missing : null, d = ke(e.missingWarn) || Wr(e.missingWarn) ? e.missingWarn : !0, h = ke(e.fallbackWarn) || Wr(e.fallbackWarn) ? e.fallbackWarn : !0, p = !!e.fallbackFormat, g = !!e.unresolving, E = Oe(e.postTranslation) ? e.postTranslation : null, v = ge(e.processor) ? e.processor : null, m = ke(e.warnHtmlMessage) ? e.warnHtmlMessage : !0, y = !!e.escapeParameter, _ = Oe(e.messageCompiler) ? e.messageCompiler : gl;
  process.env.NODE_ENV !== "production" && Oe(e.messageCompiler) && Uc(Dn(at.EXPERIMENTAL_CUSTOM_MESSAGE_COMPILER));
  const T = Oe(e.messageResolver) ? e.messageResolver : vl || Xf, N = Oe(e.localeFallbacker) ? e.localeFallbacker : ml || $f, I = ve(e.fallbackContext) ? e.fallbackContext : void 0, x = e, B = ve(x.__datetimeFormatters) ? x.__datetimeFormatters : /* @__PURE__ */ new Map(), H = ve(x.__numberFormatters) ? x.__numberFormatters : /* @__PURE__ */ new Map(), ee = ve(x.__meta) ? x.__meta : {};
  yi++;
  const L = {
    version: n,
    cid: yi,
    locale: r,
    fallbackLocale: a,
    messages: i,
    modifiers: u,
    pluralRules: f,
    missing: c,
    missingWarn: d,
    fallbackWarn: h,
    fallbackFormat: p,
    unresolving: g,
    postTranslation: E,
    processor: v,
    warnHtmlMessage: m,
    escapeParameter: y,
    messageCompiler: _,
    messageResolver: T,
    localeFallbacker: N,
    fallbackContext: I,
    onWarn: t,
    __meta: ee
  };
  return L.datetimeFormats = s, L.numberFormats = l, L.__datetimeFormatters = B, L.__numberFormatters = H, process.env.NODE_ENV !== "production" && (L.__v_emitter = x.__v_emitter != null ? x.__v_emitter : void 0), (process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__) && xf(L, n, ee), L;
}
const Oo = (e) => ({ [e]: _e() });
function ao(e, t) {
  return e instanceof RegExp ? e.test(t) : e;
}
function El(e, t) {
  return e instanceof RegExp ? e.test(t) : e;
}
function _a(e, t, n, r, o) {
  const { missing: a, onWarn: i } = e;
  if (process.env.NODE_ENV !== "production") {
    const s = e.__v_emitter;
    s && s.emit("missing", {
      locale: n,
      key: t,
      type: o,
      groupId: `${o}:${t}`
    });
  }
  if (a !== null) {
    const s = a(e, n, t, o);
    return K(s) ? s : t;
  } else
    return process.env.NODE_ENV !== "production" && El(r, t) && i(Dn(at.NOT_FOUND_KEY, { key: t, locale: n })), t;
}
function rr(e, t, n) {
  const r = e;
  r.__localeChainCache = /* @__PURE__ */ new Map(), e.localeFallbacker(e, n, t);
}
function Ml(e, t) {
  return e === t ? !1 : e.split("-")[0] === t.split("-")[0];
}
function ld(e, t) {
  const n = t.indexOf(e);
  if (n === -1)
    return !1;
  for (let r = n + 1; r < t.length; r++)
    if (Ml(e, t[r]))
      return !0;
  return !1;
}
const bi = typeof Intl < "u", _l = {
  dateTimeFormat: bi && typeof Intl.DateTimeFormat < "u",
  numberFormat: bi && typeof Intl.NumberFormat < "u"
};
function Ei(e, ...t) {
  const { datetimeFormats: n, unresolving: r, fallbackLocale: o, onWarn: a, localeFallbacker: i } = e, { __datetimeFormatters: s } = e;
  if (process.env.NODE_ENV !== "production" && !_l.dateTimeFormat)
    return a(Dn(at.CANNOT_FORMAT_DATE)), Yr;
  const [l, u, f, c] = Vo(...t), d = ke(f.missingWarn) ? f.missingWarn : e.missingWarn, h = ke(f.fallbackWarn) ? f.fallbackWarn : e.fallbackWarn, p = !!f.part, g = Ma(e, f), E = i(
    e,
    // eslint-disable-line @typescript-eslint/no-explicit-any
    o,
    g
  );
  if (!K(l) || l === "")
    return new Intl.DateTimeFormat(g, c).format(u);
  let v = {}, m, y = null, _ = g, T = null;
  const N = "datetime format";
  for (let B = 0; B < E.length; B++) {
    if (m = T = E[B], process.env.NODE_ENV !== "production" && g !== m && ao(h, l) && a(Dn(at.FALLBACK_TO_DATE_FORMAT, {
      key: l,
      target: m
    })), process.env.NODE_ENV !== "production" && g !== m) {
      const H = e.__v_emitter;
      H && H.emit("fallback", {
        type: N,
        key: l,
        from: _,
        to: T,
        groupId: `${N}:${l}`
      });
    }
    if (v = n[m] || {}, y = v[l], ge(y))
      break;
    _a(e, l, m, d, N), _ = T;
  }
  if (!ge(y) || !K(m))
    return r ? oo : l;
  let I = `${m}__${l}`;
  ro(c) || (I = `${I}__${JSON.stringify(c)}`);
  let x = s.get(I);
  return x || (x = new Intl.DateTimeFormat(m, Ye({}, y, c)), s.set(I, x)), p ? x.formatToParts(u) : x.format(u);
}
const wl = [
  "localeMatcher",
  "weekday",
  "era",
  "year",
  "month",
  "day",
  "hour",
  "minute",
  "second",
  "timeZoneName",
  "formatMatcher",
  "hour12",
  "timeZone",
  "dateStyle",
  "timeStyle",
  "calendar",
  "dayPeriod",
  "numberingSystem",
  "hourCycle",
  "fractionalSecondDigits"
];
function Vo(...e) {
  const [t, n, r, o] = e, a = _e();
  let i = _e(), s;
  if (K(t)) {
    const l = t.match(/(\d{4}-\d{2}-\d{2})(T|\s)?(.*)/);
    if (!l)
      throw Xt(Je.INVALID_ISO_DATE_ARGUMENT);
    const u = l[3] ? l[3].trim().startsWith("T") ? `${l[1].trim()}${l[3].trim()}` : `${l[1].trim()}T${l[3].trim()}` : l[1].trim();
    s = new Date(u);
    try {
      s.toISOString();
    } catch {
      throw Xt(Je.INVALID_ISO_DATE_ARGUMENT);
    }
  } else if (Fc(t)) {
    if (isNaN(t.getTime()))
      throw Xt(Je.INVALID_DATE_ARGUMENT);
    s = t;
  } else if (He(t))
    s = t;
  else
    throw Xt(Je.INVALID_ARGUMENT);
  return K(n) ? a.key = n : ge(n) && Object.keys(n).forEach((l) => {
    wl.includes(l) ? i[l] = n[l] : a[l] = n[l];
  }), K(r) ? a.locale = r : ge(r) && (i = r), ge(o) && (i = o), [a.key || "", s, a, i];
}
function Mi(e, t, n) {
  const r = e;
  for (const o in n) {
    const a = `${t}__${o}`;
    r.__datetimeFormatters.has(a) && r.__datetimeFormatters.delete(a);
  }
}
function _i(e, ...t) {
  const { numberFormats: n, unresolving: r, fallbackLocale: o, onWarn: a, localeFallbacker: i } = e, { __numberFormatters: s } = e;
  if (process.env.NODE_ENV !== "production" && !_l.numberFormat)
    return a(Dn(at.CANNOT_FORMAT_NUMBER)), Yr;
  const [l, u, f, c] = Uo(...t), d = ke(f.missingWarn) ? f.missingWarn : e.missingWarn, h = ke(f.fallbackWarn) ? f.fallbackWarn : e.fallbackWarn, p = !!f.part, g = Ma(e, f), E = i(
    e,
    // eslint-disable-line @typescript-eslint/no-explicit-any
    o,
    g
  );
  if (!K(l) || l === "")
    return new Intl.NumberFormat(g, c).format(u);
  let v = {}, m, y = null, _ = g, T = null;
  const N = "number format";
  for (let B = 0; B < E.length; B++) {
    if (m = T = E[B], process.env.NODE_ENV !== "production" && g !== m && ao(h, l) && a(Dn(at.FALLBACK_TO_NUMBER_FORMAT, {
      key: l,
      target: m
    })), process.env.NODE_ENV !== "production" && g !== m) {
      const H = e.__v_emitter;
      H && H.emit("fallback", {
        type: N,
        key: l,
        from: _,
        to: T,
        groupId: `${N}:${l}`
      });
    }
    if (v = n[m] || {}, y = v[l], ge(y))
      break;
    _a(e, l, m, d, N), _ = T;
  }
  if (!ge(y) || !K(m))
    return r ? oo : l;
  let I = `${m}__${l}`;
  ro(c) || (I = `${I}__${JSON.stringify(c)}`);
  let x = s.get(I);
  return x || (x = new Intl.NumberFormat(m, Ye({}, y, c)), s.set(I, x)), p ? x.formatToParts(u) : x.format(u);
}
const Tl = [
  "localeMatcher",
  "style",
  "currency",
  "currencyDisplay",
  "currencySign",
  "useGrouping",
  "minimumIntegerDigits",
  "minimumFractionDigits",
  "maximumFractionDigits",
  "minimumSignificantDigits",
  "maximumSignificantDigits",
  "compactDisplay",
  "notation",
  "signDisplay",
  "unit",
  "unitDisplay",
  "roundingMode",
  "roundingPriority",
  "roundingIncrement",
  "trailingZeroDisplay"
];
function Uo(...e) {
  const [t, n, r, o] = e, a = _e();
  let i = _e();
  if (!He(t))
    throw Xt(Je.INVALID_ARGUMENT);
  const s = t;
  return K(n) ? a.key = n : ge(n) && Object.keys(n).forEach((l) => {
    Tl.includes(l) ? i[l] = n[l] : a[l] = n[l];
  }), K(r) ? a.locale = r : ge(r) && (i = r), ge(o) && (i = o), [a.key || "", s, a, i];
}
function wi(e, t, n) {
  const r = e;
  for (const o in n) {
    const a = `${t}__${o}`;
    r.__numberFormatters.has(a) && r.__numberFormatters.delete(a);
  }
}
const ud = (e) => e, cd = (e) => "", fd = "text", dd = (e) => e.length === 0 ? "" : ya(e), pd = zc;
function Ti(e, t) {
  return e = Math.abs(e), t === 2 ? e ? e > 1 ? 1 : 0 : 1 : e ? Math.min(e, 2) : 0;
}
function hd(e) {
  const t = He(e.pluralIndex) ? e.pluralIndex : -1;
  return e.named && (He(e.named.count) || He(e.named.n)) ? He(e.named.count) ? e.named.count : He(e.named.n) ? e.named.n : t : t;
}
function gd(e, t) {
  t.count || (t.count = e), t.n || (t.n = e);
}
function vd(e = {}) {
  const t = e.locale, n = hd(e), r = ve(e.pluralRules) && K(t) && Oe(e.pluralRules[t]) ? e.pluralRules[t] : Ti, o = ve(e.pluralRules) && K(t) && Oe(e.pluralRules[t]) ? Ti : void 0, a = (v) => v[r(n, v.length, o)], i = e.list || [], s = (v) => i[v], l = e.named || _e();
  He(e.pluralIndex) && gd(n, l);
  const u = (v) => l[v];
  function f(v, m) {
    const y = Oe(e.messages) ? e.messages(v, !!m) : ve(e.messages) ? e.messages[v] : !1;
    return y || (e.parent ? e.parent.message(v) : cd);
  }
  const c = (v) => e.modifiers ? e.modifiers[v] : ud, d = ge(e.processor) && Oe(e.processor.normalize) ? e.processor.normalize : dd, h = ge(e.processor) && Oe(e.processor.interpolate) ? e.processor.interpolate : pd, p = ge(e.processor) && K(e.processor.type) ? e.processor.type : fd, E = {
    list: s,
    named: u,
    plural: a,
    linked: (v, ...m) => {
      const [y, _] = m;
      let T = "text", N = "";
      m.length === 1 ? ve(y) ? (N = y.modifier || N, T = y.type || T) : K(y) && (N = y || N) : m.length === 2 && (K(y) && (N = y || N), K(_) && (T = _ || T));
      const I = f(v, !0)(E), x = (
        // The message in vnode resolved with linked are returned as an array by processor.nomalize
        T === "vnode" && Ue(I) && N ? I[0] : I
      );
      return N ? c(N)(x, T) : x;
    },
    message: f,
    type: p,
    interpolate: h,
    normalize: d,
    values: Ye(_e(), i, l)
  };
  return E;
}
const Ci = () => "", gt = (e) => Oe(e);
function Oi(e, ...t) {
  const { fallbackFormat: n, postTranslation: r, unresolving: o, messageCompiler: a, fallbackLocale: i, messages: s } = e, [l, u] = Wo(...t), f = ke(u.missingWarn) ? u.missingWarn : e.missingWarn, c = ke(u.fallbackWarn) ? u.fallbackWarn : e.fallbackWarn, d = ke(u.escapeParameter) ? u.escapeParameter : e.escapeParameter, h = !!u.resolvedMessage, p = K(u.default) || ke(u.default) ? ke(u.default) ? a ? l : () => l : u.default : n ? a ? l : () => l : null, g = n || p != null && (K(p) || Oe(p)), E = Ma(e, u);
  d && md(u);
  let [v, m, y] = h ? [
    l,
    E,
    s[E] || _e()
  ] : Cl(e, l, E, i, c, f), _ = v, T = l;
  if (!h && !(K(_) || It(_) || gt(_)) && g && (_ = p, T = _), !h && (!(K(_) || It(_) || gt(_)) || !K(m)))
    return o ? oo : l;
  if (process.env.NODE_ENV !== "production" && K(_) && e.messageCompiler == null)
    return En(`The message format compilation is not supported in this build. Because message compiler isn't included. You need to pre-compilation all message format. So translate function return '${l}'.`), l;
  let N = !1;
  const I = () => {
    N = !0;
  }, x = gt(_) ? _ : Ol(e, l, m, _, T, I);
  if (N)
    return _;
  const B = Md(e, m, y, u), H = vd(B), ee = yd(e, x, H), L = r ? r(ee, l) : ee;
  if (process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__) {
    const V = {
      timestamp: Date.now(),
      key: K(l) ? l : gt(_) ? _.key : "",
      locale: m || (gt(_) ? _.locale : ""),
      format: K(_) ? _ : gt(_) ? _.source : "",
      message: L
    };
    V.meta = Ye({}, e.__meta, /* @__PURE__ */ ad() || {}), Rf(V);
  }
  return L;
}
function md(e) {
  Ue(e.list) ? e.list = e.list.map((t) => K(t) ? ii(t) : t) : ve(e.named) && Object.keys(e.named).forEach((t) => {
    K(e.named[t]) && (e.named[t] = ii(e.named[t]));
  });
}
function Cl(e, t, n, r, o, a) {
  const { messages: i, onWarn: s, messageResolver: l, localeFallbacker: u } = e, f = u(e, r, n);
  let c = _e(), d, h = null, p = n, g = null;
  const E = "translate";
  for (let v = 0; v < f.length; v++) {
    if (d = g = f[v], process.env.NODE_ENV !== "production" && n !== d && !Ml(n, d) && ao(o, t) && s(Dn(at.FALLBACK_TO_TRANSLATE, {
      key: t,
      target: d
    })), process.env.NODE_ENV !== "production" && n !== d) {
      const T = e.__v_emitter;
      T && T.emit("fallback", {
        type: E,
        key: t,
        from: p,
        to: g,
        groupId: `${E}:${t}`
      });
    }
    c = i[d] || _e();
    let m = null, y, _;
    if (process.env.NODE_ENV !== "production" && qt && (m = window.performance.now(), y = "intlify-message-resolve-start", _ = "intlify-message-resolve-end", dt && dt(y)), (h = l(c, t)) === null && (h = c[t]), process.env.NODE_ENV !== "production" && qt) {
      const T = window.performance.now(), N = e.__v_emitter;
      N && m && h && N.emit("message-resolve", {
        type: "message-resolve",
        key: t,
        message: h,
        time: T - m,
        groupId: `${E}:${t}`
      }), y && _ && dt && Pn && (dt(_), Pn("intlify message resolve", y, _));
    }
    if (K(h) || It(h) || gt(h))
      break;
    if (!ld(d, f)) {
      const T = _a(
        e,
        // eslint-disable-line @typescript-eslint/no-explicit-any
        t,
        d,
        a,
        E
      );
      T !== t && (h = T);
    }
    p = g;
  }
  return [h, d, c];
}
function Ol(e, t, n, r, o, a) {
  const { messageCompiler: i, warnHtmlMessage: s } = e;
  if (gt(r)) {
    const d = r;
    return d.locale = d.locale || n, d.key = d.key || t, d;
  }
  if (i == null) {
    const d = () => r;
    return d.locale = n, d.key = t, d;
  }
  let l = null, u, f;
  process.env.NODE_ENV !== "production" && qt && (l = window.performance.now(), u = "intlify-message-compilation-start", f = "intlify-message-compilation-end", dt && dt(u));
  const c = i(r, bd(e, n, o, r, s, a));
  if (process.env.NODE_ENV !== "production" && qt) {
    const d = window.performance.now(), h = e.__v_emitter;
    h && l && h.emit("message-compilation", {
      type: "message-compilation",
      message: r,
      time: d - l,
      groupId: `translate:${t}`
    }), u && f && dt && Pn && (dt(f), Pn("intlify message compilation", u, f));
  }
  return c.locale = n, c.key = t, c.source = r, c;
}
function yd(e, t, n) {
  let r = null, o, a;
  process.env.NODE_ENV !== "production" && qt && (r = window.performance.now(), o = "intlify-message-evaluation-start", a = "intlify-message-evaluation-end", dt && dt(o));
  const i = t(n);
  if (process.env.NODE_ENV !== "production" && qt) {
    const s = window.performance.now(), l = e.__v_emitter;
    l && r && l.emit("message-evaluation", {
      type: "message-evaluation",
      value: i,
      time: s - r,
      groupId: `translate:${t.key}`
    }), o && a && dt && Pn && (dt(a), Pn("intlify message evaluation", o, a));
  }
  return i;
}
function Wo(...e) {
  const [t, n, r] = e, o = _e();
  if (!K(t) && !He(t) && !gt(t) && !It(t))
    throw Xt(Je.INVALID_ARGUMENT);
  const a = He(t) ? String(t) : (gt(t), t);
  return He(n) ? o.plural = n : K(n) ? o.default = n : ge(n) && !ro(n) ? o.named = n : Ue(n) && (o.list = n), He(r) ? o.plural = r : K(r) ? o.default = r : ge(r) && Ye(o, r), [a, o];
}
function bd(e, t, n, r, o, a) {
  return {
    locale: t,
    key: n,
    warnHtmlMessage: o,
    onError: (i) => {
      if (a && a(i), process.env.NODE_ENV !== "production") {
        const s = Ed(r), l = `Message compilation error: ${i.message}`, u = i.location && s && Vc(s, i.location.start.offset, i.location.end.offset), f = e.__v_emitter;
        f && s && f.emit("compile-error", {
          message: s,
          error: i.message,
          start: i.location && i.location.start.offset,
          end: i.location && i.location.end.offset,
          groupId: `translate:${n}`
        }), console.error(u ? `${l}
${u}` : l);
      } else
        throw i;
    },
    onCacheKey: (i) => xc(t, n, i)
  };
}
function Ed(e) {
  if (K(e))
    return e;
  if (e.loc && e.loc.source)
    return e.loc.source;
}
function Md(e, t, n, r) {
  const { modifiers: o, pluralRules: a, messageResolver: i, fallbackLocale: s, fallbackWarn: l, missingWarn: u, fallbackContext: f } = e, d = {
    locale: t,
    modifiers: o,
    pluralRules: a,
    messages: (h, p) => {
      let g = i(n, h);
      if (g == null && (f || p)) {
        const [, , E] = Cl(
          f || e,
          // NOTE: if has fallbackContext, fallback to root, else if use linked, fallback to local context
          h,
          t,
          s,
          l,
          u
        );
        g = i(E, h);
      }
      if (K(g) || It(g)) {
        let E = !1;
        const m = Ol(e, h, t, g, h, () => {
          E = !0;
        });
        return E ? Ci : m;
      } else return gt(g) ? g : Ci;
    }
  };
  return e.processor && (d.processor = e.processor), r.list && (d.list = r.list), r.named && (d.named = r.named), He(r.plural) && (d.pluralIndex = r.plural), d;
}
Mf();
/*!
  * vue-i18n v10.0.7
  * (c) 2025 kazuya kawaguchi
  * Released under the MIT License.
  */
const _d = "10.0.7";
function wd() {
  typeof __VUE_I18N_FULL_INSTALL__ != "boolean" && (In().__VUE_I18N_FULL_INSTALL__ = !0), typeof __VUE_I18N_LEGACY_API__ != "boolean" && (In().__VUE_I18N_LEGACY_API__ = !0), typeof __INTLIFY_DROP_MESSAGE_COMPILER__ != "boolean" && (In().__INTLIFY_DROP_MESSAGE_COMPILER__ = !1), typeof __INTLIFY_PROD_DEVTOOLS__ != "boolean" && (In().__INTLIFY_PROD_DEVTOOLS__ = !1);
}
const Nn = {
  FALLBACK_TO_ROOT: Zf,
  // 8
  NOT_FOUND_PARENT_SCOPE: 9,
  IGNORE_OBJ_FLATTEN: 10,
  DEPRECATE_TC: 11
}, Td = {
  [Nn.FALLBACK_TO_ROOT]: "Fall back to {type} '{key}' with root locale.",
  [Nn.NOT_FOUND_PARENT_SCOPE]: "Not found parent scope. use the global scope.",
  [Nn.IGNORE_OBJ_FLATTEN]: "Ignore object flatten: '{key}' key has an string value",
  [Nn.DEPRECATE_TC]: "'tc' and '$tc' has been deprecated in v10. Use 't' or '$t' instead. 'tc' and '$tc’ are going to remove in v11."
};
function wa(e, ...t) {
  return no(Td[e], ...t);
}
const Ke = {
  // composer module errors
  UNEXPECTED_RETURN_TYPE: jf,
  // 24
  // legacy module errors
  INVALID_ARGUMENT: 25,
  // i18n module errors
  MUST_BE_CALL_SETUP_TOP: 26,
  NOT_INSTALLED: 27,
  // directive module errors
  REQUIRED_VALUE: 28,
  INVALID_VALUE: 29,
  // vue-devtools errors
  CANNOT_SETUP_VUE_DEVTOOLS_PLUGIN: 30,
  NOT_INSTALLED_WITH_PROVIDE: 31,
  // unexpected error
  UNEXPECTED_ERROR: 32,
  // not compatible legacy vue-i18n constructor
  NOT_COMPATIBLE_LEGACY_VUE_I18N: 33,
  // Not available Compostion API in Legacy API mode. Please make sure that the legacy API mode is working properly
  NOT_AVAILABLE_COMPOSITION_IN_LEGACY: 34
};
function vr(e, ...t) {
  return Jn(e, null, process.env.NODE_ENV !== "production" ? { messages: Cd, args: t } : void 0);
}
const Cd = {
  [Ke.UNEXPECTED_RETURN_TYPE]: "Unexpected return type in composer",
  [Ke.INVALID_ARGUMENT]: "Invalid argument",
  [Ke.MUST_BE_CALL_SETUP_TOP]: "Must be called at the top of a `setup` function",
  [Ke.NOT_INSTALLED]: "Need to install with `app.use` function",
  [Ke.UNEXPECTED_ERROR]: "Unexpected error",
  [Ke.REQUIRED_VALUE]: "Required in value: {0}",
  [Ke.INVALID_VALUE]: "Invalid value",
  [Ke.CANNOT_SETUP_VUE_DEVTOOLS_PLUGIN]: "Cannot setup vue-devtools plugin",
  [Ke.NOT_INSTALLED_WITH_PROVIDE]: "Need to install with `provide` function",
  [Ke.NOT_COMPATIBLE_LEGACY_VUE_I18N]: "Not compatible legacy VueI18n.",
  [Ke.NOT_AVAILABLE_COMPOSITION_IN_LEGACY]: "Not available Compostion API in Legacy API mode. Please make sure that the legacy API mode is working properly"
}, Ho = /* @__PURE__ */ tn("__translateVNode"), Yo = /* @__PURE__ */ tn("__datetimeParts"), Go = /* @__PURE__ */ tn("__numberParts"), Ko = /* @__PURE__ */ tn("__enableEmitter"), Xo = /* @__PURE__ */ tn("__disableEmitter"), Od = tn("__setPluralRules"), Il = /* @__PURE__ */ tn("__injectWithOption"), Qo = /* @__PURE__ */ tn("__dispose");
function mr(e) {
  if (!ve(e) || It(e))
    return e;
  for (const t in e)
    if (Ct(e, t))
      if (!t.includes("."))
        ve(e[t]) && mr(e[t]);
      else {
        const n = t.split("."), r = n.length - 1;
        let o = e, a = !1;
        for (let i = 0; i < r; i++) {
          if (n[i] === "__proto__")
            throw new Error(`unsafe key: ${n[i]}`);
          if (n[i] in o || (o[n[i]] = _e()), !ve(o[n[i]])) {
            process.env.NODE_ENV !== "production" && En(wa(Nn.IGNORE_OBJ_FLATTEN, {
              key: n[i]
            })), a = !0;
            break;
          }
          o = o[n[i]];
        }
        if (a || (It(o) ? pl.includes(n[r]) || delete e[t] : (o[n[r]] = e[t], delete e[t])), !It(o)) {
          const i = o[n[r]];
          ve(i) && mr(i);
        }
      }
  return e;
}
function Nl(e, t) {
  const { messages: n, __i18n: r, messageResolver: o, flatJson: a } = t, i = ge(n) ? n : Ue(r) ? _e() : { [e]: _e() };
  if (Ue(r) && r.forEach((s) => {
    if ("locale" in s && "resource" in s) {
      const { locale: l, resource: u } = s;
      l ? (i[l] = i[l] || _e(), zr(u, i[l])) : zr(u, i);
    } else
      K(s) && zr(JSON.parse(s), i);
  }), o == null && a)
    for (const s in i)
      Ct(i, s) && mr(i[s]);
  return i;
}
function Sl(e) {
  return e.type;
}
function Id(e, t, n) {
  let r = ve(t.messages) ? t.messages : _e();
  "__i18nGlobal" in n && (r = Nl(e.locale.value, {
    messages: r,
    __i18n: n.__i18nGlobal
  }));
  const o = Object.keys(r);
  o.length && o.forEach((a) => {
    e.mergeLocaleMessage(a, r[a]);
  });
  {
    if (ve(t.datetimeFormats)) {
      const a = Object.keys(t.datetimeFormats);
      a.length && a.forEach((i) => {
        e.mergeDateTimeFormat(i, t.datetimeFormats[i]);
      });
    }
    if (ve(t.numberFormats)) {
      const a = Object.keys(t.numberFormats);
      a.length && a.forEach((i) => {
        e.mergeNumberFormat(i, t.numberFormats[i]);
      });
    }
  }
}
function Ii(e) {
  return Ee(pa, null, e, 0);
}
const Ni = "__INTLIFY_META__", Si = () => [], Nd = () => !1;
let Ai = 0;
function Li(e) {
  return (t, n, r, o) => e(n, r, We() || void 0, o);
}
const Sd = /* @__NO_SIDE_EFFECTS__ */ () => {
  const e = We();
  let t = null;
  return e && (t = Sl(e)[Ni]) ? { [Ni]: t } : null;
};
function Ad(e = {}) {
  const { __root: t, __injectWithOption: n } = e, r = t === void 0, o = e.flatJson, a = qt ? R : vn;
  let i = ke(e.inheritLocale) ? e.inheritLocale : !0;
  const s = a(
    // prettier-ignore
    t && i ? t.locale.value : K(e.locale) ? e.locale : Hr
  ), l = a(
    // prettier-ignore
    t && i ? t.fallbackLocale.value : K(e.fallbackLocale) || Ue(e.fallbackLocale) || ge(e.fallbackLocale) || e.fallbackLocale === !1 ? e.fallbackLocale : s.value
  ), u = a(Nl(s.value, e)), f = a(ge(e.datetimeFormats) ? e.datetimeFormats : { [s.value]: {} }), c = a(ge(e.numberFormats) ? e.numberFormats : { [s.value]: {} });
  let d = t ? t.missingWarn : ke(e.missingWarn) || Wr(e.missingWarn) ? e.missingWarn : !0, h = t ? t.fallbackWarn : ke(e.fallbackWarn) || Wr(e.fallbackWarn) ? e.fallbackWarn : !0, p = t ? t.fallbackRoot : ke(e.fallbackRoot) ? e.fallbackRoot : !0, g = !!e.fallbackFormat, E = Oe(e.missing) ? e.missing : null, v = Oe(e.missing) ? Li(e.missing) : null, m = Oe(e.postTranslation) ? e.postTranslation : null, y = t ? t.warnHtmlMessage : ke(e.warnHtmlMessage) ? e.warnHtmlMessage : !0, _ = !!e.escapeParameter;
  const T = t ? t.modifiers : ge(e.modifiers) ? e.modifiers : {};
  let N = e.pluralRules || t && t.pluralRules, I;
  I = (() => {
    r && mi(null);
    const S = {
      version: _d,
      locale: s.value,
      fallbackLocale: l.value,
      messages: u.value,
      modifiers: T,
      pluralRules: N,
      missing: v === null ? void 0 : v,
      missingWarn: d,
      fallbackWarn: h,
      fallbackFormat: g,
      unresolving: !0,
      postTranslation: m === null ? void 0 : m,
      warnHtmlMessage: y,
      escapeParameter: _,
      messageResolver: e.messageResolver,
      messageCompiler: e.messageCompiler,
      __meta: { framework: "vue" }
    };
    S.datetimeFormats = f.value, S.numberFormats = c.value, S.__datetimeFormatters = ge(I) ? I.__datetimeFormatters : void 0, S.__numberFormatters = ge(I) ? I.__numberFormatters : void 0, process.env.NODE_ENV !== "production" && (S.__v_emitter = ge(I) ? I.__v_emitter : void 0);
    const F = sd(S);
    return r && mi(F), F;
  })(), rr(I, s.value, l.value);
  function B() {
    return [
      s.value,
      l.value,
      u.value,
      f.value,
      c.value
    ];
  }
  const H = D({
    get: () => s.value,
    set: (S) => {
      s.value = S, I.locale = s.value;
    }
  }), ee = D({
    get: () => l.value,
    set: (S) => {
      l.value = S, I.fallbackLocale = l.value, rr(I, s.value, S);
    }
  }), L = D(() => u.value), V = /* @__PURE__ */ D(() => f.value), me = /* @__PURE__ */ D(() => c.value);
  function fe() {
    return Oe(m) ? m : null;
  }
  function ie(S) {
    m = S, I.postTranslation = S;
  }
  function ne() {
    return E;
  }
  function G(S) {
    S !== null && (v = Li(S)), E = S, I.missing = v;
  }
  function pe(S, F) {
    return S !== "translate" || !F.resolvedMessage;
  }
  const he = (S, F, se, ye, Pt, Dt) => {
    B();
    let an;
    try {
      process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__, r || (I.fallbackContext = t ? id() : void 0), an = S(I);
    } finally {
      process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__, r || (I.fallbackContext = void 0);
    }
    if (se !== "translate exists" && // for not `te` (e.g `t`)
    He(an) && an === oo || se === "translate exists" && !an) {
      const [Vt, wo] = F();
      if (process.env.NODE_ENV !== "production" && t && K(Vt) && pe(se, wo) && (p && (ao(h, Vt) || El(d, Vt)) && En(wa(Nn.FALLBACK_TO_ROOT, {
        key: Vt,
        type: se
      })), process.env.NODE_ENV !== "production")) {
        const { __v_emitter: er } = I;
        er && p && er.emit("fallback", {
          type: se,
          key: Vt,
          to: "global",
          groupId: `${se}:${Vt}`
        });
      }
      return t && p ? ye(t) : Pt(Vt);
    } else {
      if (Dt(an))
        return an;
      throw vr(Ke.UNEXPECTED_RETURN_TYPE);
    }
  };
  function Ie(...S) {
    return he((F) => Reflect.apply(Oi, null, [F, ...S]), () => Wo(...S), "translate", (F) => Reflect.apply(F.t, F, [...S]), (F) => F, (F) => K(F));
  }
  function je(...S) {
    const [F, se, ye] = S;
    if (ye && !ve(ye))
      throw vr(Ke.INVALID_ARGUMENT);
    return Ie(F, se, Ye({ resolvedMessage: !0 }, ye || {}));
  }
  function Ge(...S) {
    return he((F) => Reflect.apply(Ei, null, [F, ...S]), () => Vo(...S), "datetime format", (F) => Reflect.apply(F.d, F, [...S]), () => Yr, (F) => K(F));
  }
  function Pe(...S) {
    return he((F) => Reflect.apply(_i, null, [F, ...S]), () => Uo(...S), "number format", (F) => Reflect.apply(F.n, F, [...S]), () => Yr, (F) => K(F));
  }
  function Se(S) {
    return S.map((F) => K(F) || He(F) || ke(F) ? Ii(String(F)) : F);
  }
  const O = {
    normalize: Se,
    interpolate: (S) => S,
    type: "vnode"
  };
  function A(...S) {
    return he((F) => {
      let se;
      const ye = F;
      try {
        ye.processor = O, se = Reflect.apply(Oi, null, [ye, ...S]);
      } finally {
        ye.processor = null;
      }
      return se;
    }, () => Wo(...S), "translate", (F) => F[Ho](...S), (F) => [Ii(F)], (F) => Ue(F));
  }
  function W(...S) {
    return he((F) => Reflect.apply(_i, null, [F, ...S]), () => Uo(...S), "number format", (F) => F[Go](...S), Si, (F) => K(F) || Ue(F));
  }
  function de(...S) {
    return he((F) => Reflect.apply(Ei, null, [F, ...S]), () => Vo(...S), "datetime format", (F) => F[Yo](...S), Si, (F) => K(F) || Ue(F));
  }
  function we(S) {
    N = S, I.pluralRules = N;
  }
  function $e(S, F) {
    return he(() => {
      if (!S)
        return !1;
      const se = K(F) ? F : s.value, ye = Ae(se), Pt = I.messageResolver(ye, S);
      return It(Pt) || gt(Pt) || K(Pt);
    }, () => [S], "translate exists", (se) => Reflect.apply(se.te, se, [S, F]), Nd, (se) => ke(se));
  }
  function Te(S) {
    let F = null;
    const se = hl(I, l.value, s.value);
    for (let ye = 0; ye < se.length; ye++) {
      const Pt = u.value[se[ye]] || {}, Dt = I.messageResolver(Pt, S);
      if (Dt != null) {
        F = Dt;
        break;
      }
    }
    return F;
  }
  function ze(S) {
    const F = Te(S);
    return F ?? (t ? t.tm(S) || {} : {});
  }
  function Ae(S) {
    return u.value[S] || {};
  }
  function De(S, F) {
    if (o) {
      const se = { [S]: F };
      for (const ye in se)
        Ct(se, ye) && mr(se[ye]);
      F = se[S];
    }
    u.value[S] = F, I.messages = u.value;
  }
  function ht(S, F) {
    u.value[S] = u.value[S] || {};
    const se = { [S]: F };
    if (o)
      for (const ye in se)
        Ct(se, ye) && mr(se[ye]);
    F = se[S], zr(F, u.value[S]), I.messages = u.value;
  }
  function M(S) {
    return f.value[S] || {};
  }
  function C(S, F) {
    f.value[S] = F, I.datetimeFormats = f.value, Mi(I, S, F);
  }
  function w(S, F) {
    f.value[S] = Ye(f.value[S] || {}, F), I.datetimeFormats = f.value, Mi(I, S, F);
  }
  function $(S) {
    return c.value[S] || {};
  }
  function re(S, F) {
    c.value[S] = F, I.numberFormats = c.value, wi(I, S, F);
  }
  function be(S, F) {
    c.value[S] = Ye(c.value[S] || {}, F), I.numberFormats = c.value, wi(I, S, F);
  }
  Ai++, t && qt && (Q(t.locale, (S) => {
    i && (s.value = S, I.locale = S, rr(I, s.value, l.value));
  }), Q(t.fallbackLocale, (S) => {
    i && (l.value = S, I.fallbackLocale = S, rr(I, s.value, l.value));
  }));
  const k = {
    id: Ai,
    locale: H,
    fallbackLocale: ee,
    get inheritLocale() {
      return i;
    },
    set inheritLocale(S) {
      i = S, S && t && (s.value = t.locale.value, l.value = t.fallbackLocale.value, rr(I, s.value, l.value));
    },
    get availableLocales() {
      return Object.keys(u.value).sort();
    },
    messages: L,
    get modifiers() {
      return T;
    },
    get pluralRules() {
      return N || {};
    },
    get isGlobal() {
      return r;
    },
    get missingWarn() {
      return d;
    },
    set missingWarn(S) {
      d = S, I.missingWarn = d;
    },
    get fallbackWarn() {
      return h;
    },
    set fallbackWarn(S) {
      h = S, I.fallbackWarn = h;
    },
    get fallbackRoot() {
      return p;
    },
    set fallbackRoot(S) {
      p = S;
    },
    get fallbackFormat() {
      return g;
    },
    set fallbackFormat(S) {
      g = S, I.fallbackFormat = g;
    },
    get warnHtmlMessage() {
      return y;
    },
    set warnHtmlMessage(S) {
      y = S, I.warnHtmlMessage = S;
    },
    get escapeParameter() {
      return _;
    },
    set escapeParameter(S) {
      _ = S, I.escapeParameter = S;
    },
    t: Ie,
    getLocaleMessage: Ae,
    setLocaleMessage: De,
    mergeLocaleMessage: ht,
    getPostTranslationHandler: fe,
    setPostTranslationHandler: ie,
    getMissingHandler: ne,
    setMissingHandler: G,
    [Od]: we
  };
  return k.datetimeFormats = V, k.numberFormats = me, k.rt = je, k.te = $e, k.tm = ze, k.d = Ge, k.n = Pe, k.getDateTimeFormat = M, k.setDateTimeFormat = C, k.mergeDateTimeFormat = w, k.getNumberFormat = $, k.setNumberFormat = re, k.mergeNumberFormat = be, k[Il] = n, k[Ho] = A, k[Yo] = de, k[Go] = W, process.env.NODE_ENV !== "production" && (k[Ko] = (S) => {
    I.__v_emitter = S;
  }, k[Xo] = () => {
    I.__v_emitter = void 0;
  }), k;
}
function Pi(e, t) {
}
const Ta = {
  tag: {
    type: [String, Object]
  },
  locale: {
    type: String
  },
  scope: {
    type: String,
    // NOTE: avoid https://github.com/microsoft/rushstack/issues/1050
    validator: (e) => e === "parent" || e === "global",
    default: "parent"
    /* ComponentI18nScope */
  },
  i18n: {
    type: Object
  }
};
function Ld({ slots: e }, t) {
  return t.length === 1 && t[0] === "default" ? (e.default ? e.default() : []).reduce((r, o) => [
    ...r,
    // prettier-ignore
    ...o.type === Xe ? o.children : [o]
  ], []) : t.reduce((n, r) => {
    const o = e[r];
    return o && (n[r] = o()), n;
  }, _e());
}
function Al() {
  return Xe;
}
Ye({
  keypath: {
    type: String,
    required: !0
  },
  plural: {
    type: [Number, String],
    validator: (e) => He(e) || !isNaN(e)
  }
}, Ta);
function Pd(e) {
  return Ue(e) && !K(e[0]);
}
function Ll(e, t, n, r) {
  const { slots: o, attrs: a } = t;
  return () => {
    const i = { part: !0 };
    let s = _e();
    e.locale && (i.locale = e.locale), K(e.format) ? i.key = e.format : ve(e.format) && (K(e.format.key) && (i.key = e.format.key), s = Object.keys(e.format).reduce((d, h) => n.includes(h) ? Ye(_e(), d, { [h]: e.format[h] }) : d, _e()));
    const l = r(e.value, i, s);
    let u = [i.key];
    Ue(l) ? u = l.map((d, h) => {
      const p = o[d.type], g = p ? p({ [d.type]: d.value, index: h, parts: l }) : [d.value];
      return Pd(g) && (g[0].key = `${d.type}-${h}`), g;
    }) : K(l) && (u = [l]);
    const f = Ye(_e(), a), c = K(e.tag) || ve(e.tag) ? e.tag : Al();
    return Js(c, f, u);
  };
}
Ye({
  value: {
    type: Number,
    required: !0
  },
  format: {
    type: [String, Object]
  }
}, Ta);
Ye({
  value: {
    type: [Number, Date],
    required: !0
  },
  format: {
    type: [String, Object]
  }
}, Ta);
const Dd = /* @__PURE__ */ tn("global-vue-i18n");
function wn(e = {}) {
  const t = We();
  if (t == null)
    throw vr(Ke.MUST_BE_CALL_SETUP_TOP);
  if (!t.isCE && t.appContext.app != null && !t.appContext.app.__VUE_I18N_SYMBOL__)
    throw vr(Ke.NOT_INSTALLED);
  const n = kd(t), r = Rd(n), o = Sl(t), a = xd(e, o);
  if (a === "global")
    return Id(r, e, o), r;
  if (a === "parent") {
    let l = Fd(n, t, e.__useComponent);
    return l == null && (process.env.NODE_ENV !== "production" && En(wa(Nn.NOT_FOUND_PARENT_SCOPE)), l = r), l;
  }
  const i = n;
  let s = i.__getInstance(t);
  if (s == null) {
    const l = Ye({}, e);
    "__i18n" in o && (l.__i18n = o.__i18n), r && (l.__root = r), s = Ad(l), i.__composerExtend && (s[Qo] = i.__composerExtend(s)), Bd(i, t, s), i.__setInstance(t, s);
  }
  return s;
}
function kd(e) {
  const t = Me(e.isCE ? Dd : e.appContext.app.__VUE_I18N_SYMBOL__);
  if (!t)
    throw vr(e.isCE ? Ke.NOT_INSTALLED_WITH_PROVIDE : Ke.UNEXPECTED_ERROR);
  return t;
}
function xd(e, t) {
  return ro(e) ? "__i18n" in t ? "local" : "global" : e.useScope ? e.useScope : "local";
}
function Rd(e) {
  return e.mode === "composition" ? e.global : e.global.__composer;
}
function Fd(e, t, n = !1) {
  let r = null;
  const o = t.root;
  let a = jd(t, n);
  for (; a != null; ) {
    const i = e;
    if (e.mode === "composition")
      r = i.__getInstance(a);
    else if (__VUE_I18N_LEGACY_API__) {
      const s = i.__getInstance(a);
      s != null && (r = s.__composer, n && r && !r[Il] && (r = null));
    }
    if (r != null || o === a)
      break;
    a = a.parent;
  }
  return r;
}
function jd(e, t = !1) {
  return e == null ? null : t && e.vnode.ctx || e.parent;
}
function Bd(e, t, n) {
  let r = null;
  xe(() => {
    if (process.env.NODE_ENV !== "production" && t.vnode.el) {
      t.vnode.el.__VUE_I18N__ = n, r = Wc();
      const o = n;
      o[Ko] && o[Ko](r), r.on("*", Pi);
    }
  }, t), to(() => {
    const o = n;
    process.env.NODE_ENV !== "production" && t.vnode.el && t.vnode.el.__VUE_I18N__ && (r && r.off("*", Pi), o[Xo] && o[Xo](), delete t.vnode.el.__VUE_I18N__), e.__deleteInstance(t);
    const a = o[Qo];
    a && (a(), delete o[Qo]);
  }, t);
}
wd();
td(Df);
nd(Qf);
rd(hl);
if (process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__) {
  const e = In();
  e.__INTLIFY__ = !0, kf(e.__INTLIFY_DEVTOOLS_GLOBAL_HOOK__);
}
process.env.NODE_ENV;
const Pl = Symbol(), Io = "el", $d = "is-", On = (e, t, n, r, o) => {
  let a = `${e}-${t}`;
  return n && (a += `-${n}`), r && (a += `__${r}`), o && (a += `--${o}`), a;
}, Dl = Symbol("namespaceContextKey"), Ca = (e) => {
  const t = We() ? Me(Dl, R(Io)) : R(Io);
  return D(() => b(t) || Io);
}, Fe = (e, t) => {
  const n = Ca();
  return {
    namespace: n,
    b: (g = "") => On(n.value, e, g, "", ""),
    e: (g) => g ? On(n.value, e, "", g, "") : "",
    m: (g) => g ? On(n.value, e, "", "", g) : "",
    be: (g, E) => g && E ? On(n.value, e, g, E, "") : "",
    em: (g, E) => g && E ? On(n.value, e, "", g, E) : "",
    bm: (g, E) => g && E ? On(n.value, e, g, "", E) : "",
    bem: (g, E, v) => g && E && v ? On(n.value, e, g, E, v) : "",
    is: (g, ...E) => {
      const v = E.length >= 1 ? E[0] : !0;
      return g && v ? `${$d}${g}` : "";
    },
    cssVar: (g) => {
      const E = {};
      for (const v in g)
        g[v] && (E[`--${n.value}-${v}`] = g[v]);
      return E;
    },
    cssVarName: (g) => `--${n.value}-${g}`,
    cssVarBlock: (g) => {
      const E = {};
      for (const v in g)
        g[v] && (E[`--${n.value}-${e}-${v}`] = g[v]);
      return E;
    },
    cssVarBlockName: (g) => `--${n.value}-${e}-${g}`
  };
};
/**
* @vue/shared v3.5.13
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/
process.env.NODE_ENV !== "production" && Object.freeze({});
process.env.NODE_ENV !== "production" && Object.freeze([]);
const yr = () => {
}, zd = Object.prototype.hasOwnProperty, Di = (e, t) => zd.call(e, t), Ot = Array.isArray, it = (e) => typeof e == "function", mn = (e) => typeof e == "string", vt = (e) => e !== null && typeof e == "object", Vd = Object.prototype.toString, Ud = (e) => Vd.call(e), Wd = (e) => Ud(e) === "[object Object]";
var kl = typeof global == "object" && global && global.Object === Object && global, Hd = typeof self == "object" && self && self.Object === Object && self, $t = kl || Hd || Function("return this")(), Ft = $t.Symbol, xl = Object.prototype, Yd = xl.hasOwnProperty, Gd = xl.toString, or = Ft ? Ft.toStringTag : void 0;
function Kd(e) {
  var t = Yd.call(e, or), n = e[or];
  try {
    e[or] = void 0;
    var r = !0;
  } catch {
  }
  var o = Gd.call(e);
  return r && (t ? e[or] = n : delete e[or]), o;
}
var Xd = Object.prototype, Qd = Xd.toString;
function Zd(e) {
  return Qd.call(e);
}
var Jd = "[object Null]", qd = "[object Undefined]", ki = Ft ? Ft.toStringTag : void 0;
function qn(e) {
  return e == null ? e === void 0 ? qd : Jd : ki && ki in Object(e) ? Kd(e) : Zd(e);
}
function Hn(e) {
  return e != null && typeof e == "object";
}
var ep = "[object Symbol]";
function io(e) {
  return typeof e == "symbol" || Hn(e) && qn(e) == ep;
}
function tp(e, t) {
  for (var n = -1, r = e == null ? 0 : e.length, o = Array(r); ++n < r; )
    o[n] = t(e[n], n, e);
  return o;
}
var At = Array.isArray, xi = Ft ? Ft.prototype : void 0, Ri = xi ? xi.toString : void 0;
function Rl(e) {
  if (typeof e == "string")
    return e;
  if (At(e))
    return tp(e, Rl) + "";
  if (io(e))
    return Ri ? Ri.call(e) : "";
  var t = e + "";
  return t == "0" && 1 / e == -1 / 0 ? "-0" : t;
}
var np = /\s/;
function rp(e) {
  for (var t = e.length; t-- && np.test(e.charAt(t)); )
    ;
  return t;
}
var op = /^\s+/;
function ap(e) {
  return e && e.slice(0, rp(e) + 1).replace(op, "");
}
function bn(e) {
  var t = typeof e;
  return e != null && (t == "object" || t == "function");
}
var Fi = NaN, ip = /^[-+]0x[0-9a-f]+$/i, sp = /^0b[01]+$/i, lp = /^0o[0-7]+$/i, up = parseInt;
function ji(e) {
  if (typeof e == "number")
    return e;
  if (io(e))
    return Fi;
  if (bn(e)) {
    var t = typeof e.valueOf == "function" ? e.valueOf() : e;
    e = bn(t) ? t + "" : t;
  }
  if (typeof e != "string")
    return e === 0 ? e : +e;
  e = ap(e);
  var n = sp.test(e);
  return n || lp.test(e) ? up(e.slice(2), n ? 2 : 8) : ip.test(e) ? Fi : +e;
}
function Fl(e) {
  return e;
}
var cp = "[object AsyncFunction]", fp = "[object Function]", dp = "[object GeneratorFunction]", pp = "[object Proxy]";
function jl(e) {
  if (!bn(e))
    return !1;
  var t = qn(e);
  return t == fp || t == dp || t == cp || t == pp;
}
var No = $t["__core-js_shared__"], Bi = function() {
  var e = /[^.]+$/.exec(No && No.keys && No.keys.IE_PROTO || "");
  return e ? "Symbol(src)_1." + e : "";
}();
function hp(e) {
  return !!Bi && Bi in e;
}
var gp = Function.prototype, vp = gp.toString;
function xn(e) {
  if (e != null) {
    try {
      return vp.call(e);
    } catch {
    }
    try {
      return e + "";
    } catch {
    }
  }
  return "";
}
var mp = /[\\^$.*+?()[\]{}|]/g, yp = /^\[object .+?Constructor\]$/, bp = Function.prototype, Ep = Object.prototype, Mp = bp.toString, _p = Ep.hasOwnProperty, wp = RegExp(
  "^" + Mp.call(_p).replace(mp, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function Tp(e) {
  if (!bn(e) || hp(e))
    return !1;
  var t = jl(e) ? wp : yp;
  return t.test(xn(e));
}
function Cp(e, t) {
  return e == null ? void 0 : e[t];
}
function Rn(e, t) {
  var n = Cp(e, t);
  return Tp(n) ? n : void 0;
}
var Zo = Rn($t, "WeakMap");
function Op(e, t, n) {
  switch (n.length) {
    case 0:
      return e.call(t);
    case 1:
      return e.call(t, n[0]);
    case 2:
      return e.call(t, n[0], n[1]);
    case 3:
      return e.call(t, n[0], n[1], n[2]);
  }
  return e.apply(t, n);
}
var Ip = 800, Np = 16, Sp = Date.now;
function Ap(e) {
  var t = 0, n = 0;
  return function() {
    var r = Sp(), o = Np - (r - n);
    if (n = r, o > 0) {
      if (++t >= Ip)
        return arguments[0];
    } else
      t = 0;
    return e.apply(void 0, arguments);
  };
}
function Lp(e) {
  return function() {
    return e;
  };
}
var Gr = function() {
  try {
    var e = Rn(Object, "defineProperty");
    return e({}, "", {}), e;
  } catch {
  }
}(), Pp = Gr ? function(e, t) {
  return Gr(e, "toString", {
    configurable: !0,
    enumerable: !1,
    value: Lp(t),
    writable: !0
  });
} : Fl, Dp = Ap(Pp);
function kp(e, t, n, r) {
  e.length;
  for (var o = n + 1; o--; )
    if (t(e[o], o, e))
      return o;
  return -1;
}
var xp = 9007199254740991, Rp = /^(?:0|[1-9]\d*)$/;
function Oa(e, t) {
  var n = typeof e;
  return t = t ?? xp, !!t && (n == "number" || n != "symbol" && Rp.test(e)) && e > -1 && e % 1 == 0 && e < t;
}
function Fp(e, t, n) {
  t == "__proto__" && Gr ? Gr(e, t, {
    configurable: !0,
    enumerable: !0,
    value: n,
    writable: !0
  }) : e[t] = n;
}
function Ia(e, t) {
  return e === t || e !== e && t !== t;
}
var jp = Object.prototype, Bp = jp.hasOwnProperty;
function $p(e, t, n) {
  var r = e[t];
  (!(Bp.call(e, t) && Ia(r, n)) || n === void 0 && !(t in e)) && Fp(e, t, n);
}
var $i = Math.max;
function zp(e, t, n) {
  return t = $i(t === void 0 ? e.length - 1 : t, 0), function() {
    for (var r = arguments, o = -1, a = $i(r.length - t, 0), i = Array(a); ++o < a; )
      i[o] = r[t + o];
    o = -1;
    for (var s = Array(t + 1); ++o < t; )
      s[o] = r[o];
    return s[t] = n(i), Op(e, this, s);
  };
}
var Vp = 9007199254740991;
function Na(e) {
  return typeof e == "number" && e > -1 && e % 1 == 0 && e <= Vp;
}
function Up(e) {
  return e != null && Na(e.length) && !jl(e);
}
var Wp = Object.prototype;
function Hp(e) {
  var t = e && e.constructor, n = typeof t == "function" && t.prototype || Wp;
  return e === n;
}
function Yp(e, t) {
  for (var n = -1, r = Array(e); ++n < e; )
    r[n] = t(n);
  return r;
}
var Gp = "[object Arguments]";
function zi(e) {
  return Hn(e) && qn(e) == Gp;
}
var Bl = Object.prototype, Kp = Bl.hasOwnProperty, Xp = Bl.propertyIsEnumerable, Sa = zi(/* @__PURE__ */ function() {
  return arguments;
}()) ? zi : function(e) {
  return Hn(e) && Kp.call(e, "callee") && !Xp.call(e, "callee");
};
function Qp() {
  return !1;
}
var $l = typeof exports == "object" && exports && !exports.nodeType && exports, Vi = $l && typeof module == "object" && module && !module.nodeType && module, Zp = Vi && Vi.exports === $l, Ui = Zp ? $t.Buffer : void 0, Jp = Ui ? Ui.isBuffer : void 0, Jo = Jp || Qp, qp = "[object Arguments]", eh = "[object Array]", th = "[object Boolean]", nh = "[object Date]", rh = "[object Error]", oh = "[object Function]", ah = "[object Map]", ih = "[object Number]", sh = "[object Object]", lh = "[object RegExp]", uh = "[object Set]", ch = "[object String]", fh = "[object WeakMap]", dh = "[object ArrayBuffer]", ph = "[object DataView]", hh = "[object Float32Array]", gh = "[object Float64Array]", vh = "[object Int8Array]", mh = "[object Int16Array]", yh = "[object Int32Array]", bh = "[object Uint8Array]", Eh = "[object Uint8ClampedArray]", Mh = "[object Uint16Array]", _h = "[object Uint32Array]", Ce = {};
Ce[hh] = Ce[gh] = Ce[vh] = Ce[mh] = Ce[yh] = Ce[bh] = Ce[Eh] = Ce[Mh] = Ce[_h] = !0;
Ce[qp] = Ce[eh] = Ce[dh] = Ce[th] = Ce[ph] = Ce[nh] = Ce[rh] = Ce[oh] = Ce[ah] = Ce[ih] = Ce[sh] = Ce[lh] = Ce[uh] = Ce[ch] = Ce[fh] = !1;
function wh(e) {
  return Hn(e) && Na(e.length) && !!Ce[qn(e)];
}
function Th(e) {
  return function(t) {
    return e(t);
  };
}
var zl = typeof exports == "object" && exports && !exports.nodeType && exports, ur = zl && typeof module == "object" && module && !module.nodeType && module, Ch = ur && ur.exports === zl, So = Ch && kl.process, Wi = function() {
  try {
    var e = ur && ur.require && ur.require("util").types;
    return e || So && So.binding && So.binding("util");
  } catch {
  }
}(), Hi = Wi && Wi.isTypedArray, Vl = Hi ? Th(Hi) : wh, Oh = Object.prototype, Ih = Oh.hasOwnProperty;
function Nh(e, t) {
  var n = At(e), r = !n && Sa(e), o = !n && !r && Jo(e), a = !n && !r && !o && Vl(e), i = n || r || o || a, s = i ? Yp(e.length, String) : [], l = s.length;
  for (var u in e)
    Ih.call(e, u) && !(i && // Safari 9 has enumerable `arguments.length` in strict mode.
    (u == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    o && (u == "offset" || u == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    a && (u == "buffer" || u == "byteLength" || u == "byteOffset") || // Skip index properties.
    Oa(u, l))) && s.push(u);
  return s;
}
function Sh(e, t) {
  return function(n) {
    return e(t(n));
  };
}
var Ah = Sh(Object.keys, Object), Lh = Object.prototype, Ph = Lh.hasOwnProperty;
function Dh(e) {
  if (!Hp(e))
    return Ah(e);
  var t = [];
  for (var n in Object(e))
    Ph.call(e, n) && n != "constructor" && t.push(n);
  return t;
}
function Ul(e) {
  return Up(e) ? Nh(e) : Dh(e);
}
var kh = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, xh = /^\w*$/;
function Aa(e, t) {
  if (At(e))
    return !1;
  var n = typeof e;
  return n == "number" || n == "symbol" || n == "boolean" || e == null || io(e) ? !0 : xh.test(e) || !kh.test(e) || t != null && e in Object(t);
}
var br = Rn(Object, "create");
function Rh() {
  this.__data__ = br ? br(null) : {}, this.size = 0;
}
function Fh(e) {
  var t = this.has(e) && delete this.__data__[e];
  return this.size -= t ? 1 : 0, t;
}
var jh = "__lodash_hash_undefined__", Bh = Object.prototype, $h = Bh.hasOwnProperty;
function zh(e) {
  var t = this.__data__;
  if (br) {
    var n = t[e];
    return n === jh ? void 0 : n;
  }
  return $h.call(t, e) ? t[e] : void 0;
}
var Vh = Object.prototype, Uh = Vh.hasOwnProperty;
function Wh(e) {
  var t = this.__data__;
  return br ? t[e] !== void 0 : Uh.call(t, e);
}
var Hh = "__lodash_hash_undefined__";
function Yh(e, t) {
  var n = this.__data__;
  return this.size += this.has(e) ? 0 : 1, n[e] = br && t === void 0 ? Hh : t, this;
}
function kn(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var r = e[t];
    this.set(r[0], r[1]);
  }
}
kn.prototype.clear = Rh;
kn.prototype.delete = Fh;
kn.prototype.get = zh;
kn.prototype.has = Wh;
kn.prototype.set = Yh;
function Gh() {
  this.__data__ = [], this.size = 0;
}
function so(e, t) {
  for (var n = e.length; n--; )
    if (Ia(e[n][0], t))
      return n;
  return -1;
}
var Kh = Array.prototype, Xh = Kh.splice;
function Qh(e) {
  var t = this.__data__, n = so(t, e);
  if (n < 0)
    return !1;
  var r = t.length - 1;
  return n == r ? t.pop() : Xh.call(t, n, 1), --this.size, !0;
}
function Zh(e) {
  var t = this.__data__, n = so(t, e);
  return n < 0 ? void 0 : t[n][1];
}
function Jh(e) {
  return so(this.__data__, e) > -1;
}
function qh(e, t) {
  var n = this.__data__, r = so(n, e);
  return r < 0 ? (++this.size, n.push([e, t])) : n[r][1] = t, this;
}
function nn(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var r = e[t];
    this.set(r[0], r[1]);
  }
}
nn.prototype.clear = Gh;
nn.prototype.delete = Qh;
nn.prototype.get = Zh;
nn.prototype.has = Jh;
nn.prototype.set = qh;
var Er = Rn($t, "Map");
function eg() {
  this.size = 0, this.__data__ = {
    hash: new kn(),
    map: new (Er || nn)(),
    string: new kn()
  };
}
function tg(e) {
  var t = typeof e;
  return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
}
function lo(e, t) {
  var n = e.__data__;
  return tg(t) ? n[typeof t == "string" ? "string" : "hash"] : n.map;
}
function ng(e) {
  var t = lo(this, e).delete(e);
  return this.size -= t ? 1 : 0, t;
}
function rg(e) {
  return lo(this, e).get(e);
}
function og(e) {
  return lo(this, e).has(e);
}
function ag(e, t) {
  var n = lo(this, e), r = n.size;
  return n.set(e, t), this.size += n.size == r ? 0 : 1, this;
}
function rn(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var r = e[t];
    this.set(r[0], r[1]);
  }
}
rn.prototype.clear = eg;
rn.prototype.delete = ng;
rn.prototype.get = rg;
rn.prototype.has = og;
rn.prototype.set = ag;
var ig = "Expected a function";
function La(e, t) {
  if (typeof e != "function" || t != null && typeof t != "function")
    throw new TypeError(ig);
  var n = function() {
    var r = arguments, o = t ? t.apply(this, r) : r[0], a = n.cache;
    if (a.has(o))
      return a.get(o);
    var i = e.apply(this, r);
    return n.cache = a.set(o, i) || a, i;
  };
  return n.cache = new (La.Cache || rn)(), n;
}
La.Cache = rn;
var sg = 500;
function lg(e) {
  var t = La(e, function(r) {
    return n.size === sg && n.clear(), r;
  }), n = t.cache;
  return t;
}
var ug = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, cg = /\\(\\)?/g, fg = lg(function(e) {
  var t = [];
  return e.charCodeAt(0) === 46 && t.push(""), e.replace(ug, function(n, r, o, a) {
    t.push(o ? a.replace(cg, "$1") : r || n);
  }), t;
});
function dg(e) {
  return e == null ? "" : Rl(e);
}
function uo(e, t) {
  return At(e) ? e : Aa(e, t) ? [e] : fg(dg(e));
}
function wr(e) {
  if (typeof e == "string" || io(e))
    return e;
  var t = e + "";
  return t == "0" && 1 / e == -1 / 0 ? "-0" : t;
}
function Pa(e, t) {
  t = uo(t, e);
  for (var n = 0, r = t.length; e != null && n < r; )
    e = e[wr(t[n++])];
  return n && n == r ? e : void 0;
}
function hn(e, t, n) {
  var r = e == null ? void 0 : Pa(e, t);
  return r === void 0 ? n : r;
}
function Wl(e, t) {
  for (var n = -1, r = t.length, o = e.length; ++n < r; )
    e[o + n] = t[n];
  return e;
}
var Yi = Ft ? Ft.isConcatSpreadable : void 0;
function pg(e) {
  return At(e) || Sa(e) || !!(Yi && e && e[Yi]);
}
function hg(e, t, n, r, o) {
  var a = -1, i = e.length;
  for (n || (n = pg), o || (o = []); ++a < i; ) {
    var s = e[a];
    n(s) ? Wl(o, s) : o[o.length] = s;
  }
  return o;
}
function gg(e) {
  var t = e == null ? 0 : e.length;
  return t ? hg(e) : [];
}
function vg(e) {
  return Dp(zp(e, void 0, gg), e + "");
}
function pn() {
  if (!arguments.length)
    return [];
  var e = arguments[0];
  return At(e) ? e : [e];
}
function mg() {
  this.__data__ = new nn(), this.size = 0;
}
function yg(e) {
  var t = this.__data__, n = t.delete(e);
  return this.size = t.size, n;
}
function bg(e) {
  return this.__data__.get(e);
}
function Eg(e) {
  return this.__data__.has(e);
}
var Mg = 200;
function _g(e, t) {
  var n = this.__data__;
  if (n instanceof nn) {
    var r = n.__data__;
    if (!Er || r.length < Mg - 1)
      return r.push([e, t]), this.size = ++n.size, this;
    n = this.__data__ = new rn(r);
  }
  return n.set(e, t), this.size = n.size, this;
}
function Zt(e) {
  var t = this.__data__ = new nn(e);
  this.size = t.size;
}
Zt.prototype.clear = mg;
Zt.prototype.delete = yg;
Zt.prototype.get = bg;
Zt.prototype.has = Eg;
Zt.prototype.set = _g;
function wg(e, t) {
  for (var n = -1, r = e == null ? 0 : e.length, o = 0, a = []; ++n < r; ) {
    var i = e[n];
    t(i, n, e) && (a[o++] = i);
  }
  return a;
}
function Tg() {
  return [];
}
var Cg = Object.prototype, Og = Cg.propertyIsEnumerable, Gi = Object.getOwnPropertySymbols, Ig = Gi ? function(e) {
  return e == null ? [] : (e = Object(e), wg(Gi(e), function(t) {
    return Og.call(e, t);
  }));
} : Tg;
function Ng(e, t, n) {
  var r = t(e);
  return At(e) ? r : Wl(r, n(e));
}
function Ki(e) {
  return Ng(e, Ul, Ig);
}
var qo = Rn($t, "DataView"), ea = Rn($t, "Promise"), ta = Rn($t, "Set"), Xi = "[object Map]", Sg = "[object Object]", Qi = "[object Promise]", Zi = "[object Set]", Ji = "[object WeakMap]", qi = "[object DataView]", Ag = xn(qo), Lg = xn(Er), Pg = xn(ea), Dg = xn(ta), kg = xn(Zo), dn = qn;
(qo && dn(new qo(new ArrayBuffer(1))) != qi || Er && dn(new Er()) != Xi || ea && dn(ea.resolve()) != Qi || ta && dn(new ta()) != Zi || Zo && dn(new Zo()) != Ji) && (dn = function(e) {
  var t = qn(e), n = t == Sg ? e.constructor : void 0, r = n ? xn(n) : "";
  if (r)
    switch (r) {
      case Ag:
        return qi;
      case Lg:
        return Xi;
      case Pg:
        return Qi;
      case Dg:
        return Zi;
      case kg:
        return Ji;
    }
  return t;
});
var es = $t.Uint8Array, xg = "__lodash_hash_undefined__";
function Rg(e) {
  return this.__data__.set(e, xg), this;
}
function Fg(e) {
  return this.__data__.has(e);
}
function Kr(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.__data__ = new rn(); ++t < n; )
    this.add(e[t]);
}
Kr.prototype.add = Kr.prototype.push = Rg;
Kr.prototype.has = Fg;
function jg(e, t) {
  for (var n = -1, r = e == null ? 0 : e.length; ++n < r; )
    if (t(e[n], n, e))
      return !0;
  return !1;
}
function Bg(e, t) {
  return e.has(t);
}
var $g = 1, zg = 2;
function Hl(e, t, n, r, o, a) {
  var i = n & $g, s = e.length, l = t.length;
  if (s != l && !(i && l > s))
    return !1;
  var u = a.get(e), f = a.get(t);
  if (u && f)
    return u == t && f == e;
  var c = -1, d = !0, h = n & zg ? new Kr() : void 0;
  for (a.set(e, t), a.set(t, e); ++c < s; ) {
    var p = e[c], g = t[c];
    if (r)
      var E = i ? r(g, p, c, t, e, a) : r(p, g, c, e, t, a);
    if (E !== void 0) {
      if (E)
        continue;
      d = !1;
      break;
    }
    if (h) {
      if (!jg(t, function(v, m) {
        if (!Bg(h, m) && (p === v || o(p, v, n, r, a)))
          return h.push(m);
      })) {
        d = !1;
        break;
      }
    } else if (!(p === g || o(p, g, n, r, a))) {
      d = !1;
      break;
    }
  }
  return a.delete(e), a.delete(t), d;
}
function Vg(e) {
  var t = -1, n = Array(e.size);
  return e.forEach(function(r, o) {
    n[++t] = [o, r];
  }), n;
}
function Ug(e) {
  var t = -1, n = Array(e.size);
  return e.forEach(function(r) {
    n[++t] = r;
  }), n;
}
var Wg = 1, Hg = 2, Yg = "[object Boolean]", Gg = "[object Date]", Kg = "[object Error]", Xg = "[object Map]", Qg = "[object Number]", Zg = "[object RegExp]", Jg = "[object Set]", qg = "[object String]", ev = "[object Symbol]", tv = "[object ArrayBuffer]", nv = "[object DataView]", ts = Ft ? Ft.prototype : void 0, Ao = ts ? ts.valueOf : void 0;
function rv(e, t, n, r, o, a, i) {
  switch (n) {
    case nv:
      if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset)
        return !1;
      e = e.buffer, t = t.buffer;
    case tv:
      return !(e.byteLength != t.byteLength || !a(new es(e), new es(t)));
    case Yg:
    case Gg:
    case Qg:
      return Ia(+e, +t);
    case Kg:
      return e.name == t.name && e.message == t.message;
    case Zg:
    case qg:
      return e == t + "";
    case Xg:
      var s = Vg;
    case Jg:
      var l = r & Wg;
      if (s || (s = Ug), e.size != t.size && !l)
        return !1;
      var u = i.get(e);
      if (u)
        return u == t;
      r |= Hg, i.set(e, t);
      var f = Hl(s(e), s(t), r, o, a, i);
      return i.delete(e), f;
    case ev:
      if (Ao)
        return Ao.call(e) == Ao.call(t);
  }
  return !1;
}
var ov = 1, av = Object.prototype, iv = av.hasOwnProperty;
function sv(e, t, n, r, o, a) {
  var i = n & ov, s = Ki(e), l = s.length, u = Ki(t), f = u.length;
  if (l != f && !i)
    return !1;
  for (var c = l; c--; ) {
    var d = s[c];
    if (!(i ? d in t : iv.call(t, d)))
      return !1;
  }
  var h = a.get(e), p = a.get(t);
  if (h && p)
    return h == t && p == e;
  var g = !0;
  a.set(e, t), a.set(t, e);
  for (var E = i; ++c < l; ) {
    d = s[c];
    var v = e[d], m = t[d];
    if (r)
      var y = i ? r(m, v, d, t, e, a) : r(v, m, d, e, t, a);
    if (!(y === void 0 ? v === m || o(v, m, n, r, a) : y)) {
      g = !1;
      break;
    }
    E || (E = d == "constructor");
  }
  if (g && !E) {
    var _ = e.constructor, T = t.constructor;
    _ != T && "constructor" in e && "constructor" in t && !(typeof _ == "function" && _ instanceof _ && typeof T == "function" && T instanceof T) && (g = !1);
  }
  return a.delete(e), a.delete(t), g;
}
var lv = 1, ns = "[object Arguments]", rs = "[object Array]", kr = "[object Object]", uv = Object.prototype, os = uv.hasOwnProperty;
function cv(e, t, n, r, o, a) {
  var i = At(e), s = At(t), l = i ? rs : dn(e), u = s ? rs : dn(t);
  l = l == ns ? kr : l, u = u == ns ? kr : u;
  var f = l == kr, c = u == kr, d = l == u;
  if (d && Jo(e)) {
    if (!Jo(t))
      return !1;
    i = !0, f = !1;
  }
  if (d && !f)
    return a || (a = new Zt()), i || Vl(e) ? Hl(e, t, n, r, o, a) : rv(e, t, l, n, r, o, a);
  if (!(n & lv)) {
    var h = f && os.call(e, "__wrapped__"), p = c && os.call(t, "__wrapped__");
    if (h || p) {
      var g = h ? e.value() : e, E = p ? t.value() : t;
      return a || (a = new Zt()), o(g, E, n, r, a);
    }
  }
  return d ? (a || (a = new Zt()), sv(e, t, n, r, o, a)) : !1;
}
function co(e, t, n, r, o) {
  return e === t ? !0 : e == null || t == null || !Hn(e) && !Hn(t) ? e !== e && t !== t : cv(e, t, n, r, co, o);
}
var fv = 1, dv = 2;
function pv(e, t, n, r) {
  var o = n.length, a = o;
  if (e == null)
    return !a;
  for (e = Object(e); o--; ) {
    var i = n[o];
    if (i[2] ? i[1] !== e[i[0]] : !(i[0] in e))
      return !1;
  }
  for (; ++o < a; ) {
    i = n[o];
    var s = i[0], l = e[s], u = i[1];
    if (i[2]) {
      if (l === void 0 && !(s in e))
        return !1;
    } else {
      var f = new Zt(), c;
      if (!(c === void 0 ? co(u, l, fv | dv, r, f) : c))
        return !1;
    }
  }
  return !0;
}
function Yl(e) {
  return e === e && !bn(e);
}
function hv(e) {
  for (var t = Ul(e), n = t.length; n--; ) {
    var r = t[n], o = e[r];
    t[n] = [r, o, Yl(o)];
  }
  return t;
}
function Gl(e, t) {
  return function(n) {
    return n == null ? !1 : n[e] === t && (t !== void 0 || e in Object(n));
  };
}
function gv(e) {
  var t = hv(e);
  return t.length == 1 && t[0][2] ? Gl(t[0][0], t[0][1]) : function(n) {
    return n === e || pv(n, e, t);
  };
}
function vv(e, t) {
  return e != null && t in Object(e);
}
function mv(e, t, n) {
  t = uo(t, e);
  for (var r = -1, o = t.length, a = !1; ++r < o; ) {
    var i = wr(t[r]);
    if (!(a = e != null && n(e, i)))
      break;
    e = e[i];
  }
  return a || ++r != o ? a : (o = e == null ? 0 : e.length, !!o && Na(o) && Oa(i, o) && (At(e) || Sa(e)));
}
function Kl(e, t) {
  return e != null && mv(e, t, vv);
}
var yv = 1, bv = 2;
function Ev(e, t) {
  return Aa(e) && Yl(t) ? Gl(wr(e), t) : function(n) {
    var r = hn(n, e);
    return r === void 0 && r === t ? Kl(n, e) : co(t, r, yv | bv);
  };
}
function Mv(e) {
  return function(t) {
    return t == null ? void 0 : t[e];
  };
}
function _v(e) {
  return function(t) {
    return Pa(t, e);
  };
}
function wv(e) {
  return Aa(e) ? Mv(wr(e)) : _v(e);
}
function Tv(e) {
  return typeof e == "function" ? e : e == null ? Fl : typeof e == "object" ? At(e) ? Ev(e[0], e[1]) : gv(e) : wv(e);
}
var Lo = function() {
  return $t.Date.now();
}, Cv = "Expected a function", Ov = Math.max, Iv = Math.min;
function Nv(e, t, n) {
  var r, o, a, i, s, l, u = 0, f = !1, c = !1, d = !0;
  if (typeof e != "function")
    throw new TypeError(Cv);
  t = ji(t) || 0, bn(n) && (f = !!n.leading, c = "maxWait" in n, a = c ? Ov(ji(n.maxWait) || 0, t) : a, d = "trailing" in n ? !!n.trailing : d);
  function h(N) {
    var I = r, x = o;
    return r = o = void 0, u = N, i = e.apply(x, I), i;
  }
  function p(N) {
    return u = N, s = setTimeout(v, t), f ? h(N) : i;
  }
  function g(N) {
    var I = N - l, x = N - u, B = t - I;
    return c ? Iv(B, a - x) : B;
  }
  function E(N) {
    var I = N - l, x = N - u;
    return l === void 0 || I >= t || I < 0 || c && x >= a;
  }
  function v() {
    var N = Lo();
    if (E(N))
      return m(N);
    s = setTimeout(v, g(N));
  }
  function m(N) {
    return s = void 0, d && r ? h(N) : (r = o = void 0, i);
  }
  function y() {
    s !== void 0 && clearTimeout(s), u = 0, r = l = o = s = void 0;
  }
  function _() {
    return s === void 0 ? i : m(Lo());
  }
  function T() {
    var N = Lo(), I = E(N);
    if (r = arguments, o = this, l = N, I) {
      if (s === void 0)
        return p(l);
      if (c)
        return clearTimeout(s), s = setTimeout(v, t), h(l);
    }
    return s === void 0 && (s = setTimeout(v, t)), i;
  }
  return T.cancel = y, T.flush = _, T;
}
function Sv(e, t, n) {
  var r = e == null ? 0 : e.length;
  if (!r)
    return -1;
  var o = r - 1;
  return kp(e, Tv(t), o);
}
function Xr(e) {
  for (var t = -1, n = e == null ? 0 : e.length, r = {}; ++t < n; ) {
    var o = e[t];
    r[o[0]] = o[1];
  }
  return r;
}
function cr(e, t) {
  return co(e, t);
}
function fo(e) {
  return e == null;
}
function Av(e) {
  return e === void 0;
}
function Lv(e, t, n, r) {
  if (!bn(e))
    return e;
  t = uo(t, e);
  for (var o = -1, a = t.length, i = a - 1, s = e; s != null && ++o < a; ) {
    var l = wr(t[o]), u = n;
    if (l === "__proto__" || l === "constructor" || l === "prototype")
      return e;
    if (o != i) {
      var f = s[l];
      u = void 0, u === void 0 && (u = bn(f) ? f : Oa(t[o + 1]) ? [] : {});
    }
    $p(s, l, u), s = s[l];
  }
  return e;
}
function Pv(e, t, n) {
  for (var r = -1, o = t.length, a = {}; ++r < o; ) {
    var i = t[r], s = Pa(e, i);
    n(s, i) && Lv(a, uo(i, e), s);
  }
  return a;
}
function Dv(e, t) {
  return Pv(e, t, function(n, r) {
    return Kl(e, r);
  });
}
var kv = vg(function(e, t) {
  return e == null ? {} : Dv(e, t);
});
const lr = (e) => e === void 0, Xl = (e) => typeof e == "boolean", pt = (e) => typeof e == "number", Jt = (e) => typeof Element > "u" ? !1 : e instanceof Element, xv = (e) => mn(e) ? !Number.isNaN(Number(e)) : !1;
var Rv = Object.defineProperty, Fv = Object.defineProperties, jv = Object.getOwnPropertyDescriptors, as = Object.getOwnPropertySymbols, Bv = Object.prototype.hasOwnProperty, $v = Object.prototype.propertyIsEnumerable, is = (e, t, n) => t in e ? Rv(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, zv = (e, t) => {
  for (var n in t || (t = {}))
    Bv.call(t, n) && is(e, n, t[n]);
  if (as)
    for (var n of as(t))
      $v.call(t, n) && is(e, n, t[n]);
  return e;
}, Vv = (e, t) => Fv(e, jv(t));
function Ql(e, t) {
  var n;
  const r = vn();
  return qs(() => {
    r.value = e();
  }, Vv(zv({}, t), {
    flush: (n = void 0) != null ? n : "sync"
  })), el(r);
}
var ss;
const Qe = typeof window < "u", Uv = (e) => typeof e == "string", Zl = () => {
}, na = Qe && ((ss = window == null ? void 0 : window.navigator) == null ? void 0 : ss.userAgent) && /iP(ad|hone|od)/.test(window.navigator.userAgent);
function Jl(e) {
  return typeof e == "function" ? e() : b(e);
}
function Wv(e) {
  return e;
}
function po(e) {
  return pc() ? (hc(e), !0) : !1;
}
function Hv(e, t = !0) {
  We() ? xe(e) : t ? e() : Ne(e);
}
function Qt(e) {
  var t;
  const n = Jl(e);
  return (t = n == null ? void 0 : n.$el) != null ? t : n;
}
const ho = Qe ? window : void 0;
function _t(...e) {
  let t, n, r, o;
  if (Uv(e[0]) || Array.isArray(e[0]) ? ([n, r, o] = e, t = ho) : [t, n, r, o] = e, !t)
    return Zl;
  Array.isArray(n) || (n = [n]), Array.isArray(r) || (r = [r]);
  const a = [], i = () => {
    a.forEach((f) => f()), a.length = 0;
  }, s = (f, c, d, h) => (f.addEventListener(c, d, h), () => f.removeEventListener(c, d, h)), l = Q(() => [Qt(t), Jl(o)], ([f, c]) => {
    i(), f && a.push(...n.flatMap((d) => r.map((h) => s(f, d, h, c))));
  }, { immediate: !0, flush: "post" }), u = () => {
    l(), i();
  };
  return po(u), u;
}
let ls = !1;
function Yv(e, t, n = {}) {
  const { window: r = ho, ignore: o = [], capture: a = !0, detectIframe: i = !1 } = n;
  if (!r)
    return;
  na && !ls && (ls = !0, Array.from(r.document.body.children).forEach((d) => d.addEventListener("click", Zl)));
  let s = !0;
  const l = (d) => o.some((h) => {
    if (typeof h == "string")
      return Array.from(r.document.querySelectorAll(h)).some((p) => p === d.target || d.composedPath().includes(p));
    {
      const p = Qt(h);
      return p && (d.target === p || d.composedPath().includes(p));
    }
  }), f = [
    _t(r, "click", (d) => {
      const h = Qt(e);
      if (!(!h || h === d.target || d.composedPath().includes(h))) {
        if (d.detail === 0 && (s = !l(d)), !s) {
          s = !0;
          return;
        }
        t(d);
      }
    }, { passive: !0, capture: a }),
    _t(r, "pointerdown", (d) => {
      const h = Qt(e);
      h && (s = !d.composedPath().includes(h) && !l(d));
    }, { passive: !0 }),
    i && _t(r, "blur", (d) => {
      var h;
      const p = Qt(e);
      ((h = r.document.activeElement) == null ? void 0 : h.tagName) === "IFRAME" && !(p != null && p.contains(r.document.activeElement)) && t(d);
    })
  ].filter(Boolean);
  return () => f.forEach((d) => d());
}
function ql(e, t = !1) {
  const n = R(), r = () => n.value = !!e();
  return r(), Hv(r, t), n;
}
const us = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {}, cs = "__vueuse_ssr_handlers__";
us[cs] = us[cs] || {};
var fs = Object.getOwnPropertySymbols, Gv = Object.prototype.hasOwnProperty, Kv = Object.prototype.propertyIsEnumerable, Xv = (e, t) => {
  var n = {};
  for (var r in e)
    Gv.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && fs)
    for (var r of fs(e))
      t.indexOf(r) < 0 && Kv.call(e, r) && (n[r] = e[r]);
  return n;
};
function Gt(e, t, n = {}) {
  const r = n, { window: o = ho } = r, a = Xv(r, ["window"]);
  let i;
  const s = ql(() => o && "ResizeObserver" in o), l = () => {
    i && (i.disconnect(), i = void 0);
  }, u = Q(() => Qt(e), (c) => {
    l(), s.value && o && c && (i = new ResizeObserver(t), i.observe(c, a));
  }, { immediate: !0, flush: "post" }), f = () => {
    l(), u();
  };
  return po(f), {
    isSupported: s,
    stop: f
  };
}
var ds = Object.getOwnPropertySymbols, Qv = Object.prototype.hasOwnProperty, Zv = Object.prototype.propertyIsEnumerable, Jv = (e, t) => {
  var n = {};
  for (var r in e)
    Qv.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && ds)
    for (var r of ds(e))
      t.indexOf(r) < 0 && Zv.call(e, r) && (n[r] = e[r]);
  return n;
};
function qv(e, t, n = {}) {
  const r = n, { window: o = ho } = r, a = Jv(r, ["window"]);
  let i;
  const s = ql(() => o && "MutationObserver" in o), l = () => {
    i && (i.disconnect(), i = void 0);
  }, u = Q(() => Qt(e), (c) => {
    l(), s.value && o && c && (i = new MutationObserver(t), i.observe(c, a));
  }, { immediate: !0 }), f = () => {
    l(), u();
  };
  return po(f), {
    isSupported: s,
    stop: f
  };
}
var ps;
(function(e) {
  e.UP = "UP", e.RIGHT = "RIGHT", e.DOWN = "DOWN", e.LEFT = "LEFT", e.NONE = "NONE";
})(ps || (ps = {}));
var em = Object.defineProperty, hs = Object.getOwnPropertySymbols, tm = Object.prototype.hasOwnProperty, nm = Object.prototype.propertyIsEnumerable, gs = (e, t, n) => t in e ? em(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, rm = (e, t) => {
  for (var n in t || (t = {}))
    tm.call(t, n) && gs(e, n, t[n]);
  if (hs)
    for (var n of hs(t))
      nm.call(t, n) && gs(e, n, t[n]);
  return e;
};
const om = {
  easeInSine: [0.12, 0, 0.39, 0],
  easeOutSine: [0.61, 1, 0.88, 1],
  easeInOutSine: [0.37, 0, 0.63, 1],
  easeInQuad: [0.11, 0, 0.5, 0],
  easeOutQuad: [0.5, 1, 0.89, 1],
  easeInOutQuad: [0.45, 0, 0.55, 1],
  easeInCubic: [0.32, 0, 0.67, 0],
  easeOutCubic: [0.33, 1, 0.68, 1],
  easeInOutCubic: [0.65, 0, 0.35, 1],
  easeInQuart: [0.5, 0, 0.75, 0],
  easeOutQuart: [0.25, 1, 0.5, 1],
  easeInOutQuart: [0.76, 0, 0.24, 1],
  easeInQuint: [0.64, 0, 0.78, 0],
  easeOutQuint: [0.22, 1, 0.36, 1],
  easeInOutQuint: [0.83, 0, 0.17, 1],
  easeInExpo: [0.7, 0, 0.84, 0],
  easeOutExpo: [0.16, 1, 0.3, 1],
  easeInOutExpo: [0.87, 0, 0.13, 1],
  easeInCirc: [0.55, 0, 1, 0.45],
  easeOutCirc: [0, 0.55, 0.45, 1],
  easeInOutCirc: [0.85, 0, 0.15, 1],
  easeInBack: [0.36, 0, 0.66, -0.56],
  easeOutBack: [0.34, 1.56, 0.64, 1],
  easeInOutBack: [0.68, -0.6, 0.32, 1.6]
};
rm({
  linear: Wv
}, om);
class eu extends Error {
  constructor(t) {
    super(t), this.name = "ElementPlusError";
  }
}
function tu(e, t) {
  throw new eu(`[${e}] ${t}`);
}
function qe(e, t) {
  if (process.env.NODE_ENV !== "production") {
    const n = mn(e) ? new eu(`[${e}] ${t}`) : e;
    console.warn(n);
  }
}
const vs = {
  current: 0
}, ms = R(0), am = 2e3, ys = Symbol("elZIndexContextKey"), nu = Symbol("zIndexContextKey"), im = (e) => {
  const t = We() ? Me(ys, vs) : vs, n = We() ? Me(nu, void 0) : void 0, r = D(() => {
    const i = b(n);
    return pt(i) ? i : am;
  }), o = D(() => r.value + ms.value), a = () => (t.current++, ms.value = t.current, o.value);
  return !Qe && !Me(ys) && qe("ZIndexInjection", `Looks like you are using server rendering, you must provide a z-index provider to ensure the hydration process to be succeed
usage: app.provide(ZINDEX_INJECTION_KEY, { current: 0 })`), {
    initialZIndex: r,
    currentZIndex: o,
    nextZIndex: a
  };
};
var ru = {
  name: "en",
  el: {
    breadcrumb: {
      label: "Breadcrumb"
    },
    colorpicker: {
      confirm: "OK",
      clear: "Clear",
      defaultLabel: "color picker",
      description: "current color is {color}. press enter to select a new color.",
      alphaLabel: "pick alpha value"
    },
    datepicker: {
      now: "Now",
      today: "Today",
      cancel: "Cancel",
      clear: "Clear",
      confirm: "OK",
      dateTablePrompt: "Use the arrow keys and enter to select the day of the month",
      monthTablePrompt: "Use the arrow keys and enter to select the month",
      yearTablePrompt: "Use the arrow keys and enter to select the year",
      selectedDate: "Selected date",
      selectDate: "Select date",
      selectTime: "Select time",
      startDate: "Start Date",
      startTime: "Start Time",
      endDate: "End Date",
      endTime: "End Time",
      prevYear: "Previous Year",
      nextYear: "Next Year",
      prevMonth: "Previous Month",
      nextMonth: "Next Month",
      year: "",
      month1: "January",
      month2: "February",
      month3: "March",
      month4: "April",
      month5: "May",
      month6: "June",
      month7: "July",
      month8: "August",
      month9: "September",
      month10: "October",
      month11: "November",
      month12: "December",
      week: "week",
      weeks: {
        sun: "Sun",
        mon: "Mon",
        tue: "Tue",
        wed: "Wed",
        thu: "Thu",
        fri: "Fri",
        sat: "Sat"
      },
      weeksFull: {
        sun: "Sunday",
        mon: "Monday",
        tue: "Tuesday",
        wed: "Wednesday",
        thu: "Thursday",
        fri: "Friday",
        sat: "Saturday"
      },
      months: {
        jan: "Jan",
        feb: "Feb",
        mar: "Mar",
        apr: "Apr",
        may: "May",
        jun: "Jun",
        jul: "Jul",
        aug: "Aug",
        sep: "Sep",
        oct: "Oct",
        nov: "Nov",
        dec: "Dec"
      }
    },
    inputNumber: {
      decrease: "decrease number",
      increase: "increase number"
    },
    select: {
      loading: "Loading",
      noMatch: "No matching data",
      noData: "No data",
      placeholder: "Select"
    },
    mention: {
      loading: "Loading"
    },
    dropdown: {
      toggleDropdown: "Toggle Dropdown"
    },
    cascader: {
      noMatch: "No matching data",
      loading: "Loading",
      placeholder: "Select",
      noData: "No data"
    },
    pagination: {
      goto: "Go to",
      pagesize: "/page",
      total: "Total {total}",
      pageClassifier: "",
      page: "Page",
      prev: "Go to previous page",
      next: "Go to next page",
      currentPage: "page {pager}",
      prevPages: "Previous {pager} pages",
      nextPages: "Next {pager} pages",
      deprecationWarning: "Deprecated usages detected, please refer to the el-pagination documentation for more details"
    },
    dialog: {
      close: "Close this dialog"
    },
    drawer: {
      close: "Close this dialog"
    },
    messagebox: {
      title: "Message",
      confirm: "OK",
      cancel: "Cancel",
      error: "Illegal input",
      close: "Close this dialog"
    },
    upload: {
      deleteTip: "press delete to remove",
      delete: "Delete",
      preview: "Preview",
      continue: "Continue"
    },
    slider: {
      defaultLabel: "slider between {min} and {max}",
      defaultRangeStartLabel: "pick start value",
      defaultRangeEndLabel: "pick end value"
    },
    table: {
      emptyText: "No Data",
      confirmFilter: "Confirm",
      resetFilter: "Reset",
      clearFilter: "All",
      sumText: "Sum"
    },
    tour: {
      next: "Next",
      previous: "Previous",
      finish: "Finish"
    },
    tree: {
      emptyText: "No Data"
    },
    transfer: {
      noMatch: "No matching data",
      noData: "No data",
      titles: ["List 1", "List 2"],
      filterPlaceholder: "Enter keyword",
      noCheckedFormat: "{total} items",
      hasCheckedFormat: "{checked}/{total} checked"
    },
    image: {
      error: "FAILED"
    },
    pageHeader: {
      title: "Back"
    },
    popconfirm: {
      confirmButtonText: "Yes",
      cancelButtonText: "No"
    },
    carousel: {
      leftArrow: "Carousel arrow left",
      rightArrow: "Carousel arrow right",
      indicator: "Carousel switch to index {index}"
    }
  }
};
const sm = (e) => (t, n) => lm(t, n, b(e)), lm = (e, t, n) => hn(n, e, e).replace(/\{(\w+)\}/g, (r, o) => {
  var a;
  return `${(a = t == null ? void 0 : t[o]) != null ? a : `{${o}}`}`;
}), um = (e) => {
  const t = D(() => b(e).name), n = gc(e) ? e : R(e);
  return {
    lang: t,
    locale: n,
    t: sm(e)
  };
}, ou = Symbol("localeContextKey"), cm = (e) => {
  const t = Me(ou, R());
  return um(D(() => t.value || ru));
}, au = "__epPropKey", ce = (e) => e, fm = (e) => vt(e) && !!e[au], go = (e, t) => {
  if (!vt(e) || fm(e))
    return e;
  const { values: n, required: r, default: o, type: a, validator: i } = e, l = {
    type: a,
    required: !!r,
    validator: n || i ? (u) => {
      let f = !1, c = [];
      if (n && (c = Array.from(n), Di(e, "default") && c.push(o), f || (f = c.includes(u))), i && (f || (f = i(u))), !f && c.length > 0) {
        const d = [...new Set(c)].map((h) => JSON.stringify(h)).join(", ");
        vc(`Invalid prop: validation failed${t ? ` for prop "${t}"` : ""}. Expected one of [${d}], got value ${JSON.stringify(u)}.`);
      }
      return f;
    } : void 0,
    [au]: !0
  };
  return Di(e, "default") && (l.default = o), l;
}, Le = (e) => Xr(Object.entries(e).map(([t, n]) => [
  t,
  go(n, t)
])), iu = ["", "default", "small", "large"], vo = go({
  type: String,
  values: iu,
  required: !1
}), su = Symbol("size"), dm = () => {
  const e = Me(su, {});
  return D(() => b(e.size) || "");
}, lu = Symbol("emptyValuesContextKey"), pm = "use-empty-values", hm = ["", void 0, null], gm = void 0, uu = Le({
  emptyValues: Array,
  valueOnClear: {
    type: [String, Number, Boolean, Function],
    default: void 0,
    validator: (e) => it(e) ? !e() : !e
  }
}), vm = (e, t) => {
  const n = We() ? Me(lu, R({})) : R({}), r = D(() => e.emptyValues || n.value.emptyValues || hm), o = D(() => it(e.valueOnClear) ? e.valueOnClear() : e.valueOnClear !== void 0 ? e.valueOnClear : it(n.value.valueOnClear) ? n.value.valueOnClear() : n.value.valueOnClear !== void 0 ? n.value.valueOnClear : gm), a = (i) => r.value.includes(i);
  return r.value.includes(o.value) || qe(pm, "value-on-clear should be a value of empty-values"), {
    emptyValues: r,
    valueOnClear: o,
    isEmptyValue: a
  };
}, bs = (e) => Object.keys(e), Qr = R();
function cu(e, t = void 0) {
  const n = We() ? Me(Pl, Qr) : Qr;
  return e ? D(() => {
    var r, o;
    return (o = (r = n.value) == null ? void 0 : r[e]) != null ? o : t;
  }) : n;
}
const fu = (e, t, n = !1) => {
  var r;
  const o = !!We(), a = o ? cu() : void 0, i = (r = void 0) != null ? r : o ? Nt : void 0;
  if (!i) {
    qe("provideGlobalConfig", "provideGlobalConfig() can only be used inside setup().");
    return;
  }
  const s = D(() => {
    const l = b(e);
    return a != null && a.value ? mm(a.value, l) : l;
  });
  return i(Pl, s), i(ou, D(() => s.value.locale)), i(Dl, D(() => s.value.namespace)), i(nu, D(() => s.value.zIndex)), i(su, {
    size: D(() => s.value.size || "")
  }), i(lu, D(() => ({
    emptyValues: s.value.emptyValues,
    valueOnClear: s.value.valueOnClear
  }))), (n || !Qr.value) && (Qr.value = s.value), s;
}, mm = (e, t) => {
  const n = [.../* @__PURE__ */ new Set([...bs(e), ...bs(t)])], r = {};
  for (const o of n)
    r[o] = t[o] !== void 0 ? t[o] : e[o];
  return r;
}, Kt = "update:modelValue", Zr = "change", Es = "input";
var Re = (e, t) => {
  const n = e.__vccOpts || e;
  for (const [r, o] of t)
    n[r] = o;
  return n;
};
const ym = "utils/dom/style";
function ra(e, t = "px") {
  if (!e)
    return "";
  if (pt(e) || xv(e))
    return `${e}${t}`;
  if (mn(e))
    return e;
  qe(ym, "binding value must be a string or number");
}
function bm(e, t) {
  if (!Qe)
    return;
  if (!t) {
    e.scrollTop = 0;
    return;
  }
  const n = [];
  let r = t.offsetParent;
  for (; r !== null && e !== r && e.contains(r); )
    n.push(r), r = r.offsetParent;
  const o = t.offsetTop + n.reduce((l, u) => l + u.offsetTop, 0), a = o + t.offsetHeight, i = e.scrollTop, s = i + e.clientHeight;
  o < i ? e.scrollTop = o : a > s && (e.scrollTop = a - e.clientHeight);
}
const zt = (e, t) => {
  if (e.install = (n) => {
    for (const r of [e, ...Object.values(t ?? {})])
      n.component(r.name, r);
  }, t)
    for (const [n, r] of Object.entries(t))
      e[n] = r;
  return e;
}, Da = (e) => (e.install = yr, e), Em = Le({
  size: {
    type: ce([Number, String])
  },
  color: {
    type: String
  }
}), Mm = q({
  name: "ElIcon",
  inheritAttrs: !1
}), _m = /* @__PURE__ */ q({
  ...Mm,
  props: Em,
  setup(e) {
    const t = e, n = Fe("icon"), r = D(() => {
      const { size: o, color: a } = t;
      return !o && !a ? {} : {
        fontSize: lr(o) ? void 0 : ra(o),
        "--color": a
      };
    });
    return (o, a) => (j(), X("i", yn({
      class: b(n).b(),
      style: b(r)
    }, o.$attrs), [
      J(o.$slots, "default")
    ], 16));
  }
});
var wm = /* @__PURE__ */ Re(_m, [["__file", "icon.vue"]]);
const xt = zt(wm), Yn = ce([
  String,
  Object,
  Function
]), du = {
  validating: rl,
  success: Ac,
  error: va
}, Tm = () => Qe && /firefox/i.test(window.navigator.userAgent);
let tt;
const Cm = {
  height: "0",
  visibility: "hidden",
  overflow: Tm() ? "" : "hidden",
  position: "absolute",
  "z-index": "-1000",
  top: "0",
  right: "0"
}, Om = [
  "letter-spacing",
  "line-height",
  "padding-top",
  "padding-bottom",
  "font-family",
  "font-weight",
  "font-size",
  "text-rendering",
  "text-transform",
  "width",
  "text-indent",
  "padding-left",
  "padding-right",
  "border-width",
  "box-sizing"
];
function Im(e) {
  const t = window.getComputedStyle(e), n = t.getPropertyValue("box-sizing"), r = Number.parseFloat(t.getPropertyValue("padding-bottom")) + Number.parseFloat(t.getPropertyValue("padding-top")), o = Number.parseFloat(t.getPropertyValue("border-bottom-width")) + Number.parseFloat(t.getPropertyValue("border-top-width"));
  return { contextStyle: Om.map((i) => [
    i,
    t.getPropertyValue(i)
  ]), paddingSize: r, borderSize: o, boxSizing: n };
}
function Ms(e, t = 1, n) {
  var r;
  tt || (tt = document.createElement("textarea"), document.body.appendChild(tt));
  const { paddingSize: o, borderSize: a, boxSizing: i, contextStyle: s } = Im(e);
  s.forEach(([c, d]) => tt == null ? void 0 : tt.style.setProperty(c, d)), Object.entries(Cm).forEach(([c, d]) => tt == null ? void 0 : tt.style.setProperty(c, d, "important")), tt.value = e.value || e.placeholder || "";
  let l = tt.scrollHeight;
  const u = {};
  i === "border-box" ? l = l + a : i === "content-box" && (l = l - o), tt.value = "";
  const f = tt.scrollHeight - o;
  if (pt(t)) {
    let c = f * t;
    i === "border-box" && (c = c + o + a), l = Math.max(c, l), u.minHeight = `${c}px`;
  }
  if (pt(n)) {
    let c = f * n;
    i === "border-box" && (c = c + o + a), l = Math.min(c, l);
  }
  return u.height = `${l}px`, (r = tt.parentNode) == null || r.removeChild(tt), tt = void 0, u;
}
const Nm = (e) => e, Sm = Le({
  ariaLabel: String,
  ariaOrientation: {
    type: String,
    values: ["horizontal", "vertical", "undefined"]
  },
  ariaControls: String
}), Tr = (e) => kv(Sm, e), Am = Le({
  id: {
    type: String,
    default: void 0
  },
  size: vo,
  disabled: Boolean,
  modelValue: {
    type: ce([
      String,
      Number,
      Object
    ]),
    default: ""
  },
  maxlength: {
    type: [String, Number]
  },
  minlength: {
    type: [String, Number]
  },
  type: {
    type: String,
    default: "text"
  },
  resize: {
    type: String,
    values: ["none", "both", "horizontal", "vertical"]
  },
  autosize: {
    type: ce([Boolean, Object]),
    default: !1
  },
  autocomplete: {
    type: String,
    default: "off"
  },
  formatter: {
    type: Function
  },
  parser: {
    type: Function
  },
  placeholder: {
    type: String
  },
  form: {
    type: String
  },
  readonly: Boolean,
  clearable: Boolean,
  showPassword: Boolean,
  showWordLimit: Boolean,
  suffixIcon: {
    type: Yn
  },
  prefixIcon: {
    type: Yn
  },
  containerRole: {
    type: String,
    default: void 0
  },
  tabindex: {
    type: [String, Number],
    default: 0
  },
  validateEvent: {
    type: Boolean,
    default: !0
  },
  inputStyle: {
    type: ce([Object, Array, String]),
    default: () => Nm({})
  },
  autofocus: Boolean,
  rows: {
    type: Number,
    default: 2
  },
  ...Tr(["ariaLabel"])
}), Lm = {
  [Kt]: (e) => mn(e),
  input: (e) => mn(e),
  change: (e) => mn(e),
  focus: (e) => e instanceof FocusEvent,
  blur: (e) => e instanceof FocusEvent,
  clear: () => !0,
  mouseleave: (e) => e instanceof MouseEvent,
  mouseenter: (e) => e instanceof MouseEvent,
  keydown: (e) => e instanceof Event,
  compositionstart: (e) => e instanceof CompositionEvent,
  compositionupdate: (e) => e instanceof CompositionEvent,
  compositionend: (e) => e instanceof CompositionEvent
}, Pm = ["class", "style"], Dm = /^on[A-Z]/, km = (e = {}) => {
  const { excludeListeners: t = !1, excludeKeys: n } = e, r = D(() => ((n == null ? void 0 : n.value) || []).concat(Pm)), o = We();
  return o ? D(() => {
    var a;
    return Xr(Object.entries((a = o.proxy) == null ? void 0 : a.$attrs).filter(([i]) => !r.value.includes(i) && !(t && Dm.test(i))));
  }) : (qe("use-attrs", "getCurrentInstance() returned null. useAttrs() must be called at the top of a setup function"), D(() => ({})));
}, ka = Symbol("formContextKey"), Jr = Symbol("formItemContextKey"), oa = {
  prefix: Math.floor(Math.random() * 1e4),
  current: 0
}, xm = Symbol("elIdInjection"), pu = () => We() ? Me(xm, oa) : oa, mo = (e) => {
  const t = pu();
  !Qe && t === oa && qe("IdInjection", `Looks like you are using server rendering, you must provide a id provider to ensure the hydration process to be succeed
usage: app.provide(ID_INJECTION_KEY, {
  prefix: number,
  current: number,
})`);
  const n = Ca();
  return Ql(() => b(e) || `${n.value}-id-${t.prefix}-${t.current++}`);
}, xa = () => {
  const e = Me(ka, void 0), t = Me(Jr, void 0);
  return {
    form: e,
    formItem: t
  };
}, hu = (e, {
  formItemContext: t,
  disableIdGeneration: n,
  disableIdManagement: r
}) => {
  n || (n = R(!1)), r || (r = R(!1));
  const o = R();
  let a;
  const i = D(() => {
    var s;
    return !!(!(e.label || e.ariaLabel) && t && t.inputIds && ((s = t.inputIds) == null ? void 0 : s.length) <= 1);
  });
  return xe(() => {
    a = Q([wt(e, "id"), n], ([s, l]) => {
      const u = s ?? (l ? void 0 : mo().value);
      u !== o.value && (t != null && t.removeInputId && (o.value && t.removeInputId(o.value), !(r != null && r.value) && !l && u && t.addInputId(u)), o.value = u);
    }, { immediate: !0 });
  }), to(() => {
    a && a(), t != null && t.removeInputId && o.value && t.removeInputId(o.value);
  }), {
    isLabeledByFormItem: i,
    inputId: o
  };
}, Ra = (e) => {
  const t = We();
  return D(() => {
    var n, r;
    return (r = (n = t == null ? void 0 : t.proxy) == null ? void 0 : n.$props) == null ? void 0 : r[e];
  });
}, yo = (e, t = {}) => {
  const n = R(void 0), r = t.prop ? n : Ra("size"), o = t.global ? n : dm(), a = t.form ? { size: void 0 } : Me(ka, void 0), i = t.formItem ? { size: void 0 } : Me(Jr, void 0);
  return D(() => r.value || b(e) || (i == null ? void 0 : i.size) || (a == null ? void 0 : a.size) || o.value || "");
}, Fa = (e) => {
  const t = Ra("disabled"), n = Me(ka, void 0);
  return D(() => t.value || b(e) || (n == null ? void 0 : n.disabled) || !1);
};
function gu(e, {
  beforeFocus: t,
  afterFocus: n,
  beforeBlur: r,
  afterBlur: o
} = {}) {
  const a = We(), { emit: i } = a, s = vn(), l = Ra("disabled"), u = R(!1), f = (h) => {
    it(t) && t(h) || u.value || (u.value = !0, i("focus", h), n == null || n());
  }, c = (h) => {
    var p;
    it(r) && r(h) || h.relatedTarget && ((p = s.value) != null && p.contains(h.relatedTarget)) || (u.value = !1, i("blur", h), o == null || o());
  }, d = () => {
    var h, p;
    (h = s.value) != null && h.contains(document.activeElement) && s.value !== document.activeElement || l.value || (p = e.value) == null || p.focus();
  };
  return Q([s, l], ([h, p]) => {
    h && (p ? h.removeAttribute("tabindex") : h.setAttribute("tabindex", "-1"));
  }), _t(s, "focus", f, !0), _t(s, "blur", c, !0), _t(s, "click", d, !0), process.env.NODE_ENV === "test" && xe(() => {
    const h = Jt(e.value) ? e.value : document.querySelector("input,textarea");
    h && (_t(h, "focus", f, !0), _t(h, "blur", c, !0));
  }), {
    isFocused: u,
    wrapperRef: s,
    handleFocus: f,
    handleBlur: c
  };
}
const Rm = (e) => /([\uAC00-\uD7AF\u3130-\u318F])+/gi.test(e);
function vu({
  afterComposition: e,
  emit: t
}) {
  const n = R(!1), r = (s) => {
    t == null || t("compositionstart", s), n.value = !0;
  }, o = (s) => {
    var l;
    t == null || t("compositionupdate", s);
    const u = (l = s.target) == null ? void 0 : l.value, f = u[u.length - 1] || "";
    n.value = !Rm(f);
  }, a = (s) => {
    t == null || t("compositionend", s), n.value && (n.value = !1, Ne(() => e(s)));
  };
  return {
    isComposing: n,
    handleComposition: (s) => {
      s.type === "compositionend" ? a(s) : o(s);
    },
    handleCompositionStart: r,
    handleCompositionUpdate: o,
    handleCompositionEnd: a
  };
}
function Fm(e) {
  let t;
  function n() {
    if (e.value == null)
      return;
    const { selectionStart: o, selectionEnd: a, value: i } = e.value;
    if (o == null || a == null)
      return;
    const s = i.slice(0, Math.max(0, o)), l = i.slice(Math.max(0, a));
    t = {
      selectionStart: o,
      selectionEnd: a,
      value: i,
      beforeTxt: s,
      afterTxt: l
    };
  }
  function r() {
    if (e.value == null || t == null)
      return;
    const { value: o } = e.value, { beforeTxt: a, afterTxt: i, selectionStart: s } = t;
    if (a == null || i == null || s == null)
      return;
    let l = o.length;
    if (o.endsWith(i))
      l = o.length - i.length;
    else if (o.startsWith(a))
      l = a.length;
    else {
      const u = a[s - 1], f = o.indexOf(u, s - 1);
      f !== -1 && (l = f + 1);
    }
    e.value.setSelectionRange(l, l);
  }
  return [n, r];
}
const mu = "ElInput", jm = q({
  name: mu,
  inheritAttrs: !1
}), Bm = /* @__PURE__ */ q({
  ...jm,
  props: Am,
  emits: Lm,
  setup(e, { expose: t, emit: n }) {
    const r = e, o = mc(), a = km(), i = tl(), s = D(() => [
      r.type === "textarea" ? g.b() : p.b(),
      p.m(d.value),
      p.is("disabled", h.value),
      p.is("exceed", je.value),
      {
        [p.b("group")]: i.prepend || i.append,
        [p.m("prefix")]: i.prefix || r.prefixIcon,
        [p.m("suffix")]: i.suffix || r.suffixIcon || r.clearable || r.showPassword,
        [p.bm("suffix", "password-clear")]: G.value && pe.value,
        [p.b("hidden")]: r.type === "hidden"
      },
      o.class
    ]), l = D(() => [
      p.e("wrapper"),
      p.is("focus", x.value)
    ]), { form: u, formItem: f } = xa(), { inputId: c } = hu(r, {
      formItemContext: f
    }), d = yo(), h = Fa(), p = Fe("input"), g = Fe("textarea"), E = vn(), v = vn(), m = R(!1), y = R(!1), _ = R(), T = vn(r.inputStyle), N = D(() => E.value || v.value), { wrapperRef: I, isFocused: x, handleFocus: B, handleBlur: H } = gu(N, {
      beforeFocus() {
        return h.value;
      },
      afterBlur() {
        var k;
        r.validateEvent && ((k = f == null ? void 0 : f.validate) == null || k.call(f, "blur").catch((S) => qe(S)));
      }
    }), ee = D(() => {
      var k;
      return (k = u == null ? void 0 : u.statusIcon) != null ? k : !1;
    }), L = D(() => (f == null ? void 0 : f.validateState) || ""), V = D(() => L.value && du[L.value]), me = D(() => y.value ? Lc : Pc), fe = D(() => [
      o.style
    ]), ie = D(() => [
      r.inputStyle,
      T.value,
      { resize: r.resize }
    ]), ne = D(() => fo(r.modelValue) ? "" : String(r.modelValue)), G = D(() => r.clearable && !h.value && !r.readonly && !!ne.value && (x.value || m.value)), pe = D(() => r.showPassword && !h.value && !!ne.value && (!!ne.value || x.value)), he = D(() => r.showWordLimit && !!r.maxlength && (r.type === "text" || r.type === "textarea") && !h.value && !r.readonly && !r.showPassword), Ie = D(() => ne.value.length), je = D(() => !!he.value && Ie.value > Number(r.maxlength)), Ge = D(() => !!i.suffix || !!r.suffixIcon || G.value || r.showPassword || he.value || !!L.value && ee.value), [Pe, Se] = Fm(E);
    Gt(v, (k) => {
      if (A(), !he.value || r.resize !== "both")
        return;
      const S = k[0], { width: F } = S.contentRect;
      _.value = {
        right: `calc(100% - ${F + 15 + 6}px)`
      };
    });
    const Be = () => {
      const { type: k, autosize: S } = r;
      if (!(!Qe || k !== "textarea" || !v.value))
        if (S) {
          const F = vt(S) ? S.minRows : void 0, se = vt(S) ? S.maxRows : void 0, ye = Ms(v.value, F, se);
          T.value = {
            overflowY: "hidden",
            ...ye
          }, Ne(() => {
            v.value.offsetHeight, T.value = ye;
          });
        } else
          T.value = {
            minHeight: Ms(v.value).minHeight
          };
    }, A = ((k) => {
      let S = !1;
      return () => {
        var F;
        if (S || !r.autosize)
          return;
        ((F = v.value) == null ? void 0 : F.offsetParent) === null || (k(), S = !0);
      };
    })(Be), W = () => {
      const k = N.value, S = r.formatter ? r.formatter(ne.value) : ne.value;
      !k || k.value === S || (k.value = S);
    }, de = async (k) => {
      Pe();
      let { value: S } = k.target;
      if (r.formatter && r.parser && (S = r.parser(S)), !$e.value) {
        if (S === ne.value) {
          W();
          return;
        }
        n(Kt, S), n(Es, S), await Ne(), W(), Se();
      }
    }, we = (k) => {
      let { value: S } = k.target;
      r.formatter && r.parser && (S = r.parser(S)), n(Zr, S);
    }, {
      isComposing: $e,
      handleCompositionStart: Te,
      handleCompositionUpdate: ze,
      handleCompositionEnd: Ae
    } = vu({ emit: n, afterComposition: de }), De = () => {
      Pe(), y.value = !y.value, setTimeout(Se);
    }, ht = () => {
      var k;
      return (k = N.value) == null ? void 0 : k.focus();
    }, M = () => {
      var k;
      return (k = N.value) == null ? void 0 : k.blur();
    }, C = (k) => {
      m.value = !1, n("mouseleave", k);
    }, w = (k) => {
      m.value = !0, n("mouseenter", k);
    }, $ = (k) => {
      n("keydown", k);
    }, re = () => {
      var k;
      (k = N.value) == null || k.select();
    }, be = () => {
      n(Kt, ""), n(Zr, ""), n("clear"), n(Es, "");
    };
    return Q(() => r.modelValue, () => {
      var k;
      Ne(() => Be()), r.validateEvent && ((k = f == null ? void 0 : f.validate) == null || k.call(f, "change").catch((S) => qe(S)));
    }), Q(ne, () => W()), Q(() => r.type, async () => {
      await Ne(), W(), Be();
    }), xe(() => {
      !r.formatter && r.parser && qe(mu, "If you set the parser, you also need to set the formatter."), W(), Ne(Be);
    }), t({
      input: E,
      textarea: v,
      ref: N,
      textareaStyle: ie,
      autosize: wt(r, "autosize"),
      isComposing: $e,
      focus: ht,
      blur: M,
      select: re,
      clear: be,
      resizeTextarea: Be
    }), (k, S) => (j(), X("div", {
      class: Y([
        b(s),
        {
          [b(p).bm("group", "append")]: k.$slots.append,
          [b(p).bm("group", "prepend")]: k.$slots.prepend
        }
      ]),
      style: mt(b(fe)),
      onMouseenter: w,
      onMouseleave: C
    }, [
      te(" input "),
      k.type !== "textarea" ? (j(), X(Xe, { key: 0 }, [
        te(" prepend slot "),
        k.$slots.prepend ? (j(), X("div", {
          key: 0,
          class: Y(b(p).be("group", "prepend"))
        }, [
          J(k.$slots, "prepend")
        ], 2)) : te("v-if", !0),
        Z("div", {
          ref_key: "wrapperRef",
          ref: I,
          class: Y(b(l))
        }, [
          te(" prefix slot "),
          k.$slots.prefix || k.prefixIcon ? (j(), X("span", {
            key: 0,
            class: Y(b(p).e("prefix"))
          }, [
            Z("span", {
              class: Y(b(p).e("prefix-inner"))
            }, [
              J(k.$slots, "prefix"),
              k.prefixIcon ? (j(), ue(b(xt), {
                key: 0,
                class: Y(b(p).e("icon"))
              }, {
                default: ae(() => [
                  (j(), ue(Tt(k.prefixIcon)))
                ]),
                _: 1
              }, 8, ["class"])) : te("v-if", !0)
            ], 2)
          ], 2)) : te("v-if", !0),
          Z("input", yn({
            id: b(c),
            ref_key: "input",
            ref: E,
            class: b(p).e("inner")
          }, b(a), {
            minlength: k.minlength,
            maxlength: k.maxlength,
            type: k.showPassword ? y.value ? "text" : "password" : k.type,
            disabled: b(h),
            readonly: k.readonly,
            autocomplete: k.autocomplete,
            tabindex: k.tabindex,
            "aria-label": k.ariaLabel,
            placeholder: k.placeholder,
            style: k.inputStyle,
            form: k.form,
            autofocus: k.autofocus,
            role: k.containerRole,
            onCompositionstart: b(Te),
            onCompositionupdate: b(ze),
            onCompositionend: b(Ae),
            onInput: de,
            onChange: we,
            onKeydown: $
          }), null, 16, ["id", "minlength", "maxlength", "type", "disabled", "readonly", "autocomplete", "tabindex", "aria-label", "placeholder", "form", "autofocus", "role", "onCompositionstart", "onCompositionupdate", "onCompositionend"]),
          te(" suffix slot "),
          b(Ge) ? (j(), X("span", {
            key: 1,
            class: Y(b(p).e("suffix"))
          }, [
            Z("span", {
              class: Y(b(p).e("suffix-inner"))
            }, [
              !b(G) || !b(pe) || !b(he) ? (j(), X(Xe, { key: 0 }, [
                J(k.$slots, "suffix"),
                k.suffixIcon ? (j(), ue(b(xt), {
                  key: 0,
                  class: Y(b(p).e("icon"))
                }, {
                  default: ae(() => [
                    (j(), ue(Tt(k.suffixIcon)))
                  ]),
                  _: 1
                }, 8, ["class"])) : te("v-if", !0)
              ], 64)) : te("v-if", !0),
              b(G) ? (j(), ue(b(xt), {
                key: 1,
                class: Y([b(p).e("icon"), b(p).e("clear")]),
                onMousedown: nt(b(yr), ["prevent"]),
                onClick: be
              }, {
                default: ae(() => [
                  Ee(b(va))
                ]),
                _: 1
              }, 8, ["class", "onMousedown"])) : te("v-if", !0),
              b(pe) ? (j(), ue(b(xt), {
                key: 2,
                class: Y([b(p).e("icon"), b(p).e("password")]),
                onClick: De
              }, {
                default: ae(() => [
                  (j(), ue(Tt(b(me))))
                ]),
                _: 1
              }, 8, ["class"])) : te("v-if", !0),
              b(he) ? (j(), X("span", {
                key: 3,
                class: Y(b(p).e("count"))
              }, [
                Z("span", {
                  class: Y(b(p).e("count-inner"))
                }, ot(b(Ie)) + " / " + ot(k.maxlength), 3)
              ], 2)) : te("v-if", !0),
              b(L) && b(V) && b(ee) ? (j(), ue(b(xt), {
                key: 4,
                class: Y([
                  b(p).e("icon"),
                  b(p).e("validateIcon"),
                  b(p).is("loading", b(L) === "validating")
                ])
              }, {
                default: ae(() => [
                  (j(), ue(Tt(b(V))))
                ]),
                _: 1
              }, 8, ["class"])) : te("v-if", !0)
            ], 2)
          ], 2)) : te("v-if", !0)
        ], 2),
        te(" append slot "),
        k.$slots.append ? (j(), X("div", {
          key: 1,
          class: Y(b(p).be("group", "append"))
        }, [
          J(k.$slots, "append")
        ], 2)) : te("v-if", !0)
      ], 64)) : (j(), X(Xe, { key: 1 }, [
        te(" textarea "),
        Z("textarea", yn({
          id: b(c),
          ref_key: "textarea",
          ref: v,
          class: [b(g).e("inner"), b(p).is("focus", b(x))]
        }, b(a), {
          minlength: k.minlength,
          maxlength: k.maxlength,
          tabindex: k.tabindex,
          disabled: b(h),
          readonly: k.readonly,
          autocomplete: k.autocomplete,
          style: b(ie),
          "aria-label": k.ariaLabel,
          placeholder: k.placeholder,
          form: k.form,
          autofocus: k.autofocus,
          rows: k.rows,
          role: k.containerRole,
          onCompositionstart: b(Te),
          onCompositionupdate: b(ze),
          onCompositionend: b(Ae),
          onInput: de,
          onFocus: b(B),
          onBlur: b(H),
          onChange: we,
          onKeydown: $
        }), null, 16, ["id", "minlength", "maxlength", "tabindex", "disabled", "readonly", "autocomplete", "aria-label", "placeholder", "form", "autofocus", "rows", "role", "onCompositionstart", "onCompositionupdate", "onCompositionend", "onFocus", "onBlur"]),
        b(he) ? (j(), X("span", {
          key: 0,
          style: mt(_.value),
          class: Y(b(p).e("count"))
        }, ot(b(Ie)) + " / " + ot(k.maxlength), 7)) : te("v-if", !0)
      ], 64))
    ], 38));
  }
});
var $m = /* @__PURE__ */ Re(Bm, [["__file", "input.vue"]]);
const zm = zt($m), jn = 4, Vm = {
  vertical: {
    offset: "offsetHeight",
    scroll: "scrollTop",
    scrollSize: "scrollHeight",
    size: "height",
    key: "vertical",
    axis: "Y",
    client: "clientY",
    direction: "top"
  },
  horizontal: {
    offset: "offsetWidth",
    scroll: "scrollLeft",
    scrollSize: "scrollWidth",
    size: "width",
    key: "horizontal",
    axis: "X",
    client: "clientX",
    direction: "left"
  }
}, Um = ({
  move: e,
  size: t,
  bar: n
}) => ({
  [n.size]: t,
  transform: `translate${n.axis}(${e}%)`
}), ja = Symbol("scrollbarContextKey"), Wm = Le({
  vertical: Boolean,
  size: String,
  move: Number,
  ratio: {
    type: Number,
    required: !0
  },
  always: Boolean
}), Hm = "Thumb", Ym = /* @__PURE__ */ q({
  __name: "thumb",
  props: Wm,
  setup(e) {
    const t = e, n = Me(ja), r = Fe("scrollbar");
    n || tu(Hm, "can not inject scrollbar context");
    const o = R(), a = R(), i = R({}), s = R(!1);
    let l = !1, u = !1, f = Qe ? document.onselectstart : null;
    const c = D(() => Vm[t.vertical ? "vertical" : "horizontal"]), d = D(() => Um({
      size: t.size,
      move: t.move,
      bar: c.value
    })), h = D(() => o.value[c.value.offset] ** 2 / n.wrapElement[c.value.scrollSize] / t.ratio / a.value[c.value.offset]), p = (N) => {
      var I;
      if (N.stopPropagation(), N.ctrlKey || [1, 2].includes(N.button))
        return;
      (I = window.getSelection()) == null || I.removeAllRanges(), E(N);
      const x = N.currentTarget;
      x && (i.value[c.value.axis] = x[c.value.offset] - (N[c.value.client] - x.getBoundingClientRect()[c.value.direction]));
    }, g = (N) => {
      if (!a.value || !o.value || !n.wrapElement)
        return;
      const I = Math.abs(N.target.getBoundingClientRect()[c.value.direction] - N[c.value.client]), x = a.value[c.value.offset] / 2, B = (I - x) * 100 * h.value / o.value[c.value.offset];
      n.wrapElement[c.value.scroll] = B * n.wrapElement[c.value.scrollSize] / 100;
    }, E = (N) => {
      N.stopImmediatePropagation(), l = !0, document.addEventListener("mousemove", v), document.addEventListener("mouseup", m), f = document.onselectstart, document.onselectstart = () => !1;
    }, v = (N) => {
      if (!o.value || !a.value || l === !1)
        return;
      const I = i.value[c.value.axis];
      if (!I)
        return;
      const x = (o.value.getBoundingClientRect()[c.value.direction] - N[c.value.client]) * -1, B = a.value[c.value.offset] - I, H = (x - B) * 100 * h.value / o.value[c.value.offset];
      n.wrapElement[c.value.scroll] = H * n.wrapElement[c.value.scrollSize] / 100;
    }, m = () => {
      l = !1, i.value[c.value.axis] = 0, document.removeEventListener("mousemove", v), document.removeEventListener("mouseup", m), T(), u && (s.value = !1);
    }, y = () => {
      u = !1, s.value = !!t.size;
    }, _ = () => {
      u = !0, s.value = l;
    };
    Bt(() => {
      T(), document.removeEventListener("mouseup", m);
    });
    const T = () => {
      document.onselectstart !== f && (document.onselectstart = f);
    };
    return _t(wt(n, "scrollbarElement"), "mousemove", y), _t(wt(n, "scrollbarElement"), "mouseleave", _), (N, I) => (j(), ue(ha, {
      name: b(r).b("fade"),
      persisted: ""
    }, {
      default: ae(() => [
        st(Z("div", {
          ref_key: "instance",
          ref: o,
          class: Y([b(r).e("bar"), b(r).is(b(c).key)]),
          onMousedown: g,
          onClick: nt(() => {
          }, ["stop"])
        }, [
          Z("div", {
            ref_key: "thumb",
            ref: a,
            class: Y(b(r).e("thumb")),
            style: mt(b(d)),
            onMousedown: p
          }, null, 38)
        ], 42, ["onClick"]), [
          [St, N.always || s.value]
        ])
      ]),
      _: 1
    }, 8, ["name"]));
  }
});
var _s = /* @__PURE__ */ Re(Ym, [["__file", "thumb.vue"]]);
const Gm = Le({
  always: {
    type: Boolean,
    default: !0
  },
  minSize: {
    type: Number,
    required: !0
  }
}), Km = /* @__PURE__ */ q({
  __name: "bar",
  props: Gm,
  setup(e, { expose: t }) {
    const n = e, r = Me(ja), o = R(0), a = R(0), i = R(""), s = R(""), l = R(1), u = R(1);
    return t({
      handleScroll: (d) => {
        if (d) {
          const h = d.offsetHeight - jn, p = d.offsetWidth - jn;
          a.value = d.scrollTop * 100 / h * l.value, o.value = d.scrollLeft * 100 / p * u.value;
        }
      },
      update: () => {
        const d = r == null ? void 0 : r.wrapElement;
        if (!d)
          return;
        const h = d.offsetHeight - jn, p = d.offsetWidth - jn, g = h ** 2 / d.scrollHeight, E = p ** 2 / d.scrollWidth, v = Math.max(g, n.minSize), m = Math.max(E, n.minSize);
        l.value = g / (h - g) / (v / (h - v)), u.value = E / (p - E) / (m / (p - m)), s.value = v + jn < h ? `${v}px` : "", i.value = m + jn < p ? `${m}px` : "";
      }
    }), (d, h) => (j(), X(Xe, null, [
      Ee(_s, {
        move: o.value,
        ratio: u.value,
        size: i.value,
        always: d.always
      }, null, 8, ["move", "ratio", "size", "always"]),
      Ee(_s, {
        move: a.value,
        ratio: l.value,
        size: s.value,
        vertical: "",
        always: d.always
      }, null, 8, ["move", "ratio", "size", "always"])
    ], 64));
  }
});
var Xm = /* @__PURE__ */ Re(Km, [["__file", "bar.vue"]]);
const Qm = Le({
  height: {
    type: [String, Number],
    default: ""
  },
  maxHeight: {
    type: [String, Number],
    default: ""
  },
  native: {
    type: Boolean,
    default: !1
  },
  wrapStyle: {
    type: ce([String, Object, Array]),
    default: ""
  },
  wrapClass: {
    type: [String, Array],
    default: ""
  },
  viewClass: {
    type: [String, Array],
    default: ""
  },
  viewStyle: {
    type: [String, Array, Object],
    default: ""
  },
  noresize: Boolean,
  tag: {
    type: String,
    default: "div"
  },
  always: Boolean,
  minSize: {
    type: Number,
    default: 20
  },
  tabindex: {
    type: [String, Number],
    default: void 0
  },
  id: String,
  role: String,
  ...Tr(["ariaLabel", "ariaOrientation"])
}), yu = {
  scroll: ({
    scrollTop: e,
    scrollLeft: t
  }) => [e, t].every(pt)
}, aa = "ElScrollbar", Zm = q({
  name: aa
}), Jm = /* @__PURE__ */ q({
  ...Zm,
  props: Qm,
  emits: yu,
  setup(e, { expose: t, emit: n }) {
    const r = e, o = Fe("scrollbar");
    let a, i, s = 0, l = 0;
    const u = R(), f = R(), c = R(), d = R(), h = D(() => {
      const T = {};
      return r.height && (T.height = ra(r.height)), r.maxHeight && (T.maxHeight = ra(r.maxHeight)), [r.wrapStyle, T];
    }), p = D(() => [
      r.wrapClass,
      o.e("wrap"),
      { [o.em("wrap", "hidden-default")]: !r.native }
    ]), g = D(() => [o.e("view"), r.viewClass]), E = () => {
      var T;
      f.value && ((T = d.value) == null || T.handleScroll(f.value), s = f.value.scrollTop, l = f.value.scrollLeft, n("scroll", {
        scrollTop: f.value.scrollTop,
        scrollLeft: f.value.scrollLeft
      }));
    };
    function v(T, N) {
      vt(T) ? f.value.scrollTo(T) : pt(T) && pt(N) && f.value.scrollTo(T, N);
    }
    const m = (T) => {
      if (!pt(T)) {
        qe(aa, "value must be a number");
        return;
      }
      f.value.scrollTop = T;
    }, y = (T) => {
      if (!pt(T)) {
        qe(aa, "value must be a number");
        return;
      }
      f.value.scrollLeft = T;
    }, _ = () => {
      var T;
      (T = d.value) == null || T.update();
    };
    return Q(() => r.noresize, (T) => {
      T ? (a == null || a(), i == null || i()) : ({ stop: a } = Gt(c, _), i = _t("resize", _));
    }, { immediate: !0 }), Q(() => [r.maxHeight, r.height], () => {
      r.native || Ne(() => {
        var T;
        _(), f.value && ((T = d.value) == null || T.handleScroll(f.value));
      });
    }), Nt(ja, Ln({
      scrollbarElement: u,
      wrapElement: f
    })), yc(() => {
      f.value && (f.value.scrollTop = s, f.value.scrollLeft = l);
    }), xe(() => {
      r.native || Ne(() => {
        _();
      });
    }), bc(() => _()), t({
      wrapRef: f,
      update: _,
      scrollTo: v,
      setScrollTop: m,
      setScrollLeft: y,
      handleScroll: E
    }), (T, N) => (j(), X("div", {
      ref_key: "scrollbarRef",
      ref: u,
      class: Y(b(o).b())
    }, [
      Z("div", {
        ref_key: "wrapRef",
        ref: f,
        class: Y(b(p)),
        style: mt(b(h)),
        tabindex: T.tabindex,
        onScroll: E
      }, [
        (j(), ue(Tt(T.tag), {
          id: T.id,
          ref_key: "resizeRef",
          ref: c,
          class: Y(b(g)),
          style: mt(T.viewStyle),
          role: T.role,
          "aria-label": T.ariaLabel,
          "aria-orientation": T.ariaOrientation
        }, {
          default: ae(() => [
            J(T.$slots, "default")
          ]),
          _: 3
        }, 8, ["id", "class", "style", "role", "aria-label", "aria-orientation"]))
      ], 46, ["tabindex"]),
      T.native ? te("v-if", !0) : (j(), ue(Xm, {
        key: 0,
        ref_key: "barRef",
        ref: d,
        always: T.always,
        "min-size": T.minSize
      }, null, 8, ["always", "min-size"]))
    ], 2));
  }
});
var qm = /* @__PURE__ */ Re(Jm, [["__file", "scrollbar.vue"]]);
const e0 = zt(qm), Ba = Symbol("popper"), bu = Symbol("popperContent"), t0 = [
  "dialog",
  "grid",
  "group",
  "listbox",
  "menu",
  "navigation",
  "tooltip",
  "tree"
], Eu = Le({
  role: {
    type: String,
    values: t0,
    default: "tooltip"
  }
}), n0 = q({
  name: "ElPopper",
  inheritAttrs: !1
}), r0 = /* @__PURE__ */ q({
  ...n0,
  props: Eu,
  setup(e, { expose: t }) {
    const n = e, r = R(), o = R(), a = R(), i = R(), s = D(() => n.role), l = {
      triggerRef: r,
      popperInstanceRef: o,
      contentRef: a,
      referenceRef: i,
      role: s
    };
    return t(l), Nt(Ba, l), (u, f) => J(u.$slots, "default");
  }
});
var o0 = /* @__PURE__ */ Re(r0, [["__file", "popper.vue"]]);
const Mu = Le({
  arrowOffset: {
    type: Number,
    default: 5
  }
}), a0 = q({
  name: "ElPopperArrow",
  inheritAttrs: !1
}), i0 = /* @__PURE__ */ q({
  ...a0,
  props: Mu,
  setup(e, { expose: t }) {
    const n = e, r = Fe("popper"), { arrowOffset: o, arrowRef: a, arrowStyle: i } = Me(bu, void 0);
    return Q(() => n.arrowOffset, (s) => {
      o.value = s;
    }), Bt(() => {
      a.value = void 0;
    }), t({
      arrowRef: a
    }), (s, l) => (j(), X("span", {
      ref_key: "arrowRef",
      ref: a,
      class: Y(b(r).e("arrow")),
      style: mt(b(i)),
      "data-popper-arrow": ""
    }, null, 6));
  }
});
var s0 = /* @__PURE__ */ Re(i0, [["__file", "arrow.vue"]]);
const _u = Le({
  virtualRef: {
    type: ce(Object)
  },
  virtualTriggering: Boolean,
  onMouseenter: {
    type: ce(Function)
  },
  onMouseleave: {
    type: ce(Function)
  },
  onClick: {
    type: ce(Function)
  },
  onKeydown: {
    type: ce(Function)
  },
  onFocus: {
    type: ce(Function)
  },
  onBlur: {
    type: ce(Function)
  },
  onContextmenu: {
    type: ce(Function)
  },
  id: String,
  open: Boolean
}), wu = Symbol("elForwardRef"), l0 = (e) => {
  Nt(wu, {
    setForwardRef: (n) => {
      e.value = n;
    }
  });
}, u0 = (e) => ({
  mounted(t) {
    e(t);
  },
  updated(t) {
    e(t);
  },
  unmounted() {
    e(null);
  }
}), ia = (e) => {
  if (e.tabIndex > 0 || e.tabIndex === 0 && e.getAttribute("tabIndex") !== null)
    return !0;
  if (e.tabIndex < 0 || e.hasAttribute("disabled") || e.getAttribute("aria-disabled") === "true")
    return !1;
  switch (e.nodeName) {
    case "A":
      return !!e.href && e.rel !== "ignore";
    case "INPUT":
      return !(e.type === "hidden" || e.type === "file");
    case "BUTTON":
    case "SELECT":
    case "TEXTAREA":
      return !0;
    default:
      return !1;
  }
}, Po = "ElOnlyChild", c0 = q({
  name: Po,
  setup(e, {
    slots: t,
    attrs: n
  }) {
    var r;
    const o = Me(wu), a = u0((r = o == null ? void 0 : o.setForwardRef) != null ? r : yr);
    return () => {
      var i;
      const s = (i = t.default) == null ? void 0 : i.call(t, n);
      if (!s)
        return null;
      if (s.length > 1)
        return qe(Po, "requires exact only one valid child."), null;
      const l = Tu(s);
      return l ? st(Ec(l, n), [[a]]) : (qe(Po, "no valid child node found"), null);
    };
  }
});
function Tu(e) {
  if (!e)
    return null;
  const t = e;
  for (const n of t) {
    if (vt(n))
      switch (n.type) {
        case Mc:
          continue;
        case pa:
        case "svg":
          return ws(n);
        case Xe:
          return Tu(n.children);
        default:
          return n;
      }
    return ws(n);
  }
  return null;
}
function ws(e) {
  const t = Fe("only-child");
  return Ee("span", {
    class: t.e("content")
  }, [e]);
}
const f0 = q({
  name: "ElPopperTrigger",
  inheritAttrs: !1
}), d0 = /* @__PURE__ */ q({
  ...f0,
  props: _u,
  setup(e, { expose: t }) {
    const n = e, { role: r, triggerRef: o } = Me(Ba, void 0);
    l0(o);
    const a = D(() => s.value ? n.id : void 0), i = D(() => {
      if (r && r.value === "tooltip")
        return n.open && n.id ? n.id : void 0;
    }), s = D(() => {
      if (r && r.value !== "tooltip")
        return r.value;
    }), l = D(() => s.value ? `${n.open}` : void 0);
    let u;
    const f = [
      "onMouseenter",
      "onMouseleave",
      "onClick",
      "onKeydown",
      "onFocus",
      "onBlur",
      "onContextmenu"
    ];
    return xe(() => {
      Q(() => n.virtualRef, (c) => {
        c && (o.value = Qt(c));
      }, {
        immediate: !0
      }), Q(o, (c, d) => {
        u == null || u(), u = void 0, Jt(c) && (f.forEach((h) => {
          var p;
          const g = n[h];
          g && (c.addEventListener(h.slice(2).toLowerCase(), g), (p = d == null ? void 0 : d.removeEventListener) == null || p.call(d, h.slice(2).toLowerCase(), g));
        }), ia(c) && (u = Q([a, i, s, l], (h) => {
          [
            "aria-controls",
            "aria-describedby",
            "aria-haspopup",
            "aria-expanded"
          ].forEach((p, g) => {
            fo(h[g]) ? c.removeAttribute(p) : c.setAttribute(p, h[g]);
          });
        }, { immediate: !0 }))), Jt(d) && ia(d) && [
          "aria-controls",
          "aria-describedby",
          "aria-haspopup",
          "aria-expanded"
        ].forEach((h) => d.removeAttribute(h));
      }, {
        immediate: !0
      });
    }), Bt(() => {
      if (u == null || u(), u = void 0, o.value && Jt(o.value)) {
        const c = o.value;
        f.forEach((d) => {
          const h = n[d];
          h && c.removeEventListener(d.slice(2).toLowerCase(), h);
        }), o.value = void 0;
      }
    }), t({
      triggerRef: o
    }), (c, d) => c.virtualTriggering ? te("v-if", !0) : (j(), ue(b(c0), yn({ key: 0 }, c.$attrs, {
      "aria-controls": b(a),
      "aria-describedby": b(i),
      "aria-expanded": b(l),
      "aria-haspopup": b(s)
    }), {
      default: ae(() => [
        J(c.$slots, "default")
      ]),
      _: 3
    }, 16, ["aria-controls", "aria-describedby", "aria-expanded", "aria-haspopup"]));
  }
});
var p0 = /* @__PURE__ */ Re(d0, [["__file", "trigger.vue"]]);
const Do = "focus-trap.focus-after-trapped", ko = "focus-trap.focus-after-released", h0 = "focus-trap.focusout-prevented", Ts = {
  cancelable: !0,
  bubbles: !1
}, g0 = {
  cancelable: !0,
  bubbles: !1
}, Cs = "focusAfterTrapped", Os = "focusAfterReleased", v0 = Symbol("elFocusTrap"), $a = R(), bo = R(0), za = R(0);
let xr = 0;
const Cu = (e) => {
  const t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (r) => {
      const o = r.tagName === "INPUT" && r.type === "hidden";
      return r.disabled || r.hidden || o ? NodeFilter.FILTER_SKIP : r.tabIndex >= 0 || r === document.activeElement ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; n.nextNode(); )
    t.push(n.currentNode);
  return t;
}, Is = (e, t) => {
  for (const n of e)
    if (!m0(n, t))
      return n;
}, m0 = (e, t) => {
  if (process.env.NODE_ENV === "test")
    return !1;
  if (getComputedStyle(e).visibility === "hidden")
    return !0;
  for (; e; ) {
    if (t && e === t)
      return !1;
    if (getComputedStyle(e).display === "none")
      return !0;
    e = e.parentElement;
  }
  return !1;
}, y0 = (e) => {
  const t = Cu(e), n = Is(t, e), r = Is(t.reverse(), e);
  return [n, r];
}, b0 = (e) => e instanceof HTMLInputElement && "select" in e, Ht = (e, t) => {
  if (e && e.focus) {
    const n = document.activeElement;
    let r = !1;
    Jt(e) && !ia(e) && !e.getAttribute("tabindex") && (e.setAttribute("tabindex", "-1"), r = !0), e.focus({ preventScroll: !0 }), za.value = window.performance.now(), e !== n && b0(e) && t && e.select(), Jt(e) && r && e.removeAttribute("tabindex");
  }
};
function Ns(e, t) {
  const n = [...e], r = e.indexOf(t);
  return r !== -1 && n.splice(r, 1), n;
}
const E0 = () => {
  let e = [];
  return {
    push: (r) => {
      const o = e[0];
      o && r !== o && o.pause(), e = Ns(e, r), e.unshift(r);
    },
    remove: (r) => {
      var o, a;
      e = Ns(e, r), (a = (o = e[0]) == null ? void 0 : o.resume) == null || a.call(o);
    }
  };
}, M0 = (e, t = !1) => {
  const n = document.activeElement;
  for (const r of e)
    if (Ht(r, t), document.activeElement !== n)
      return;
}, Ss = E0(), _0 = () => bo.value > za.value, Rr = () => {
  $a.value = "pointer", bo.value = window.performance.now();
}, As = () => {
  $a.value = "keyboard", bo.value = window.performance.now();
}, w0 = () => (xe(() => {
  xr === 0 && (document.addEventListener("mousedown", Rr), document.addEventListener("touchstart", Rr), document.addEventListener("keydown", As)), xr++;
}), Bt(() => {
  xr--, xr <= 0 && (document.removeEventListener("mousedown", Rr), document.removeEventListener("touchstart", Rr), document.removeEventListener("keydown", As));
}), {
  focusReason: $a,
  lastUserFocusTimestamp: bo,
  lastAutomatedFocusTimestamp: za
}), Fr = (e) => new CustomEvent(h0, {
  ...g0,
  detail: e
}), Vn = {
  tab: "Tab",
  enter: "Enter",
  space: "Space",
  esc: "Escape",
  delete: "Delete",
  numpadEnter: "NumpadEnter"
};
let zn = [];
const Ls = (e) => {
  e.code === Vn.esc && zn.forEach((t) => t(e));
}, T0 = (e) => {
  xe(() => {
    zn.length === 0 && document.addEventListener("keydown", Ls), Qe && zn.push(e);
  }), Bt(() => {
    zn = zn.filter((t) => t !== e), zn.length === 0 && Qe && document.removeEventListener("keydown", Ls);
  });
}, C0 = q({
  name: "ElFocusTrap",
  inheritAttrs: !1,
  props: {
    loop: Boolean,
    trapped: Boolean,
    focusTrapEl: Object,
    focusStartEl: {
      type: [Object, String],
      default: "first"
    }
  },
  emits: [
    Cs,
    Os,
    "focusin",
    "focusout",
    "focusout-prevented",
    "release-requested"
  ],
  setup(e, { emit: t }) {
    const n = R();
    let r, o;
    const { focusReason: a } = w0();
    T0((p) => {
      e.trapped && !i.paused && t("release-requested", p);
    });
    const i = {
      paused: !1,
      pause() {
        this.paused = !0;
      },
      resume() {
        this.paused = !1;
      }
    }, s = (p) => {
      if (!e.loop && !e.trapped || i.paused)
        return;
      const { code: g, altKey: E, ctrlKey: v, metaKey: m, currentTarget: y, shiftKey: _ } = p, { loop: T } = e, N = g === Vn.tab && !E && !v && !m, I = document.activeElement;
      if (N && I) {
        const x = y, [B, H] = y0(x);
        if (B && H) {
          if (!_ && I === H) {
            const L = Fr({
              focusReason: a.value
            });
            t("focusout-prevented", L), L.defaultPrevented || (p.preventDefault(), T && Ht(B, !0));
          } else if (_ && [B, x].includes(I)) {
            const L = Fr({
              focusReason: a.value
            });
            t("focusout-prevented", L), L.defaultPrevented || (p.preventDefault(), T && Ht(H, !0));
          }
        } else if (I === x) {
          const L = Fr({
            focusReason: a.value
          });
          t("focusout-prevented", L), L.defaultPrevented || p.preventDefault();
        }
      }
    };
    Nt(v0, {
      focusTrapRef: n,
      onKeydown: s
    }), Q(() => e.focusTrapEl, (p) => {
      p && (n.value = p);
    }, { immediate: !0 }), Q([n], ([p], [g]) => {
      p && (p.addEventListener("keydown", s), p.addEventListener("focusin", f), p.addEventListener("focusout", c)), g && (g.removeEventListener("keydown", s), g.removeEventListener("focusin", f), g.removeEventListener("focusout", c));
    });
    const l = (p) => {
      t(Cs, p);
    }, u = (p) => t(Os, p), f = (p) => {
      const g = b(n);
      if (!g)
        return;
      const E = p.target, v = p.relatedTarget, m = E && g.contains(E);
      e.trapped || v && g.contains(v) || (r = v), m && t("focusin", p), !i.paused && e.trapped && (m ? o = E : Ht(o, !0));
    }, c = (p) => {
      const g = b(n);
      if (!(i.paused || !g))
        if (e.trapped) {
          const E = p.relatedTarget;
          !fo(E) && !g.contains(E) && setTimeout(() => {
            if (!i.paused && e.trapped) {
              const v = Fr({
                focusReason: a.value
              });
              t("focusout-prevented", v), v.defaultPrevented || Ht(o, !0);
            }
          }, 0);
        } else {
          const E = p.target;
          E && g.contains(E) || t("focusout", p);
        }
    };
    async function d() {
      await Ne();
      const p = b(n);
      if (p) {
        Ss.push(i);
        const g = p.contains(document.activeElement) ? r : document.activeElement;
        if (r = g, !p.contains(g)) {
          const v = new Event(Do, Ts);
          p.addEventListener(Do, l), p.dispatchEvent(v), v.defaultPrevented || Ne(() => {
            let m = e.focusStartEl;
            mn(m) || (Ht(m), document.activeElement !== m && (m = "first")), m === "first" && M0(Cu(p), !0), (document.activeElement === g || m === "container") && Ht(p);
          });
        }
      }
    }
    function h() {
      const p = b(n);
      if (p) {
        p.removeEventListener(Do, l);
        const g = new CustomEvent(ko, {
          ...Ts,
          detail: {
            focusReason: a.value
          }
        });
        p.addEventListener(ko, u), p.dispatchEvent(g), !g.defaultPrevented && (a.value == "keyboard" || !_0() || p.contains(document.activeElement)) && Ht(r ?? document.body), p.removeEventListener(ko, u), Ss.remove(i);
      }
    }
    return xe(() => {
      e.trapped && d(), Q(() => e.trapped, (p) => {
        p ? d() : h();
      });
    }), Bt(() => {
      e.trapped && h(), n.value && (n.value.removeEventListener("keydown", s), n.value.removeEventListener("focusin", f), n.value.removeEventListener("focusout", c), n.value = void 0);
    }), {
      onKeydown: s
    };
  }
});
function O0(e, t, n, r, o, a) {
  return J(e.$slots, "default", { handleKeydown: e.onKeydown });
}
var I0 = /* @__PURE__ */ Re(C0, [["render", O0], ["__file", "focus-trap.vue"]]), lt = "top", bt = "bottom", Et = "right", ut = "left", Va = "auto", Cr = [lt, bt, Et, ut], Gn = "start", Mr = "end", N0 = "clippingParents", Ou = "viewport", ar = "popper", S0 = "reference", Ps = Cr.reduce(function(e, t) {
  return e.concat([t + "-" + Gn, t + "-" + Mr]);
}, []), Eo = [].concat(Cr, [Va]).reduce(function(e, t) {
  return e.concat([t, t + "-" + Gn, t + "-" + Mr]);
}, []), A0 = "beforeRead", L0 = "read", P0 = "afterRead", D0 = "beforeMain", k0 = "main", x0 = "afterMain", R0 = "beforeWrite", F0 = "write", j0 = "afterWrite", B0 = [A0, L0, P0, D0, k0, x0, R0, F0, j0];
function jt(e) {
  return e ? (e.nodeName || "").toLowerCase() : null;
}
function Lt(e) {
  if (e == null) return window;
  if (e.toString() !== "[object Window]") {
    var t = e.ownerDocument;
    return t && t.defaultView || window;
  }
  return e;
}
function Kn(e) {
  var t = Lt(e).Element;
  return e instanceof t || e instanceof Element;
}
function yt(e) {
  var t = Lt(e).HTMLElement;
  return e instanceof t || e instanceof HTMLElement;
}
function Ua(e) {
  if (typeof ShadowRoot > "u") return !1;
  var t = Lt(e).ShadowRoot;
  return e instanceof t || e instanceof ShadowRoot;
}
function $0(e) {
  var t = e.state;
  Object.keys(t.elements).forEach(function(n) {
    var r = t.styles[n] || {}, o = t.attributes[n] || {}, a = t.elements[n];
    !yt(a) || !jt(a) || (Object.assign(a.style, r), Object.keys(o).forEach(function(i) {
      var s = o[i];
      s === !1 ? a.removeAttribute(i) : a.setAttribute(i, s === !0 ? "" : s);
    }));
  });
}
function z0(e) {
  var t = e.state, n = { popper: { position: t.options.strategy, left: "0", top: "0", margin: "0" }, arrow: { position: "absolute" }, reference: {} };
  return Object.assign(t.elements.popper.style, n.popper), t.styles = n, t.elements.arrow && Object.assign(t.elements.arrow.style, n.arrow), function() {
    Object.keys(t.elements).forEach(function(r) {
      var o = t.elements[r], a = t.attributes[r] || {}, i = Object.keys(t.styles.hasOwnProperty(r) ? t.styles[r] : n[r]), s = i.reduce(function(l, u) {
        return l[u] = "", l;
      }, {});
      !yt(o) || !jt(o) || (Object.assign(o.style, s), Object.keys(a).forEach(function(l) {
        o.removeAttribute(l);
      }));
    });
  };
}
var Iu = { name: "applyStyles", enabled: !0, phase: "write", fn: $0, effect: z0, requires: ["computeStyles"] };
function Rt(e) {
  return e.split("-")[0];
}
var An = Math.max, qr = Math.min, Xn = Math.round;
function Qn(e, t) {
  t === void 0 && (t = !1);
  var n = e.getBoundingClientRect(), r = 1, o = 1;
  if (yt(e) && t) {
    var a = e.offsetHeight, i = e.offsetWidth;
    i > 0 && (r = Xn(n.width) / i || 1), a > 0 && (o = Xn(n.height) / a || 1);
  }
  return { width: n.width / r, height: n.height / o, top: n.top / o, right: n.right / r, bottom: n.bottom / o, left: n.left / r, x: n.left / r, y: n.top / o };
}
function Wa(e) {
  var t = Qn(e), n = e.offsetWidth, r = e.offsetHeight;
  return Math.abs(t.width - n) <= 1 && (n = t.width), Math.abs(t.height - r) <= 1 && (r = t.height), { x: e.offsetLeft, y: e.offsetTop, width: n, height: r };
}
function Nu(e, t) {
  var n = t.getRootNode && t.getRootNode();
  if (e.contains(t)) return !0;
  if (n && Ua(n)) {
    var r = t;
    do {
      if (r && e.isSameNode(r)) return !0;
      r = r.parentNode || r.host;
    } while (r);
  }
  return !1;
}
function en(e) {
  return Lt(e).getComputedStyle(e);
}
function V0(e) {
  return ["table", "td", "th"].indexOf(jt(e)) >= 0;
}
function Tn(e) {
  return ((Kn(e) ? e.ownerDocument : e.document) || window.document).documentElement;
}
function Mo(e) {
  return jt(e) === "html" ? e : e.assignedSlot || e.parentNode || (Ua(e) ? e.host : null) || Tn(e);
}
function Ds(e) {
  return !yt(e) || en(e).position === "fixed" ? null : e.offsetParent;
}
function U0(e) {
  var t = navigator.userAgent.toLowerCase().indexOf("firefox") !== -1, n = navigator.userAgent.indexOf("Trident") !== -1;
  if (n && yt(e)) {
    var r = en(e);
    if (r.position === "fixed") return null;
  }
  var o = Mo(e);
  for (Ua(o) && (o = o.host); yt(o) && ["html", "body"].indexOf(jt(o)) < 0; ) {
    var a = en(o);
    if (a.transform !== "none" || a.perspective !== "none" || a.contain === "paint" || ["transform", "perspective"].indexOf(a.willChange) !== -1 || t && a.willChange === "filter" || t && a.filter && a.filter !== "none") return o;
    o = o.parentNode;
  }
  return null;
}
function Or(e) {
  for (var t = Lt(e), n = Ds(e); n && V0(n) && en(n).position === "static"; ) n = Ds(n);
  return n && (jt(n) === "html" || jt(n) === "body" && en(n).position === "static") ? t : n || U0(e) || t;
}
function Ha(e) {
  return ["top", "bottom"].indexOf(e) >= 0 ? "x" : "y";
}
function fr(e, t, n) {
  return An(e, qr(t, n));
}
function W0(e, t, n) {
  var r = fr(e, t, n);
  return r > n ? n : r;
}
function Su() {
  return { top: 0, right: 0, bottom: 0, left: 0 };
}
function Au(e) {
  return Object.assign({}, Su(), e);
}
function Lu(e, t) {
  return t.reduce(function(n, r) {
    return n[r] = e, n;
  }, {});
}
var H0 = function(e, t) {
  return e = typeof e == "function" ? e(Object.assign({}, t.rects, { placement: t.placement })) : e, Au(typeof e != "number" ? e : Lu(e, Cr));
};
function Y0(e) {
  var t, n = e.state, r = e.name, o = e.options, a = n.elements.arrow, i = n.modifiersData.popperOffsets, s = Rt(n.placement), l = Ha(s), u = [ut, Et].indexOf(s) >= 0, f = u ? "height" : "width";
  if (!(!a || !i)) {
    var c = H0(o.padding, n), d = Wa(a), h = l === "y" ? lt : ut, p = l === "y" ? bt : Et, g = n.rects.reference[f] + n.rects.reference[l] - i[l] - n.rects.popper[f], E = i[l] - n.rects.reference[l], v = Or(a), m = v ? l === "y" ? v.clientHeight || 0 : v.clientWidth || 0 : 0, y = g / 2 - E / 2, _ = c[h], T = m - d[f] - c[p], N = m / 2 - d[f] / 2 + y, I = fr(_, N, T), x = l;
    n.modifiersData[r] = (t = {}, t[x] = I, t.centerOffset = I - N, t);
  }
}
function G0(e) {
  var t = e.state, n = e.options, r = n.element, o = r === void 0 ? "[data-popper-arrow]" : r;
  o != null && (typeof o == "string" && (o = t.elements.popper.querySelector(o), !o) || !Nu(t.elements.popper, o) || (t.elements.arrow = o));
}
var K0 = { name: "arrow", enabled: !0, phase: "main", fn: Y0, effect: G0, requires: ["popperOffsets"], requiresIfExists: ["preventOverflow"] };
function Zn(e) {
  return e.split("-")[1];
}
var X0 = { top: "auto", right: "auto", bottom: "auto", left: "auto" };
function Q0(e) {
  var t = e.x, n = e.y, r = window, o = r.devicePixelRatio || 1;
  return { x: Xn(t * o) / o || 0, y: Xn(n * o) / o || 0 };
}
function ks(e) {
  var t, n = e.popper, r = e.popperRect, o = e.placement, a = e.variation, i = e.offsets, s = e.position, l = e.gpuAcceleration, u = e.adaptive, f = e.roundOffsets, c = e.isFixed, d = i.x, h = d === void 0 ? 0 : d, p = i.y, g = p === void 0 ? 0 : p, E = typeof f == "function" ? f({ x: h, y: g }) : { x: h, y: g };
  h = E.x, g = E.y;
  var v = i.hasOwnProperty("x"), m = i.hasOwnProperty("y"), y = ut, _ = lt, T = window;
  if (u) {
    var N = Or(n), I = "clientHeight", x = "clientWidth";
    if (N === Lt(n) && (N = Tn(n), en(N).position !== "static" && s === "absolute" && (I = "scrollHeight", x = "scrollWidth")), N = N, o === lt || (o === ut || o === Et) && a === Mr) {
      _ = bt;
      var B = c && N === T && T.visualViewport ? T.visualViewport.height : N[I];
      g -= B - r.height, g *= l ? 1 : -1;
    }
    if (o === ut || (o === lt || o === bt) && a === Mr) {
      y = Et;
      var H = c && N === T && T.visualViewport ? T.visualViewport.width : N[x];
      h -= H - r.width, h *= l ? 1 : -1;
    }
  }
  var ee = Object.assign({ position: s }, u && X0), L = f === !0 ? Q0({ x: h, y: g }) : { x: h, y: g };
  if (h = L.x, g = L.y, l) {
    var V;
    return Object.assign({}, ee, (V = {}, V[_] = m ? "0" : "", V[y] = v ? "0" : "", V.transform = (T.devicePixelRatio || 1) <= 1 ? "translate(" + h + "px, " + g + "px)" : "translate3d(" + h + "px, " + g + "px, 0)", V));
  }
  return Object.assign({}, ee, (t = {}, t[_] = m ? g + "px" : "", t[y] = v ? h + "px" : "", t.transform = "", t));
}
function Z0(e) {
  var t = e.state, n = e.options, r = n.gpuAcceleration, o = r === void 0 ? !0 : r, a = n.adaptive, i = a === void 0 ? !0 : a, s = n.roundOffsets, l = s === void 0 ? !0 : s, u = { placement: Rt(t.placement), variation: Zn(t.placement), popper: t.elements.popper, popperRect: t.rects.popper, gpuAcceleration: o, isFixed: t.options.strategy === "fixed" };
  t.modifiersData.popperOffsets != null && (t.styles.popper = Object.assign({}, t.styles.popper, ks(Object.assign({}, u, { offsets: t.modifiersData.popperOffsets, position: t.options.strategy, adaptive: i, roundOffsets: l })))), t.modifiersData.arrow != null && (t.styles.arrow = Object.assign({}, t.styles.arrow, ks(Object.assign({}, u, { offsets: t.modifiersData.arrow, position: "absolute", adaptive: !1, roundOffsets: l })))), t.attributes.popper = Object.assign({}, t.attributes.popper, { "data-popper-placement": t.placement });
}
var Pu = { name: "computeStyles", enabled: !0, phase: "beforeWrite", fn: Z0, data: {} }, jr = { passive: !0 };
function J0(e) {
  var t = e.state, n = e.instance, r = e.options, o = r.scroll, a = o === void 0 ? !0 : o, i = r.resize, s = i === void 0 ? !0 : i, l = Lt(t.elements.popper), u = [].concat(t.scrollParents.reference, t.scrollParents.popper);
  return a && u.forEach(function(f) {
    f.addEventListener("scroll", n.update, jr);
  }), s && l.addEventListener("resize", n.update, jr), function() {
    a && u.forEach(function(f) {
      f.removeEventListener("scroll", n.update, jr);
    }), s && l.removeEventListener("resize", n.update, jr);
  };
}
var Du = { name: "eventListeners", enabled: !0, phase: "write", fn: function() {
}, effect: J0, data: {} }, q0 = { left: "right", right: "left", bottom: "top", top: "bottom" };
function Vr(e) {
  return e.replace(/left|right|bottom|top/g, function(t) {
    return q0[t];
  });
}
var ey = { start: "end", end: "start" };
function xs(e) {
  return e.replace(/start|end/g, function(t) {
    return ey[t];
  });
}
function Ya(e) {
  var t = Lt(e), n = t.pageXOffset, r = t.pageYOffset;
  return { scrollLeft: n, scrollTop: r };
}
function Ga(e) {
  return Qn(Tn(e)).left + Ya(e).scrollLeft;
}
function ty(e) {
  var t = Lt(e), n = Tn(e), r = t.visualViewport, o = n.clientWidth, a = n.clientHeight, i = 0, s = 0;
  return r && (o = r.width, a = r.height, /^((?!chrome|android).)*safari/i.test(navigator.userAgent) || (i = r.offsetLeft, s = r.offsetTop)), { width: o, height: a, x: i + Ga(e), y: s };
}
function ny(e) {
  var t, n = Tn(e), r = Ya(e), o = (t = e.ownerDocument) == null ? void 0 : t.body, a = An(n.scrollWidth, n.clientWidth, o ? o.scrollWidth : 0, o ? o.clientWidth : 0), i = An(n.scrollHeight, n.clientHeight, o ? o.scrollHeight : 0, o ? o.clientHeight : 0), s = -r.scrollLeft + Ga(e), l = -r.scrollTop;
  return en(o || n).direction === "rtl" && (s += An(n.clientWidth, o ? o.clientWidth : 0) - a), { width: a, height: i, x: s, y: l };
}
function Ka(e) {
  var t = en(e), n = t.overflow, r = t.overflowX, o = t.overflowY;
  return /auto|scroll|overlay|hidden/.test(n + o + r);
}
function ku(e) {
  return ["html", "body", "#document"].indexOf(jt(e)) >= 0 ? e.ownerDocument.body : yt(e) && Ka(e) ? e : ku(Mo(e));
}
function dr(e, t) {
  var n;
  t === void 0 && (t = []);
  var r = ku(e), o = r === ((n = e.ownerDocument) == null ? void 0 : n.body), a = Lt(r), i = o ? [a].concat(a.visualViewport || [], Ka(r) ? r : []) : r, s = t.concat(i);
  return o ? s : s.concat(dr(Mo(i)));
}
function sa(e) {
  return Object.assign({}, e, { left: e.x, top: e.y, right: e.x + e.width, bottom: e.y + e.height });
}
function ry(e) {
  var t = Qn(e);
  return t.top = t.top + e.clientTop, t.left = t.left + e.clientLeft, t.bottom = t.top + e.clientHeight, t.right = t.left + e.clientWidth, t.width = e.clientWidth, t.height = e.clientHeight, t.x = t.left, t.y = t.top, t;
}
function Rs(e, t) {
  return t === Ou ? sa(ty(e)) : Kn(t) ? ry(t) : sa(ny(Tn(e)));
}
function oy(e) {
  var t = dr(Mo(e)), n = ["absolute", "fixed"].indexOf(en(e).position) >= 0, r = n && yt(e) ? Or(e) : e;
  return Kn(r) ? t.filter(function(o) {
    return Kn(o) && Nu(o, r) && jt(o) !== "body";
  }) : [];
}
function ay(e, t, n) {
  var r = t === "clippingParents" ? oy(e) : [].concat(t), o = [].concat(r, [n]), a = o[0], i = o.reduce(function(s, l) {
    var u = Rs(e, l);
    return s.top = An(u.top, s.top), s.right = qr(u.right, s.right), s.bottom = qr(u.bottom, s.bottom), s.left = An(u.left, s.left), s;
  }, Rs(e, a));
  return i.width = i.right - i.left, i.height = i.bottom - i.top, i.x = i.left, i.y = i.top, i;
}
function xu(e) {
  var t = e.reference, n = e.element, r = e.placement, o = r ? Rt(r) : null, a = r ? Zn(r) : null, i = t.x + t.width / 2 - n.width / 2, s = t.y + t.height / 2 - n.height / 2, l;
  switch (o) {
    case lt:
      l = { x: i, y: t.y - n.height };
      break;
    case bt:
      l = { x: i, y: t.y + t.height };
      break;
    case Et:
      l = { x: t.x + t.width, y: s };
      break;
    case ut:
      l = { x: t.x - n.width, y: s };
      break;
    default:
      l = { x: t.x, y: t.y };
  }
  var u = o ? Ha(o) : null;
  if (u != null) {
    var f = u === "y" ? "height" : "width";
    switch (a) {
      case Gn:
        l[u] = l[u] - (t[f] / 2 - n[f] / 2);
        break;
      case Mr:
        l[u] = l[u] + (t[f] / 2 - n[f] / 2);
        break;
    }
  }
  return l;
}
function _r(e, t) {
  t === void 0 && (t = {});
  var n = t, r = n.placement, o = r === void 0 ? e.placement : r, a = n.boundary, i = a === void 0 ? N0 : a, s = n.rootBoundary, l = s === void 0 ? Ou : s, u = n.elementContext, f = u === void 0 ? ar : u, c = n.altBoundary, d = c === void 0 ? !1 : c, h = n.padding, p = h === void 0 ? 0 : h, g = Au(typeof p != "number" ? p : Lu(p, Cr)), E = f === ar ? S0 : ar, v = e.rects.popper, m = e.elements[d ? E : f], y = ay(Kn(m) ? m : m.contextElement || Tn(e.elements.popper), i, l), _ = Qn(e.elements.reference), T = xu({ reference: _, element: v, placement: o }), N = sa(Object.assign({}, v, T)), I = f === ar ? N : _, x = { top: y.top - I.top + g.top, bottom: I.bottom - y.bottom + g.bottom, left: y.left - I.left + g.left, right: I.right - y.right + g.right }, B = e.modifiersData.offset;
  if (f === ar && B) {
    var H = B[o];
    Object.keys(x).forEach(function(ee) {
      var L = [Et, bt].indexOf(ee) >= 0 ? 1 : -1, V = [lt, bt].indexOf(ee) >= 0 ? "y" : "x";
      x[ee] += H[V] * L;
    });
  }
  return x;
}
function iy(e, t) {
  t === void 0 && (t = {});
  var n = t, r = n.placement, o = n.boundary, a = n.rootBoundary, i = n.padding, s = n.flipVariations, l = n.allowedAutoPlacements, u = l === void 0 ? Eo : l, f = Zn(r), c = f ? s ? Ps : Ps.filter(function(p) {
    return Zn(p) === f;
  }) : Cr, d = c.filter(function(p) {
    return u.indexOf(p) >= 0;
  });
  d.length === 0 && (d = c);
  var h = d.reduce(function(p, g) {
    return p[g] = _r(e, { placement: g, boundary: o, rootBoundary: a, padding: i })[Rt(g)], p;
  }, {});
  return Object.keys(h).sort(function(p, g) {
    return h[p] - h[g];
  });
}
function sy(e) {
  if (Rt(e) === Va) return [];
  var t = Vr(e);
  return [xs(e), t, xs(t)];
}
function ly(e) {
  var t = e.state, n = e.options, r = e.name;
  if (!t.modifiersData[r]._skip) {
    for (var o = n.mainAxis, a = o === void 0 ? !0 : o, i = n.altAxis, s = i === void 0 ? !0 : i, l = n.fallbackPlacements, u = n.padding, f = n.boundary, c = n.rootBoundary, d = n.altBoundary, h = n.flipVariations, p = h === void 0 ? !0 : h, g = n.allowedAutoPlacements, E = t.options.placement, v = Rt(E), m = v === E, y = l || (m || !p ? [Vr(E)] : sy(E)), _ = [E].concat(y).reduce(function(Pe, Se) {
      return Pe.concat(Rt(Se) === Va ? iy(t, { placement: Se, boundary: f, rootBoundary: c, padding: u, flipVariations: p, allowedAutoPlacements: g }) : Se);
    }, []), T = t.rects.reference, N = t.rects.popper, I = /* @__PURE__ */ new Map(), x = !0, B = _[0], H = 0; H < _.length; H++) {
      var ee = _[H], L = Rt(ee), V = Zn(ee) === Gn, me = [lt, bt].indexOf(L) >= 0, fe = me ? "width" : "height", ie = _r(t, { placement: ee, boundary: f, rootBoundary: c, altBoundary: d, padding: u }), ne = me ? V ? Et : ut : V ? bt : lt;
      T[fe] > N[fe] && (ne = Vr(ne));
      var G = Vr(ne), pe = [];
      if (a && pe.push(ie[L] <= 0), s && pe.push(ie[ne] <= 0, ie[G] <= 0), pe.every(function(Pe) {
        return Pe;
      })) {
        B = ee, x = !1;
        break;
      }
      I.set(ee, pe);
    }
    if (x) for (var he = p ? 3 : 1, Ie = function(Pe) {
      var Se = _.find(function(Be) {
        var O = I.get(Be);
        if (O) return O.slice(0, Pe).every(function(A) {
          return A;
        });
      });
      if (Se) return B = Se, "break";
    }, je = he; je > 0; je--) {
      var Ge = Ie(je);
      if (Ge === "break") break;
    }
    t.placement !== B && (t.modifiersData[r]._skip = !0, t.placement = B, t.reset = !0);
  }
}
var uy = { name: "flip", enabled: !0, phase: "main", fn: ly, requiresIfExists: ["offset"], data: { _skip: !1 } };
function Fs(e, t, n) {
  return n === void 0 && (n = { x: 0, y: 0 }), { top: e.top - t.height - n.y, right: e.right - t.width + n.x, bottom: e.bottom - t.height + n.y, left: e.left - t.width - n.x };
}
function js(e) {
  return [lt, Et, bt, ut].some(function(t) {
    return e[t] >= 0;
  });
}
function cy(e) {
  var t = e.state, n = e.name, r = t.rects.reference, o = t.rects.popper, a = t.modifiersData.preventOverflow, i = _r(t, { elementContext: "reference" }), s = _r(t, { altBoundary: !0 }), l = Fs(i, r), u = Fs(s, o, a), f = js(l), c = js(u);
  t.modifiersData[n] = { referenceClippingOffsets: l, popperEscapeOffsets: u, isReferenceHidden: f, hasPopperEscaped: c }, t.attributes.popper = Object.assign({}, t.attributes.popper, { "data-popper-reference-hidden": f, "data-popper-escaped": c });
}
var fy = { name: "hide", enabled: !0, phase: "main", requiresIfExists: ["preventOverflow"], fn: cy };
function dy(e, t, n) {
  var r = Rt(e), o = [ut, lt].indexOf(r) >= 0 ? -1 : 1, a = typeof n == "function" ? n(Object.assign({}, t, { placement: e })) : n, i = a[0], s = a[1];
  return i = i || 0, s = (s || 0) * o, [ut, Et].indexOf(r) >= 0 ? { x: s, y: i } : { x: i, y: s };
}
function py(e) {
  var t = e.state, n = e.options, r = e.name, o = n.offset, a = o === void 0 ? [0, 0] : o, i = Eo.reduce(function(f, c) {
    return f[c] = dy(c, t.rects, a), f;
  }, {}), s = i[t.placement], l = s.x, u = s.y;
  t.modifiersData.popperOffsets != null && (t.modifiersData.popperOffsets.x += l, t.modifiersData.popperOffsets.y += u), t.modifiersData[r] = i;
}
var hy = { name: "offset", enabled: !0, phase: "main", requires: ["popperOffsets"], fn: py };
function gy(e) {
  var t = e.state, n = e.name;
  t.modifiersData[n] = xu({ reference: t.rects.reference, element: t.rects.popper, placement: t.placement });
}
var Ru = { name: "popperOffsets", enabled: !0, phase: "read", fn: gy, data: {} };
function vy(e) {
  return e === "x" ? "y" : "x";
}
function my(e) {
  var t = e.state, n = e.options, r = e.name, o = n.mainAxis, a = o === void 0 ? !0 : o, i = n.altAxis, s = i === void 0 ? !1 : i, l = n.boundary, u = n.rootBoundary, f = n.altBoundary, c = n.padding, d = n.tether, h = d === void 0 ? !0 : d, p = n.tetherOffset, g = p === void 0 ? 0 : p, E = _r(t, { boundary: l, rootBoundary: u, padding: c, altBoundary: f }), v = Rt(t.placement), m = Zn(t.placement), y = !m, _ = Ha(v), T = vy(_), N = t.modifiersData.popperOffsets, I = t.rects.reference, x = t.rects.popper, B = typeof g == "function" ? g(Object.assign({}, t.rects, { placement: t.placement })) : g, H = typeof B == "number" ? { mainAxis: B, altAxis: B } : Object.assign({ mainAxis: 0, altAxis: 0 }, B), ee = t.modifiersData.offset ? t.modifiersData.offset[t.placement] : null, L = { x: 0, y: 0 };
  if (N) {
    if (a) {
      var V, me = _ === "y" ? lt : ut, fe = _ === "y" ? bt : Et, ie = _ === "y" ? "height" : "width", ne = N[_], G = ne + E[me], pe = ne - E[fe], he = h ? -x[ie] / 2 : 0, Ie = m === Gn ? I[ie] : x[ie], je = m === Gn ? -x[ie] : -I[ie], Ge = t.elements.arrow, Pe = h && Ge ? Wa(Ge) : { width: 0, height: 0 }, Se = t.modifiersData["arrow#persistent"] ? t.modifiersData["arrow#persistent"].padding : Su(), Be = Se[me], O = Se[fe], A = fr(0, I[ie], Pe[ie]), W = y ? I[ie] / 2 - he - A - Be - H.mainAxis : Ie - A - Be - H.mainAxis, de = y ? -I[ie] / 2 + he + A + O + H.mainAxis : je + A + O + H.mainAxis, we = t.elements.arrow && Or(t.elements.arrow), $e = we ? _ === "y" ? we.clientTop || 0 : we.clientLeft || 0 : 0, Te = (V = ee == null ? void 0 : ee[_]) != null ? V : 0, ze = ne + W - Te - $e, Ae = ne + de - Te, De = fr(h ? qr(G, ze) : G, ne, h ? An(pe, Ae) : pe);
      N[_] = De, L[_] = De - ne;
    }
    if (s) {
      var ht, M = _ === "x" ? lt : ut, C = _ === "x" ? bt : Et, w = N[T], $ = T === "y" ? "height" : "width", re = w + E[M], be = w - E[C], k = [lt, ut].indexOf(v) !== -1, S = (ht = ee == null ? void 0 : ee[T]) != null ? ht : 0, F = k ? re : w - I[$] - x[$] - S + H.altAxis, se = k ? w + I[$] + x[$] - S - H.altAxis : be, ye = h && k ? W0(F, w, se) : fr(h ? F : re, w, h ? se : be);
      N[T] = ye, L[T] = ye - w;
    }
    t.modifiersData[r] = L;
  }
}
var yy = { name: "preventOverflow", enabled: !0, phase: "main", fn: my, requiresIfExists: ["offset"] };
function by(e) {
  return { scrollLeft: e.scrollLeft, scrollTop: e.scrollTop };
}
function Ey(e) {
  return e === Lt(e) || !yt(e) ? Ya(e) : by(e);
}
function My(e) {
  var t = e.getBoundingClientRect(), n = Xn(t.width) / e.offsetWidth || 1, r = Xn(t.height) / e.offsetHeight || 1;
  return n !== 1 || r !== 1;
}
function _y(e, t, n) {
  n === void 0 && (n = !1);
  var r = yt(t), o = yt(t) && My(t), a = Tn(t), i = Qn(e, o), s = { scrollLeft: 0, scrollTop: 0 }, l = { x: 0, y: 0 };
  return (r || !r && !n) && ((jt(t) !== "body" || Ka(a)) && (s = Ey(t)), yt(t) ? (l = Qn(t, !0), l.x += t.clientLeft, l.y += t.clientTop) : a && (l.x = Ga(a))), { x: i.left + s.scrollLeft - l.x, y: i.top + s.scrollTop - l.y, width: i.width, height: i.height };
}
function wy(e) {
  var t = /* @__PURE__ */ new Map(), n = /* @__PURE__ */ new Set(), r = [];
  e.forEach(function(a) {
    t.set(a.name, a);
  });
  function o(a) {
    n.add(a.name);
    var i = [].concat(a.requires || [], a.requiresIfExists || []);
    i.forEach(function(s) {
      if (!n.has(s)) {
        var l = t.get(s);
        l && o(l);
      }
    }), r.push(a);
  }
  return e.forEach(function(a) {
    n.has(a.name) || o(a);
  }), r;
}
function Ty(e) {
  var t = wy(e);
  return B0.reduce(function(n, r) {
    return n.concat(t.filter(function(o) {
      return o.phase === r;
    }));
  }, []);
}
function Cy(e) {
  var t;
  return function() {
    return t || (t = new Promise(function(n) {
      Promise.resolve().then(function() {
        t = void 0, n(e());
      });
    })), t;
  };
}
function Oy(e) {
  var t = e.reduce(function(n, r) {
    var o = n[r.name];
    return n[r.name] = o ? Object.assign({}, o, r, { options: Object.assign({}, o.options, r.options), data: Object.assign({}, o.data, r.data) }) : r, n;
  }, {});
  return Object.keys(t).map(function(n) {
    return t[n];
  });
}
var Bs = { placement: "bottom", modifiers: [], strategy: "absolute" };
function $s() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) t[n] = arguments[n];
  return !t.some(function(r) {
    return !(r && typeof r.getBoundingClientRect == "function");
  });
}
function Xa(e) {
  e === void 0 && (e = {});
  var t = e, n = t.defaultModifiers, r = n === void 0 ? [] : n, o = t.defaultOptions, a = o === void 0 ? Bs : o;
  return function(i, s, l) {
    l === void 0 && (l = a);
    var u = { placement: "bottom", orderedModifiers: [], options: Object.assign({}, Bs, a), modifiersData: {}, elements: { reference: i, popper: s }, attributes: {}, styles: {} }, f = [], c = !1, d = { state: u, setOptions: function(g) {
      var E = typeof g == "function" ? g(u.options) : g;
      p(), u.options = Object.assign({}, a, u.options, E), u.scrollParents = { reference: Kn(i) ? dr(i) : i.contextElement ? dr(i.contextElement) : [], popper: dr(s) };
      var v = Ty(Oy([].concat(r, u.options.modifiers)));
      return u.orderedModifiers = v.filter(function(m) {
        return m.enabled;
      }), h(), d.update();
    }, forceUpdate: function() {
      if (!c) {
        var g = u.elements, E = g.reference, v = g.popper;
        if ($s(E, v)) {
          u.rects = { reference: _y(E, Or(v), u.options.strategy === "fixed"), popper: Wa(v) }, u.reset = !1, u.placement = u.options.placement, u.orderedModifiers.forEach(function(x) {
            return u.modifiersData[x.name] = Object.assign({}, x.data);
          });
          for (var m = 0; m < u.orderedModifiers.length; m++) {
            if (u.reset === !0) {
              u.reset = !1, m = -1;
              continue;
            }
            var y = u.orderedModifiers[m], _ = y.fn, T = y.options, N = T === void 0 ? {} : T, I = y.name;
            typeof _ == "function" && (u = _({ state: u, options: N, name: I, instance: d }) || u);
          }
        }
      }
    }, update: Cy(function() {
      return new Promise(function(g) {
        d.forceUpdate(), g(u);
      });
    }), destroy: function() {
      p(), c = !0;
    } };
    if (!$s(i, s)) return d;
    d.setOptions(l).then(function(g) {
      !c && l.onFirstUpdate && l.onFirstUpdate(g);
    });
    function h() {
      u.orderedModifiers.forEach(function(g) {
        var E = g.name, v = g.options, m = v === void 0 ? {} : v, y = g.effect;
        if (typeof y == "function") {
          var _ = y({ state: u, name: E, instance: d, options: m }), T = function() {
          };
          f.push(_ || T);
        }
      });
    }
    function p() {
      f.forEach(function(g) {
        return g();
      }), f = [];
    }
    return d;
  };
}
Xa();
var Iy = [Du, Ru, Pu, Iu];
Xa({ defaultModifiers: Iy });
var Ny = [Du, Ru, Pu, Iu, hy, uy, yy, K0, fy], Sy = Xa({ defaultModifiers: Ny });
const Ay = ["fixed", "absolute"], Ly = Le({
  boundariesPadding: {
    type: Number,
    default: 0
  },
  fallbackPlacements: {
    type: ce(Array),
    default: void 0
  },
  gpuAcceleration: {
    type: Boolean,
    default: !0
  },
  offset: {
    type: Number,
    default: 12
  },
  placement: {
    type: String,
    values: Eo,
    default: "bottom"
  },
  popperOptions: {
    type: ce(Object),
    default: () => ({})
  },
  strategy: {
    type: String,
    values: Ay,
    default: "absolute"
  }
}), Fu = Le({
  ...Ly,
  id: String,
  style: {
    type: ce([String, Array, Object])
  },
  className: {
    type: ce([String, Array, Object])
  },
  effect: {
    type: ce(String),
    default: "dark"
  },
  visible: Boolean,
  enterable: {
    type: Boolean,
    default: !0
  },
  pure: Boolean,
  focusOnShow: {
    type: Boolean,
    default: !1
  },
  trapping: {
    type: Boolean,
    default: !1
  },
  popperClass: {
    type: ce([String, Array, Object])
  },
  popperStyle: {
    type: ce([String, Array, Object])
  },
  referenceEl: {
    type: ce(Object)
  },
  triggerTargetEl: {
    type: ce(Object)
  },
  stopPopperMouseEvent: {
    type: Boolean,
    default: !0
  },
  virtualTriggering: Boolean,
  zIndex: Number,
  ...Tr(["ariaLabel"])
}), Py = {
  mouseenter: (e) => e instanceof MouseEvent,
  mouseleave: (e) => e instanceof MouseEvent,
  focus: () => !0,
  blur: () => !0,
  close: () => !0
}, Dy = (e, t) => {
  const n = R(!1), r = R();
  return {
    focusStartRef: r,
    trapped: n,
    onFocusAfterReleased: (u) => {
      var f;
      ((f = u.detail) == null ? void 0 : f.focusReason) !== "pointer" && (r.value = "first", t("blur"));
    },
    onFocusAfterTrapped: () => {
      t("focus");
    },
    onFocusInTrap: (u) => {
      e.visible && !n.value && (u.target && (r.value = u.target), n.value = !0);
    },
    onFocusoutPrevented: (u) => {
      e.trapping || (u.detail.focusReason === "pointer" && u.preventDefault(), n.value = !1);
    },
    onReleaseRequested: () => {
      n.value = !1, t("close");
    }
  };
}, ky = (e, t = []) => {
  const { placement: n, strategy: r, popperOptions: o } = e, a = {
    placement: n,
    strategy: r,
    ...o,
    modifiers: [...Ry(e), ...t]
  };
  return Fy(a, o == null ? void 0 : o.modifiers), a;
}, xy = (e) => {
  if (Qe)
    return Qt(e);
};
function Ry(e) {
  const { offset: t, gpuAcceleration: n, fallbackPlacements: r } = e;
  return [
    {
      name: "offset",
      options: {
        offset: [0, t ?? 12]
      }
    },
    {
      name: "preventOverflow",
      options: {
        padding: {
          top: 2,
          bottom: 2,
          left: 5,
          right: 5
        }
      }
    },
    {
      name: "flip",
      options: {
        padding: 5,
        fallbackPlacements: r
      }
    },
    {
      name: "computeStyles",
      options: {
        gpuAcceleration: n
      }
    }
  ];
}
function Fy(e, t) {
  t && (e.modifiers = [...e.modifiers, ...t ?? []]);
}
const jy = (e, t, n = {}) => {
  const r = {
    name: "updateState",
    enabled: !0,
    phase: "write",
    fn: ({ state: l }) => {
      const u = By(l);
      Object.assign(i.value, u);
    },
    requires: ["computeStyles"]
  }, o = D(() => {
    const { onFirstUpdate: l, placement: u, strategy: f, modifiers: c } = b(n);
    return {
      onFirstUpdate: l,
      placement: u || "bottom",
      strategy: f || "absolute",
      modifiers: [
        ...c || [],
        r,
        { name: "applyStyles", enabled: !1 }
      ]
    };
  }), a = vn(), i = R({
    styles: {
      popper: {
        position: b(o).strategy,
        left: "0",
        top: "0"
      },
      arrow: {
        position: "absolute"
      }
    },
    attributes: {}
  }), s = () => {
    a.value && (a.value.destroy(), a.value = void 0);
  };
  return Q(o, (l) => {
    const u = b(a);
    u && u.setOptions(l);
  }, {
    deep: !0
  }), Q([e, t], ([l, u]) => {
    s(), !(!l || !u) && (a.value = Sy(l, u, b(o)));
  }), Bt(() => {
    s();
  }), {
    state: D(() => {
      var l;
      return { ...((l = b(a)) == null ? void 0 : l.state) || {} };
    }),
    styles: D(() => b(i).styles),
    attributes: D(() => b(i).attributes),
    update: () => {
      var l;
      return (l = b(a)) == null ? void 0 : l.update();
    },
    forceUpdate: () => {
      var l;
      return (l = b(a)) == null ? void 0 : l.forceUpdate();
    },
    instanceRef: D(() => b(a))
  };
};
function By(e) {
  const t = Object.keys(e.elements), n = Xr(t.map((o) => [o, e.styles[o] || {}])), r = Xr(t.map((o) => [o, e.attributes[o]]));
  return {
    styles: n,
    attributes: r
  };
}
const $y = 0, zy = (e) => {
  const { popperInstanceRef: t, contentRef: n, triggerRef: r, role: o } = Me(Ba, void 0), a = R(), i = R(), s = D(() => ({
    name: "eventListeners",
    enabled: !!e.visible
  })), l = D(() => {
    var v;
    const m = b(a), y = (v = b(i)) != null ? v : $y;
    return {
      name: "arrow",
      enabled: !Av(m),
      options: {
        element: m,
        padding: y
      }
    };
  }), u = D(() => ({
    onFirstUpdate: () => {
      p();
    },
    ...ky(e, [
      b(l),
      b(s)
    ])
  })), f = D(() => xy(e.referenceEl) || b(r)), { attributes: c, state: d, styles: h, update: p, forceUpdate: g, instanceRef: E } = jy(f, n, u);
  return Q(E, (v) => t.value = v, {
    flush: "sync"
  }), xe(() => {
    Q(() => {
      var v;
      return (v = b(f)) == null ? void 0 : v.getBoundingClientRect();
    }, () => {
      p();
    });
  }), {
    attributes: c,
    arrowRef: a,
    contentRef: n,
    instanceRef: E,
    state: d,
    styles: h,
    role: o,
    forceUpdate: g,
    update: p
  };
}, Vy = (e, {
  attributes: t,
  styles: n,
  role: r
}) => {
  const { nextZIndex: o } = im(), a = Fe("popper"), i = D(() => b(t).popper), s = R(pt(e.zIndex) ? e.zIndex : o()), l = D(() => [
    a.b(),
    a.is("pure", e.pure),
    a.is(e.effect),
    e.popperClass
  ]), u = D(() => [
    { zIndex: b(s) },
    b(n).popper,
    e.popperStyle || {}
  ]), f = D(() => r.value === "dialog" ? "false" : void 0), c = D(() => b(n).arrow || {});
  return {
    ariaModal: f,
    arrowStyle: c,
    contentAttrs: i,
    contentClass: l,
    contentStyle: u,
    contentZIndex: s,
    updateZIndex: () => {
      s.value = pt(e.zIndex) ? e.zIndex : o();
    }
  };
}, Uy = q({
  name: "ElPopperContent"
}), Wy = /* @__PURE__ */ q({
  ...Uy,
  props: Fu,
  emits: Py,
  setup(e, { expose: t, emit: n }) {
    const r = e, {
      focusStartRef: o,
      trapped: a,
      onFocusAfterReleased: i,
      onFocusAfterTrapped: s,
      onFocusInTrap: l,
      onFocusoutPrevented: u,
      onReleaseRequested: f
    } = Dy(r, n), { attributes: c, arrowRef: d, contentRef: h, styles: p, instanceRef: g, role: E, update: v } = zy(r), {
      ariaModal: m,
      arrowStyle: y,
      contentAttrs: _,
      contentClass: T,
      contentStyle: N,
      updateZIndex: I
    } = Vy(r, {
      styles: p,
      attributes: c,
      role: E
    }), x = Me(Jr, void 0), B = R();
    Nt(bu, {
      arrowStyle: y,
      arrowRef: d,
      arrowOffset: B
    }), x && Nt(Jr, {
      ...x,
      addInputId: yr,
      removeInputId: yr
    });
    let H;
    const ee = (V = !0) => {
      v(), V && I();
    }, L = () => {
      ee(!1), r.visible && r.focusOnShow ? a.value = !0 : r.visible === !1 && (a.value = !1);
    };
    return xe(() => {
      Q(() => r.triggerTargetEl, (V, me) => {
        H == null || H(), H = void 0;
        const fe = b(V || h.value), ie = b(me || h.value);
        Jt(fe) && (H = Q([E, () => r.ariaLabel, m, () => r.id], (ne) => {
          ["role", "aria-label", "aria-modal", "id"].forEach((G, pe) => {
            fo(ne[pe]) ? fe.removeAttribute(G) : fe.setAttribute(G, ne[pe]);
          });
        }, { immediate: !0 })), ie !== fe && Jt(ie) && ["role", "aria-label", "aria-modal", "id"].forEach((ne) => {
          ie.removeAttribute(ne);
        });
      }, { immediate: !0 }), Q(() => r.visible, L, { immediate: !0 });
    }), Bt(() => {
      H == null || H(), H = void 0;
    }), t({
      popperContentRef: h,
      popperInstanceRef: g,
      updatePopper: ee,
      contentStyle: N
    }), (V, me) => (j(), X("div", yn({
      ref_key: "contentRef",
      ref: h
    }, b(_), {
      style: b(N),
      class: b(T),
      tabindex: "-1",
      onMouseenter: (fe) => V.$emit("mouseenter", fe),
      onMouseleave: (fe) => V.$emit("mouseleave", fe)
    }), [
      Ee(b(I0), {
        trapped: b(a),
        "trap-on-focus-in": !0,
        "focus-trap-el": b(h),
        "focus-start-el": b(o),
        onFocusAfterTrapped: b(s),
        onFocusAfterReleased: b(i),
        onFocusin: b(l),
        onFocusoutPrevented: b(u),
        onReleaseRequested: b(f)
      }, {
        default: ae(() => [
          J(V.$slots, "default")
        ]),
        _: 3
      }, 8, ["trapped", "focus-trap-el", "focus-start-el", "onFocusAfterTrapped", "onFocusAfterReleased", "onFocusin", "onFocusoutPrevented", "onReleaseRequested"])
    ], 16, ["onMouseenter", "onMouseleave"]));
  }
});
var Hy = /* @__PURE__ */ Re(Wy, [["__file", "content.vue"]]);
const Yy = zt(o0), Qa = Symbol("elTooltip");
function zs() {
  let e;
  const t = (r, o) => {
    n(), e = window.setTimeout(r, o);
  }, n = () => window.clearTimeout(e);
  return po(() => n()), {
    registerTimeout: t,
    cancelTimeout: n
  };
}
const Gy = Le({
  showAfter: {
    type: Number,
    default: 0
  },
  hideAfter: {
    type: Number,
    default: 200
  },
  autoClose: {
    type: Number,
    default: 0
  }
}), Ky = ({
  showAfter: e,
  hideAfter: t,
  autoClose: n,
  open: r,
  close: o
}) => {
  const { registerTimeout: a } = zs(), {
    registerTimeout: i,
    cancelTimeout: s
  } = zs();
  return {
    onOpen: (f) => {
      a(() => {
        r(f);
        const c = b(n);
        pt(c) && c > 0 && i(() => {
          o(f);
        }, c);
      }, b(e));
    },
    onClose: (f) => {
      s(), a(() => {
        o(f);
      }, b(t));
    }
  };
}, ju = Le({
  to: {
    type: ce([String, Object]),
    required: !0
  },
  disabled: Boolean
}), eo = Le({
  ...Gy,
  ...Fu,
  appendTo: {
    type: ju.to.type
  },
  content: {
    type: String,
    default: ""
  },
  rawContent: Boolean,
  persistent: Boolean,
  visible: {
    type: ce(Boolean),
    default: null
  },
  transition: String,
  teleported: {
    type: Boolean,
    default: !0
  },
  disabled: Boolean,
  ...Tr(["ariaLabel"])
}), Bu = Le({
  ..._u,
  disabled: Boolean,
  trigger: {
    type: ce([String, Array]),
    default: "hover"
  },
  triggerKeys: {
    type: ce(Array),
    default: () => [Vn.enter, Vn.numpadEnter, Vn.space]
  }
}), Xy = go({
  type: ce(Boolean),
  default: null
}), Qy = go({
  type: ce(Function)
}), Zy = (e) => {
  const t = `update:${e}`, n = `onUpdate:${e}`, r = [t], o = {
    [e]: Xy,
    [n]: Qy
  };
  return {
    useModelToggle: ({
      indicator: i,
      toggleReason: s,
      shouldHideWhenRouteChanges: l,
      shouldProceed: u,
      onShow: f,
      onHide: c
    }) => {
      const d = We(), { emit: h } = d, p = d.props, g = D(() => it(p[n])), E = D(() => p[e] === null), v = (I) => {
        i.value !== !0 && (i.value = !0, s && (s.value = I), it(f) && f(I));
      }, m = (I) => {
        i.value !== !1 && (i.value = !1, s && (s.value = I), it(c) && c(I));
      }, y = (I) => {
        if (p.disabled === !0 || it(u) && !u())
          return;
        const x = g.value && Qe;
        x && h(t, !0), (E.value || !x) && v(I);
      }, _ = (I) => {
        if (p.disabled === !0 || !Qe)
          return;
        const x = g.value && Qe;
        x && h(t, !1), (E.value || !x) && m(I);
      }, T = (I) => {
        Xl(I) && (p.disabled && I ? g.value && h(t, !1) : i.value !== I && (I ? v() : m()));
      }, N = () => {
        i.value ? _() : y();
      };
      return Q(() => p[e], T), l && d.appContext.config.globalProperties.$route !== void 0 && Q(() => ({
        ...d.proxy.$route
      }), () => {
        l.value && i.value && _();
      }), xe(() => {
        T(p[e]);
      }), {
        hide: _,
        show: y,
        toggle: N,
        hasUpdateHandler: g
      };
    },
    useModelToggleProps: o,
    useModelToggleEmits: r
  };
}, {
  useModelToggleProps: Jy,
  useModelToggleEmits: qy,
  useModelToggle: eb
} = Zy("visible"), tb = Le({
  ...Eu,
  ...Jy,
  ...eo,
  ...Bu,
  ...Mu,
  showArrow: {
    type: Boolean,
    default: !0
  }
}), nb = [
  ...qy,
  "before-show",
  "before-hide",
  "show",
  "hide",
  "open",
  "close"
], rb = (e, t) => Ot(e) ? e.includes(t) : e === t, Bn = (e, t, n) => (r) => {
  rb(b(e), t) && n(r);
}, Yt = (e, t, { checkForDefaultPrevented: n = !0 } = {}) => (o) => {
  const a = e == null ? void 0 : e(o);
  if (n === !1 || !a)
    return t == null ? void 0 : t(o);
}, ob = q({
  name: "ElTooltipTrigger"
}), ab = /* @__PURE__ */ q({
  ...ob,
  props: Bu,
  setup(e, { expose: t }) {
    const n = e, r = Fe("tooltip"), { controlled: o, id: a, open: i, onOpen: s, onClose: l, onToggle: u } = Me(Qa, void 0), f = R(null), c = () => {
      if (b(o) || n.disabled)
        return !0;
    }, d = wt(n, "trigger"), h = Yt(c, Bn(d, "hover", s)), p = Yt(c, Bn(d, "hover", l)), g = Yt(c, Bn(d, "click", (_) => {
      _.button === 0 && u(_);
    })), E = Yt(c, Bn(d, "focus", s)), v = Yt(c, Bn(d, "focus", l)), m = Yt(c, Bn(d, "contextmenu", (_) => {
      _.preventDefault(), u(_);
    })), y = Yt(c, (_) => {
      const { code: T } = _;
      n.triggerKeys.includes(T) && (_.preventDefault(), u(_));
    });
    return t({
      triggerRef: f
    }), (_, T) => (j(), ue(b(p0), {
      id: b(a),
      "virtual-ref": _.virtualRef,
      open: b(i),
      "virtual-triggering": _.virtualTriggering,
      class: Y(b(r).e("trigger")),
      onBlur: b(v),
      onClick: b(g),
      onContextmenu: b(m),
      onFocus: b(E),
      onMouseenter: b(h),
      onMouseleave: b(p),
      onKeydown: b(y)
    }, {
      default: ae(() => [
        J(_.$slots, "default")
      ]),
      _: 3
    }, 8, ["id", "virtual-ref", "open", "virtual-triggering", "class", "onBlur", "onClick", "onContextmenu", "onFocus", "onMouseenter", "onMouseleave", "onKeydown"]));
  }
});
var ib = /* @__PURE__ */ Re(ab, [["__file", "trigger.vue"]]);
const sb = /* @__PURE__ */ q({
  __name: "teleport",
  props: ju,
  setup(e) {
    return (t, n) => t.disabled ? J(t.$slots, "default", { key: 0 }) : (j(), ue(_c, {
      key: 1,
      to: t.to
    }, [
      J(t.$slots, "default")
    ], 8, ["to"]));
  }
});
var lb = /* @__PURE__ */ Re(sb, [["__file", "teleport.vue"]]);
const ub = zt(lb), $u = () => {
  const e = Ca(), t = pu(), n = D(() => `${e.value}-popper-container-${t.prefix}`), r = D(() => `#${n.value}`);
  return {
    id: n,
    selector: r
  };
}, cb = (e) => {
  const t = document.createElement("div");
  return t.id = e, document.body.appendChild(t), t;
}, fb = () => {
  const { id: e, selector: t } = $u();
  return wc(() => {
    Qe && (process.env.NODE_ENV === "test" || !document.body.querySelector(t.value)) && cb(e.value);
  }), {
    id: e,
    selector: t
  };
}, db = q({
  name: "ElTooltipContent",
  inheritAttrs: !1
}), pb = /* @__PURE__ */ q({
  ...db,
  props: eo,
  setup(e, { expose: t }) {
    const n = e, { selector: r } = $u(), o = Fe("tooltip"), a = R(), i = Ql(() => {
      var G;
      return (G = a.value) == null ? void 0 : G.popperContentRef;
    });
    let s;
    const {
      controlled: l,
      id: u,
      open: f,
      trigger: c,
      onClose: d,
      onOpen: h,
      onShow: p,
      onHide: g,
      onBeforeShow: E,
      onBeforeHide: v
    } = Me(Qa, void 0), m = D(() => n.transition || `${o.namespace.value}-fade-in-linear`), y = D(() => process.env.NODE_ENV === "test" ? !0 : n.persistent);
    Bt(() => {
      s == null || s();
    });
    const _ = D(() => b(y) ? !0 : b(f)), T = D(() => n.disabled ? !1 : b(f)), N = D(() => n.appendTo || r.value), I = D(() => {
      var G;
      return (G = n.style) != null ? G : {};
    }), x = R(!0), B = () => {
      g(), ne() && Ht(document.body), x.value = !0;
    }, H = () => {
      if (b(l))
        return !0;
    }, ee = Yt(H, () => {
      n.enterable && b(c) === "hover" && h();
    }), L = Yt(H, () => {
      b(c) === "hover" && d();
    }), V = () => {
      var G, pe;
      (pe = (G = a.value) == null ? void 0 : G.updatePopper) == null || pe.call(G), E == null || E();
    }, me = () => {
      v == null || v();
    }, fe = () => {
      p(), s = Yv(i, () => {
        if (b(l))
          return;
        b(c) !== "hover" && d();
      });
    }, ie = () => {
      n.virtualTriggering || d();
    }, ne = (G) => {
      var pe;
      const he = (pe = a.value) == null ? void 0 : pe.popperContentRef, Ie = (G == null ? void 0 : G.relatedTarget) || document.activeElement;
      return he == null ? void 0 : he.contains(Ie);
    };
    return Q(() => b(f), (G) => {
      G ? x.value = !1 : s == null || s();
    }, {
      flush: "post"
    }), Q(() => n.content, () => {
      var G, pe;
      (pe = (G = a.value) == null ? void 0 : G.updatePopper) == null || pe.call(G);
    }), t({
      contentRef: a,
      isFocusInsideContent: ne
    }), (G, pe) => (j(), ue(b(ub), {
      disabled: !G.teleported,
      to: b(N)
    }, {
      default: ae(() => [
        Ee(ha, {
          name: b(m),
          onAfterLeave: B,
          onBeforeEnter: V,
          onAfterEnter: fe,
          onBeforeLeave: me
        }, {
          default: ae(() => [
            b(_) ? st((j(), ue(b(Hy), yn({
              key: 0,
              id: b(u),
              ref_key: "contentRef",
              ref: a
            }, G.$attrs, {
              "aria-label": G.ariaLabel,
              "aria-hidden": x.value,
              "boundaries-padding": G.boundariesPadding,
              "fallback-placements": G.fallbackPlacements,
              "gpu-acceleration": G.gpuAcceleration,
              offset: G.offset,
              placement: G.placement,
              "popper-options": G.popperOptions,
              strategy: G.strategy,
              effect: G.effect,
              enterable: G.enterable,
              pure: G.pure,
              "popper-class": G.popperClass,
              "popper-style": [G.popperStyle, b(I)],
              "reference-el": G.referenceEl,
              "trigger-target-el": G.triggerTargetEl,
              visible: b(T),
              "z-index": G.zIndex,
              onMouseenter: b(ee),
              onMouseleave: b(L),
              onBlur: ie,
              onClose: b(d)
            }), {
              default: ae(() => [
                J(G.$slots, "default")
              ]),
              _: 3
            }, 16, ["id", "aria-label", "aria-hidden", "boundaries-padding", "fallback-placements", "gpu-acceleration", "offset", "placement", "popper-options", "strategy", "effect", "enterable", "pure", "popper-class", "popper-style", "reference-el", "trigger-target-el", "visible", "z-index", "onMouseenter", "onMouseleave", "onClose"])), [
              [St, b(T)]
            ]) : te("v-if", !0)
          ]),
          _: 3
        }, 8, ["name"])
      ]),
      _: 3
    }, 8, ["disabled", "to"]));
  }
});
var hb = /* @__PURE__ */ Re(pb, [["__file", "content.vue"]]);
const gb = q({
  name: "ElTooltip"
}), vb = /* @__PURE__ */ q({
  ...gb,
  props: tb,
  emits: nb,
  setup(e, { expose: t, emit: n }) {
    const r = e;
    fb();
    const o = Fe("tooltip"), a = mo(), i = R(), s = R(), l = () => {
      var y;
      const _ = b(i);
      _ && ((y = _.popperInstanceRef) == null || y.update());
    }, u = R(!1), f = R(), { show: c, hide: d, hasUpdateHandler: h } = eb({
      indicator: u,
      toggleReason: f
    }), { onOpen: p, onClose: g } = Ky({
      showAfter: wt(r, "showAfter"),
      hideAfter: wt(r, "hideAfter"),
      autoClose: wt(r, "autoClose"),
      open: c,
      close: d
    }), E = D(() => Xl(r.visible) && !h.value), v = D(() => [o.b(), r.popperClass]);
    Nt(Qa, {
      controlled: E,
      id: a,
      open: el(u),
      trigger: wt(r, "trigger"),
      onOpen: (y) => {
        p(y);
      },
      onClose: (y) => {
        g(y);
      },
      onToggle: (y) => {
        b(u) ? g(y) : p(y);
      },
      onShow: () => {
        n("show", f.value);
      },
      onHide: () => {
        n("hide", f.value);
      },
      onBeforeShow: () => {
        n("before-show", f.value);
      },
      onBeforeHide: () => {
        n("before-hide", f.value);
      },
      updatePopper: l
    }), Q(() => r.disabled, (y) => {
      y && u.value && (u.value = !1);
    });
    const m = (y) => {
      var _;
      return (_ = s.value) == null ? void 0 : _.isFocusInsideContent(y);
    };
    return Tc(() => u.value && d()), t({
      popperRef: i,
      contentRef: s,
      isFocusInsideContent: m,
      updatePopper: l,
      onOpen: p,
      onClose: g,
      hide: d
    }), (y, _) => (j(), ue(b(Yy), {
      ref_key: "popperRef",
      ref: i,
      role: y.role
    }, {
      default: ae(() => [
        Ee(ib, {
          disabled: y.disabled,
          trigger: y.trigger,
          "trigger-keys": y.triggerKeys,
          "virtual-ref": y.virtualRef,
          "virtual-triggering": y.virtualTriggering
        }, {
          default: ae(() => [
            y.$slots.default ? J(y.$slots, "default", { key: 0 }) : te("v-if", !0)
          ]),
          _: 3
        }, 8, ["disabled", "trigger", "trigger-keys", "virtual-ref", "virtual-triggering"]),
        Ee(hb, {
          ref_key: "contentRef",
          ref: s,
          "aria-label": y.ariaLabel,
          "boundaries-padding": y.boundariesPadding,
          content: y.content,
          disabled: y.disabled,
          effect: y.effect,
          enterable: y.enterable,
          "fallback-placements": y.fallbackPlacements,
          "hide-after": y.hideAfter,
          "gpu-acceleration": y.gpuAcceleration,
          offset: y.offset,
          persistent: y.persistent,
          "popper-class": b(v),
          "popper-style": y.popperStyle,
          placement: y.placement,
          "popper-options": y.popperOptions,
          pure: y.pure,
          "raw-content": y.rawContent,
          "reference-el": y.referenceEl,
          "trigger-target-el": y.triggerTargetEl,
          "show-after": y.showAfter,
          strategy: y.strategy,
          teleported: y.teleported,
          transition: y.transition,
          "virtual-triggering": y.virtualTriggering,
          "z-index": y.zIndex,
          "append-to": y.appendTo
        }, {
          default: ae(() => [
            J(y.$slots, "content", {}, () => [
              y.rawContent ? (j(), X("span", {
                key: 0,
                innerHTML: y.content
              }, null, 8, ["innerHTML"])) : (j(), X("span", { key: 1 }, ot(y.content), 1))
            ]),
            y.showArrow ? (j(), ue(b(s0), {
              key: 0,
              "arrow-offset": y.arrowOffset
            }, null, 8, ["arrow-offset"])) : te("v-if", !0)
          ]),
          _: 3
        }, 8, ["aria-label", "boundaries-padding", "content", "disabled", "effect", "enterable", "fallback-placements", "hide-after", "gpu-acceleration", "offset", "persistent", "popper-class", "popper-style", "placement", "popper-options", "pure", "raw-content", "reference-el", "trigger-target-el", "show-after", "strategy", "teleported", "transition", "virtual-triggering", "z-index", "append-to"])
      ]),
      _: 3
    }, 8, ["role"]));
  }
});
var mb = /* @__PURE__ */ Re(vb, [["__file", "tooltip.vue"]]);
const yb = zt(mb), zu = Symbol("buttonGroupContextKey"), bb = ({ from: e, replacement: t, scope: n, version: r, ref: o, type: a = "API" }, i) => {
  Q(() => b(i), (s) => {
    s && qe(n, `[${a}] ${e} is about to be deprecated in version ${r}, please use ${t} instead.
For more detail, please visit: ${o}
`);
  }, {
    immediate: !0
  });
}, Eb = (e, t) => {
  bb({
    from: "type.text",
    replacement: "link",
    version: "3.0.0",
    scope: "props",
    ref: "https://element-plus.org/en-US/component/button.html#button-attributes"
  }, D(() => e.type === "text"));
  const n = Me(zu, void 0), r = cu("button"), { form: o } = xa(), a = yo(D(() => n == null ? void 0 : n.size)), i = Fa(), s = R(), l = tl(), u = D(() => e.type || (n == null ? void 0 : n.type) || ""), f = D(() => {
    var p, g, E;
    return (E = (g = e.autoInsertSpace) != null ? g : (p = r.value) == null ? void 0 : p.autoInsertSpace) != null ? E : !1;
  }), c = D(() => e.tag === "button" ? {
    ariaDisabled: i.value || e.loading,
    disabled: i.value || e.loading,
    autofocus: e.autofocus,
    type: e.nativeType
  } : {}), d = D(() => {
    var p;
    const g = (p = l.default) == null ? void 0 : p.call(l);
    if (f.value && (g == null ? void 0 : g.length) === 1) {
      const E = g[0];
      if ((E == null ? void 0 : E.type) === pa) {
        const v = E.children;
        return new RegExp("^\\p{Unified_Ideograph}{2}$", "u").test(v.trim());
      }
    }
    return !1;
  });
  return {
    _disabled: i,
    _size: a,
    _type: u,
    _ref: s,
    _props: c,
    shouldAddSpace: d,
    handleClick: (p) => {
      if (i.value || e.loading) {
        p.stopPropagation();
        return;
      }
      e.nativeType === "reset" && (o == null || o.resetFields()), t("click", p);
    }
  };
}, Mb = [
  "default",
  "primary",
  "success",
  "warning",
  "info",
  "danger",
  "text",
  ""
], _b = ["button", "submit", "reset"], la = Le({
  size: vo,
  disabled: Boolean,
  type: {
    type: String,
    values: Mb,
    default: ""
  },
  icon: {
    type: Yn
  },
  nativeType: {
    type: String,
    values: _b,
    default: "button"
  },
  loading: Boolean,
  loadingIcon: {
    type: Yn,
    default: () => rl
  },
  plain: Boolean,
  text: Boolean,
  link: Boolean,
  bg: Boolean,
  autofocus: Boolean,
  round: Boolean,
  circle: Boolean,
  color: String,
  dark: Boolean,
  autoInsertSpace: {
    type: Boolean,
    default: void 0
  },
  tag: {
    type: ce([String, Object]),
    default: "button"
  }
}), wb = {
  click: (e) => e instanceof MouseEvent
};
function Ze(e, t) {
  Tb(e) && (e = "100%");
  var n = Cb(e);
  return e = t === 360 ? e : Math.min(t, Math.max(0, parseFloat(e))), n && (e = parseInt(String(e * t), 10) / 100), Math.abs(e - t) < 1e-6 ? 1 : (t === 360 ? e = (e < 0 ? e % t + t : e % t) / parseFloat(String(t)) : e = e % t / parseFloat(String(t)), e);
}
function Br(e) {
  return Math.min(1, Math.max(0, e));
}
function Tb(e) {
  return typeof e == "string" && e.indexOf(".") !== -1 && parseFloat(e) === 1;
}
function Cb(e) {
  return typeof e == "string" && e.indexOf("%") !== -1;
}
function Vu(e) {
  return e = parseFloat(e), (isNaN(e) || e < 0 || e > 1) && (e = 1), e;
}
function $r(e) {
  return e <= 1 ? "".concat(Number(e) * 100, "%") : e;
}
function Sn(e) {
  return e.length === 1 ? "0" + e : String(e);
}
function Ob(e, t, n) {
  return {
    r: Ze(e, 255) * 255,
    g: Ze(t, 255) * 255,
    b: Ze(n, 255) * 255
  };
}
function Vs(e, t, n) {
  e = Ze(e, 255), t = Ze(t, 255), n = Ze(n, 255);
  var r = Math.max(e, t, n), o = Math.min(e, t, n), a = 0, i = 0, s = (r + o) / 2;
  if (r === o)
    i = 0, a = 0;
  else {
    var l = r - o;
    switch (i = s > 0.5 ? l / (2 - r - o) : l / (r + o), r) {
      case e:
        a = (t - n) / l + (t < n ? 6 : 0);
        break;
      case t:
        a = (n - e) / l + 2;
        break;
      case n:
        a = (e - t) / l + 4;
        break;
    }
    a /= 6;
  }
  return { h: a, s: i, l: s };
}
function xo(e, t, n) {
  return n < 0 && (n += 1), n > 1 && (n -= 1), n < 1 / 6 ? e + (t - e) * (6 * n) : n < 1 / 2 ? t : n < 2 / 3 ? e + (t - e) * (2 / 3 - n) * 6 : e;
}
function Ib(e, t, n) {
  var r, o, a;
  if (e = Ze(e, 360), t = Ze(t, 100), n = Ze(n, 100), t === 0)
    o = n, a = n, r = n;
  else {
    var i = n < 0.5 ? n * (1 + t) : n + t - n * t, s = 2 * n - i;
    r = xo(s, i, e + 1 / 3), o = xo(s, i, e), a = xo(s, i, e - 1 / 3);
  }
  return { r: r * 255, g: o * 255, b: a * 255 };
}
function Us(e, t, n) {
  e = Ze(e, 255), t = Ze(t, 255), n = Ze(n, 255);
  var r = Math.max(e, t, n), o = Math.min(e, t, n), a = 0, i = r, s = r - o, l = r === 0 ? 0 : s / r;
  if (r === o)
    a = 0;
  else {
    switch (r) {
      case e:
        a = (t - n) / s + (t < n ? 6 : 0);
        break;
      case t:
        a = (n - e) / s + 2;
        break;
      case n:
        a = (e - t) / s + 4;
        break;
    }
    a /= 6;
  }
  return { h: a, s: l, v: i };
}
function Nb(e, t, n) {
  e = Ze(e, 360) * 6, t = Ze(t, 100), n = Ze(n, 100);
  var r = Math.floor(e), o = e - r, a = n * (1 - t), i = n * (1 - o * t), s = n * (1 - (1 - o) * t), l = r % 6, u = [n, i, a, a, s, n][l], f = [s, n, n, i, a, a][l], c = [a, a, s, n, n, i][l];
  return { r: u * 255, g: f * 255, b: c * 255 };
}
function Ws(e, t, n, r) {
  var o = [
    Sn(Math.round(e).toString(16)),
    Sn(Math.round(t).toString(16)),
    Sn(Math.round(n).toString(16))
  ];
  return r && o[0].startsWith(o[0].charAt(1)) && o[1].startsWith(o[1].charAt(1)) && o[2].startsWith(o[2].charAt(1)) ? o[0].charAt(0) + o[1].charAt(0) + o[2].charAt(0) : o.join("");
}
function Sb(e, t, n, r, o) {
  var a = [
    Sn(Math.round(e).toString(16)),
    Sn(Math.round(t).toString(16)),
    Sn(Math.round(n).toString(16)),
    Sn(Ab(r))
  ];
  return o && a[0].startsWith(a[0].charAt(1)) && a[1].startsWith(a[1].charAt(1)) && a[2].startsWith(a[2].charAt(1)) && a[3].startsWith(a[3].charAt(1)) ? a[0].charAt(0) + a[1].charAt(0) + a[2].charAt(0) + a[3].charAt(0) : a.join("");
}
function Ab(e) {
  return Math.round(parseFloat(e) * 255).toString(16);
}
function Hs(e) {
  return ft(e) / 255;
}
function ft(e) {
  return parseInt(e, 16);
}
function Lb(e) {
  return {
    r: e >> 16,
    g: (e & 65280) >> 8,
    b: e & 255
  };
}
var ua = {
  aliceblue: "#f0f8ff",
  antiquewhite: "#faebd7",
  aqua: "#00ffff",
  aquamarine: "#7fffd4",
  azure: "#f0ffff",
  beige: "#f5f5dc",
  bisque: "#ffe4c4",
  black: "#000000",
  blanchedalmond: "#ffebcd",
  blue: "#0000ff",
  blueviolet: "#8a2be2",
  brown: "#a52a2a",
  burlywood: "#deb887",
  cadetblue: "#5f9ea0",
  chartreuse: "#7fff00",
  chocolate: "#d2691e",
  coral: "#ff7f50",
  cornflowerblue: "#6495ed",
  cornsilk: "#fff8dc",
  crimson: "#dc143c",
  cyan: "#00ffff",
  darkblue: "#00008b",
  darkcyan: "#008b8b",
  darkgoldenrod: "#b8860b",
  darkgray: "#a9a9a9",
  darkgreen: "#006400",
  darkgrey: "#a9a9a9",
  darkkhaki: "#bdb76b",
  darkmagenta: "#8b008b",
  darkolivegreen: "#556b2f",
  darkorange: "#ff8c00",
  darkorchid: "#9932cc",
  darkred: "#8b0000",
  darksalmon: "#e9967a",
  darkseagreen: "#8fbc8f",
  darkslateblue: "#483d8b",
  darkslategray: "#2f4f4f",
  darkslategrey: "#2f4f4f",
  darkturquoise: "#00ced1",
  darkviolet: "#9400d3",
  deeppink: "#ff1493",
  deepskyblue: "#00bfff",
  dimgray: "#696969",
  dimgrey: "#696969",
  dodgerblue: "#1e90ff",
  firebrick: "#b22222",
  floralwhite: "#fffaf0",
  forestgreen: "#228b22",
  fuchsia: "#ff00ff",
  gainsboro: "#dcdcdc",
  ghostwhite: "#f8f8ff",
  goldenrod: "#daa520",
  gold: "#ffd700",
  gray: "#808080",
  green: "#008000",
  greenyellow: "#adff2f",
  grey: "#808080",
  honeydew: "#f0fff0",
  hotpink: "#ff69b4",
  indianred: "#cd5c5c",
  indigo: "#4b0082",
  ivory: "#fffff0",
  khaki: "#f0e68c",
  lavenderblush: "#fff0f5",
  lavender: "#e6e6fa",
  lawngreen: "#7cfc00",
  lemonchiffon: "#fffacd",
  lightblue: "#add8e6",
  lightcoral: "#f08080",
  lightcyan: "#e0ffff",
  lightgoldenrodyellow: "#fafad2",
  lightgray: "#d3d3d3",
  lightgreen: "#90ee90",
  lightgrey: "#d3d3d3",
  lightpink: "#ffb6c1",
  lightsalmon: "#ffa07a",
  lightseagreen: "#20b2aa",
  lightskyblue: "#87cefa",
  lightslategray: "#778899",
  lightslategrey: "#778899",
  lightsteelblue: "#b0c4de",
  lightyellow: "#ffffe0",
  lime: "#00ff00",
  limegreen: "#32cd32",
  linen: "#faf0e6",
  magenta: "#ff00ff",
  maroon: "#800000",
  mediumaquamarine: "#66cdaa",
  mediumblue: "#0000cd",
  mediumorchid: "#ba55d3",
  mediumpurple: "#9370db",
  mediumseagreen: "#3cb371",
  mediumslateblue: "#7b68ee",
  mediumspringgreen: "#00fa9a",
  mediumturquoise: "#48d1cc",
  mediumvioletred: "#c71585",
  midnightblue: "#191970",
  mintcream: "#f5fffa",
  mistyrose: "#ffe4e1",
  moccasin: "#ffe4b5",
  navajowhite: "#ffdead",
  navy: "#000080",
  oldlace: "#fdf5e6",
  olive: "#808000",
  olivedrab: "#6b8e23",
  orange: "#ffa500",
  orangered: "#ff4500",
  orchid: "#da70d6",
  palegoldenrod: "#eee8aa",
  palegreen: "#98fb98",
  paleturquoise: "#afeeee",
  palevioletred: "#db7093",
  papayawhip: "#ffefd5",
  peachpuff: "#ffdab9",
  peru: "#cd853f",
  pink: "#ffc0cb",
  plum: "#dda0dd",
  powderblue: "#b0e0e6",
  purple: "#800080",
  rebeccapurple: "#663399",
  red: "#ff0000",
  rosybrown: "#bc8f8f",
  royalblue: "#4169e1",
  saddlebrown: "#8b4513",
  salmon: "#fa8072",
  sandybrown: "#f4a460",
  seagreen: "#2e8b57",
  seashell: "#fff5ee",
  sienna: "#a0522d",
  silver: "#c0c0c0",
  skyblue: "#87ceeb",
  slateblue: "#6a5acd",
  slategray: "#708090",
  slategrey: "#708090",
  snow: "#fffafa",
  springgreen: "#00ff7f",
  steelblue: "#4682b4",
  tan: "#d2b48c",
  teal: "#008080",
  thistle: "#d8bfd8",
  tomato: "#ff6347",
  turquoise: "#40e0d0",
  violet: "#ee82ee",
  wheat: "#f5deb3",
  white: "#ffffff",
  whitesmoke: "#f5f5f5",
  yellow: "#ffff00",
  yellowgreen: "#9acd32"
};
function Pb(e) {
  var t = { r: 0, g: 0, b: 0 }, n = 1, r = null, o = null, a = null, i = !1, s = !1;
  return typeof e == "string" && (e = xb(e)), typeof e == "object" && (Wt(e.r) && Wt(e.g) && Wt(e.b) ? (t = Ob(e.r, e.g, e.b), i = !0, s = String(e.r).substr(-1) === "%" ? "prgb" : "rgb") : Wt(e.h) && Wt(e.s) && Wt(e.v) ? (r = $r(e.s), o = $r(e.v), t = Nb(e.h, r, o), i = !0, s = "hsv") : Wt(e.h) && Wt(e.s) && Wt(e.l) && (r = $r(e.s), a = $r(e.l), t = Ib(e.h, r, a), i = !0, s = "hsl"), Object.prototype.hasOwnProperty.call(e, "a") && (n = e.a)), n = Vu(n), {
    ok: i,
    format: e.format || s,
    r: Math.min(255, Math.max(t.r, 0)),
    g: Math.min(255, Math.max(t.g, 0)),
    b: Math.min(255, Math.max(t.b, 0)),
    a: n
  };
}
var Db = "[-\\+]?\\d+%?", kb = "[-\\+]?\\d*\\.\\d+%?", gn = "(?:".concat(kb, ")|(?:").concat(Db, ")"), Ro = "[\\s|\\(]+(".concat(gn, ")[,|\\s]+(").concat(gn, ")[,|\\s]+(").concat(gn, ")\\s*\\)?"), Fo = "[\\s|\\(]+(".concat(gn, ")[,|\\s]+(").concat(gn, ")[,|\\s]+(").concat(gn, ")[,|\\s]+(").concat(gn, ")\\s*\\)?"), Mt = {
  CSS_UNIT: new RegExp(gn),
  rgb: new RegExp("rgb" + Ro),
  rgba: new RegExp("rgba" + Fo),
  hsl: new RegExp("hsl" + Ro),
  hsla: new RegExp("hsla" + Fo),
  hsv: new RegExp("hsv" + Ro),
  hsva: new RegExp("hsva" + Fo),
  hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
  hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
  hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
  hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
};
function xb(e) {
  if (e = e.trim().toLowerCase(), e.length === 0)
    return !1;
  var t = !1;
  if (ua[e])
    e = ua[e], t = !0;
  else if (e === "transparent")
    return { r: 0, g: 0, b: 0, a: 0, format: "name" };
  var n = Mt.rgb.exec(e);
  return n ? { r: n[1], g: n[2], b: n[3] } : (n = Mt.rgba.exec(e), n ? { r: n[1], g: n[2], b: n[3], a: n[4] } : (n = Mt.hsl.exec(e), n ? { h: n[1], s: n[2], l: n[3] } : (n = Mt.hsla.exec(e), n ? { h: n[1], s: n[2], l: n[3], a: n[4] } : (n = Mt.hsv.exec(e), n ? { h: n[1], s: n[2], v: n[3] } : (n = Mt.hsva.exec(e), n ? { h: n[1], s: n[2], v: n[3], a: n[4] } : (n = Mt.hex8.exec(e), n ? {
    r: ft(n[1]),
    g: ft(n[2]),
    b: ft(n[3]),
    a: Hs(n[4]),
    format: t ? "name" : "hex8"
  } : (n = Mt.hex6.exec(e), n ? {
    r: ft(n[1]),
    g: ft(n[2]),
    b: ft(n[3]),
    format: t ? "name" : "hex"
  } : (n = Mt.hex4.exec(e), n ? {
    r: ft(n[1] + n[1]),
    g: ft(n[2] + n[2]),
    b: ft(n[3] + n[3]),
    a: Hs(n[4] + n[4]),
    format: t ? "name" : "hex8"
  } : (n = Mt.hex3.exec(e), n ? {
    r: ft(n[1] + n[1]),
    g: ft(n[2] + n[2]),
    b: ft(n[3] + n[3]),
    format: t ? "name" : "hex"
  } : !1)))))))));
}
function Wt(e) {
  return !!Mt.CSS_UNIT.exec(String(e));
}
var Rb = (
  /** @class */
  function() {
    function e(t, n) {
      t === void 0 && (t = ""), n === void 0 && (n = {});
      var r;
      if (t instanceof e)
        return t;
      typeof t == "number" && (t = Lb(t)), this.originalInput = t;
      var o = Pb(t);
      this.originalInput = t, this.r = o.r, this.g = o.g, this.b = o.b, this.a = o.a, this.roundA = Math.round(100 * this.a) / 100, this.format = (r = n.format) !== null && r !== void 0 ? r : o.format, this.gradientType = n.gradientType, this.r < 1 && (this.r = Math.round(this.r)), this.g < 1 && (this.g = Math.round(this.g)), this.b < 1 && (this.b = Math.round(this.b)), this.isValid = o.ok;
    }
    return e.prototype.isDark = function() {
      return this.getBrightness() < 128;
    }, e.prototype.isLight = function() {
      return !this.isDark();
    }, e.prototype.getBrightness = function() {
      var t = this.toRgb();
      return (t.r * 299 + t.g * 587 + t.b * 114) / 1e3;
    }, e.prototype.getLuminance = function() {
      var t = this.toRgb(), n, r, o, a = t.r / 255, i = t.g / 255, s = t.b / 255;
      return a <= 0.03928 ? n = a / 12.92 : n = Math.pow((a + 0.055) / 1.055, 2.4), i <= 0.03928 ? r = i / 12.92 : r = Math.pow((i + 0.055) / 1.055, 2.4), s <= 0.03928 ? o = s / 12.92 : o = Math.pow((s + 0.055) / 1.055, 2.4), 0.2126 * n + 0.7152 * r + 0.0722 * o;
    }, e.prototype.getAlpha = function() {
      return this.a;
    }, e.prototype.setAlpha = function(t) {
      return this.a = Vu(t), this.roundA = Math.round(100 * this.a) / 100, this;
    }, e.prototype.isMonochrome = function() {
      var t = this.toHsl().s;
      return t === 0;
    }, e.prototype.toHsv = function() {
      var t = Us(this.r, this.g, this.b);
      return { h: t.h * 360, s: t.s, v: t.v, a: this.a };
    }, e.prototype.toHsvString = function() {
      var t = Us(this.r, this.g, this.b), n = Math.round(t.h * 360), r = Math.round(t.s * 100), o = Math.round(t.v * 100);
      return this.a === 1 ? "hsv(".concat(n, ", ").concat(r, "%, ").concat(o, "%)") : "hsva(".concat(n, ", ").concat(r, "%, ").concat(o, "%, ").concat(this.roundA, ")");
    }, e.prototype.toHsl = function() {
      var t = Vs(this.r, this.g, this.b);
      return { h: t.h * 360, s: t.s, l: t.l, a: this.a };
    }, e.prototype.toHslString = function() {
      var t = Vs(this.r, this.g, this.b), n = Math.round(t.h * 360), r = Math.round(t.s * 100), o = Math.round(t.l * 100);
      return this.a === 1 ? "hsl(".concat(n, ", ").concat(r, "%, ").concat(o, "%)") : "hsla(".concat(n, ", ").concat(r, "%, ").concat(o, "%, ").concat(this.roundA, ")");
    }, e.prototype.toHex = function(t) {
      return t === void 0 && (t = !1), Ws(this.r, this.g, this.b, t);
    }, e.prototype.toHexString = function(t) {
      return t === void 0 && (t = !1), "#" + this.toHex(t);
    }, e.prototype.toHex8 = function(t) {
      return t === void 0 && (t = !1), Sb(this.r, this.g, this.b, this.a, t);
    }, e.prototype.toHex8String = function(t) {
      return t === void 0 && (t = !1), "#" + this.toHex8(t);
    }, e.prototype.toHexShortString = function(t) {
      return t === void 0 && (t = !1), this.a === 1 ? this.toHexString(t) : this.toHex8String(t);
    }, e.prototype.toRgb = function() {
      return {
        r: Math.round(this.r),
        g: Math.round(this.g),
        b: Math.round(this.b),
        a: this.a
      };
    }, e.prototype.toRgbString = function() {
      var t = Math.round(this.r), n = Math.round(this.g), r = Math.round(this.b);
      return this.a === 1 ? "rgb(".concat(t, ", ").concat(n, ", ").concat(r, ")") : "rgba(".concat(t, ", ").concat(n, ", ").concat(r, ", ").concat(this.roundA, ")");
    }, e.prototype.toPercentageRgb = function() {
      var t = function(n) {
        return "".concat(Math.round(Ze(n, 255) * 100), "%");
      };
      return {
        r: t(this.r),
        g: t(this.g),
        b: t(this.b),
        a: this.a
      };
    }, e.prototype.toPercentageRgbString = function() {
      var t = function(n) {
        return Math.round(Ze(n, 255) * 100);
      };
      return this.a === 1 ? "rgb(".concat(t(this.r), "%, ").concat(t(this.g), "%, ").concat(t(this.b), "%)") : "rgba(".concat(t(this.r), "%, ").concat(t(this.g), "%, ").concat(t(this.b), "%, ").concat(this.roundA, ")");
    }, e.prototype.toName = function() {
      if (this.a === 0)
        return "transparent";
      if (this.a < 1)
        return !1;
      for (var t = "#" + Ws(this.r, this.g, this.b, !1), n = 0, r = Object.entries(ua); n < r.length; n++) {
        var o = r[n], a = o[0], i = o[1];
        if (t === i)
          return a;
      }
      return !1;
    }, e.prototype.toString = function(t) {
      var n = !!t;
      t = t ?? this.format;
      var r = !1, o = this.a < 1 && this.a >= 0, a = !n && o && (t.startsWith("hex") || t === "name");
      return a ? t === "name" && this.a === 0 ? this.toName() : this.toRgbString() : (t === "rgb" && (r = this.toRgbString()), t === "prgb" && (r = this.toPercentageRgbString()), (t === "hex" || t === "hex6") && (r = this.toHexString()), t === "hex3" && (r = this.toHexString(!0)), t === "hex4" && (r = this.toHex8String(!0)), t === "hex8" && (r = this.toHex8String()), t === "name" && (r = this.toName()), t === "hsl" && (r = this.toHslString()), t === "hsv" && (r = this.toHsvString()), r || this.toHexString());
    }, e.prototype.toNumber = function() {
      return (Math.round(this.r) << 16) + (Math.round(this.g) << 8) + Math.round(this.b);
    }, e.prototype.clone = function() {
      return new e(this.toString());
    }, e.prototype.lighten = function(t) {
      t === void 0 && (t = 10);
      var n = this.toHsl();
      return n.l += t / 100, n.l = Br(n.l), new e(n);
    }, e.prototype.brighten = function(t) {
      t === void 0 && (t = 10);
      var n = this.toRgb();
      return n.r = Math.max(0, Math.min(255, n.r - Math.round(255 * -(t / 100)))), n.g = Math.max(0, Math.min(255, n.g - Math.round(255 * -(t / 100)))), n.b = Math.max(0, Math.min(255, n.b - Math.round(255 * -(t / 100)))), new e(n);
    }, e.prototype.darken = function(t) {
      t === void 0 && (t = 10);
      var n = this.toHsl();
      return n.l -= t / 100, n.l = Br(n.l), new e(n);
    }, e.prototype.tint = function(t) {
      return t === void 0 && (t = 10), this.mix("white", t);
    }, e.prototype.shade = function(t) {
      return t === void 0 && (t = 10), this.mix("black", t);
    }, e.prototype.desaturate = function(t) {
      t === void 0 && (t = 10);
      var n = this.toHsl();
      return n.s -= t / 100, n.s = Br(n.s), new e(n);
    }, e.prototype.saturate = function(t) {
      t === void 0 && (t = 10);
      var n = this.toHsl();
      return n.s += t / 100, n.s = Br(n.s), new e(n);
    }, e.prototype.greyscale = function() {
      return this.desaturate(100);
    }, e.prototype.spin = function(t) {
      var n = this.toHsl(), r = (n.h + t) % 360;
      return n.h = r < 0 ? 360 + r : r, new e(n);
    }, e.prototype.mix = function(t, n) {
      n === void 0 && (n = 50);
      var r = this.toRgb(), o = new e(t).toRgb(), a = n / 100, i = {
        r: (o.r - r.r) * a + r.r,
        g: (o.g - r.g) * a + r.g,
        b: (o.b - r.b) * a + r.b,
        a: (o.a - r.a) * a + r.a
      };
      return new e(i);
    }, e.prototype.analogous = function(t, n) {
      t === void 0 && (t = 6), n === void 0 && (n = 30);
      var r = this.toHsl(), o = 360 / n, a = [this];
      for (r.h = (r.h - (o * t >> 1) + 720) % 360; --t; )
        r.h = (r.h + o) % 360, a.push(new e(r));
      return a;
    }, e.prototype.complement = function() {
      var t = this.toHsl();
      return t.h = (t.h + 180) % 360, new e(t);
    }, e.prototype.monochromatic = function(t) {
      t === void 0 && (t = 6);
      for (var n = this.toHsv(), r = n.h, o = n.s, a = n.v, i = [], s = 1 / t; t--; )
        i.push(new e({ h: r, s: o, v: a })), a = (a + s) % 1;
      return i;
    }, e.prototype.splitcomplement = function() {
      var t = this.toHsl(), n = t.h;
      return [
        this,
        new e({ h: (n + 72) % 360, s: t.s, l: t.l }),
        new e({ h: (n + 216) % 360, s: t.s, l: t.l })
      ];
    }, e.prototype.onBackground = function(t) {
      var n = this.toRgb(), r = new e(t).toRgb(), o = n.a + r.a * (1 - n.a);
      return new e({
        r: (n.r * n.a + r.r * r.a * (1 - n.a)) / o,
        g: (n.g * n.a + r.g * r.a * (1 - n.a)) / o,
        b: (n.b * n.a + r.b * r.a * (1 - n.a)) / o,
        a: o
      });
    }, e.prototype.triad = function() {
      return this.polyad(3);
    }, e.prototype.tetrad = function() {
      return this.polyad(4);
    }, e.prototype.polyad = function(t) {
      for (var n = this.toHsl(), r = n.h, o = [this], a = 360 / t, i = 1; i < t; i++)
        o.push(new e({ h: (r + i * a) % 360, s: n.s, l: n.l }));
      return o;
    }, e.prototype.equals = function(t) {
      return this.toRgbString() === new e(t).toRgbString();
    }, e;
  }()
);
function un(e, t = 20) {
  return e.mix("#141414", t).toString();
}
function Fb(e) {
  const t = Fa(), n = Fe("button");
  return D(() => {
    let r = {}, o = e.color;
    if (o) {
      const a = o.match(/var\((.*?)\)/);
      a && (o = window.getComputedStyle(window.document.documentElement).getPropertyValue(a[1]));
      const i = new Rb(o), s = e.dark ? i.tint(20).toString() : un(i, 20);
      if (e.plain)
        r = n.cssVarBlock({
          "bg-color": e.dark ? un(i, 90) : i.tint(90).toString(),
          "text-color": o,
          "border-color": e.dark ? un(i, 50) : i.tint(50).toString(),
          "hover-text-color": `var(${n.cssVarName("color-white")})`,
          "hover-bg-color": o,
          "hover-border-color": o,
          "active-bg-color": s,
          "active-text-color": `var(${n.cssVarName("color-white")})`,
          "active-border-color": s
        }), t.value && (r[n.cssVarBlockName("disabled-bg-color")] = e.dark ? un(i, 90) : i.tint(90).toString(), r[n.cssVarBlockName("disabled-text-color")] = e.dark ? un(i, 50) : i.tint(50).toString(), r[n.cssVarBlockName("disabled-border-color")] = e.dark ? un(i, 80) : i.tint(80).toString());
      else {
        const l = e.dark ? un(i, 30) : i.tint(30).toString(), u = i.isDark() ? `var(${n.cssVarName("color-white")})` : `var(${n.cssVarName("color-black")})`;
        if (r = n.cssVarBlock({
          "bg-color": o,
          "text-color": u,
          "border-color": o,
          "hover-bg-color": l,
          "hover-text-color": u,
          "hover-border-color": l,
          "active-bg-color": s,
          "active-border-color": s
        }), t.value) {
          const f = e.dark ? un(i, 50) : i.tint(50).toString();
          r[n.cssVarBlockName("disabled-bg-color")] = f, r[n.cssVarBlockName("disabled-text-color")] = e.dark ? "rgba(255, 255, 255, 0.5)" : `var(${n.cssVarName("color-white")})`, r[n.cssVarBlockName("disabled-border-color")] = f;
        }
      }
    }
    return r;
  });
}
const jb = q({
  name: "ElButton"
}), Bb = /* @__PURE__ */ q({
  ...jb,
  props: la,
  emits: wb,
  setup(e, { expose: t, emit: n }) {
    const r = e, o = Fb(r), a = Fe("button"), { _ref: i, _size: s, _type: l, _disabled: u, _props: f, shouldAddSpace: c, handleClick: d } = Eb(r, n), h = D(() => [
      a.b(),
      a.m(l.value),
      a.m(s.value),
      a.is("disabled", u.value),
      a.is("loading", r.loading),
      a.is("plain", r.plain),
      a.is("round", r.round),
      a.is("circle", r.circle),
      a.is("text", r.text),
      a.is("link", r.link),
      a.is("has-bg", r.bg)
    ]);
    return t({
      ref: i,
      size: s,
      type: l,
      disabled: u,
      shouldAddSpace: c
    }), (p, g) => (j(), ue(Tt(p.tag), yn({
      ref_key: "_ref",
      ref: i
    }, b(f), {
      class: b(h),
      style: b(o),
      onClick: b(d)
    }), {
      default: ae(() => [
        p.loading ? (j(), X(Xe, { key: 0 }, [
          p.$slots.loading ? J(p.$slots, "loading", { key: 0 }) : (j(), ue(b(xt), {
            key: 1,
            class: Y(b(a).is("loading"))
          }, {
            default: ae(() => [
              (j(), ue(Tt(p.loadingIcon)))
            ]),
            _: 1
          }, 8, ["class"]))
        ], 64)) : p.icon || p.$slots.icon ? (j(), ue(b(xt), { key: 1 }, {
          default: ae(() => [
            p.icon ? (j(), ue(Tt(p.icon), { key: 0 })) : J(p.$slots, "icon", { key: 1 })
          ]),
          _: 3
        })) : te("v-if", !0),
        p.$slots.default ? (j(), X("span", {
          key: 2,
          class: Y({ [b(a).em("text", "expand")]: b(c) })
        }, [
          J(p.$slots, "default")
        ], 2)) : te("v-if", !0)
      ]),
      _: 3
    }, 16, ["class", "style", "onClick"]));
  }
});
var $b = /* @__PURE__ */ Re(Bb, [["__file", "button.vue"]]);
const zb = {
  size: la.size,
  type: la.type
}, Vb = q({
  name: "ElButtonGroup"
}), Ub = /* @__PURE__ */ q({
  ...Vb,
  props: zb,
  setup(e) {
    const t = e;
    Nt(zu, Ln({
      size: wt(t, "size"),
      type: wt(t, "type")
    }));
    const n = Fe("button");
    return (r, o) => (j(), X("div", {
      class: Y(b(n).b("group"))
    }, [
      J(r.$slots, "default")
    ], 2));
  }
});
var Uu = /* @__PURE__ */ Re(Ub, [["__file", "button-group.vue"]]);
const Wu = zt($b, {
  ButtonGroup: Uu
});
Da(Uu);
const Wb = (e = "") => e.replace(/[|\\{}()[\]^$+*?.]/g, "\\$&").replace(/-/g, "\\x2d"), ca = Le({
  type: {
    type: String,
    values: ["primary", "success", "info", "warning", "danger"],
    default: "primary"
  },
  closable: Boolean,
  disableTransitions: Boolean,
  hit: Boolean,
  color: String,
  size: {
    type: String,
    values: iu
  },
  effect: {
    type: String,
    values: ["dark", "light", "plain"],
    default: "light"
  },
  round: Boolean
}), Hb = {
  close: (e) => e instanceof MouseEvent,
  click: (e) => e instanceof MouseEvent
}, Yb = q({
  name: "ElTag"
}), Gb = /* @__PURE__ */ q({
  ...Yb,
  props: ca,
  emits: Hb,
  setup(e, { emit: t }) {
    const n = e, r = yo(), o = Fe("tag"), a = D(() => {
      const { type: u, hit: f, effect: c, closable: d, round: h } = n;
      return [
        o.b(),
        o.is("closable", d),
        o.m(u || "primary"),
        o.m(r.value),
        o.m(c),
        o.is("hit", f),
        o.is("round", h)
      ];
    }), i = (u) => {
      t("close", u);
    }, s = (u) => {
      t("click", u);
    }, l = (u) => {
      var f, c, d;
      (d = (c = (f = u == null ? void 0 : u.component) == null ? void 0 : f.subTree) == null ? void 0 : c.component) != null && d.bum && (u.component.subTree.component.bum = null);
    };
    return (u, f) => u.disableTransitions ? (j(), X("span", {
      key: 0,
      class: Y(b(a)),
      style: mt({ backgroundColor: u.color }),
      onClick: s
    }, [
      Z("span", {
        class: Y(b(o).e("content"))
      }, [
        J(u.$slots, "default")
      ], 2),
      u.closable ? (j(), ue(b(xt), {
        key: 0,
        class: Y(b(o).e("close")),
        onClick: nt(i, ["stop"])
      }, {
        default: ae(() => [
          Ee(b(Ur))
        ]),
        _: 1
      }, 8, ["class", "onClick"])) : te("v-if", !0)
    ], 6)) : (j(), ue(ha, {
      key: 1,
      name: `${b(o).namespace.value}-zoom-in-center`,
      appear: "",
      onVnodeMounted: l
    }, {
      default: ae(() => [
        Z("span", {
          class: Y(b(a)),
          style: mt({ backgroundColor: u.color }),
          onClick: s
        }, [
          Z("span", {
            class: Y(b(o).e("content"))
          }, [
            J(u.$slots, "default")
          ], 2),
          u.closable ? (j(), ue(b(xt), {
            key: 0,
            class: Y(b(o).e("close")),
            onClick: nt(i, ["stop"])
          }, {
            default: ae(() => [
              Ee(b(Ur))
            ]),
            _: 1
          }, 8, ["class", "onClick"])) : te("v-if", !0)
        ], 6)
      ]),
      _: 3
    }, 8, ["name"]));
  }
});
var Kb = /* @__PURE__ */ Re(Gb, [["__file", "tag.vue"]]);
const Xb = zt(Kb), fn = /* @__PURE__ */ new Map();
if (Qe) {
  let e;
  document.addEventListener("mousedown", (t) => e = t), document.addEventListener("mouseup", (t) => {
    if (e) {
      for (const n of fn.values())
        for (const { documentHandler: r } of n)
          r(t, e);
      e = void 0;
    }
  });
}
function Ys(e, t) {
  let n = [];
  return Ot(t.arg) ? n = t.arg : Jt(t.arg) && n.push(t.arg), function(r, o) {
    const a = t.instance.popperRef, i = r.target, s = o == null ? void 0 : o.target, l = !t || !t.instance, u = !i || !s, f = e.contains(i) || e.contains(s), c = e === i, d = n.length && n.some((p) => p == null ? void 0 : p.contains(i)) || n.length && n.includes(s), h = a && (a.contains(i) || a.contains(s));
    l || u || f || c || d || h || t.value(r, o);
  };
}
const Qb = {
  beforeMount(e, t) {
    fn.has(e) || fn.set(e, []), fn.get(e).push({
      documentHandler: Ys(e, t),
      bindingFn: t.value
    });
  },
  updated(e, t) {
    fn.has(e) || fn.set(e, []);
    const n = fn.get(e), r = n.findIndex((a) => a.bindingFn === t.oldValue), o = {
      documentHandler: Ys(e, t),
      bindingFn: t.value
    };
    r >= 0 ? n.splice(r, 1, o) : n.push(o);
  },
  unmounted(e) {
    fn.delete(e);
  }
}, Zb = Le({
  a11y: {
    type: Boolean,
    default: !0
  },
  locale: {
    type: ce(Object)
  },
  size: vo,
  button: {
    type: ce(Object)
  },
  experimentalFeatures: {
    type: ce(Object)
  },
  keyboardNavigation: {
    type: Boolean,
    default: !0
  },
  message: {
    type: ce(Object)
  },
  zIndex: Number,
  namespace: {
    type: String,
    default: "el"
  },
  ...uu
}), Jb = {}, qb = q({
  name: "ElConfigProvider",
  props: Zb,
  setup(e, { slots: t }) {
    Q(() => e.message, (r) => {
      Object.assign(Jb, r ?? {});
    }, { immediate: !0, deep: !0 });
    const n = fu(e);
    return () => J(t, "default", { config: n == null ? void 0 : n.value });
  }
}), eE = zt(qb);
function tE() {
  const e = vn(), t = R(0), n = 11, r = D(() => ({
    minWidth: `${Math.max(t.value, n)}px`
  }));
  return Gt(e, () => {
    var a, i;
    t.value = (i = (a = e.value) == null ? void 0 : a.getBoundingClientRect().width) != null ? i : 0;
  }), {
    calculatorRef: e,
    calculatorWidth: t,
    inputStyle: r
  };
}
const Hu = Symbol("ElSelectGroup"), _o = Symbol("ElSelect"), fa = "ElOption", nE = Le({
  value: {
    type: [String, Number, Boolean, Object],
    required: !0
  },
  label: {
    type: [String, Number]
  },
  created: Boolean,
  disabled: Boolean
});
function rE(e, t) {
  const n = Me(_o);
  n || tu(fa, "usage: <el-select><el-option /></el-select/>");
  const r = Me(Hu, { disabled: !1 }), o = D(() => f(pn(n.props.modelValue), e.value)), a = D(() => {
    var h;
    if (n.props.multiple) {
      const p = pn((h = n.props.modelValue) != null ? h : []);
      return !o.value && p.length >= n.props.multipleLimit && n.props.multipleLimit > 0;
    } else
      return !1;
  }), i = D(() => e.label || (vt(e.value) ? "" : e.value)), s = D(() => e.value || e.label || ""), l = D(() => e.disabled || t.groupDisabled || a.value), u = We(), f = (h = [], p) => {
    if (vt(e.value)) {
      const g = n.props.valueKey;
      return h && h.some((E) => Cc(hn(E, g)) === hn(p, g));
    } else
      return h && h.includes(p);
  }, c = () => {
    !e.disabled && !r.disabled && (n.states.hoveringIndex = n.optionsArray.indexOf(u.proxy));
  }, d = (h) => {
    const p = new RegExp(Wb(h), "i");
    t.visible = p.test(String(i.value)) || e.created;
  };
  return Q(() => i.value, () => {
    !e.created && !n.props.remote && n.setSelected();
  }), Q(() => e.value, (h, p) => {
    const { remote: g, valueKey: E } = n.props;
    if ((g ? h !== p : !cr(h, p)) && (n.onOptionDestroy(p, u.proxy), n.onOptionCreate(u.proxy)), !e.created && !g) {
      if (E && vt(h) && vt(p) && h[E] === p[E])
        return;
      n.setSelected();
    }
  }), Q(() => r.disabled, () => {
    t.groupDisabled = r.disabled;
  }, { immediate: !0 }), {
    select: n,
    currentLabel: i,
    currentValue: s,
    itemSelected: o,
    isDisabled: l,
    hoverItem: c,
    updateOption: d
  };
}
const oE = q({
  name: fa,
  componentName: fa,
  props: nE,
  setup(e) {
    const t = Fe("select"), n = mo(), r = D(() => [
      t.be("dropdown", "item"),
      t.is("disabled", b(s)),
      t.is("selected", b(i)),
      t.is("hovering", b(d))
    ]), o = Ln({
      index: -1,
      groupDisabled: !1,
      visible: !0,
      hover: !1
    }), {
      currentLabel: a,
      itemSelected: i,
      isDisabled: s,
      select: l,
      hoverItem: u,
      updateOption: f
    } = rE(e, o), { visible: c, hover: d } = ga(o), h = We().proxy;
    l.onOptionCreate(h), Bt(() => {
      const g = h.value, { selected: E } = l.states, v = E.some((m) => m.value === h.value);
      Ne(() => {
        l.states.cachedOptions.get(g) === h && !v && l.states.cachedOptions.delete(g);
      }), l.onOptionDestroy(g, h);
    });
    function p() {
      s.value || l.handleOptionSelect(h);
    }
    return {
      ns: t,
      id: n,
      containerKls: r,
      currentLabel: a,
      itemSelected: i,
      isDisabled: s,
      select: l,
      visible: c,
      hover: d,
      states: o,
      hoverItem: u,
      updateOption: f,
      selectOptionClick: p
    };
  }
});
function aE(e, t) {
  return st((j(), X("li", {
    id: e.id,
    class: Y(e.containerKls),
    role: "option",
    "aria-disabled": e.isDisabled || void 0,
    "aria-selected": e.itemSelected,
    onMousemove: e.hoverItem,
    onClick: nt(e.selectOptionClick, ["stop"])
  }, [
    J(e.$slots, "default", {}, () => [
      Z("span", null, ot(e.currentLabel), 1)
    ])
  ], 42, ["id", "aria-disabled", "aria-selected", "onMousemove", "onClick"])), [
    [St, e.visible]
  ]);
}
var Za = /* @__PURE__ */ Re(oE, [["render", aE], ["__file", "option.vue"]]);
const iE = q({
  name: "ElSelectDropdown",
  componentName: "ElSelectDropdown",
  setup() {
    const e = Me(_o), t = Fe("select"), n = D(() => e.props.popperClass), r = D(() => e.props.multiple), o = D(() => e.props.fitInputWidth), a = R("");
    function i() {
      var s;
      a.value = `${(s = e.selectRef) == null ? void 0 : s.offsetWidth}px`;
    }
    return xe(() => {
      i(), Gt(e.selectRef, i);
    }), {
      ns: t,
      minWidth: a,
      popperClass: n,
      isMultiple: r,
      isFitInputWidth: o
    };
  }
});
function sE(e, t, n, r, o, a) {
  return j(), X("div", {
    class: Y([e.ns.b("dropdown"), e.ns.is("multiple", e.isMultiple), e.popperClass]),
    style: mt({ [e.isFitInputWidth ? "width" : "minWidth"]: e.minWidth })
  }, [
    e.$slots.header ? (j(), X("div", {
      key: 0,
      class: Y(e.ns.be("dropdown", "header"))
    }, [
      J(e.$slots, "header")
    ], 2)) : te("v-if", !0),
    J(e.$slots, "default"),
    e.$slots.footer ? (j(), X("div", {
      key: 1,
      class: Y(e.ns.be("dropdown", "footer"))
    }, [
      J(e.$slots, "footer")
    ], 2)) : te("v-if", !0)
  ], 6);
}
var lE = /* @__PURE__ */ Re(iE, [["render", sE], ["__file", "select-dropdown.vue"]]);
const uE = (e, t) => {
  const { t: n } = cm(), r = mo(), o = Fe("select"), a = Fe("input"), i = Ln({
    inputValue: "",
    options: /* @__PURE__ */ new Map(),
    cachedOptions: /* @__PURE__ */ new Map(),
    optionValues: [],
    selected: [],
    selectionWidth: 0,
    collapseItemWidth: 0,
    selectedLabel: "",
    hoveringIndex: -1,
    previousQuery: null,
    inputHovering: !1,
    menuVisibleOnFocus: !1,
    isBeforeHide: !1
  }), s = R(), l = R(), u = R(), f = R(), c = R(), d = R(), h = R(), p = R(), g = R(), E = R(), v = R(), {
    isComposing: m,
    handleCompositionStart: y,
    handleCompositionUpdate: _,
    handleCompositionEnd: T
  } = vu({
    afterComposition: (P) => ye(P)
  }), { wrapperRef: N, isFocused: I, handleBlur: x } = gu(c, {
    beforeFocus() {
      return ie.value;
    },
    afterFocus() {
      e.automaticDropdown && !B.value && (B.value = !0, i.menuVisibleOnFocus = !0);
    },
    beforeBlur(P) {
      var U, le;
      return ((U = u.value) == null ? void 0 : U.isFocusInsideContent(P)) || ((le = f.value) == null ? void 0 : le.isFocusInsideContent(P));
    },
    afterBlur() {
      var P;
      B.value = !1, i.menuVisibleOnFocus = !1, e.validateEvent && ((P = L == null ? void 0 : L.validate) == null || P.call(L, "blur").catch((U) => qe(U)));
    }
  }), B = R(!1), H = R(), { form: ee, formItem: L } = xa(), { inputId: V } = hu(e, {
    formItemContext: L
  }), { valueOnClear: me, isEmptyValue: fe } = vm(e), ie = D(() => e.disabled || (ee == null ? void 0 : ee.disabled)), ne = D(() => Ot(e.modelValue) ? e.modelValue.length > 0 : !fe(e.modelValue)), G = D(() => {
    var P;
    return (P = ee == null ? void 0 : ee.statusIcon) != null ? P : !1;
  }), pe = D(() => e.clearable && !ie.value && i.inputHovering && ne.value), he = D(() => e.remote && e.filterable && !e.remoteShowSuffix ? "" : e.suffixIcon), Ie = D(() => o.is("reverse", !!(he.value && B.value))), je = D(() => (L == null ? void 0 : L.validateState) || ""), Ge = D(() => je.value && du[je.value]), Pe = D(() => e.remote ? 300 : 0), Se = D(() => e.remote && !i.inputValue && i.options.size === 0), Be = D(() => e.loading ? e.loadingText || n("el.select.loading") : e.filterable && i.inputValue && i.options.size > 0 && O.value === 0 ? e.noMatchText || n("el.select.noMatch") : i.options.size === 0 ? e.noDataText || n("el.select.noData") : null), O = D(() => A.value.filter((P) => P.visible).length), A = D(() => {
    const P = Array.from(i.options.values()), U = [];
    return i.optionValues.forEach((le) => {
      const Ve = P.findIndex((ct) => ct.value === le);
      Ve > -1 && U.push(P[Ve]);
    }), U.length >= P.length ? U : P;
  }), W = D(() => Array.from(i.cachedOptions.values())), de = D(() => {
    const P = A.value.filter((U) => !U.created).some((U) => U.currentLabel === i.inputValue);
    return e.filterable && e.allowCreate && i.inputValue !== "" && !P;
  }), we = () => {
    e.filterable && it(e.filterMethod) || e.filterable && e.remote && it(e.remoteMethod) || A.value.forEach((P) => {
      var U;
      (U = P.updateOption) == null || U.call(P, i.inputValue);
    });
  }, $e = yo(), Te = D(() => ["small"].includes($e.value) ? "small" : "default"), ze = D({
    get() {
      return B.value && !Se.value;
    },
    set(P) {
      B.value = P;
    }
  }), Ae = D(() => {
    if (e.multiple && !lr(e.modelValue))
      return pn(e.modelValue).length === 0 && !i.inputValue;
    const P = Ot(e.modelValue) ? e.modelValue[0] : e.modelValue;
    return e.filterable || lr(P) ? !i.inputValue : !0;
  }), De = D(() => {
    var P;
    const U = (P = e.placeholder) != null ? P : n("el.select.placeholder");
    return e.multiple || !ne.value ? U : i.selectedLabel;
  }), ht = D(() => na ? null : "mouseenter");
  Q(() => e.modelValue, (P, U) => {
    e.multiple && e.filterable && !e.reserveKeyword && (i.inputValue = "", M("")), w(), !cr(P, U) && e.validateEvent && (L == null || L.validate("change").catch((le) => qe(le)));
  }, {
    flush: "post",
    deep: !0
  }), Q(() => B.value, (P) => {
    P ? M(i.inputValue) : (i.inputValue = "", i.previousQuery = null, i.isBeforeHide = !0), t("visible-change", P);
  }), Q(() => i.options.entries(), () => {
    Qe && (w(), e.defaultFirstOption && (e.filterable || e.remote) && O.value && C());
  }, {
    flush: "post"
  }), Q([() => i.hoveringIndex, A], ([P]) => {
    pt(P) && P > -1 ? H.value = A.value[P] || {} : H.value = {}, A.value.forEach((U) => {
      U.hover = H.value === U;
    });
  }), qs(() => {
    i.isBeforeHide || we();
  });
  const M = (P) => {
    i.previousQuery === P || m.value || (i.previousQuery = P, e.filterable && it(e.filterMethod) ? e.filterMethod(P) : e.filterable && e.remote && it(e.remoteMethod) && e.remoteMethod(P), e.defaultFirstOption && (e.filterable || e.remote) && O.value ? Ne(C) : Ne(re));
  }, C = () => {
    const P = A.value.filter((ct) => ct.visible && !ct.disabled && !ct.states.groupDisabled), U = P.find((ct) => ct.created), le = P[0], Ve = A.value.map((ct) => ct.value);
    i.hoveringIndex = ti(Ve, U || le);
  }, w = () => {
    if (e.multiple)
      i.selectedLabel = "";
    else {
      const U = Ot(e.modelValue) ? e.modelValue[0] : e.modelValue, le = $(U);
      i.selectedLabel = le.currentLabel, i.selected = [le];
      return;
    }
    const P = [];
    lr(e.modelValue) || pn(e.modelValue).forEach((U) => {
      P.push($(U));
    }), i.selected = P;
  }, $ = (P) => {
    let U;
    const le = Wd(P);
    for (let Fn = i.cachedOptions.size - 1; Fn >= 0; Fn--) {
      const sn = W.value[Fn];
      if (le ? hn(sn.value, e.valueKey) === hn(P, e.valueKey) : sn.value === P) {
        U = {
          value: P,
          currentLabel: sn.currentLabel,
          get isDisabled() {
            return sn.isDisabled;
          }
        };
        break;
      }
    }
    if (U)
      return U;
    const Ve = le ? P.label : P ?? "";
    return {
      value: P,
      currentLabel: Ve
    };
  }, re = () => {
    i.hoveringIndex = A.value.findIndex((P) => i.selected.some((U) => Sr(U) === Sr(P)));
  }, be = () => {
    i.selectionWidth = l.value.getBoundingClientRect().width;
  }, k = () => {
    i.collapseItemWidth = E.value.getBoundingClientRect().width;
  }, S = () => {
    var P, U;
    (U = (P = u.value) == null ? void 0 : P.updatePopper) == null || U.call(P);
  }, F = () => {
    var P, U;
    (U = (P = f.value) == null ? void 0 : P.updatePopper) == null || U.call(P);
  }, se = () => {
    i.inputValue.length > 0 && !B.value && (B.value = !0), M(i.inputValue);
  }, ye = (P) => {
    if (i.inputValue = P.target.value, e.remote)
      Pt();
    else
      return se();
  }, Pt = Nv(() => {
    se();
  }, Pe.value), Dt = (P) => {
    cr(e.modelValue, P) || t(Zr, P);
  }, an = (P) => Sv(P, (U) => {
    const le = i.cachedOptions.get(U);
    return le && !le.disabled && !le.states.groupDisabled;
  }), Vt = (P) => {
    if (e.multiple && P.code !== Vn.delete && P.target.value.length <= 0) {
      const U = pn(e.modelValue).slice(), le = an(U);
      if (le < 0)
        return;
      const Ve = U[le];
      U.splice(le, 1), t(Kt, U), Dt(U), t("remove-tag", Ve);
    }
  }, wo = (P, U) => {
    const le = i.selected.indexOf(U);
    if (le > -1 && !ie.value) {
      const Ve = pn(e.modelValue).slice();
      Ve.splice(le, 1), t(Kt, Ve), Dt(Ve), t("remove-tag", U.value);
    }
    P.stopPropagation(), Nr();
  }, er = (P) => {
    P.stopPropagation();
    const U = e.multiple ? [] : me.value;
    if (e.multiple)
      for (const le of i.selected)
        le.isDisabled && U.push(le.value);
    t(Kt, U), Dt(U), i.hoveringIndex = -1, B.value = !1, t("clear"), Nr();
  }, ei = (P) => {
    var U;
    if (e.multiple) {
      const le = pn((U = e.modelValue) != null ? U : []).slice(), Ve = ti(le, P);
      Ve > -1 ? le.splice(Ve, 1) : (e.multipleLimit <= 0 || le.length < e.multipleLimit) && le.push(P.value), t(Kt, le), Dt(le), P.created && M(""), e.filterable && !e.reserveKeyword && (i.inputValue = "");
    } else
      t(Kt, P.value), Dt(P.value), B.value = !1;
    Nr(), !B.value && Ne(() => {
      Ir(P);
    });
  }, ti = (P, U) => lr(U) ? -1 : vt(U.value) ? P.findIndex((le) => cr(hn(le, e.valueKey), Sr(U))) : P.indexOf(U.value), Ir = (P) => {
    var U, le, Ve, ct, Fn;
    const sn = Ot(P) ? P[0] : P;
    let Ar = null;
    if (sn != null && sn.value) {
      const tr = A.value.filter((cc) => cc.value === sn.value);
      tr.length > 0 && (Ar = tr[0].$el);
    }
    if (u.value && Ar) {
      const tr = (ct = (Ve = (le = (U = u.value) == null ? void 0 : U.popperRef) == null ? void 0 : le.contentRef) == null ? void 0 : Ve.querySelector) == null ? void 0 : ct.call(Ve, `.${o.be("dropdown", "wrap")}`);
      tr && bm(tr, Ar);
    }
    (Fn = v.value) == null || Fn.handleScroll();
  }, Ku = (P) => {
    i.options.set(P.value, P), i.cachedOptions.set(P.value, P);
  }, Xu = (P, U) => {
    i.options.get(P) === U && i.options.delete(P);
  }, Qu = D(() => {
    var P, U;
    return (U = (P = u.value) == null ? void 0 : P.popperRef) == null ? void 0 : U.contentRef;
  }), Zu = () => {
    i.isBeforeHide = !1, Ne(() => {
      var P;
      (P = v.value) == null || P.update(), Ir(i.selected);
    });
  }, Nr = () => {
    var P;
    (P = c.value) == null || P.focus();
  }, Ju = () => {
    var P;
    if (B.value) {
      B.value = !1, Ne(() => {
        var U;
        return (U = c.value) == null ? void 0 : U.blur();
      });
      return;
    }
    (P = c.value) == null || P.blur();
  }, qu = (P) => {
    er(P);
  }, ec = (P) => {
    if (B.value = !1, I.value) {
      const U = new FocusEvent("focus", P);
      Ne(() => x(U));
    }
  }, tc = () => {
    i.inputValue.length > 0 ? i.inputValue = "" : B.value = !1;
  }, ni = () => {
    ie.value || (na && (i.inputHovering = !0), i.menuVisibleOnFocus ? i.menuVisibleOnFocus = !1 : B.value = !B.value);
  }, nc = () => {
    if (!B.value)
      ni();
    else {
      const P = A.value[i.hoveringIndex];
      P && !P.isDisabled && ei(P);
    }
  }, Sr = (P) => vt(P.value) ? hn(P.value, e.valueKey) : P.value, rc = D(() => A.value.filter((P) => P.visible).every((P) => P.isDisabled)), oc = D(() => e.multiple ? e.collapseTags ? i.selected.slice(0, e.maxCollapseTags) : i.selected : []), ac = D(() => e.multiple ? e.collapseTags ? i.selected.slice(e.maxCollapseTags) : [] : []), ri = (P) => {
    if (!B.value) {
      B.value = !0;
      return;
    }
    if (!(i.options.size === 0 || O.value === 0 || m.value) && !rc.value) {
      P === "next" ? (i.hoveringIndex++, i.hoveringIndex === i.options.size && (i.hoveringIndex = 0)) : P === "prev" && (i.hoveringIndex--, i.hoveringIndex < 0 && (i.hoveringIndex = i.options.size - 1));
      const U = A.value[i.hoveringIndex];
      (U.isDisabled || !U.visible) && ri(P), Ne(() => Ir(H.value));
    }
  }, ic = () => {
    if (!l.value)
      return 0;
    const P = window.getComputedStyle(l.value);
    return Number.parseFloat(P.gap || "6px");
  }, sc = D(() => {
    const P = ic();
    return { maxWidth: `${E.value && e.maxCollapseTags === 1 ? i.selectionWidth - i.collapseItemWidth - P : i.selectionWidth}px` };
  }), lc = D(() => ({ maxWidth: `${i.selectionWidth}px` })), uc = (P) => {
    t("popup-scroll", P);
  };
  return Gt(l, be), Gt(p, S), Gt(N, S), Gt(g, F), Gt(E, k), xe(() => {
    w();
  }), {
    inputId: V,
    contentId: r,
    nsSelect: o,
    nsInput: a,
    states: i,
    isFocused: I,
    expanded: B,
    optionsArray: A,
    hoverOption: H,
    selectSize: $e,
    filteredOptionsCount: O,
    updateTooltip: S,
    updateTagTooltip: F,
    debouncedOnInputChange: Pt,
    onInput: ye,
    deletePrevTag: Vt,
    deleteTag: wo,
    deleteSelected: er,
    handleOptionSelect: ei,
    scrollToOption: Ir,
    hasModelValue: ne,
    shouldShowPlaceholder: Ae,
    currentPlaceholder: De,
    mouseEnterEventName: ht,
    needStatusIcon: G,
    showClose: pe,
    iconComponent: he,
    iconReverse: Ie,
    validateState: je,
    validateIcon: Ge,
    showNewOption: de,
    updateOptions: we,
    collapseTagSize: Te,
    setSelected: w,
    selectDisabled: ie,
    emptyText: Be,
    handleCompositionStart: y,
    handleCompositionUpdate: _,
    handleCompositionEnd: T,
    onOptionCreate: Ku,
    onOptionDestroy: Xu,
    handleMenuEnter: Zu,
    focus: Nr,
    blur: Ju,
    handleClearClick: qu,
    handleClickOutside: ec,
    handleEsc: tc,
    toggleMenu: ni,
    selectOption: nc,
    getValueKey: Sr,
    navigateOptions: ri,
    dropdownMenuVisible: ze,
    showTagList: oc,
    collapseTagList: ac,
    popupScroll: uc,
    tagStyle: sc,
    collapseTagStyle: lc,
    popperRef: Qu,
    inputRef: c,
    tooltipRef: u,
    tagTooltipRef: f,
    prefixRef: d,
    suffixRef: h,
    selectRef: s,
    wrapperRef: N,
    selectionRef: l,
    scrollbarRef: v,
    menuRef: p,
    tagMenuRef: g,
    collapseItemRef: E
  };
};
var cE = q({
  name: "ElOptions",
  setup(e, { slots: t }) {
    const n = Me(_o);
    let r = [];
    return () => {
      var o, a;
      const i = (o = t.default) == null ? void 0 : o.call(t), s = [];
      function l(u) {
        Ot(u) && u.forEach((f) => {
          var c, d, h, p;
          const g = (c = (f == null ? void 0 : f.type) || {}) == null ? void 0 : c.name;
          g === "ElOptionGroup" ? l(!mn(f.children) && !Ot(f.children) && it((d = f.children) == null ? void 0 : d.default) ? (h = f.children) == null ? void 0 : h.default() : f.children) : g === "ElOption" ? s.push((p = f.props) == null ? void 0 : p.value) : Ot(f.children) && l(f.children);
        });
      }
      return i.length && l((a = i[0]) == null ? void 0 : a.children), cr(s, r) || (r = s, n && (n.states.optionValues = s)), i;
    };
  }
});
const fE = Le({
  name: String,
  id: String,
  modelValue: {
    type: ce([
      Array,
      String,
      Number,
      Boolean,
      Object
    ]),
    default: void 0
  },
  autocomplete: {
    type: String,
    default: "off"
  },
  automaticDropdown: Boolean,
  size: vo,
  effect: {
    type: ce(String),
    default: "light"
  },
  disabled: Boolean,
  clearable: Boolean,
  filterable: Boolean,
  allowCreate: Boolean,
  loading: Boolean,
  popperClass: {
    type: String,
    default: ""
  },
  popperOptions: {
    type: ce(Object),
    default: () => ({})
  },
  remote: Boolean,
  loadingText: String,
  noMatchText: String,
  noDataText: String,
  remoteMethod: Function,
  filterMethod: Function,
  multiple: Boolean,
  multipleLimit: {
    type: Number,
    default: 0
  },
  placeholder: {
    type: String
  },
  defaultFirstOption: Boolean,
  reserveKeyword: {
    type: Boolean,
    default: !0
  },
  valueKey: {
    type: String,
    default: "value"
  },
  collapseTags: Boolean,
  collapseTagsTooltip: Boolean,
  maxCollapseTags: {
    type: Number,
    default: 1
  },
  teleported: eo.teleported,
  persistent: {
    type: Boolean,
    default: !0
  },
  clearIcon: {
    type: Yn,
    default: va
  },
  fitInputWidth: Boolean,
  suffixIcon: {
    type: Yn,
    default: Dc
  },
  tagType: { ...ca.type, default: "info" },
  tagEffect: { ...ca.effect, default: "light" },
  validateEvent: {
    type: Boolean,
    default: !0
  },
  remoteShowSuffix: Boolean,
  showArrow: {
    type: Boolean,
    default: !0
  },
  offset: {
    type: Number,
    default: 12
  },
  placement: {
    type: ce(String),
    values: Eo,
    default: "bottom-start"
  },
  fallbackPlacements: {
    type: ce(Array),
    default: ["bottom-start", "top-start", "right", "left"]
  },
  tabindex: {
    type: [String, Number],
    default: 0
  },
  appendTo: eo.appendTo,
  ...uu,
  ...Tr(["ariaLabel"])
});
yu.scroll;
const Gs = "ElSelect", dE = q({
  name: Gs,
  componentName: Gs,
  components: {
    ElSelectMenu: lE,
    ElOption: Za,
    ElOptions: cE,
    ElTag: Xb,
    ElScrollbar: e0,
    ElTooltip: yb,
    ElIcon: xt
  },
  directives: { ClickOutside: Qb },
  props: fE,
  emits: [
    Kt,
    Zr,
    "remove-tag",
    "clear",
    "visible-change",
    "focus",
    "blur",
    "popup-scroll"
  ],
  setup(e, { emit: t }) {
    const n = D(() => {
      const { modelValue: l, multiple: u } = e, f = u ? [] : void 0;
      return Ot(l) ? u ? l : f : u ? f : l;
    }), r = Ln({
      ...ga(e),
      modelValue: n
    }), o = uE(r, t), { calculatorRef: a, inputStyle: i } = tE();
    Nt(_o, Ln({
      props: r,
      states: o.states,
      selectRef: o.selectRef,
      optionsArray: o.optionsArray,
      setSelected: o.setSelected,
      handleOptionSelect: o.handleOptionSelect,
      onOptionCreate: o.onOptionCreate,
      onOptionDestroy: o.onOptionDestroy
    }));
    const s = D(() => e.multiple ? o.states.selected.map((l) => l.currentLabel) : o.states.selectedLabel);
    return {
      ...o,
      modelValue: n,
      selectedLabel: s,
      calculatorRef: a,
      inputStyle: i
    };
  }
});
function pE(e, t) {
  const n = Cn("el-tag"), r = Cn("el-tooltip"), o = Cn("el-icon"), a = Cn("el-option"), i = Cn("el-options"), s = Cn("el-scrollbar"), l = Cn("el-select-menu"), u = Oc("click-outside");
  return st((j(), X("div", {
    ref: "selectRef",
    class: Y([e.nsSelect.b(), e.nsSelect.m(e.selectSize)]),
    [Ic(e.mouseEnterEventName)]: (f) => e.states.inputHovering = !0,
    onMouseleave: (f) => e.states.inputHovering = !1
  }, [
    Ee(r, {
      ref: "tooltipRef",
      visible: e.dropdownMenuVisible,
      placement: e.placement,
      teleported: e.teleported,
      "popper-class": [e.nsSelect.e("popper"), e.popperClass],
      "popper-options": e.popperOptions,
      "fallback-placements": e.fallbackPlacements,
      effect: e.effect,
      pure: "",
      trigger: "click",
      transition: `${e.nsSelect.namespace.value}-zoom-in-top`,
      "stop-popper-mouse-event": !1,
      "gpu-acceleration": !1,
      persistent: e.persistent,
      "append-to": e.appendTo,
      "show-arrow": e.showArrow,
      offset: e.offset,
      onBeforeShow: e.handleMenuEnter,
      onHide: (f) => e.states.isBeforeHide = !1
    }, {
      default: ae(() => {
        var f;
        return [
          Z("div", {
            ref: "wrapperRef",
            class: Y([
              e.nsSelect.e("wrapper"),
              e.nsSelect.is("focused", e.isFocused),
              e.nsSelect.is("hovering", e.states.inputHovering),
              e.nsSelect.is("filterable", e.filterable),
              e.nsSelect.is("disabled", e.selectDisabled)
            ]),
            onClick: nt(e.toggleMenu, ["prevent"])
          }, [
            e.$slots.prefix ? (j(), X("div", {
              key: 0,
              ref: "prefixRef",
              class: Y(e.nsSelect.e("prefix"))
            }, [
              J(e.$slots, "prefix")
            ], 2)) : te("v-if", !0),
            Z("div", {
              ref: "selectionRef",
              class: Y([
                e.nsSelect.e("selection"),
                e.nsSelect.is("near", e.multiple && !e.$slots.prefix && !!e.states.selected.length)
              ])
            }, [
              e.multiple ? J(e.$slots, "tag", { key: 0 }, () => [
                (j(!0), X(Xe, null, pr(e.showTagList, (c) => (j(), X("div", {
                  key: e.getValueKey(c),
                  class: Y(e.nsSelect.e("selected-item"))
                }, [
                  Ee(n, {
                    closable: !e.selectDisabled && !c.isDisabled,
                    size: e.collapseTagSize,
                    type: e.tagType,
                    effect: e.tagEffect,
                    "disable-transitions": "",
                    style: mt(e.tagStyle),
                    onClose: (d) => e.deleteTag(d, c)
                  }, {
                    default: ae(() => [
                      Z("span", {
                        class: Y(e.nsSelect.e("tags-text"))
                      }, [
                        J(e.$slots, "label", {
                          label: c.currentLabel,
                          value: c.value
                        }, () => [
                          oi(ot(c.currentLabel), 1)
                        ])
                      ], 2)
                    ]),
                    _: 2
                  }, 1032, ["closable", "size", "type", "effect", "style", "onClose"])
                ], 2))), 128)),
                e.collapseTags && e.states.selected.length > e.maxCollapseTags ? (j(), ue(r, {
                  key: 0,
                  ref: "tagTooltipRef",
                  disabled: e.dropdownMenuVisible || !e.collapseTagsTooltip,
                  "fallback-placements": ["bottom", "top", "right", "left"],
                  effect: e.effect,
                  placement: "bottom",
                  teleported: e.teleported
                }, {
                  default: ae(() => [
                    Z("div", {
                      ref: "collapseItemRef",
                      class: Y(e.nsSelect.e("selected-item"))
                    }, [
                      Ee(n, {
                        closable: !1,
                        size: e.collapseTagSize,
                        type: e.tagType,
                        effect: e.tagEffect,
                        "disable-transitions": "",
                        style: mt(e.collapseTagStyle)
                      }, {
                        default: ae(() => [
                          Z("span", {
                            class: Y(e.nsSelect.e("tags-text"))
                          }, " + " + ot(e.states.selected.length - e.maxCollapseTags), 3)
                        ]),
                        _: 1
                      }, 8, ["size", "type", "effect", "style"])
                    ], 2)
                  ]),
                  content: ae(() => [
                    Z("div", {
                      ref: "tagMenuRef",
                      class: Y(e.nsSelect.e("selection"))
                    }, [
                      (j(!0), X(Xe, null, pr(e.collapseTagList, (c) => (j(), X("div", {
                        key: e.getValueKey(c),
                        class: Y(e.nsSelect.e("selected-item"))
                      }, [
                        Ee(n, {
                          class: "in-tooltip",
                          closable: !e.selectDisabled && !c.isDisabled,
                          size: e.collapseTagSize,
                          type: e.tagType,
                          effect: e.tagEffect,
                          "disable-transitions": "",
                          onClose: (d) => e.deleteTag(d, c)
                        }, {
                          default: ae(() => [
                            Z("span", {
                              class: Y(e.nsSelect.e("tags-text"))
                            }, [
                              J(e.$slots, "label", {
                                label: c.currentLabel,
                                value: c.value
                              }, () => [
                                oi(ot(c.currentLabel), 1)
                              ])
                            ], 2)
                          ]),
                          _: 2
                        }, 1032, ["closable", "size", "type", "effect", "onClose"])
                      ], 2))), 128))
                    ], 2)
                  ]),
                  _: 3
                }, 8, ["disabled", "effect", "teleported"])) : te("v-if", !0)
              ]) : te("v-if", !0),
              Z("div", {
                class: Y([
                  e.nsSelect.e("selected-item"),
                  e.nsSelect.e("input-wrapper"),
                  e.nsSelect.is("hidden", !e.filterable)
                ])
              }, [
                st(Z("input", {
                  id: e.inputId,
                  ref: "inputRef",
                  "onUpdate:modelValue": (c) => e.states.inputValue = c,
                  type: "text",
                  name: e.name,
                  class: Y([e.nsSelect.e("input"), e.nsSelect.is(e.selectSize)]),
                  disabled: e.selectDisabled,
                  autocomplete: e.autocomplete,
                  style: mt(e.inputStyle),
                  tabindex: e.tabindex,
                  role: "combobox",
                  readonly: !e.filterable,
                  spellcheck: "false",
                  "aria-activedescendant": ((f = e.hoverOption) == null ? void 0 : f.id) || "",
                  "aria-controls": e.contentId,
                  "aria-expanded": e.dropdownMenuVisible,
                  "aria-label": e.ariaLabel,
                  "aria-autocomplete": "none",
                  "aria-haspopup": "listbox",
                  onKeydown: [
                    nr(nt((c) => e.navigateOptions("next"), ["stop", "prevent"]), ["down"]),
                    nr(nt((c) => e.navigateOptions("prev"), ["stop", "prevent"]), ["up"]),
                    nr(nt(e.handleEsc, ["stop", "prevent"]), ["esc"]),
                    nr(nt(e.selectOption, ["stop", "prevent"]), ["enter"]),
                    nr(nt(e.deletePrevTag, ["stop"]), ["delete"])
                  ],
                  onCompositionstart: e.handleCompositionStart,
                  onCompositionupdate: e.handleCompositionUpdate,
                  onCompositionend: e.handleCompositionEnd,
                  onInput: e.onInput,
                  onClick: nt(e.toggleMenu, ["stop"])
                }, null, 46, ["id", "onUpdate:modelValue", "name", "disabled", "autocomplete", "tabindex", "readonly", "aria-activedescendant", "aria-controls", "aria-expanded", "aria-label", "onKeydown", "onCompositionstart", "onCompositionupdate", "onCompositionend", "onInput", "onClick"]), [
                  [Nc, e.states.inputValue]
                ]),
                e.filterable ? (j(), X("span", {
                  key: 0,
                  ref: "calculatorRef",
                  "aria-hidden": "true",
                  class: Y(e.nsSelect.e("input-calculator")),
                  textContent: ot(e.states.inputValue)
                }, null, 10, ["textContent"])) : te("v-if", !0)
              ], 2),
              e.shouldShowPlaceholder ? (j(), X("div", {
                key: 1,
                class: Y([
                  e.nsSelect.e("selected-item"),
                  e.nsSelect.e("placeholder"),
                  e.nsSelect.is("transparent", !e.hasModelValue || e.expanded && !e.states.inputValue)
                ])
              }, [
                e.hasModelValue ? J(e.$slots, "label", {
                  key: 0,
                  label: e.currentPlaceholder,
                  value: e.modelValue
                }, () => [
                  Z("span", null, ot(e.currentPlaceholder), 1)
                ]) : (j(), X("span", { key: 1 }, ot(e.currentPlaceholder), 1))
              ], 2)) : te("v-if", !0)
            ], 2),
            Z("div", {
              ref: "suffixRef",
              class: Y(e.nsSelect.e("suffix"))
            }, [
              e.iconComponent && !e.showClose ? (j(), ue(o, {
                key: 0,
                class: Y([e.nsSelect.e("caret"), e.nsSelect.e("icon"), e.iconReverse])
              }, {
                default: ae(() => [
                  (j(), ue(Tt(e.iconComponent)))
                ]),
                _: 1
              }, 8, ["class"])) : te("v-if", !0),
              e.showClose && e.clearIcon ? (j(), ue(o, {
                key: 1,
                class: Y([
                  e.nsSelect.e("caret"),
                  e.nsSelect.e("icon"),
                  e.nsSelect.e("clear")
                ]),
                onClick: e.handleClearClick
              }, {
                default: ae(() => [
                  (j(), ue(Tt(e.clearIcon)))
                ]),
                _: 1
              }, 8, ["class", "onClick"])) : te("v-if", !0),
              e.validateState && e.validateIcon && e.needStatusIcon ? (j(), ue(o, {
                key: 2,
                class: Y([
                  e.nsInput.e("icon"),
                  e.nsInput.e("validateIcon"),
                  e.nsInput.is("loading", e.validateState === "validating")
                ])
              }, {
                default: ae(() => [
                  (j(), ue(Tt(e.validateIcon)))
                ]),
                _: 1
              }, 8, ["class"])) : te("v-if", !0)
            ], 2)
          ], 10, ["onClick"])
        ];
      }),
      content: ae(() => [
        Ee(l, { ref: "menuRef" }, {
          default: ae(() => [
            e.$slots.header ? (j(), X("div", {
              key: 0,
              class: Y(e.nsSelect.be("dropdown", "header")),
              onClick: nt(() => {
              }, ["stop"])
            }, [
              J(e.$slots, "header")
            ], 10, ["onClick"])) : te("v-if", !0),
            st(Ee(s, {
              id: e.contentId,
              ref: "scrollbarRef",
              tag: "ul",
              "wrap-class": e.nsSelect.be("dropdown", "wrap"),
              "view-class": e.nsSelect.be("dropdown", "list"),
              class: Y([e.nsSelect.is("empty", e.filteredOptionsCount === 0)]),
              role: "listbox",
              "aria-label": e.ariaLabel,
              "aria-orientation": "vertical",
              onScroll: e.popupScroll
            }, {
              default: ae(() => [
                e.showNewOption ? (j(), ue(a, {
                  key: 0,
                  value: e.states.inputValue,
                  created: !0
                }, null, 8, ["value"])) : te("v-if", !0),
                Ee(i, null, {
                  default: ae(() => [
                    J(e.$slots, "default")
                  ]),
                  _: 3
                })
              ]),
              _: 3
            }, 8, ["id", "wrap-class", "view-class", "class", "aria-label", "onScroll"]), [
              [St, e.states.options.size > 0 && !e.loading]
            ]),
            e.$slots.loading && e.loading ? (j(), X("div", {
              key: 1,
              class: Y(e.nsSelect.be("dropdown", "loading"))
            }, [
              J(e.$slots, "loading")
            ], 2)) : e.loading || e.filteredOptionsCount === 0 ? (j(), X("div", {
              key: 2,
              class: Y(e.nsSelect.be("dropdown", "empty"))
            }, [
              J(e.$slots, "empty", {}, () => [
                Z("span", null, ot(e.emptyText), 1)
              ])
            ], 2)) : te("v-if", !0),
            e.$slots.footer ? (j(), X("div", {
              key: 3,
              class: Y(e.nsSelect.be("dropdown", "footer")),
              onClick: nt(() => {
              }, ["stop"])
            }, [
              J(e.$slots, "footer")
            ], 10, ["onClick"])) : te("v-if", !0)
          ]),
          _: 3
        }, 512)
      ]),
      _: 3
    }, 8, ["visible", "placement", "teleported", "popper-class", "popper-options", "fallback-placements", "effect", "transition", "persistent", "append-to", "show-arrow", "offset", "onBeforeShow", "onHide"])
  ], 16, ["onMouseleave"])), [
    [u, e.handleClickOutside, e.popperRef]
  ]);
}
var hE = /* @__PURE__ */ Re(dE, [["render", pE], ["__file", "select.vue"]]);
const gE = q({
  name: "ElOptionGroup",
  componentName: "ElOptionGroup",
  props: {
    label: String,
    disabled: Boolean
  },
  setup(e) {
    const t = Fe("select"), n = R(), r = We(), o = R([]);
    Nt(Hu, Ln({
      ...ga(e)
    }));
    const a = D(() => o.value.some((u) => u.visible === !0)), i = (u) => {
      var f;
      return u.type.name === "ElOption" && !!((f = u.component) != null && f.proxy);
    }, s = (u) => {
      const f = pn(u), c = [];
      return f.forEach((d) => {
        var h;
        Sc(d) && (i(d) ? c.push(d.component.proxy) : Ot(d.children) && d.children.length ? c.push(...s(d.children)) : (h = d.component) != null && h.subTree && c.push(...s(d.component.subTree)));
      }), c;
    }, l = () => {
      o.value = s(r.subTree);
    };
    return xe(() => {
      l();
    }), qv(n, l, {
      attributes: !0,
      subtree: !0,
      childList: !0
    }), {
      groupRef: n,
      visible: a,
      ns: t
    };
  }
});
function vE(e, t, n, r, o, a) {
  return st((j(), X("ul", {
    ref: "groupRef",
    class: Y(e.ns.be("group", "wrap"))
  }, [
    Z("li", {
      class: Y(e.ns.be("group", "title"))
    }, ot(e.label), 3),
    Z("li", null, [
      Z("ul", {
        class: Y(e.ns.b("group"))
      }, [
        J(e.$slots, "default")
      ], 2)
    ])
  ], 2)), [
    [St, e.visible]
  ]);
}
var Yu = /* @__PURE__ */ Re(gE, [["render", vE], ["__file", "option-group.vue"]]);
const mE = zt(hE, {
  Option: Za,
  OptionGroup: Yu
}), yE = Da(Za);
Da(Yu);
function Un(e) {
  let t = globalThis.Microsoft;
  return new t.Maps.Location(e.lat, e.lng);
}
function Gu(e) {
  return { lng: e.longitude, lat: e.latitude, name: e.name };
}
function Ks(e) {
  var t, n;
  return {
    _pinid: e._pinid,
    lat: (t = e == null ? void 0 : e.getLocation()) == null ? void 0 : t.latitude,
    lng: (n = e == null ? void 0 : e.getLocation()) == null ? void 0 : n.longitude
  };
}
class Ja {
  constructor(t) {
    z(this, "map");
    z(this, "searchManager");
    z(this, "selectedSuggestionCallback");
    this.map = t, this.searchManager = void 0;
  }
  init({ searchBoxContainerId: t, searchBoxId: n }) {
    let r = globalThis.Microsoft;
    r.Maps.loadModule("Microsoft.Maps.AutoSuggest", () => {
      new r.Maps.AutosuggestManager({ map: this.map, businessSuggestions: !0 }).attachAutosuggest(`#${n}`, `#${t}`, (a) => {
        a.location.name = a.address.formattedAddress, this.selectedSuggestionCallback && this.selectedSuggestionCallback(Gu(a.location));
      });
    });
  }
  _initSearchModule() {
    return this.searchManager ? Promise.resolve() : new Promise((t, n) => {
      let r = globalThis.Microsoft;
      r.Maps.loadModule("Microsoft.Maps.Search", () => (this.searchManager = new r.Maps.Search.SearchManager(this.map), t("")));
    });
  }
  async search(t) {
    return await this._initSearchModule(), new Promise((n, r) => {
      let o = {
        where: t,
        callback: (a) => {
          if (a && a.results && a.results.length > 0) {
            let i = [];
            for (const s of a.results)
              i.push({
                lat: s.location.latitude,
                lng: s.location.longitude,
                name: s.name
              });
            n(i);
          }
        },
        errorCallback: function(a) {
          n([]), console.log(`Bing地图检索地址失败,${a}`);
        }
      };
      this.searchManager.geocode(o);
    });
  }
  async searchByLocation(t) {
    return await this._initSearchModule(), new Promise((n, r) => {
      let o = JSON.parse(JSON.stringify(t)), a = {
        location: { longitude: o.lng, latitude: o.lat },
        callback: (i) => {
          n({
            lat: o.lat,
            lng: o.lng,
            name: i.name
          });
        },
        errorCallback: function(i) {
          n(void 0), console.log(`Bing地图检索地址失败,${i}`);
        }
      };
      this.searchManager.reverseGeocode(a);
    });
  }
  setSelectedSuggestionCallback(t) {
    this.selectedSuggestionCallback = t;
  }
}
const bE = ["id"], EE = /* @__PURE__ */ q({
  __name: "AddressSearchModule",
  props: {
    location: {},
    address: {}
  },
  emits: ["change"],
  setup(e, { expose: t, emit: n }) {
    const r = e;
    t({
      init: u,
      setAddressByLocation: f
    });
    const o = n;
    let a, i = R("search-box-container-default-id"), s = R("search-box-default-id");
    const l = R("");
    Q(() => r.address, (c) => {
      l.value = c ?? "";
    }, {
      immediate: !0
    });
    function u(c) {
      i.value = "search-box-container-id-" + c._mapid, s.value = "search-box-id-" + c._mapid, a = new Ja(c), Ne(() => a.init({ searchBoxContainerId: i.value, searchBoxId: s.value })), a.setSelectedSuggestionCallback((d) => {
        o("change", d);
      });
    }
    async function f(c) {
      if (!c || !a) return;
      let d = await a.searchByLocation(c);
      return l.value = (d == null ? void 0 : d.name) ?? "", d == null ? void 0 : d.name;
    }
    return (c, d) => {
      const h = zm;
      return j(), X("div", { id: b(i) }, [
        Ee(h, {
          modelValue: l.value,
          "onUpdate:modelValue": d[0] || (d[0] = (p) => l.value = p),
          id: b(s)
        }, null, 8, ["modelValue", "id"])
      ], 8, bE);
    };
  }
}), on = (e, t) => {
  const n = e.__vccOpts || e;
  for (const [r, o] of t)
    n[r] = o;
  return n;
}, ME = /* @__PURE__ */ on(EE, [["__scopeId", "data-v-1af926f4"]]);
let _E = class {
  constructor() {
    z(this, "map");
    z(this, "infobox");
    z(this, "infoboxId");
    z(this, "contentHtmlEmbeded");
    z(this, "contentHtml");
    this.infoboxId = "infobox-default-id", this.contentHtml = void 0, this.contentHtmlEmbeded = !1;
  }
  init(t, n, r) {
    this.map = t, this.infoboxId = n;
    let o = globalThis.Microsoft;
    this.infobox = new o.Maps.Infobox(this.map.getCenter(), {
      visible: !1,
      htmlContent: `<div id="${this.infoboxId}"></div>`,
      offset: new o.Maps.Point((r == null ? void 0 : r.xOffset) ?? 0, 25)
    }), this.infobox.setMap(this.map);
  }
  show(t) {
    if (this.infobox) {
      if (this.contentHtmlEmbeded) {
        let n = document.getElementById(this.infoboxId);
        if (!n || !this.contentHtml) return;
        n.contains(this.contentHtml) && n.removeChild(this.contentHtml), n.appendChild(this.contentHtml), this.contentHtmlEmbeded = !0;
      } else {
        let n = document.getElementById(this.infoboxId);
        if (!n || !this.contentHtml) return;
        n.appendChild(this.contentHtml), this.contentHtmlEmbeded = !0;
      }
      setTimeout(() => {
        this.infobox.setLocation(Un(t)), this.infobox.setOptions({ visible: !0 });
      }, 1);
    }
  }
  hide() {
    this.infobox && this.infobox.setOptions({ visible: !1 });
  }
  setXOffset(t) {
    if (!this.infobox) return;
    let n = globalThis.Microsoft;
    this.infobox.setOptions({ offset: new n.Maps.Point(t, 25) });
  }
  setContentHtml(t) {
    t && (this.contentHtml = t);
  }
};
const wE = { class: "content-wrapper" }, TE = { class: "title-bar" }, CE = { class: "pin-box" }, OE = {
  key: 0,
  width: "14",
  height: "14",
  viewBox: "-3 -3 20 20"
}, IE = {
  key: 0,
  width: "14",
  height: "14"
}, NE = ["onClick"], SE = {
  key: 1,
  width: "14",
  height: "14",
  viewBox: "-3 -3 20 20"
}, AE = { class: "content" }, ir = 10, LE = /* @__PURE__ */ q({
  __name: "Infobox",
  props: {
    width: { default: 250 }
  },
  emits: ["change", "activateOverlapPin"],
  setup(e, { expose: t, emit: n }) {
    nl((T) => ({
      "8bdb8976": c.value
    }));
    const r = e, o = n;
    t({
      init: d,
      show: h,
      close: p,
      setContentHtml: g,
      setOverlapPins: E
    });
    const a = R(!1), i = R(), s = new _E(), l = R([]), u = R(0), f = R(0), c = D(() => (s.setXOffset(-r.width / 2), r.width + "px"));
    xe(() => {
    });
    function d(T, N) {
      s.init(T, N ?? "infobox-default-id"), s.setContentHtml(i.value), s.setXOffset(-r.width / 2);
    }
    function h(T) {
      a.value = !0, s.show(T);
    }
    function p() {
      s.hide();
    }
    function g(T) {
      s.setContentHtml(T);
    }
    function E(T) {
      l.value = T, T.length > 0 && (f.value = 0, u.value = 0, y(T[0]));
    }
    function v() {
      u.value -= 1, u.value <= 0 && (u.value = 0);
    }
    function m() {
      u.value += 1, u.value >= l.value.length - ir && (u.value = l.value.length - ir);
    }
    function y(T) {
      o("activateOverlapPin", T);
    }
    function _(T, N) {
      f.value = N, y(T);
    }
    return (T, N) => {
      const I = Wu;
      return st((j(), X("div", {
        class: "infobox",
        ref_key: "infoboxWrapper",
        ref: i
      }, [
        Z("div", wE, [
          Z("div", TE, [
            Z("div", CE, [
              l.value.length > ir && u.value > 0 ? (j(), X("svg", OE, [
                Z("polygon", {
                  class: "more-pin-arrow",
                  points: "13,1 1,7 13,13",
                  fill: "#b3b1b0f0",
                  onClick: v
                })
              ])) : te("", !0),
              (j(!0), X(Xe, null, pr(l.value, (x, B) => (j(), X(Xe, null, [
                B >= u.value && B < u.value + 10 ? (j(), X("svg", IE, [
                  Z("circle", {
                    class: Y([f.value == B ? "pin-icon-activate" : "pin-icon"]),
                    cx: "7",
                    cy: "7",
                    r: "5",
                    "stroke-width": "2",
                    onClick: (H) => _(x, B)
                  }, null, 10, NE)
                ])) : te("", !0)
              ], 64))), 256)),
              l.value.length > ir && u.value < l.value.length - ir ? (j(), X("svg", SE, [
                Z("polygon", {
                  class: "more-pin-arrow",
                  points: "1,1 13,7 1,13",
                  fill: "#b3b1b0f0",
                  onClick: m
                })
              ])) : te("", !0)
            ]),
            Ee(I, {
              style: { width: "16px", height: "16px" },
              icon: b(Ur),
              size: "small",
              circle: "",
              onClick: p
            }, null, 8, ["icon"])
          ]),
          Z("div", AE, [
            J(T.$slots, "default", {}, void 0, !0)
          ])
        ])
      ], 512)), [
        [St, a.value]
      ]);
    };
  }
}), PE = /* @__PURE__ */ on(LE, [["__scopeId", "data-v-ef303c28"]]), DE = "data:image/svg+xml;base64,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", kE = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBzdGFuZGFsb25lPSJubyI/PjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+PHN2ZyB0PSIxNzMyNjA5OTYyNjg4IiBjbGFzcz0iaWNvbiIgdmlld0JveD0iMCAwIDEwMjQgMTAyNCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHAtaWQ9IjExNjcxIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgd2lkdGg9IjE2IiBoZWlnaHQ9IjE2Ij48cGF0aCBkPSJNNzcwLjc1IDM1Ni4zNjdoLTQzMi4zODN2LTE4My43MzVsLTI3Ni4zNjcgMjE0LjMzNSAyNzYuMzY3IDIwMC45N3YtMTY0LjA3MGg0MzIuMzgzYzcxLjcwNyAwIDEyMy43NSA1Mi4wNDMgMTIzLjc1IDEyMy43NXYxMTIuNWMwIDM3LjIxNS05Ljg1NSAxMjMuNzUtMTAxLjI1IDEyMy43NWgtNjA3LjV2NjcuNWg2MDcuNWMxMDIuNTEgMCAxNjguNzUtNzUuMDYwIDE2OC43NS0xOTEuMjV2LTExMi41YzAtMTA5LjAzNS04Mi4yMTUtMTkxLjI1LTE5MS4yNS0xOTEuMjV6IiBwLWlkPSIxMTY3MiIgZmlsbD0iIzUxNTE1MSI+PC9wYXRoPjwvc3ZnPg==", xE = { class: "tool-bar" }, RE = ["src"], FE = ["src"], jE = /* @__PURE__ */ q({
  __name: "ToolBar",
  emits: ["startDrawPolygon", "undo", "clear"],
  setup(e, { expose: t, emit: n }) {
    const r = n;
    t({
      reset: s
    });
    const o = R(!1);
    function a() {
      o.value = !o.value, r("startDrawPolygon", o.value);
    }
    function i() {
      r("undo");
    }
    function s() {
      o.value = !1;
    }
    return (l, u) => (j(), X("div", xE, [
      Z("div", {
        class: Y("button " + (o.value ? "activated" : "")),
        size: "small",
        onClick: a
      }, [
        Z("img", {
          class: Y(o.value ? "activated" : ""),
          src: b(DE)
        }, null, 10, RE)
      ], 2),
      Z("div", {
        class: "button",
        size: "small",
        onClick: i
      }, [
        Z("img", { src: b(kE) }, null, 8, FE)
      ])
    ]));
  }
}), BE = /* @__PURE__ */ on(jE, [["__scopeId", "data-v-37f8f129"]]);
class $E {
  constructor() {
    z(this, "map");
    z(this, "pin");
    z(this, "enable");
    z(this, "addressSearchModule");
    z(this, "location");
    z(this, "label");
    z(this, "icon");
    z(this, "iconAnchorX");
    z(this, "iconAnchorY");
    z(this, "locationChangeCallback");
    this.enable = !0, this.label = "当前位置";
  }
  init(t) {
    this.map = t, this.addressSearchModule = new Ja(t), globalThis.Microsoft.Maps.Events.addHandler(this.map, "click", (r) => {
      this.enable && (this.setLocation({ lng: r.location.longitude, lat: r.location.latitude }), this.locationChangeCallback && (this.addressSearchModule ? this.addressSearchModule.searchByLocation({ lng: r.location.longitude, lat: r.location.latitude }).then((o) => {
        o && (r.location.name = o.name), this.locationChangeCallback && this.locationChangeCallback({ lng: r.location.longitude, lat: r.location.latitude, name: o == null ? void 0 : o.name });
      }) : this.locationChangeCallback({ lng: r.location.longitude, lat: r.location.latitude })));
    });
  }
  setEnable(t) {
    this.enable = t;
  }
  setLocationChangeCallback(t) {
    this.locationChangeCallback = t;
  }
  setLocation(t) {
    let n = globalThis.Microsoft, r = this.location = new n.Maps.Location(t.lat, t.lng);
    this.location = Gu(this.location), this.map.setView({ center: r, animate: !0 }), this.pin ? this.pin.setLocation(r) : (this.pin = new n.Maps.Pushpin(r, { color: "#FF262B", title: this.label ?? "当前位置", icon: this.icon, anchor: new n.Maps.Point(this.iconAnchorX ?? 0, this.iconAnchorY ?? 0) }), this.map.entities.push(this.pin)), this.map.setView({ center: r, animate: !0 });
  }
  setLocationOption(t) {
    let n = globalThis.Microsoft;
    this.label = t.label, this.icon = t.icon, this.iconAnchorX = t.anchorX, this.iconAnchorY = t.anchorY, this.pin && this.location && (this.pin.setLocation(Un(this.location)), this.pin.setOptions({ color: "#FF262B", title: this.label ?? "当前位置", icon: this.icon, anchor: new n.Maps.Point(this.iconAnchorX ?? 0, this.iconAnchorY ?? 0) }));
  }
  fillLocationOption(t) {
    return this.label !== void 0 && (t.label = this.label), this.icon !== void 0 && (t.icon = this.icon), this.iconAnchorX !== void 0 && (t.anchorX = this.iconAnchorX), this.iconAnchorY !== void 0 && (t.anchorY = this.iconAnchorY), t;
  }
  getLocation() {
    return this.location;
  }
}
function da(e, t) {
  return [e, t];
}
function Xs(e) {
  return e = e.replace("#", ""), "#" + (16777215 ^ parseInt(e, 16)).toString(16).padStart(6, "0");
}
class zE {
  constructor() {
    z(this, "map");
    z(this, "pins");
    z(this, "clusterLayer");
    z(this, "clusterLayerInserted");
    z(this, "delayHandlePin");
    z(this, "selectPinCallback");
    z(this, "handleOverlapPins");
    this.pins = [], this.clusterLayerInserted = !1;
  }
  init(t, n) {
    let r = globalThis.Microsoft;
    this.map = t, this.selectPinCallback = n == null ? void 0 : n.selectPinCallback, r.Maps.Events.addHandler(this.map, "viewchangeend", () => {
      this.delayHandlePin && (this.selectPinCallback && this.selectPinCallback(this.delayHandlePin, this.delayHandlePin._pinid), this.delayHandlePin = void 0);
    });
  }
  activatePin(t) {
    Math.abs(this.map.getCenter().latitude - t.lat) >= 1e-5 || Math.abs(this.map.getCenter().longitude - t.lng) >= 1e-5 ? (this.delayHandlePin = t, this.map.setView({ center: { longitude: t.lng, latitude: t.lat }, animate: !0 })) : this.selectPinCallback && this.selectPinCallback(t, t._pinid);
  }
  setOverlapPinsHandler(t) {
    this.handleOverlapPins = t;
  }
  setPins(t) {
    var r, o;
    if (!this.map) return;
    let n = globalThis.Microsoft;
    this.pins = [];
    for (let a = 0, i = t.length; a < i; ++a) {
      let s = da(t[a].lng, t[a].lat), l = new n.Maps.Pushpin(new n.Maps.Location(s[1], s[0]), {
        color: "#00B050",
        icon: t[a].icon,
        anchor: new n.Maps.Point(((r = t[a]) == null ? void 0 : r.iconAnchorX) ?? 0, ((o = t[a]) == null ? void 0 : o.iconAnchorY) ?? 0)
      });
      t[a]._pinid = a, l._pinid = a, n.Maps.Events.addHandler(l, "click", (u) => {
        this.activatePin({ _pinid: u.target._pinid, lng: u.target.getLocation().longitude, lat: u.target.getLocation().latitude }), this.handleOverlapPins && this.handleOverlapPins([]);
      }), n.Maps.Events.addHandler(l, "mouseover", (u) => {
        let f = u.target.getColor(), c = Xs(f);
        u.target.setOptions({ color: c });
      }), n.Maps.Events.addHandler(l, "mouseout", (u) => {
        let f = u.target.getColor(), c = Xs(f);
        u.target.setOptions({ color: c });
      }), this.pins.push(l);
    }
    n.Maps.loadModule("Microsoft.Maps.Clustering", () => {
      this.clusterLayerInserted ? this.clusterLayer.setPushpins(this.pins) : (this.clusterLayer = new n.Maps.ClusterLayer(this.pins, {
        gridSize: 60,
        clusteredPinCallback: (a) => {
          n.Maps.Events.addHandler(a, "click", (d) => {
            if (d.target.containedPushpins) {
              let h = [];
              for (let g = 0, E = d.target.containedPushpins.length; g < E; g++)
                h.push(d.target.containedPushpins[g].getLocation());
              this.handleOverlapPins && this.map.getZoom() >= 20 && d.target.containedPushpins.length > 1 && (this.handleOverlapPins(d.target.containedPushpins.map((g) => Ks(g))), this.activatePin(Ks(d.target.containedPushpins[0])));
              let p = n.Maps.LocationRect.fromLocations(h);
              this.map.setView({ bounds: p, padding: 20 });
            }
          });
          let i = 8, s = 2, l = a.containedPushpins.length, u = Math.log(l) / Math.log(10) * 5 + i, f = "rgba(20, 180, 20, 0.5)";
          l > 50 ? f = "rgba(255, 40, 40, 0.5)" : l > 20 && (f = "rgba(255, 210, 40, 0.5)");
          let c = [
            '<svg xmlns="http://www.w3.org/2000/svg" width="',
            u * 2,
            '" height="',
            u * 2,
            '">',
            '<circle cx="',
            u,
            '" cy="',
            u,
            '" r="',
            u,
            '" fill="',
            f,
            '"/>',
            '<circle cx="',
            u,
            '" cy="',
            u,
            '" r="',
            u - s,
            '" fill="',
            f,
            '"/>',
            "</svg>"
          ];
          a.setOptions({
            icon: c.join(""),
            anchor: new n.Maps.Point(u, u),
            textOffset: new n.Maps.Point(0, u - 8)
            //Subtract 8 to compensate for height of text.
          });
        }
      }), this.map.layers.insert(this.clusterLayer), this.clusterLayerInserted = !0);
    });
  }
  setIcon(t, n) {
    this.pins[t._pinid].setOptions({ icon: n });
  }
}
class VE {
  constructor() {
    z(this, "map");
    z(this, "startPin");
    z(this, "endPin");
    z(this, "lastPoint");
    z(this, "line");
    z(this, "lines");
    z(this, "opts");
  }
  init(t) {
    this.map = t, this.lines = [];
  }
  // 仅追踪一次
  setTrack(t, n) {
    if (!Array.isArray(t) || !this.map || (this.clear(), t.length == 0)) return;
    let r = globalThis.Microsoft, o = [];
    t.forEach((a) => {
      let i = da(a.lng, a.lat);
      o.push(new r.Maps.Location(i[1], i[0]));
    }), this.startPin = new r.Maps.Pushpin(o[0], {
      color: "#00DD50",
      title: (n == null ? void 0 : n.startTitle) ?? "起点",
      icon: n == null ? void 0 : n.startIcon,
      anchor: new r.Maps.Point((n == null ? void 0 : n.startIconAnchorX) ?? 0, (n == null ? void 0 : n.startIconAnchorY) ?? 0),
      visible: (n == null ? void 0 : n.startVisible) ?? !0
    }), this.endPin = new r.Maps.Pushpin(o[o.length - 1], {
      color: "#5000DD",
      title: (n == null ? void 0 : n.endTitle) ?? "终点",
      icon: n == null ? void 0 : n.endIcon,
      anchor: new r.Maps.Point((n == null ? void 0 : n.endIconAnchorX) ?? 0, (n == null ? void 0 : n.endIconAnchorY) ?? 0),
      visible: (n == null ? void 0 : n.endVisible) ?? !0
    }), this.line = new r.Maps.Polyline(o, {
      strokeColor: (n == null ? void 0 : n.strokeColor) ?? "rgba(0, 51, 153, 1)",
      strokeThickness: (n == null ? void 0 : n.strokeWeight) ?? 2
    }), this.map.entities.push(this.line), this.map.entities.push(this.startPin), this.map.entities.push(this.endPin);
  }
  /* 首次追踪 */
  track(t) {
    this.setTrack(t, this.opts), this.lastPoint = t[t.length - 1];
  }
  // 持续追踪
  tracking(t) {
    var i;
    if (!Array.isArray(t) || !this.map || t.length == 0) return;
    this.endPin && (this.map.entities.remove(this.endPin), this.endPin = void 0);
    const n = this.opts;
    let r = globalThis.Microsoft, o = this.lastPoint ? [new r.Maps.Location(this.lastPoint.lat, this.lastPoint.lng)] : [];
    if (this.lastPoint) {
      let s = t.findIndex((l) => {
        var u, f;
        return l.lng == ((u = this.lastPoint) == null ? void 0 : u.lng) && l.lat == ((f = this.lastPoint) == null ? void 0 : f.lat);
      });
      s > -1 && (t = t.slice(s + 1));
    }
    this.lastPoint = t[t.length - 1], t.forEach((s) => {
      let l = da(s.lng, s.lat);
      o.push(new r.Maps.Location(l[1], l[0]));
    }), this.startPin || (this.map.setView({ center: o[0] }), this.startPin = new r.Maps.Pushpin(o[0], {
      color: "#00DD50",
      title: (n == null ? void 0 : n.startTitle) ?? "起点",
      icon: n == null ? void 0 : n.startIcon,
      anchor: new r.Maps.Point((n == null ? void 0 : n.startIconAnchorX) ?? 0, (n == null ? void 0 : n.startIconAnchorY) ?? 0),
      visible: (n == null ? void 0 : n.startVisible) ?? !0
    }), this.map.entities.push(this.startPin)), this.endPin = new r.Maps.Pushpin(o[o.length - 1], {
      color: "#5000DD",
      title: (n == null ? void 0 : n.endTitle) ?? "终点",
      icon: n == null ? void 0 : n.endIcon,
      anchor: new r.Maps.Point((n == null ? void 0 : n.endIconAnchorX) ?? 0, (n == null ? void 0 : n.endIconAnchorY) ?? 0),
      visible: (n == null ? void 0 : n.endVisible) ?? !0
    });
    const a = new r.Maps.Polyline(o, {
      strokeColor: (n == null ? void 0 : n.strokeColor) ?? "rgba(0, 51, 153, 1)",
      strokeThickness: (n == null ? void 0 : n.strokeWeight) ?? 2
    });
    (i = this.lines) == null || i.push(a), this.map.entities.push(a), this.map.entities.push(this.endPin);
  }
  setOptions(t) {
    const n = globalThis.Microsoft;
    this.opts = t, this.line && this.line.setOptions({
      strokeColor: t.strokeColor ?? "rgba(0, 51, 153, 1)",
      strokeThickness: (t == null ? void 0 : t.strokeWeight) ?? 2
    }), this.lines && this.lines.forEach((r) => {
      r.setOptions({
        strokeColor: t.strokeColor ?? "rgba(0, 51, 153, 1)",
        strokeThickness: (t == null ? void 0 : t.strokeWeight) ?? 2
      });
    }), this.startPin && this.startPin.setOptions({
      title: (t == null ? void 0 : t.startTitle) ?? "起点",
      icon: t == null ? void 0 : t.startIcon,
      anchor: new n.Maps.Point((t == null ? void 0 : t.startIconAnchorX) ?? 0, (t == null ? void 0 : t.startIconAnchorY) ?? 0),
      visible: (t == null ? void 0 : t.startVisible) ?? !0
    }), this.endPin && this.endPin.setOptions({
      title: (t == null ? void 0 : t.endTitle) ?? "终点",
      icon: t == null ? void 0 : t.endIcon,
      anchor: new n.Maps.Point((t == null ? void 0 : t.endIconAnchorX) ?? 0, (t == null ? void 0 : t.endIconAnchorY) ?? 0),
      visible: (t == null ? void 0 : t.endVisible) ?? !0
    });
  }
  clear() {
    this.line && (this.map.entities.remove(this.line), this.line = void 0), this.lines && (this.lines.forEach((t) => this.map.entities.remove(t)), this.lines = []), this.startPin && (this.map.entities.remove(this.startPin), this.startPin = void 0), this.endPin && (this.map.entities.remove(this.endPin), this.endPin = void 0);
  }
}
function UE({ r: e, round_num: t = 32 }) {
  let n = t - 1, r = 360 / n, o = n % 4, a = o ? r * o / 8 : 0, i = [], s = [];
  for (let l = a; l <= 90; l += r) {
    let u = [e * Math.cos(l * Math.PI / 180), -e * Math.sin(l * Math.PI / 180), 0];
    s.push(u), i.push(u);
  }
  for (let l = o ? s.length - 1 : s.length - 2; l >= 0; --l) {
    let u = s[l].slice();
    u[0] = -u[0], i.push(u);
  }
  for (let l = o ? 0 : 1, u = s.length; l < u; ++l) {
    let f = s[l].slice();
    f[0] = -f[0], f[1] = -f[1], i.push(f);
  }
  for (let l = o ? s.length - 1 : s.length - 2; l >= 0; --l) {
    let u = s[l].slice();
    u[1] = -u[1], i.push(u);
  }
  return i;
}
function WE({ r: e, round_num: t = 128, ox: n, oy: r }) {
  let o = UE({ r: e, round_num: t });
  for (let a = 0, i = o.length; a < i; ++a)
    o[a][0] += n, o[a][1] += r;
  return o;
}
class HE {
  constructor() {
    z(this, "map");
    z(this, "circles");
    this.circles = [];
  }
  init(t) {
    this.map = t;
  }
  setCircles(t) {
    if (!this.map) return;
    let n = globalThis.Microsoft;
    for (let r = 0, o = this.circles.length; r < o; ++r) this.map.entities.remove(this.circles[r]);
    this.circles = [];
    for (let r = 0, o = t.length; r < o; ++r) {
      let a = this.map.tryLocationToPixel(new n.Maps.Location(t[r].lat, t[r].lng)), i = this.map.getMetersPerPixel(t[r].lat, this.map.getZoom()), s = WE({ ox: a.x, oy: a.y, r: t[r].radius / i }), l = new n.Maps.Polygon(s.map((u) => this.map.tryPixelToLocation(new n.Maps.Point(u[0], u[1]))), {
        fillColor: "rgba(15, 82, 186, 0.1)",
        strokeColor: "rgba(12, 75, 172, 1)"
      });
      this.map.entities.push(l), this.circles.push(l);
    }
  }
}
const Qs = "data:image/svg+xml,%3c?xml%20version='1.0'%20standalone='no'?%3e%3c!DOCTYPE%20svg%20PUBLIC%20'-//W3C//DTD%20SVG%201.1//EN'%20'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3e%3csvg%20t='1732678174091'%20class='icon'%20viewBox='0%200%201024%201024'%20version='1.1'%20xmlns='http://www.w3.org/2000/svg'%20p-id='37859'%20width='10'%20height='10'%20xmlns:xlink='http://www.w3.org/1999/xlink'%3e%3cpath%20d='M512%20512m-490.666667%200a490.666667%20490.666667%200%201%200%20981.333334%200%20490.666667%20490.666667%200%201%200-981.333334%200Z'%20fill='%23dbdbdb'%20p-id='37860'%20data-spm-anchor-id='a313x.search_index.0.i22.44ad3a815vTaKM'%20class=''%3e%3c/path%3e%3cpath%20d='M512%20512m-256%200a256%20256%200%201%200%20512%200%20256%20256%200%201%200-512%200Z'%20fill='%23FFFFFF'%20p-id='37861'%3e%3c/path%3e%3cpath%20d='M512%20512m-149.333333%200a149.333333%20149.333333%200%201%200%20298.666666%200%20149.333333%20149.333333%200%201%200-298.666666%200Z'%20fill='%23707070'%20p-id='37862'%20data-spm-anchor-id='a313x.search_index.0.i21.44ad3a815vTaKM'%20class='selected'%3e%3c/path%3e%3c/svg%3e", YE = "data:image/svg+xml,%3c?xml%20version='1.0'%20standalone='no'?%3e%3c!DOCTYPE%20svg%20PUBLIC%20'-//W3C//DTD%20SVG%201.1//EN'%20'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3e%3csvg%20t='1733907837287'%20class='icon'%20viewBox='0%200%201024%201024'%20version='1.1'%20xmlns='http://www.w3.org/2000/svg'%20p-id='4261'%20width='10'%20height='10'%20xmlns:xlink='http://www.w3.org/1999/xlink'%3e%3cpath%20d='M865.6%20809.6c16%2016%2016%2041.6%200%2056-8%208-17.6%2011.2-28.8%2011.2s-20.8-3.2-28.8-11.2L512%20568%20214.4%20865.6c-8%208-17.6%2011.2-28.8%2011.2s-20.8-3.2-28.8-11.2c-16-16-16-41.6%200-56L456%20512%20158.4%20214.4c-16-16-16-41.6%200-56%2016-16%2041.6-16%2056%200L512%20456%20809.6%20158.4c16-16%2041.6-16%2056%200%2016%2016%2016%2041.6%200%2056L568%20512l297.6%20297.6z'%20fill='%23d81e06'%20p-id='4262'%3e%3c/path%3e%3c/svg%3e", cn = 1e-12;
class GE {
  constructor() {
    z(this, "map");
    z(this, "polygon");
    z(this, "points");
    z(this, "activePoint");
    z(this, "activePin");
    z(this, "opts");
    z(this, "isCross");
    // 是否存在线段相交
    z(this, "lang");
    this.points = [], this.opts = {
      fillColor: "rgba(0, 255, 0, 0.5)",
      strokeColor: "red",
      strokeThickness: 1
    }, this.isCross = !1, this.lang = "zh";
  }
  init(t) {
    this.map = t, this.redraw(), this.moveViewToCenter();
  }
  setLocale(t) {
    Q(() => t.value, (n) => {
      this.lang = n, n == "zh" ? this.setOptions({ clickTitle: "单击设置顶点", dbclickTitle: "双击结束绘制" }) : this.setOptions({ clickTitle: "Click set vertex", dbclickTitle: "Double click finish" }), this.isCross && this.setOptions({ dbclickTitle: "Cannot be crossed" });
    }, { immediate: !0 });
  }
  addPoint(t) {
    this.isCross || (t = JSON.parse(JSON.stringify(t)), this.activePoint && this.points.pop(), this.points.push(t), this.points.push(t), this.activePoint = t, this.redraw());
  }
  // 移动活动点
  moveActivePoint(t) {
    t = JSON.parse(JSON.stringify(t)), this.activePoint && this.points.pop(), this.points.push(t), this.activePoint = t, this.redraw(), this.checkActiveLineCross();
  }
  undo() {
    this.points.length > 0 && this.points.splice(this.points.length - 1, 1), this.redraw();
  }
  // 开始放置点位
  startPlacePoint() {
    this.clear();
  }
  // 结束放置点位
  endPlacePoint() {
    return this.isCross || this.points.length <= 3 ? !1 : (this.activePin && (this.map.entities.remove(this.activePin), this.activePin = void 0), this.points.pop(), this.redrawLine(), !0);
  }
  // 判断一个值是否在两个值之间
  isBetween2Value(t, n, r) {
    return (t - n > 0 || Math.abs(t - n) < cn) && (t - r < 0 || Math.abs(t - r) < cn) || (t - n < 0 || Math.abs(t - n) < cn) && (t - r > 0 || Math.abs(t - r) < cn);
  }
  // 判断两条线段是否相交，在两直线相交的基础上做进一步判断
  isLineCross(t, n, r) {
    let o = t.y2 - t.y1, a = t.x1 - t.x2, i = t.x2 * t.y1 - t.x1 * t.y2, s = n.y2 - n.y1, l = n.x1 - n.x2, u = n.x2 * n.y1 - n.x1 * n.y2, f = i * s - u * o, c = o * l - s * a, d = u * a - i * l, h = o * l - s * a;
    if (Math.abs(o * n.x1 + a * n.y1 + i) < cn && Math.abs(o * n.x2 + a * n.y2 + i) < cn)
      return this.isBetween2Value(t.x1, n.x1, n.x2) && this.isBetween2Value(t.y1, n.y1, n.y2) || this.isBetween2Value(t.x2, n.x1, n.x2) && this.isBetween2Value(t.y2, n.y1, n.y2) || this.isBetween2Value(n.x1, t.x1, t.x2) && this.isBetween2Value(n.y1, t.y1, t.y2) ? !0 : !!(this.isBetween2Value(n.x2, t.x1, t.x2) && this.isBetween2Value(n.y2, t.y1, t.y2));
    if ((r == null ? void 0 : r.overlap) === !0 || Math.abs(c) < cn || Math.abs(h) < cn) return !1;
    let p = f / c, g = d / h;
    return !!(this.isBetween2Value(g, t.x1, t.x2) && this.isBetween2Value(p, t.y1, t.y2) && this.isBetween2Value(g, n.x1, n.x2) && this.isBetween2Value(p, n.y1, n.y2));
  }
  // 检查活动边线是否与其他边线产生交叉
  checkActiveLineCross() {
    var t, n, r, o, a, i, s, l;
    if (this.activePin) {
      if (this.points.length > 2) {
        let u = { x1: (t = this.activePoint) == null ? void 0 : t.lng, y1: (n = this.activePoint) == null ? void 0 : n.lat, x2: this.points[0].lng, y2: this.points[0].lat }, f = { x1: (r = this.activePoint) == null ? void 0 : r.lng, y1: (o = this.activePoint) == null ? void 0 : o.lat, x2: this.points[this.points.length - 2].lng, y2: this.points[this.points.length - 2].lat };
        if (this.points.length == 3) {
          let c = this.points;
          this.isCross = this.isLineCross(u, { x1: c[0].lng, y1: c[0].lat, x2: c[1].lng, y2: c[1].lat }, { overlap: !0 }) || this.isLineCross(f, { x1: c[0].lng, y1: c[0].lat, x2: c[1].lng, y2: c[1].lat }, { overlap: !0 });
        } else if (this.points.length > 2)
          for (let c = 0, d = this.points; c < d.length - 2 && (this.isCross = this.isLineCross(u, { x1: d[c].lng, y1: d[c].lat, x2: d[c + 1].lng, y2: d[c + 1].lat }, { overlap: c == 0 }), c == 0 && this.isCross && this.isBetween2Value(d[c].lng, (a = this.activePoint) == null ? void 0 : a.lng, d[c + 1].lng) && this.isBetween2Value(d[c].lat, (i = this.activePoint) == null ? void 0 : i.lat, d[c + 1].lat) && (this.isCross = !1), !(this.isCross || (this.isCross = this.isLineCross(f, { x1: d[c].lng, y1: d[c].lat, x2: d[c + 1].lng, y2: d[c + 1].lat }, { overlap: c == d.length - 3 }), c == d.length - 3 && this.isCross && this.isBetween2Value(d[c + 1].lng, (s = this.activePoint) == null ? void 0 : s.lng, d[c].lng) && this.isBetween2Value(d[c + 1].lat, (l = this.activePoint) == null ? void 0 : l.lat, d[c].lat) && (this.isCross = !1), this.isCross))); ++c)
            ;
      }
      this.isCross ? this.setOptions({ dbclickTitle: this.lang == "zh" ? "边线不可交叉" : "Cannot be crossed", activePointIcon: YE }) : this.setOptions({ dbclickTitle: void 0, activePointIcon: void 0 });
    }
  }
  redrawLine() {
    if (!this.map) return;
    let t = globalThis.Microsoft, n = this.points.map((r) => Un(r));
    this.polygon ? this.polygon.setLocations(n) : n.length && (this.polygon = new t.Maps.Polygon(n, this.opts), this.map.entities.push(this.polygon));
  }
  redrawActivePin() {
    if (!this.map) return;
    let t = globalThis.Microsoft, n = this.points.map((r) => Un(r));
    this.activePin ? n.length && this.activePin.setLocation(n[n.length - 1]) : n.length && (this.activePin = new t.Maps.Pushpin(n[n.length - 1], { color: "#00B050", icon: Qs, anchor: new t.Maps.Point(5, 5) }), this.map.entities.push(this.activePin)), this.setOptions({});
  }
  redraw() {
    this.redrawLine(), this.redrawActivePin();
  }
  setOptions(t) {
    var n, r, o;
    Object.assign(this.opts, t), this.polygon && this.polygon.setOptions(this.opts), this.activePin && (this.points.length > 2 ? this.activePin.setOptions({ title: ((n = this.opts) == null ? void 0 : n.dbclickTitle) ?? (this.lang == "zh" ? "双击结束绘制" : "Double click finish") }) : this.activePin.setOptions({ title: ((r = this.opts) == null ? void 0 : r.clickTitle) ?? (this.lang == "zh" ? "单击设置顶点" : "Click set vertex") }), this.activePin.setOptions({ icon: ((o = this.opts) == null ? void 0 : o.activePointIcon) ?? Qs }));
  }
  clear() {
    this.polygon && (this.map.entities.remove(this.polygon), this.polygon = void 0), this.activePin && (this.map.entities.remove(this.activePin), this.activePin = void 0), this.points.length = 0, this.isCross = !1;
  }
  getPoints() {
    return JSON.parse(JSON.stringify(this.points));
  }
  moveViewToCenter() {
    if (!this.map || this.points.length == 0) return;
    let t = this.points.reduce((r, o) => (r += o.lng, r), 0) / this.points.length, n = this.points.reduce((r, o) => (r += o.lat, r), 0) / this.points.length;
    this.map.setView({ center: Un({ lng: t, lat: n }), animate: !0 });
  }
  // 显示政边界，coordinate默认是世界坐标系的坐标
  showAreaBound({ coordinate: t }) {
    this.clear();
    let n = JSON.parse(JSON.stringify(t));
    this.points = n, this.redrawLine(), this.moveViewToCenter();
  }
}
const KE = { class: "map-display-area" }, XE = { class: "address-search-area" }, QE = ["id"], ZE = /* @__PURE__ */ q({
  __name: "ZBingMap",
  props: {
    enableLocationSelected: { type: Boolean, default: !1 },
    enableAddressSearch: { type: Boolean, default: !1 },
    showToolBar: { type: Boolean, default: !1 }
  },
  emits: ["initDone", "curLocationChange", "selectPin", "polygonDrawDone"],
  setup(e, { expose: t, emit: n }) {
    const r = e, o = n;
    t({
      activatePin: L,
      setPins: me,
      setPinIcon: ie,
      closeInfobox: Se,
      setStyle: Be,
      searchAddressByLocation: O,
      setInfoboxContentHtml: B,
      setCurLocation: H,
      setCurLocationOption: ee,
      setPolygonOptions: ne,
      setTrackOptions: G,
      setTrack: pe,
      track: he,
      tracking: Ie,
      clearTrack: je,
      setCenter: Ge,
      setZoom: Pe,
      setCircles: fe,
      showAreaBound: C
    });
    const { locale: a } = wn();
    globalThis.bingMapId === void 0 && (globalThis.bingMapId = 0);
    let i = "bing-map-id" + globalThis.bingMapId;
    ++globalThis.bingMapId;
    let s, l, u = new $E(), f = new zE(), c = new VE(), d = new HE(), h = new GE();
    const p = R(), g = R(), E = R("");
    let v, m, y, _ = [], T = [], N, I = !1;
    const x = R();
    function B(w) {
      p.value.setContentHtml(w);
    }
    async function H(w) {
      if (!((w == null ? void 0 : w.lng) === void 0 || (w == null ? void 0 : w.lat) === void 0))
        if (E.value = w.name ?? "", u.setLocation(w), w.name)
          o("curLocationChange", u.fillLocationOption(w));
        else {
          let $ = await g.value.setAddressByLocation(w);
          if ($) {
            let re = u.getLocation();
            (re == null ? void 0 : re.lng) !== void 0 && (re == null ? void 0 : re.lat) !== void 0 && Math.abs(re.lng - w.lng) < 1e-6 && Math.abs(re.lat - w.lat) < 1e-6 && (w.name = $, o("curLocationChange", u.fillLocationOption(w)));
          }
        }
    }
    async function ee(w) {
      u.setLocationOption(w);
    }
    function L(w) {
      p.value.setOverlapPins([]), f.activatePin(w);
    }
    function V(w) {
      f.activatePin(w);
    }
    function me(w) {
      f.setPins(w);
    }
    function fe(w) {
      d.setCircles(w);
    }
    function ie(w, $) {
      f.setIcon(w, $);
    }
    function ne(w) {
      h.setOptions(w);
    }
    function G(w) {
      if (!l) {
        y = w;
        return;
      }
      c.setOptions(w);
    }
    function pe(w, $) {
      c.setTrack(w, $);
    }
    function he(w) {
      if (!l) {
        _ = JSON.parse(JSON.stringify(w));
        return;
      }
      c.track(w);
    }
    function Ie(w) {
      if (!l) {
        T.push(w);
        return;
      }
      c.tracking(w);
    }
    function je() {
      c.clear();
    }
    function Ge(w) {
      if (!l) {
        v = w;
        return;
      }
      l.setView({ center: Un(w) });
    }
    function Pe(w) {
      if (!l) {
        m = w;
        return;
      }
      l.setView({ zoom: w });
    }
    function Se() {
      p.value.close();
    }
    function Be(w) {
      l && l.setOptions({ customMapStyle: w });
    }
    async function O(w) {
      let re = await new Ja(l).searchByLocation(w);
      return (re == null ? void 0 : re.name) ?? "";
    }
    function A(w) {
      u.setLocation(w), o("curLocationChange", u.fillLocationOption(w));
    }
    function W() {
      globalThis.initBingMapDone = !1, de();
      let w = setInterval(() => {
        globalThis.initBingMapDone && (clearInterval(w), we());
      }, 1e3);
      if (globalThis.initBingMap = () => {
        globalThis.initBingMapDone = !0, globalThis.loadingBingMap = !1;
      }, !globalThis.loadingBingMap) {
        const $ = a.value ?? "zh";
        s = document.createElement("script"), s.type = "text/javascript", s.src = `https://wwww.bing.com/api/maps/mapcontrol?branch=experimental&setLang=${$}&key=Aimj_4Iu4inKVdcLzSthlSQ0iyLFaz83cQlSvT50_ITMhaCTi0lNZVm68yPLLNr7&callback=initBingMap`, document.body.appendChild(s);
      }
      globalThis.loadingBingMap = !0;
    }
    function de() {
      s && (document.body.removeChild(s), s = void 0);
    }
    function we() {
      let w = globalThis.Microsoft;
      l = new w.Maps.Map(document.getElementById(i), {
        zoom: 3,
        navigationBarMode: w.Maps.NavigationBarMode.compact,
        showMapTypeSelector: !1
      }), l._mapid = i, v && (Ge(v), v = void 0), m && (Pe(m), m = void 0), y && (G(y), y = void 0), _ && (he(_), _ = []), T && (T.forEach(($) => Ie($)), T = []), g.value.init(l), p.value.init(l, i + "-infobox"), u.init(l), u.setLocationChangeCallback($e), N && N(), N = Q(() => r.enableLocationSelected, ($) => u.setEnable($), { immediate: !0 }), f.init(l, {
        selectPinCallback: ($, re) => {
          p.value.show($), o("selectPin", $, re);
        }
      }), f.setOverlapPinsHandler(($) => {
        p.value.setOverlapPins($);
      }), c.init(l), d.init(l), h.init(l), h.setLocale(a), w.Maps.Events.addHandler(l, "click", Te), w.Maps.Events.addHandler(l, "dblclick", ze), w.Maps.Events.addHandler(l, "mousemove", Ae), o("initDone");
    }
    xe(() => {
      W();
    }), to(() => {
      de();
    });
    function $e(w) {
      E.value = w.name ?? "", o("curLocationChange", u.fillLocationOption(w));
    }
    function Te(w) {
      var $, re;
      p.value.close(), I && h.addPoint({ lng: ($ = w.location) == null ? void 0 : $.longitude, lat: (re = w.location) == null ? void 0 : re.latitude });
    }
    function ze(w) {
      I && h.endPlacePoint() && (I = !1, o("polygonDrawDone", h.getPoints()));
    }
    function Ae(w) {
      var $, re;
      I && h.moveActivePoint({ lng: ($ = w.location) == null ? void 0 : $.longitude, lat: (re = w.location) == null ? void 0 : re.latitude });
    }
    function De(w) {
      I = w, w ? h.startPlacePoint() : (h.clear(), h.endPlacePoint());
    }
    function ht() {
      I && h.undo();
    }
    function M() {
      h.clear();
    }
    function C({ coordinate: w }) {
      I = !1, h.showAreaBound({ coordinate: w }), x == null || x.value.reset();
    }
    return (w, $) => (j(), X("div", KE, [
      st(Z("div", XE, [
        J(w.$slots, "prefix-address-search", {}, void 0, !0),
        Ee(ME, {
          class: "address-search-input",
          ref_key: "addressSearchModule",
          ref: g,
          address: E.value,
          onChange: A
        }, null, 8, ["address"])
      ], 512), [
        [St, w.enableAddressSearch]
      ]),
      Z("div", {
        class: "map-body",
        id: b(i)
      }, null, 8, QE),
      st(Ee(BE, {
        ref_key: "toolBar",
        ref: x,
        onStartDrawPolygon: De,
        onUndo: ht,
        onClear: M
      }, null, 512), [
        [St, w.showToolBar]
      ]),
      Ee(PE, {
        ref_key: "infobox",
        ref: p,
        onActivateOverlapPin: V
      }, {
        default: ae(() => [
          J(w.$slots, "default", {}, void 0, !0)
        ]),
        _: 3
      }, 512)
    ]));
  }
}), JE = /* @__PURE__ */ on(ZE, [["__scopeId", "data-v-6f2e5c63"]]);
class qa {
  constructor() {
    z(this, "siteService");
    this.siteService = new HWMapJsSDK.HWSiteService();
  }
  init() {
  }
  // 根据经纬度查询地址
  async reverseGeocode(t, n) {
    return new Promise((r, o) => {
      const a = {
        location: {
          lat: n,
          lng: t
        }
      };
      this.siteService.reverseGeocode(a, (i) => {
        i && i.sites && i.sites.length > 0 ? r(i.sites[0].formatAddress) : r("");
      }, (i) => {
        r("");
      });
    });
  }
}
const qE = /* @__PURE__ */ q({
  __name: "AddressSearchInput",
  props: {
    address: { default: "" },
    manager: {}
  },
  emits: ["change"],
  setup(e, { expose: t, emit: n }) {
    const r = e, o = n;
    t({
      init: u,
      setAddressByLocation: h
    });
    const a = R(""), i = R([]), s = R(!1);
    let l;
    Q(() => r.address, (p) => {
      a.value = p ?? "";
    }, { immediate: !0 });
    function u() {
      l = new HWMapJsSDK.HWSiteService(), r.address && c(r.address);
    }
    let f = !1;
    const c = async (p) => {
      if (p === "") {
        i.value = [];
        return;
      }
      if (!f) {
        f = !0, setTimeout(() => {
          f = !1;
        }, 1e3), s.value = !0;
        try {
          const g = { query: p }, E = await new Promise((v, m) => {
            l.querySuggestion(g, (y) => {
              v(y);
            }, (y) => {
              m(y);
            });
          });
          i.value = E.sites || [];
        } catch {
          i.value = [];
        } finally {
          s.value = !1;
        }
      }
    };
    function d(p) {
      let g = i.value.find((E) => E.formatAddress === p);
      r.manager && (r.manager.markerManager.get("当前位置") ? r.manager.markerManager.set("当前位置", { lng: g.location.lng, lat: g.location.lat }) : r.manager.markerManager.add("当前位置", { position: { lng: g.location.lng, lat: g.location.lat } })), o("change", { name: p, lng: g.location.lng, lat: g.location.lat });
    }
    async function h(p) {
      if (p)
        return a.value = await new qa().reverseGeocode(p.lng, p.lat), a.value;
    }
    return (p, g) => {
      const E = yE, v = mE;
      return j(), ue(v, {
        modelValue: a.value,
        "onUpdate:modelValue": g[0] || (g[0] = (m) => a.value = m),
        filterable: "",
        remote: "",
        "remote-method": c,
        loading: s.value,
        onChange: d
      }, {
        default: ae(() => [
          (j(!0), X(Xe, null, pr(i.value, (m) => (j(), ue(E, {
            key: m.formatAddress,
            label: m.formatAddress,
            value: m.formatAddress
          }, null, 8, ["label", "value"]))), 128))
        ]),
        _: 1
      }, 8, ["modelValue", "loading"]);
    };
  }
}), eM = /* @__PURE__ */ on(qE, [["__scopeId", "data-v-507b724a"]]), tM = { class: "content-wrapper" }, nM = { class: "title-bar" }, rM = { class: "pin-box" }, oM = {
  key: 0,
  width: "14",
  height: "14",
  viewBox: "-3 -3 20 20"
}, aM = {
  key: 0,
  width: "14",
  height: "14"
}, iM = ["onClick"], sM = {
  key: 1,
  width: "14",
  height: "14",
  viewBox: "-3 -3 20 20"
}, lM = { class: "content" }, sr = 10, uM = /* @__PURE__ */ q({
  __name: "Infobox",
  props: {
    width: { default: 250 }
  },
  emits: ["change", "activateOverlapPin"],
  setup(e, { expose: t, emit: n }) {
    nl((N) => ({
      bf3a362a: f.value
    }));
    const r = e, o = n;
    t({
      init: d,
      show: h,
      close: p,
      setContentHtml: E,
      setOverlapPins: v,
      setCloseHandle: g
    });
    const a = R(!1), i = R(), s = R([]), l = R(0), u = R(0), f = D(() => r.width + "px");
    let c = () => {
    };
    xe(() => {
    });
    function d(N, I) {
    }
    function h() {
      a.value = !0;
    }
    function p() {
      c == null || c();
    }
    function g(N) {
      c = N;
    }
    function E(N) {
    }
    function v(N) {
      s.value = N, N.length > 0 && (u.value = 0, l.value = 0, _(N[0]));
    }
    function m() {
      l.value -= 1, l.value <= 0 && (l.value = 0);
    }
    function y() {
      l.value += 1, l.value >= s.value.length - sr && (l.value = s.value.length - sr);
    }
    function _(N) {
      o("activateOverlapPin", N);
    }
    function T(N, I) {
      u.value = I, _(N);
    }
    return (N, I) => {
      const x = Wu;
      return st((j(), X("div", {
        class: "infobox",
        ref_key: "infoboxWrapper",
        ref: i
      }, [
        Z("div", tM, [
          Z("div", nM, [
            Z("div", rM, [
              s.value.length > sr && l.value > 0 ? (j(), X("svg", oM, [
                Z("polygon", {
                  class: "more-pin-arrow",
                  points: "13,1 1,7 13,13",
                  fill: "#b3b1b0f0",
                  onClick: m
                })
              ])) : te("", !0),
              (j(!0), X(Xe, null, pr(s.value, (B, H) => (j(), X(Xe, null, [
                H >= l.value && H < l.value + 10 ? (j(), X("svg", aM, [
                  Z("circle", {
                    class: Y([u.value == H ? "pin-icon-activate" : "pin-icon"]),
                    cx: "7",
                    cy: "7",
                    r: "5",
                    "stroke-width": "2",
                    onClick: (ee) => T(B, H)
                  }, null, 10, iM)
                ])) : te("", !0)
              ], 64))), 256)),
              s.value.length > sr && l.value < s.value.length - sr ? (j(), X("svg", sM, [
                Z("polygon", {
                  class: "more-pin-arrow",
                  points: "1,1 13,7 1,13",
                  fill: "#b3b1b0f0",
                  onClick: y
                })
              ])) : te("", !0)
            ]),
            Ee(x, {
              style: { width: "16px", height: "16px" },
              icon: b(Ur),
              size: "small",
              circle: "",
              onClick: p
            }, null, 8, ["icon"])
          ]),
          Z("div", lM, [
            J(N.$slots, "default", {}, void 0, !0)
          ])
        ])
      ], 512)), [
        [St, a.value]
      ]);
    };
  }
}), cM = /* @__PURE__ */ on(uM, [["__scopeId", "data-v-41a63fc8"]]), fM = "data:image/svg+xml;base64,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", dM = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBzdGFuZGFsb25lPSJubyI/PjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+PHN2ZyB0PSIxNzMyNjA5OTYyNjg4IiBjbGFzcz0iaWNvbiIgdmlld0JveD0iMCAwIDEwMjQgMTAyNCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHAtaWQ9IjExNjcxIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgd2lkdGg9IjE2IiBoZWlnaHQ9IjE2Ij48cGF0aCBkPSJNNzcwLjc1IDM1Ni4zNjdoLTQzMi4zODN2LTE4My43MzVsLTI3Ni4zNjcgMjE0LjMzNSAyNzYuMzY3IDIwMC45N3YtMTY0LjA3MGg0MzIuMzgzYzcxLjcwNyAwIDEyMy43NSA1Mi4wNDMgMTIzLjc1IDEyMy43NXYxMTIuNWMwIDM3LjIxNS05Ljg1NSAxMjMuNzUtMTAxLjI1IDEyMy43NWgtNjA3LjV2NjcuNWg2MDcuNWMxMDIuNTEgMCAxNjguNzUtNzUuMDYwIDE2OC43NS0xOTEuMjV2LTExMi41YzAtMTA5LjAzNS04Mi4yMTUtMTkxLjI1LTE5MS4yNS0xOTEuMjV6IiBwLWlkPSIxMTY3MiIgZmlsbD0iIzUxNTE1MSI+PC9wYXRoPjwvc3ZnPg==", pM = { class: "tool-bar" }, hM = ["src"], gM = ["src"], vM = /* @__PURE__ */ q({
  __name: "ToolBar",
  emits: ["startDrawPolygon", "undo", "clear"],
  setup(e, { expose: t, emit: n }) {
    const r = n;
    t({
      reset: s
    });
    const o = R(!1);
    function a() {
      o.value = !o.value, r("startDrawPolygon", o.value);
    }
    function i() {
      r("undo");
    }
    function s() {
      o.value = !1;
    }
    return (l, u) => (j(), X("div", pM, [
      Z("div", {
        class: Y("button " + (o.value ? "activated" : "")),
        size: "small",
        onClick: a
      }, [
        Z("img", {
          class: Y(o.value ? "activated" : ""),
          src: b(fM)
        }, null, 10, hM)
      ], 2),
      Z("div", {
        class: "button",
        size: "small",
        onClick: i
      }, [
        Z("img", { src: b(dM) }, null, 8, gM)
      ])
    ]));
  }
}), mM = /* @__PURE__ */ on(vM, [["__scopeId", "data-v-9f470fce"]]), rt = 1e-8, jo = void 0, Bo = void 0;
class yM {
  // 新增：标记id
  constructor(t, n) {
    z(this, "map");
    z(this, "manager");
    z(this, "markers");
    z(this, "markerCluster");
    // 点聚合对象
    z(this, "currentInfoWindowWrapper");
    // 新增：记录当前打开的信息窗口容器
    z(this, "currentInfoWindow");
    // 新增：记录当前打开的信息窗口
    z(this, "onMarkerSelectedCallback");
    // 新增：标记选择回调函数
    z(this, "id");
    this.map = t, this.manager = n, this.markers = {}, this.id = 0, this.markerCluster = null, this.currentInfoWindowWrapper = null, this.currentInfoWindow = void 0;
  }
  init() {
    let t = this.map;
    this.currentInfoWindowWrapper = new HWMapJsSDK.HWInfoWindow({ map: t, offset: [-90, 0] }), this.currentInfoWindow && this.currentInfoWindowWrapper.setContent(this.currentInfoWindow.$el);
  }
  // 新增函数：在指定位置添加标记
  add(t, n) {
    var i, s, l, u, f;
    let r = this.map, o = this.markers;
    this.del(t);
    let a = {
      position: n.position,
      map: r,
      zIndex: 1
    };
    return n.iconUrl && (a.icon = { url: n.iconUrl }, n.iconAnchorX == null || n.iconAnchorY == null ? (a.icon.anchor = [0.5, 1], a.icon.anchorUnit = "fraction") : (a.icon.anchor = [n.iconAnchorX, n.iconAnchorY], a.icon.anchorUnit = "pixels")), n.text && (a.label = {
      text: n.text,
      offsetY: n.labelOffsetY,
      offsetX: n.labelOffsetX,
      color: n.color,
      fontSize: n.fontSize
    }), o[t] = new HWMapJsSDK.HWMarker(a), o[t]._marker = n, o[t]._marker._origin && (o[t]._marker._origin._pinid = this.id++), o[t].addListener("click", (c) => {
      var d, h, p, g, E, v;
      c.stopPropagation(), !(t.startsWith("当前位置") || t.startsWith("起点") || t.startsWith("终点") || t.startsWith("活动点")) && ((d = this.currentInfoWindow) == null || d.setOverlapPins([]), this.openInfowindow(o[t]), this.map.panTo({ lng: (p = (h = o[t]._marker) == null ? void 0 : h.position) == null ? void 0 : p.lng, lat: (E = (g = o[t]._marker) == null ? void 0 : g.position) == null ? void 0 : E.lat }), (v = this.onMarkerSelectedCallback) == null || v.call(this, o[t]._marker, o[t]._index));
    }), t == "当前位置" && ((i = n.position) == null ? void 0 : i.lng) != null && ((s = n.position) == null ? void 0 : s.lat) != null && ((f = this.map) == null || f.panTo({ lng: (l = n.position) == null ? void 0 : l.lng, lat: (u = n.position) == null ? void 0 : u.lat })), this.markerCluster && this.markerCluster.addMarker(o[t]), o[t];
  }
  activate(t) {
    var o, a, i;
    let n = this.map, r = Object.values(this.markers).filter((s) => {
      var l;
      return (l = s == null ? void 0 : s._marker) == null ? void 0 : l._origin;
    }).find((s) => s._marker._origin._pinid === t._origin._pinid);
    r && ((o = this.onMarkerSelectedCallback) == null || o.call(this, r._marker, r._index), this.openInfowindow(r), n.panTo({ lng: (a = t.position) == null ? void 0 : a.lng, lat: (i = t.position) == null ? void 0 : i.lat }));
  }
  // 删除标记
  del(t) {
    let n = this.markers;
    n[t] && (this.markerCluster && this.markerCluster.removeMarker(n[t]), n[t].setMap(null), delete n[t]);
  }
  get(t) {
    let n = this.markers;
    if (n[t]) return n[t]._marker;
  }
  // 设置标记，设置部分属性（文本、文本颜色、文本偏移等）会导致标记重新创建
  set(t, n) {
    var o, a, i, s, l, u, f, c, d, h, p;
    let r = this.markers;
    if (r[t]) {
      if (n.text || n.text === "" || n.color != null || n.labelOffsetX != null || n.labelOffsetY != null) {
        let E = r[t]._marker;
        for (let v in n) n[v] === void 0 && delete n[v];
        return Object.assign(E, n), this.del(t), this.add(t, E);
      }
      n.position && r[t].setPosition(n.position);
      let g = r[t].getIcon();
      g && (n.iconAnchorX != null && n.iconAnchorY != null && (g.anchor = [n.iconAnchorX, n.iconAnchorY], g.anchorUnit = "pixels"), n.iconUrl ? g.url = n.iconUrl : n.iconUrl === "" && (g.url = ""), r[t].setIcon(g)), t == "当前位置" && ((o = n.position) == null ? void 0 : o.lng) != null && ((a = n.position) == null ? void 0 : a.lat) != null && (((l = (s = (i = r[t]) == null ? void 0 : i._marker) == null ? void 0 : s.position) == null ? void 0 : l.lng) == null || ((c = (f = (u = r[t]) == null ? void 0 : u._marker) == null ? void 0 : f.position) == null ? void 0 : c.lat) == null || Math.abs(n.position.lng - r[t]._marker.position.lng) >= rt || Math.abs(n.position.lat - r[t]._marker.position.lat) >= rt) && ((p = this.map) == null || p.panTo({ lng: (d = n.position) == null ? void 0 : d.lng, lat: (h = n.position) == null ? void 0 : h.lat }));
      for (let E in n) n[E] === void 0 && delete n[E];
      Object.assign(r[t]._marker, n);
    }
  }
  hide(t) {
    let n = this.markers;
    n[t] && (n[t].visible = !1, n[t].setMap(null));
  }
  show(t) {
    let n = this.markers;
    n[t] && (n[t].visible = !0, n[t].setMap(this.map));
  }
  setMarkers(t) {
    let n = t.reduce((r, o) => {
      var a;
      return ((a = o._origin) == null ? void 0 : a._pinid) !== void 0 && (r[o._origin._pinid] = o), r;
    }, {});
    if (t.length == 0) {
      for (let r in this.markers) r.startsWith("默认名字") && this.del(r);
      return;
    } else Object.values(this.markers).forEach((r) => {
      var o, a;
      ((a = (o = r == null ? void 0 : r._marker) == null ? void 0 : o._origin) == null ? void 0 : a._pinid) != null && n[r._marker._origin._pinid] === void 0 && this.del(r.name);
    });
    this.delCluster(), t.forEach((r, o) => {
      var a;
      ((a = r._origin) == null ? void 0 : a._pinid) === void 0 || !this.markers[r.name ?? `默认名字${o}`] ? r.name ? this.add(r.name, r) : this.add(`默认名字${o}`, r) : this.set(r.name ?? `默认名字${o}`, r), this.markers[r.name ?? `默认名字${o}`]._index = o;
    }), this.createCluster();
  }
  setInfowindow(t) {
    var n, r;
    (n = this.currentInfoWindowWrapper) == null || n.setContent(t.$el), this.currentInfoWindow = t, (r = this.currentInfoWindow) == null || r.setCloseHandle(() => {
      var o;
      return (o = this.currentInfoWindowWrapper) == null ? void 0 : o.close();
    });
  }
  closeInfowindow() {
    this.currentInfoWindowWrapper.close();
  }
  openInfowindow(t) {
    var n;
    this.currentInfoWindowWrapper && this.currentInfoWindowWrapper.close(), (n = this.currentInfoWindow) == null || n.show(), this.currentInfoWindowWrapper.open(t);
  }
  setOnMarkerSelectedCallback(t) {
    this.onMarkerSelectedCallback = t;
  }
  // 将所有标记指向新地图
  setMap(t) {
    this.map = t;
    let n = this.markers;
    this.delCluster();
    for (let r in n)
      n[r].getMap() && n[r].setMap(t);
    Object.values(n).forEach((r) => {
      r.visible !== !1 && r.setMap(t);
    }), this.init();
  }
  // 随机生成200个标记点
  generateRandomMarkers() {
    for (var t = 0; t < 200; t++) {
      var n = Math.random() * 180 - 90, r = Math.random() * 360 - 180, o = { lat: n, lng: r };
      this.add("marker_" + t, { position: o });
    }
    this.createCluster();
  }
  // 更新点聚合
  createCluster(t) {
    let n = t ?? this.map, r = this.markers;
    var o = Object.values(r);
    (!this.markerCluster || t) && (this.markerCluster = new HWMapJsSDK.HWMarkerCluster(n, o, { zIndex: 1 }), this.markerCluster.addListener("click", (a) => {
      var c;
      var i = a.markers;
      if (i.length === 0) return;
      let s = 1 / 0, l = -1 / 0, u = 1 / 0, f = -1 / 0;
      if (i.forEach((d) => {
        s = Math.min(s, d.position.lat), l = Math.max(l, d.position.lat), u = Math.min(u, d.position.lng), f = Math.max(f, d.position.lng);
      }), n.fitBounds({
        sw: { lat: s, lng: u },
        ne: { lat: l, lng: f }
      }), n.getZoom() >= 17 && Math.abs(s - l) <= 1e-3 && Math.abs(u - f) <= 1e-3) {
        let d = Object.values(r).filter((h) => {
          var p;
          return (p = h == null ? void 0 : h._marker) != null && p.position ? i.some((g) => Math.abs(h._marker.position.lat - g.position.lat) <= rt && Math.abs(h._marker.position.lng - g.position.lng) <= rt) : !1;
        });
        (c = this.currentInfoWindow) == null || c.setOverlapPins(d.map((h) => h._marker)), this.openInfowindow(d[0]);
      }
    }));
  }
  addToCluster(t) {
    this.markerCluster && this.markerCluster.addMarkers(t);
  }
  delCluster() {
    this.markerCluster && (this.markerCluster.clearMarkers(), this.markerCluster = void 0);
  }
}
class bM {
  constructor(t, n) {
    z(this, "map");
    z(this, "manager");
    z(this, "polylines");
    this.map = t, this.manager = n, this.polylines = {};
  }
  init() {
  }
  // 给定一个经纬度数组在地图上绘制出折线
  add(t, n) {
    let r = this.map, o = this.polylines;
    o[t] && (o[t].setMap(null), delete o[t]), o[t] = new HWMapJsSDK.HWPolyline({
      map: r,
      path: n.path ?? [],
      strokeColor: n.strokeColor ?? "#0000FF",
      // 线条颜色
      strokeWeight: n.strokeWeight ?? 1,
      // 线条宽度
      strokeOpacity: 1
      // 线条透明度
    }), o[t]._polyline = n;
  }
  append(t, n) {
    this.polylines[t] && (this.polylines[t]._polyline.path = this.polylines[t]._polyline.path.concat(n), this.polylines[t].setPath(this.polylines[t]._polyline.path));
  }
  // 删除指定名称的折线
  del(t) {
    let n = this.polylines;
    n[t] && (n[t].setMap(null), delete n[t]);
  }
  set(t, n) {
    this.polylines[t] && (n.path && (this.polylines[t]._polyline.path = JSON.parse(JSON.stringify(n.path)), this.polylines[t].setPath(n.path)), n.strokeColor && this.polylines[t].setStrokeColor(n.strokeColor), n.strokeWeight && this.polylines[t].setStrokeWeight(n.strokeWeight));
  }
  get(t) {
    return this.polylines[t]._polyline;
  }
  setMap(t) {
    this.map = t;
    let n = this.polylines;
    for (let r in n) n[r].setMap(t);
  }
}
class EM {
  constructor(t, n) {
    z(this, "map");
    z(this, "manager");
    z(this, "tracks");
    z(this, "id");
    z(this, "lang");
    this.map = t, this.manager = n, this.tracks = {}, this.id = 0, this.lang = "zh";
  }
  init() {
  }
  // 添加轨迹
  add(t, n) {
    var a, i, s, l, u, f, c, d, h, p, g, E, v;
    let r = this.map;
    this.del(t);
    let o = this.tracks[t] = { trackName: "", startMarkerName: "", endMarkerName: "" };
    this.manager.polylineManager.add(`轨迹${this.id}`, { path: n.path ?? [], strokeColor: n.strokeColor, strokeWeight: n.strokeWeight }), o.trackName = `轨迹${this.id}`, this.manager.markerManager.add(`起点${this.id}`, {
      position: (a = n == null ? void 0 : n.path) != null && a.length ? n.path[0] : void 0,
      url: (i = n.startMarker) == null ? void 0 : i.iconUrl,
      color: (s = n.startMarker) == null ? void 0 : s.color,
      fontSize: (l = n.startMarker) == null ? void 0 : l.fontSize,
      offsetX: (u = n.startMarker) == null ? void 0 : u.offsetX,
      offsetY: (f = n.startMarker) == null ? void 0 : f.offsetY
    }), o.startMarkerName = `起点${this.id}`, this.manager.markerManager.add(`终点${this.id}`, {
      position: (c = n == null ? void 0 : n.path) != null && c.length ? n.path[n.path.length - 1] : void 0,
      url: (d = n.endMarker) == null ? void 0 : d.iconUrl,
      color: (h = n.endMarker) == null ? void 0 : h.color,
      fontSize: (p = n.endMarker) == null ? void 0 : p.fontSize,
      offsetX: (g = n.endMarker) == null ? void 0 : g.offsetX,
      offsetY: (E = n.endMarker) == null ? void 0 : E.offsetY
    }), o.endMarkerName = `终点${this.id}`, (v = n == null ? void 0 : n.path) != null && v.length && r.panTo(n.path[0]), this.id++;
  }
  append(t, n) {
    if (!this.tracks[t]) return;
    let r = this.tracks[t].trackName;
    this.manager.polylineManager.append(r, n);
    let o = this.tracks[t].endMarkerName;
    this.manager.markerManager.set(o, { position: n[n.length - 1] });
  }
  del(t) {
    let n = this.tracks;
    n[t] && (this.manager.polylineManager.del(n[t].trackName), this.manager.markerManager.del(n[t].startMarkerName), this.manager.markerManager.del(n[t].endMarkerName)), delete n[t];
  }
  set(t, n) {
    var i, s, l, u, f;
    if (!this.tracks[t]) return;
    let r = this.tracks[t];
    this.manager.polylineManager.set(r.trackName, { path: n.path, strokeColor: n.strokeColor, strokeWeight: n.strokeWeight });
    let o = {
      ...n == null ? void 0 : n.startMarker,
      position: (i = n == null ? void 0 : n.path) != null && i.length ? (s = n == null ? void 0 : n.path) == null ? void 0 : s[0] : void 0
    };
    this.manager.markerManager.set(r.startMarkerName, o);
    let a = {
      ...n == null ? void 0 : n.endMarker,
      position: (l = n == null ? void 0 : n.path) != null && l.length ? (u = n == null ? void 0 : n.path) == null ? void 0 : u[n.path.length - 1] : void 0
    };
    this.manager.markerManager.set(r.endMarkerName, a), ((f = n.path) == null ? void 0 : f.length) == 0 ? (this.manager.markerManager.hide(r.startMarkerName), this.manager.markerManager.hide(r.endMarkerName)) : (this.manager.markerManager.show(r.startMarkerName), this.manager.markerManager.show(r.endMarkerName));
  }
  setLocale(t) {
    var r, o, a, i;
    this.lang = t;
    let n = this.tracks;
    for (let s in n)
      (((r = this.manager.markerManager.get(n[s].startMarkerName)) == null ? void 0 : r.text) == "起点" || ((o = this.manager.markerManager.get(n[s].startMarkerName)) == null ? void 0 : o.text) == "Start") && this.manager.markerManager.set(n[s].startMarkerName, {
        text: t == "zh" ? "起点" : "Start"
      }), (((a = this.manager.markerManager.get(n[s].endMarkerName)) == null ? void 0 : a.text) == "终点" || ((i = this.manager.markerManager.get(n[s].endMarkerName)) == null ? void 0 : i.text) == "End") && this.manager.markerManager.set(n[s].endMarkerName, {
        text: t == "zh" ? "终点" : "End"
      });
  }
  get(t) {
    return this.tracks[t];
  }
  setMap(t) {
    this.map = t;
  }
}
const Zs = "data:image/svg+xml,%3c?xml%20version='1.0'%20standalone='no'?%3e%3c!DOCTYPE%20svg%20PUBLIC%20'-//W3C//DTD%20SVG%201.1//EN'%20'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3e%3csvg%20t='1732678174091'%20class='icon'%20viewBox='0%200%201024%201024'%20version='1.1'%20xmlns='http://www.w3.org/2000/svg'%20p-id='37859'%20width='10'%20height='10'%20xmlns:xlink='http://www.w3.org/1999/xlink'%3e%3cpath%20d='M512%20512m-490.666667%200a490.666667%20490.666667%200%201%200%20981.333334%200%20490.666667%20490.666667%200%201%200-981.333334%200Z'%20fill='%23dbdbdb'%20p-id='37860'%20data-spm-anchor-id='a313x.search_index.0.i22.44ad3a815vTaKM'%20class=''%3e%3c/path%3e%3cpath%20d='M512%20512m-256%200a256%20256%200%201%200%20512%200%20256%20256%200%201%200-512%200Z'%20fill='%23FFFFFF'%20p-id='37861'%3e%3c/path%3e%3cpath%20d='M512%20512m-149.333333%200a149.333333%20149.333333%200%201%200%20298.666666%200%20149.333333%20149.333333%200%201%200-298.666666%200Z'%20fill='%23707070'%20p-id='37862'%20data-spm-anchor-id='a313x.search_index.0.i21.44ad3a815vTaKM'%20class='selected'%3e%3c/path%3e%3c/svg%3e", MM = "data:image/svg+xml,%3c?xml%20version='1.0'%20standalone='no'?%3e%3c!DOCTYPE%20svg%20PUBLIC%20'-//W3C//DTD%20SVG%201.1//EN'%20'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3e%3csvg%20t='1733907837287'%20class='icon'%20viewBox='0%200%201024%201024'%20version='1.1'%20xmlns='http://www.w3.org/2000/svg'%20p-id='4261'%20width='10'%20height='10'%20xmlns:xlink='http://www.w3.org/1999/xlink'%3e%3cpath%20d='M865.6%20809.6c16%2016%2016%2041.6%200%2056-8%208-17.6%2011.2-28.8%2011.2s-20.8-3.2-28.8-11.2L512%20568%20214.4%20865.6c-8%208-17.6%2011.2-28.8%2011.2s-20.8-3.2-28.8-11.2c-16-16-16-41.6%200-56L456%20512%20158.4%20214.4c-16-16-16-41.6%200-56%2016-16%2041.6-16%2056%200L512%20456%20809.6%20158.4c16-16%2041.6-16%2056%200%2016%2016%2016%2041.6%200%2056L568%20512l297.6%20297.6z'%20fill='%23d81e06'%20p-id='4262'%3e%3c/path%3e%3c/svg%3e";
class _M {
  constructor(t, n) {
    z(this, "map");
    z(this, "manager");
    z(this, "polygons");
    z(this, "drawing");
    z(this, "isCross");
    // 是否存在线段相交
    z(this, "polygonDrawingOpts");
    z(this, "activePoint");
    // 活动点
    z(this, "polygonDrawingPoints");
    // 已绘制的点
    z(this, "lang");
    z(this, "existPointerEventHandler");
    z(this, "endDrawingPolygonHandler");
    this.map = t, this.manager = n, this.polygons = {}, this.drawing = !1, this.isCross = !1, this.polygonDrawingOpts = {}, this.activePoint = void 0, this.polygonDrawingPoints = [], this.lang = "zh", this.existPointerEventHandler = !1;
  }
  init() {
    this.redraw(), this.moveViewToCenter();
  }
  // 给定一个经纬度数组在地图上绘制出折线
  add(t, n) {
    let r = this.map, o = this.polygons;
    o[t] && (o[t].setMap(null), delete o[t]), o[t] = new HWMapJsSDK.HWPolygon({
      map: r,
      paths: [n.path],
      strokeColor: n.strokeColor ?? "#7ea1fff0",
      // 边框颜色
      strokeWeight: n.strokeWeight ?? 1,
      // 边框宽度
      fillColor: n.fillColor ?? "#7ca10a50"
      // 填充颜色
    });
  }
  del(t) {
    let n = this.polygons;
    n[t] && (n[t].setMap(null), delete n[t]);
  }
  get(t) {
    return this.polygons[t];
  }
  set(t, n) {
    this.polygons[t] && (n.path && this.polygons[t].setPaths(n.path), n.fillColor && this.polygons[t].setFillColor(n.fillColor), n.strokeColor && this.polygons[t].setStrokeColor(n.strokeColor), n.strokeWeight != null && this.polygons[t].setStrokeWeight(n.strokeWeight));
  }
  setMap(t) {
    this.map = t;
    let n = this.polygons;
    for (let r in n) n[r].setMap(t);
    this.listenMouseEvent(!0);
  }
  setDrawingPolygonOptions(t) {
    var n, r, o, a, i, s;
    this.polygonDrawingOpts && Object.assign(this.polygonDrawingOpts, t), this.set("绘制的多边形", t), this.activePoint && (this.polygonDrawingPoints.length > 2 ? (r = this.manager) == null || r.markerManager.set("活动点", { text: ((n = this.polygonDrawingOpts) == null ? void 0 : n.dbclickTitle) ?? (this.lang == "zh" ? "双击结束绘制" : "Double click finish") }) : (a = this.manager) == null || a.markerManager.set("活动点", { text: ((o = this.polygonDrawingOpts) == null ? void 0 : o.clickTitle) ?? (this.lang == "zh" ? "单击设置顶点" : "Click set vertex") }), (s = this.manager) == null || s.markerManager.set("活动点", { iconUrl: ((i = this.polygonDrawingOpts) == null ? void 0 : i.activePointIcon) ?? Zs }));
  }
  undo() {
    this.drawing && (this.polygonDrawingPoints.length > 0 && this.polygonDrawingPoints.splice(this.polygonDrawingPoints.length - 1, 1), this.redraw());
  }
  // 判断一个值是否在两个值之间
  isBetween2Value(t, n, r) {
    return (t - n > 0 || Math.abs(t - n) < rt) && (t - r < 0 || Math.abs(t - r) < rt) || (t - n < 0 || Math.abs(t - n) < rt) && (t - r > 0 || Math.abs(t - r) < rt);
  }
  // 判断两条线段是否相交，在两直线相交的基础上做进一步判断
  isLineCross(t, n, r) {
    let o = t.y2 - t.y1, a = t.x1 - t.x2, i = t.x2 * t.y1 - t.x1 * t.y2, s = n.y2 - n.y1, l = n.x1 - n.x2, u = n.x2 * n.y1 - n.x1 * n.y2, f = i * s - u * o, c = o * l - s * a, d = u * a - i * l, h = o * l - s * a;
    if (Math.abs(o * n.x1 + a * n.y1 + i) < rt && Math.abs(o * n.x2 + a * n.y2 + i) < rt)
      return this.isBetween2Value(t.x1, n.x1, n.x2) && this.isBetween2Value(t.y1, n.y1, n.y2) || this.isBetween2Value(t.x2, n.x1, n.x2) && this.isBetween2Value(t.y2, n.y1, n.y2) || this.isBetween2Value(n.x1, t.x1, t.x2) && this.isBetween2Value(n.y1, t.y1, t.y2) ? !0 : !!(this.isBetween2Value(n.x2, t.x1, t.x2) && this.isBetween2Value(n.y2, t.y1, t.y2));
    if ((r == null ? void 0 : r.overlap) === !0 || Math.abs(c) < rt || Math.abs(h) < rt) return !1;
    let p = f / c, g = d / h;
    return !!(this.isBetween2Value(g, t.x1, t.x2) && this.isBetween2Value(p, t.y1, t.y2) && this.isBetween2Value(g, n.x1, n.x2) && this.isBetween2Value(p, n.y1, n.y2));
  }
  // 检查活动边线是否与其他边线产生交叉
  checkActiveLineCross(t) {
    var n, r, o, a;
    if (!this.drawing) return this.isCross;
    if (this.polygonDrawingPoints.length > 2) {
      let i = t ?? this.activePoint, s = { x1: i == null ? void 0 : i.lng, y1: i == null ? void 0 : i.lat, x2: this.polygonDrawingPoints[0].lng, y2: this.polygonDrawingPoints[0].lat }, l = { x1: i == null ? void 0 : i.lng, y1: i == null ? void 0 : i.lat, x2: this.polygonDrawingPoints[this.polygonDrawingPoints.length - 2].lng, y2: this.polygonDrawingPoints[this.polygonDrawingPoints.length - 2].lat };
      if (this.polygonDrawingPoints.length == 3) {
        let u = this.polygonDrawingPoints;
        this.isCross = this.isLineCross(s, { x1: u[0].lng, y1: u[0].lat, x2: u[1].lng, y2: u[1].lat }, { overlap: !0 }) || this.isLineCross(l, { x1: u[0].lng, y1: u[0].lat, x2: u[1].lng, y2: u[1].lat }, { overlap: !0 });
      } else if (this.polygonDrawingPoints.length > 2)
        for (let u = 0, f = this.polygonDrawingPoints; u < f.length - 2 && (this.isCross = this.isLineCross(s, { x1: f[u].lng, y1: f[u].lat, x2: f[u + 1].lng, y2: f[u + 1].lat }, { overlap: u == 0 }), u == 0 && this.isCross && this.isBetween2Value(f[u].lng, (n = this.activePoint) == null ? void 0 : n.lng, f[u + 1].lng) && this.isBetween2Value(f[u].lat, (r = this.activePoint) == null ? void 0 : r.lat, f[u + 1].lat) && (this.isCross = !1), !(this.isCross || (this.isCross = this.isLineCross(l, { x1: f[u].lng, y1: f[u].lat, x2: f[u + 1].lng, y2: f[u + 1].lat }, { overlap: u == f.length - 3 }), u == f.length - 3 && this.isCross && this.isBetween2Value(f[u + 1].lng, (o = this.activePoint) == null ? void 0 : o.lng, f[u].lng) && this.isBetween2Value(f[u + 1].lat, (a = this.activePoint) == null ? void 0 : a.lat, f[u].lat) && (this.isCross = !1), this.isCross))); ++u)
          ;
    } else this.isCross = !1;
    return this.isCross ? this.setDrawingPolygonOptions({ dbclickTitle: this.lang == "zh" ? "边线不可交叉" : "Cannot be crossed", activePointIcon: MM }) : this.setDrawingPolygonOptions({ dbclickTitle: void 0, activePointIcon: void 0 }), this.isCross;
  }
  redrawActivePin() {
    this.map && (this.polygonDrawingPoints.length <= 0 || (this.manager.markerManager.get("活动点") ? this.manager.markerManager.set("活动点", { position: { lng: this.polygonDrawingPoints[this.polygonDrawingPoints.length - 1].lng, lat: this.polygonDrawingPoints[this.polygonDrawingPoints.length - 1].lat } }) : this.manager.markerManager.add("活动点", {
      position: { lng: this.polygonDrawingPoints[this.polygonDrawingPoints.length - 1].lng, lat: this.polygonDrawingPoints[this.polygonDrawingPoints.length - 1].lat },
      iconUrl: Zs,
      iconAnchorX: 5,
      iconAnchorY: 5,
      labelOffsetY: -12
    }), this.setDrawingPolygonOptions({})));
  }
  redrawLine() {
    var t;
    this.get("绘制的多边形") ? (t = this.get("绘制的多边形")) == null || t.setPaths([this.polygonDrawingPoints]) : this.add("绘制的多边形", { path: this.polygonDrawingPoints });
  }
  redraw() {
    this.redrawLine(), this.redrawActivePin();
  }
  listenMouseEvent(t = !1) {
    if (!t && this.existPointerEventHandler) return;
    let n = this.map;
    n.on("pointermove", (r) => {
      if (!this.drawing) return;
      let o = HWMapJsSDK.HWMapUtils.epsgToLatLng(r.coordinate);
      this.activePoint && this.polygonDrawingPoints.pop(), this.polygonDrawingPoints.push(o), this.activePoint = o, this.redraw(), this.checkActiveLineCross();
    }), n.on("singleclick", (r) => {
      if (!this.drawing || this.isCross) return;
      let o = HWMapJsSDK.HWMapUtils.epsgToLatLng(r.coordinate);
      if (this.checkActiveLineCross(o)) {
        this.checkActiveLineCross();
        return;
      }
      this.activePoint && this.polygonDrawingPoints.pop(), this.polygonDrawingPoints.push(o), this.polygonDrawingPoints.push(o), this.activePoint = o, this.redraw();
    }), n.on("dblclick", (r) => {
      !this.drawing || this.isCross || this.polygonDrawingPoints.length < 3 || (this.endPlacePoint(), this.endDrawingPolygonHandler && this.endDrawingPolygonHandler());
    }), this.existPointerEventHandler = !0;
  }
  startDrawing(t) {
    this.drawing = t, this.map && (t ? (this.drawing && (this.clear(), this.endPlacePoint()), this.listenMouseEvent()) : (this.clear(), this.endPlacePoint()));
  }
  setEndDrawingPolygonHandler(t) {
    this.endDrawingPolygonHandler = t;
  }
  getEndDrawingPolygonHandler() {
    return this.endDrawingPolygonHandler;
  }
  getDrawingPolgonPoints() {
    return JSON.parse(JSON.stringify(this.polygonDrawingPoints));
  }
  clear() {
    var t;
    this.del("绘制的多边形"), (t = this.manager) == null || t.markerManager.del("活动点"), this.polygonDrawingPoints.length = 0, this.isCross = !1;
  }
  endPlacePoint() {
    var t;
    return this.isCross || this.polygonDrawingPoints.length < 3 ? !1 : ((t = this.manager) == null || t.markerManager.del("活动点"), this.redrawLine(), this.drawing = !1, !0);
  }
  moveViewToCenter() {
    if (!this.map || this.polygonDrawingPoints.length == 0) return;
    let t = this.polygonDrawingPoints.reduce((r, o) => (r += o.lng, r), 0) / this.polygonDrawingPoints.length, n = this.polygonDrawingPoints.reduce((r, o) => (r += o.lat, r), 0) / this.polygonDrawingPoints.length;
    this.map.panTo({ lng: t, lat: n });
  }
  // 显示政边界，coordinate默认是世界坐标系的坐标
  showAreaBound({ coordinate: t }) {
    this.clear();
    let n = JSON.parse(JSON.stringify(t));
    this.polygonDrawingPoints = n, this.redrawLine(), this.moveViewToCenter();
  }
  setLocale(t) {
    this.lang = t, t == "zh" ? this.setDrawingPolygonOptions({ clickTitle: "单击设置顶点", dbclickTitle: "双击结束绘制" }) : this.setDrawingPolygonOptions({ clickTitle: "Click set vertex", dbclickTitle: "Double click finish" }), this.isCross && this.setDrawingPolygonOptions({ dbclickTitle: "Cannot be crossed" });
  }
}
class wM {
  constructor(t, n) {
    z(this, "map");
    z(this, "manager");
    z(this, "circles");
    this.map = t, this.manager = n, this.circles = {};
  }
  init() {
  }
  add(t, n) {
    let r = this.map, o = this.circles;
    o[t] && (o[t].setMap(null), delete o[t]), o[t] = new HWMapJsSDK.HWCircle({
      map: r,
      center: { lng: n.lng, lat: n.lat },
      radius: n.radius,
      fillColor: n.fillColor ?? "#add8e680",
      strokeColor: n.strokeColor ?? "#00008b80"
    }), o[t]._circle = n;
  }
  del(t) {
    let n = this.circles;
    n[t] && (n[t].setMap(null), delete n[t]);
  }
  set(t, n) {
    this.circles[t] && (n.lng != null && n.lat != null && this.circles[t].setCenter({ lng: n.lng, lat: n.lat }), n.radius != null && this.circles[t].setRadius(n.radius));
  }
  setCircles(t) {
    this.map;
    for (let n in this.circles) this.del(n);
    t.forEach((n, r) => this.add(`默认${r}`, n));
  }
  setMap(t) {
    this.map = t;
    let n = this.circles;
    for (let r in n) n[r].setMap(t);
  }
}
class TM {
  constructor(t) {
    z(this, "map");
    z(this, "markerManager");
    z(this, "polylineManager");
    z(this, "trackManager");
    z(this, "polygonManager");
    z(this, "circleManager");
    this.map = t, this.markerManager = new yM(t, this), this.polylineManager = new bM(t, this), this.trackManager = new EM(t, this), this.polygonManager = new _M(t, this), this.circleManager = new wM(t, this);
  }
  init() {
    this.markerManager.init(), this.polylineManager.init(), this.trackManager.init(), this.polygonManager.init(), this.circleManager.init();
  }
  setMap(t) {
    this.markerManager.setMap(t), this.polylineManager.setMap(t), this.trackManager.setMap(t), this.polygonManager.setMap(t), this.circleManager.setMap(t);
  }
  setLocale(t) {
    this.trackManager.setLocale(t), this.polygonManager.setLocale(t);
  }
  getMap() {
    return this.map;
  }
}
class CM {
  constructor() {
    z(this, "map");
    z(this, "manager");
    z(this, "searchAddrModule");
    z(this, "curLanauage");
    z(this, "opt");
    z(this, "style");
    z(this, "enableCurLocationSelect");
    z(this, "curLocationChangeEventHandler");
    this.map = null, this.manager = void 0, this.curLanauage = "CHI", this.opt = {
      center: { lat: 23.1291, lng: 113.2644 },
      zoom: 3,
      minZoom: 3,
      language: "CHI",
      sourceType: "raster"
    }, this.enableCurLocationSelect = !1, this.curLocationChangeEventHandler = void 0;
  }
  init(t) {
    var i, s;
    if (Object.assign(this.opt, t), !this.map && !(t != null && t.container)) return;
    t.container ? t.container.innerHTML = "" : this.opt.container && (this.opt.container.innerHTML = "");
    let n = (i = this.map) == null ? void 0 : i.getCenter(), r = (s = this.map) == null ? void 0 : s.getZoom(), o = JSON.parse(JSON.stringify(this.opt));
    n && (o.center = n), r && (o.zoom = r), this.map = new HWMapJsSDK.HWMap(this.opt.container, o);
    const a = () => {
      this.map.rMap.un("rendercomplete", a), this.style && this.map.setStyle(this.style);
    };
    return this.map.on("rendercomplete", a), this.style && this.map.setStyle(this.style), this.manager ? this.manager.setMap(this.map) : (this.manager = new TM(this.map), this.manager.init()), this.searchAddrModule ? this.searchAddrModule.init() : (this.searchAddrModule = new qa(), this.searchAddrModule.init()), this.map.on("click", (l) => {
      var f, c, d, h;
      if (!this.enableCurLocationSelect) return;
      let u = HWMapJsSDK.HWMapUtils.epsgToLatLng(l.coordinate);
      (f = this.manager) != null && f.markerManager.get("当前位置") ? (c = this.manager) == null || c.markerManager.set("当前位置", { position: { lat: u.lat, lng: u.lng } }) : (d = this.manager) == null || d.markerManager.add("当前位置", { position: { lat: u.lat, lng: u.lng } }), this.curLocationChangeEventHandler && ((h = this.searchAddrModule) == null || h.reverseGeocode(u.lng, u.lat).then((p) => {
        this.curLocationChangeEventHandler && this.curLocationChangeEventHandler({ lat: u.lat, lng: u.lng, name: p });
      }));
    }), this.manager;
  }
  setEnableCurLocationSelect(t) {
    this.enableCurLocationSelect = t;
  }
  setStyle(t) {
    this.map.setStyle(t), this.style = t;
  }
  setCenter(t) {
    this.map.setCenter({ lng: t.lng, lat: t.lat });
  }
  setZoom(t) {
    this.map.setZoom(t);
  }
  setCurrentLocationChangeEventHandler(t) {
    this.curLocationChangeEventHandler = t;
  }
}
const OM = { class: "map-display-area" }, IM = { class: "address-search-area" }, NM = /* @__PURE__ */ q({
  __name: "ZHuaweiMap",
  props: {
    enableLocationSelected: { type: Boolean, default: !1 },
    enableAddressSearch: { type: Boolean, default: !1 },
    showToolBar: { type: Boolean, default: !1 }
  },
  emits: ["initDone", "curLocationChange", "selectPin", "polygonDrawDone"],
  setup(e, { expose: t, emit: n }) {
    const r = e, o = n;
    t({
      activatePin: _,
      setPins: N,
      closeInfobox: ie,
      setStyle: ne,
      searchAddressByLocation: G,
      setInfoboxContentHtml: E,
      setCurLocation: m,
      setCurLocationOption: y,
      setPolygonOptions: x,
      setTrackOptions: B,
      setTrack: H,
      track: ee,
      tracking: L,
      clearTrack: V,
      setCenter: me,
      setZoom: fe,
      setCircles: I,
      showAreaBound: Be
    });
    const { locale: a } = wn();
    let i, s, l = R(void 0), u, f = R(), c;
    const d = R(), h = R(""), p = R(), g = R();
    function E(O) {
      d.value.setContentHtml(O);
    }
    function v(O) {
      var de;
      let A = {}, W = (de = c == null ? void 0 : c.manager) == null ? void 0 : de.markerManager.get("当前位置");
      return Object.assign(A, O), ((W == null ? void 0 : W.text) === "" || W != null && W.text) && (A.label = W == null ? void 0 : W.text), ((W == null ? void 0 : W.icon) === "" || W != null && W.icon) && (A.icon = W == null ? void 0 : W.icon), (W == null ? void 0 : W.iconAnchorX) !== void 0 && (A.anchorX = W == null ? void 0 : W.iconAnchorX), (W == null ? void 0 : W.iconAnchorY) !== void 0 && (A.anchorY = W == null ? void 0 : W.iconAnchorY), A;
    }
    async function m(O) {
      var de, we, $e, Te, ze, Ae;
      if ((O == null ? void 0 : O.lng) === void 0 || (O == null ? void 0 : O.lat) === void 0) return;
      h.value = O.name ?? "", (de = c == null ? void 0 : c.manager) != null && de.markerManager.get("当前位置") ? ($e = c == null ? void 0 : c.manager) == null || $e.markerManager.set("当前位置", { position: JSON.parse(JSON.stringify(O)) }) : (we = c == null ? void 0 : c.manager) == null || we.markerManager.add("当前位置", { position: JSON.parse(JSON.stringify(O)) });
      let A = v(O), W = (Te = c == null ? void 0 : c.manager) == null ? void 0 : Te.markerManager.get("当前位置");
      if (O.name)
        o("curLocationChange", A);
      else {
        let De = await p.value.setAddressByLocation(O);
        if (!De) {
          A.name = "", o("curLocationChange", A);
          return;
        }
        h.value = De, ((ze = W == null ? void 0 : W.position) == null ? void 0 : ze.lng) !== void 0 && ((Ae = W == null ? void 0 : W.position) == null ? void 0 : Ae.lat) !== void 0 && Math.abs(W.position.lng - O.lng) < rt && Math.abs(W.position.lat - O.lat) < rt && (A.name = De, o("curLocationChange", A));
      }
    }
    async function y(O) {
      var A;
      (A = c == null ? void 0 : c.manager) == null || A.markerManager.set("当前位置", {
        text: O.label,
        iconUrl: O.icon,
        iconAnchorX: O.anchorX,
        iconAnchorY: O.anchorY
      });
    }
    function _(O) {
      var A;
      d.value.setOverlapPins([]), (A = c == null ? void 0 : c.manager) == null || A.markerManager.activate({ position: { lng: O.lng, lat: O.lat }, _origin: O });
    }
    function T(O) {
      var A;
      (A = c == null ? void 0 : c.manager) == null || A.markerManager.activate(O);
    }
    function N(O) {
      var A;
      (A = c == null ? void 0 : c.manager) == null || A.markerManager.setMarkers(O.map((W) => ({
        position: { lng: W.lng, lat: W.lat },
        iconUrl: W.icon,
        iconAnchorX: W.iconAnchorX,
        iconAnchorY: W.iconAnchorY,
        _origin: W
      })));
    }
    function I(O) {
      var A;
      (A = c == null ? void 0 : c.manager) == null || A.circleManager.setCircles(O);
    }
    function x(O) {
      var A;
      (A = c == null ? void 0 : c.manager) == null || A.polygonManager.set("绘制的多边形", O);
    }
    function B(O) {
      var A, W, de;
      (A = c == null ? void 0 : c.manager) != null && A.trackManager.get("轨迹") ? (de = c == null ? void 0 : c.manager) == null || de.trackManager.set("轨迹", {
        strokeColor: O == null ? void 0 : O.strokeColor,
        strokeWeight: O == null ? void 0 : O.strokeWeight,
        startMarker: {
          text: O == null ? void 0 : O.startTitle,
          color: O == null ? void 0 : O.startTitleColor,
          iconUrl: O == null ? void 0 : O.startIcon,
          iconAnchorX: O == null ? void 0 : O.startIconAnchorX,
          iconAnchorY: O == null ? void 0 : O.startIconAnchorY,
          labelOffsetX: O == null ? void 0 : O.startTitleOffsetX,
          labelOffsetY: O == null ? void 0 : O.startTitleOffsetY
        },
        endMarker: {
          text: O == null ? void 0 : O.endTitle,
          color: O == null ? void 0 : O.endTitleColor,
          iconUrl: O == null ? void 0 : O.endIcon,
          iconAnchorX: O == null ? void 0 : O.endIconAnchorX,
          iconAnchorY: O == null ? void 0 : O.endIconAnchorY,
          labelOffsetX: O == null ? void 0 : O.endTitleOffsetX,
          labelOffsetY: O == null ? void 0 : O.endTitleOffsetY
        }
      }) : (W = c == null ? void 0 : c.manager) == null || W.trackManager.add("轨迹", {
        strokeColor: O == null ? void 0 : O.strokeColor,
        strokeWeight: O == null ? void 0 : O.strokeWeight,
        startMarker: {
          text: O == null ? void 0 : O.startTitle,
          color: O == null ? void 0 : O.startTitleColor,
          iconUrl: O == null ? void 0 : O.startIcon,
          iconAnchorX: O == null ? void 0 : O.startIconAnchorX,
          iconAnchorY: O == null ? void 0 : O.startIconAnchorY
        },
        endMarker: {
          text: O == null ? void 0 : O.endTitle,
          color: O == null ? void 0 : O.endTitleColor,
          iconUrl: O == null ? void 0 : O.endIcon,
          iconAnchorX: O == null ? void 0 : O.endIconAnchorX,
          iconAnchorY: O == null ? void 0 : O.endIconAnchorY
        }
      });
    }
    function H(O, A) {
      var W, de, we;
      (W = c == null ? void 0 : c.manager) != null && W.trackManager.get("轨迹") ? (de = c == null ? void 0 : c.manager) == null || de.trackManager.set("轨迹", {
        path: O,
        strokeColor: A == null ? void 0 : A.strokeColor,
        strokeWeight: A == null ? void 0 : A.strokeWeight,
        startMarker: {
          position: O[0],
          text: A == null ? void 0 : A.startTitle,
          color: A == null ? void 0 : A.startTitleColor,
          iconUrl: A == null ? void 0 : A.startIcon,
          iconAnchorX: A == null ? void 0 : A.startIconAnchorX,
          iconAnchorY: A == null ? void 0 : A.startIconAnchorY
        },
        endMarker: {
          position: O[O.length - 1],
          text: A == null ? void 0 : A.endTitle,
          color: A == null ? void 0 : A.endTitleColor,
          iconUrl: A == null ? void 0 : A.endIcon,
          iconAnchorX: A == null ? void 0 : A.endIconAnchorX,
          iconAnchorY: A == null ? void 0 : A.endIconAnchorY
        }
      }) : (we = c == null ? void 0 : c.manager) == null || we.trackManager.add("轨迹", {
        path: O,
        strokeColor: A == null ? void 0 : A.strokeColor,
        strokeWeight: A == null ? void 0 : A.strokeWeight,
        startMarker: {
          position: O[0],
          text: A == null ? void 0 : A.startTitle,
          color: A == null ? void 0 : A.startTitleColor,
          iconUrl: A == null ? void 0 : A.startIcon,
          iconAnchorX: A == null ? void 0 : A.startIconAnchorX,
          iconAnchorY: A == null ? void 0 : A.startIconAnchorY
        },
        endMarker: {
          position: O[O.length - 1],
          text: A == null ? void 0 : A.endTitle,
          color: A == null ? void 0 : A.endTitleColor,
          iconUrl: A == null ? void 0 : A.endIcon,
          iconAnchorX: A == null ? void 0 : A.endIconAnchorX,
          iconAnchorY: A == null ? void 0 : A.endIconAnchorY
        }
      });
    }
    function ee(O) {
      var A, W, de;
      (A = c == null ? void 0 : c.manager) != null && A.trackManager.get("轨迹") ? (W = c == null ? void 0 : c.manager) == null || W.trackManager.set("轨迹", { path: O }) : (de = c == null ? void 0 : c.manager) == null || de.trackManager.add("轨迹", { path: O });
    }
    function L(O) {
      var A;
      (A = c == null ? void 0 : c.manager) == null || A.trackManager.append("轨迹", O);
    }
    function V() {
      var O;
      (O = c == null ? void 0 : c.manager) != null && O.trackManager.get("轨迹") && c.manager.trackManager.set("轨迹", { path: [] });
    }
    function me(O) {
      if (!c) {
        s = O;
        return;
      }
      c.setCenter({ lng: O.lng, lat: O.lat });
    }
    function fe(O) {
      if (!c) {
        i = O;
        return;
      }
      c.setZoom(O);
    }
    function ie() {
      var O;
      (O = c == null ? void 0 : c.manager) == null || O.markerManager.closeInfowindow();
    }
    function ne(O) {
      c && c.setStyle(O);
    }
    async function G(O) {
      return await new qa().reverseGeocode(O.lng, O.lat) ?? "";
    }
    function pe(O) {
      m(O);
    }
    async function he() {
      Ie(), globalThis.initMap = () => {
        globalThis.loadedHuaweiMap = !0;
      }, globalThis.loadedHuaweiMap || (u = document.createElement("script"), u.type = "text/javascript", u.src = "https://mapapi.cloud.huawei.com/mapjs/v1/api/js?callback=initMap&key=DQEDALpjxXZzNGR4mvKDo4eHiVpXruC%2FyYYbGFKUurPofe%2B4V40qPf1jtPRFhZCf9p4iAElbl9bTLrHql9WK662ENJD0JbfQiIKonA%3D%3D", document.body.appendChild(u)), await new Promise((O) => {
        const A = setInterval(() => {
          var de, we, $e;
          if (!globalThis.loadedHuaweiMap) return;
          clearInterval(A), c = new CM();
          let W = { container: f.value, zoom: i ?? 3 };
          s && (W.center = s), l.value = c.init(W), (de = c == null ? void 0 : c.manager) == null || de.markerManager.setInfowindow(d.value), (we = p.value) == null || we.init(), c.setCurrentLocationChangeEventHandler(je), ($e = c == null ? void 0 : c.manager) == null || $e.markerManager.setOnMarkerSelectedCallback((Te, ze) => {
            var Ae, De;
            o("selectPin", { lng: (Ae = Te.position) == null ? void 0 : Ae.lng, lat: (De = Te.position) == null ? void 0 : De.lat }, ze);
          }), Q(() => r.enableLocationSelected, (Te) => c.setEnableCurLocationSelect(Te), { immediate: !0 }), Q(() => a.value, () => {
            var Te;
            c && c.init({ language: a.value == "zh" ? "CHI" : "ENG" }), (Te = c == null ? void 0 : c.manager) == null || Te.setLocale(a.value);
          }, { immediate: !0 }), o("initDone"), O(void 0);
        }, 200);
      });
    }
    function Ie() {
      u && (document.body.removeChild(u), u = void 0);
    }
    xe(() => {
      he();
    }), to(() => {
      Ie();
    });
    function je(O) {
      h.value = O.name ?? "", o("curLocationChange", v(O));
    }
    function Ge(O) {
      var A, W, de;
      (A = c == null ? void 0 : c.manager) == null || A.polygonManager.startDrawing(O), (W = c == null ? void 0 : c.manager) != null && W.polygonManager.getEndDrawingPolygonHandler() || (de = c == null ? void 0 : c.manager) == null || de.polygonManager.setEndDrawingPolygonHandler(() => {
        var we;
        o("polygonDrawDone", (we = c == null ? void 0 : c.manager) == null ? void 0 : we.polygonManager.getDrawingPolgonPoints());
      });
    }
    function Pe() {
      var O;
      (O = c == null ? void 0 : c.manager) == null || O.polygonManager.undo();
    }
    function Se() {
      var O;
      (O = c == null ? void 0 : c.manager) == null || O.polygonManager.clear();
    }
    function Be({ coordinate: O }) {
      var A;
      O = JSON.parse(JSON.stringify(O)), (A = c == null ? void 0 : c.manager) == null || A.polygonManager.showAreaBound({ coordinate: O }), g == null || g.value.reset();
    }
    return (O, A) => (j(), X(Xe, null, [
      Z("div", OM, [
        st(Z("div", IM, [
          J(O.$slots, "prefix-address-search", {}, void 0, !0),
          Ee(eM, {
            class: "address-search-input",
            ref_key: "addressSearchInput",
            ref: p,
            address: h.value,
            manager: b(l),
            onChange: pe
          }, null, 8, ["address", "manager"])
        ], 512), [
          [St, O.enableAddressSearch]
        ]),
        Z("div", {
          class: "map-body",
          ref_key: "mapContainer",
          ref: f
        }, null, 512),
        st(Ee(mM, {
          ref_key: "toolBar",
          ref: g,
          onStartDrawPolygon: Ge,
          onUndo: Pe,
          onClear: Se
        }, null, 512), [
          [St, O.showToolBar]
        ])
      ]),
      Ee(cM, {
        ref_key: "infobox",
        ref: d,
        onActivateOverlapPin: T
      }, {
        default: ae(() => [
          J(O.$slots, "default", {}, void 0, !0)
        ]),
        _: 3
      }, 512)
    ], 64));
  }
}), SM = /* @__PURE__ */ on(NM, [["__scopeId", "data-v-3e841eea"]]), AM = {
  key: 0,
  class: "map-ctrl"
}, LM = {
  key: 1,
  class: "map-ctrl"
}, PM = /* @__PURE__ */ q({
  __name: "MapCtrl",
  props: {
    provider: { default: "huawei" },
    ak: { default: "0Ylw7nN3CGLp27qSVL25imNx8ShWtpa9" },
    mapID: {},
    infoWindowStyle: {},
    track: { default: () => ({ path: [] }) },
    markers: { default: () => [] },
    circles: { default: () => [] },
    lines: { default: () => [] },
    center: { default: () => [jo, Bo] },
    zoom: { default: 15 },
    zoomMax: { default: 17 },
    zoomCenter: { default: () => ({ lng: 0, lat: 0 }) },
    selectedPoint: { default: () => ({ lnglat: [jo, Bo] }) },
    enableSelectPoint: { type: Boolean, default: !1 },
    showZoomCtrl: { type: Boolean, default: !0 },
    zoomCtrlOptions: {},
    showCityListCtrl: { type: Boolean, default: !1 },
    showSearchAddrCtrl: { type: Boolean, default: !1 },
    searchAddrPlaceholder: { default: "请输入需要搜索的地址" },
    enableMapClick: { type: Boolean, default: !1 },
    mapStyle: {},
    needMarkerClusterer: { type: Boolean, default: !0 },
    curMarker: {},
    showToolBar: { type: Boolean, default: !1 }
  },
  emits: ["curMarkerChange", "update:selectedPoint", "selectedPoint", "update:zoom", "polygonDrawDone"],
  setup(e, { expose: t, emit: n }) {
    const r = e, o = n;
    t({
      closeInfoWindow: y,
      // 关闭信息窗口
      searchAddressByLocation: _,
      setPolygonOptions: N,
      setTrackOptions: I,
      track: x,
      tracking: B,
      clearTrack: H,
      showAreaBound: ee
    });
    const { locale: a } = wn(), i = R(!1);
    let s = R(), l = R(), u, f = D(() => r.enableSelectPoint), c = [], d = R(!0);
    Q(() => a.value, () => {
      d.value = !1, Ne(() => {
        d.value = !0, Ne(() => Ne(() => N(T)));
      });
    });
    function h(L, ...V) {
      h.prototype.initFuncMap || (h.prototype.initFuncMap = {});
      let me = h.prototype.initFuncMap;
      if (L) {
        if (L && (me[L] = { initFuncName: L, args: arguments }), !u.value || !i.value) return;
        L && u.value[L](...V);
      } else
        try {
          for (let fe in me) {
            let ie = me[fe].initFuncName;
            if (ie) {
              let ne = u.value[ie];
              if (ne) {
                let G = [].slice.call(me[fe].args);
                ne.apply(u.value, G.slice(1));
              }
            }
          }
        } catch (fe) {
          console.log(`初始化模块出错，错误：${fe}`);
        }
    }
    function p(L) {
      o("update:selectedPoint", { lnglat: [L.lng, L.lat], address: L.name, label: L.label, icon: L.icon, iconAnchorX: L.anchorX, iconAnchorY: L.anchorY }), o("selectedPoint", { lnglat: [L.lng, L.lat], address: L.name, label: L.label, icon: L.icon, iconAnchorX: L.anchorX, iconAnchorY: L.anchorY });
    }
    function g(L, V) {
      o("curMarkerChange", {
        lng: L.lng,
        lat: L.lat,
        index: V
      });
    }
    function E() {
      i.value = !0, m(), h();
    }
    function v(L) {
      o("polygonDrawDone", L);
    }
    function m() {
      c.forEach((L) => L()), c.length = 0, c.push(Q(
        () => r.infoWindowStyle,
        (L) => {
          var V;
          r.provider == "bing" && ((V = u.value) == null || V.setInfoboxContentHtml(L));
        },
        {
          immediate: !0,
          deep: !0
        }
      )), c.push(Q(
        () => r.markers,
        (L) => {
          var V;
          (V = u.value) == null || V.setPins(L);
        },
        {
          immediate: !0,
          deep: !0
        }
      )), c.push(Q(
        () => r.circles,
        (L) => {
          var V;
          (V = u.value) == null || V.setCircles(L);
        },
        {
          immediate: !0,
          deep: !0
        }
      )), c.push(Q(
        () => r.selectedPoint,
        (L, V) => {
          var ie, ne;
          if ((ie = u.value) == null || ie.setCurLocationOption({ label: L.label, icon: L.icon, anchorX: L.iconAnchorX, anchorY: L.iconAnchorY }), !L.lnglat || L.lnglat[1] === void 0 || L.lnglat[0] === void 0 || V != null && V.lnglat && V.lnglat[0] !== void 0 && Math.abs(L.lnglat[0] - V.lnglat[0]) < 1e-6 && (V != null && V.lnglat) && V.lnglat[1] !== void 0 && Math.abs(L.lnglat[1] - V.lnglat[1]) < 1e-6) return;
          let me = +L.lnglat[0], fe = +L.lnglat[1];
          (ne = u.value) == null || ne.setCurLocation({ lat: fe, lng: me, name: L.address });
        },
        {
          immediate: !0,
          deep: !0
        }
      )), c.push(Q(
        () => r.mapStyle,
        (L) => {
          var V;
          (V = u.value) == null || V.setStyle(L);
        },
        {
          immediate: !0,
          deep: !0
        }
      )), c.push(Q(
        () => r.track,
        (L) => {
          var V;
          (V = u.value) == null || V.setTrack(L.path, L);
        },
        {
          immediate: !0,
          deep: !0
        }
      )), c.push(Q(
        () => r.curMarker,
        (L) => {
          var V;
          (V = u.value) == null || V.activatePin(L);
        }
      ));
    }
    xe(() => {
      r.provider == "bing" ? u = s : r.provider == "huawei" && (u = l), Q(
        () => r.center,
        (L) => {
          var V;
          L[0] == jo || L[1] == Bo || (V = u.value) == null || V.setCenter({ lng: L[0], lat: L[1] });
        },
        {
          immediate: !0,
          deep: !0
        }
      ), Q(
        () => r.zoom,
        (L) => {
          var V;
          L !== void 0 && ((V = u.value) == null || V.setZoom(L));
        },
        {
          immediate: !0,
          deep: !0
        }
      );
    });
    function y() {
      h("closeInfobox");
    }
    async function _(L) {
      return new Promise((V, me) => {
        let fe = Q(i, async (ie) => {
          var ne;
          ie && (V(await ((ne = u.value) == null ? void 0 : ne.searchAddressByLocation(L))), fe());
        }, { immediate: !0 });
      });
    }
    let T;
    function N(L) {
      L && (T ? Object.assign(T, L) : T = JSON.parse(JSON.stringify(L)), h("setPolygonOptions", L));
    }
    function I(L) {
      h("setTrackOptions", L);
    }
    function x(L) {
      h("track", L);
    }
    function B(L) {
      h("tracking", L);
    }
    function H() {
      h("clearTrack");
    }
    function ee({ coordinate: L }) {
      h("showAreaBound", { coordinate: L });
    }
    return (L, V) => (j(), X(Xe, null, [
      L.provider == "bing" ? (j(), X("div", AM, [
        b(d) ? (j(), ue(JE, {
          key: 0,
          ref_key: "bingMap",
          ref: s,
          onCurLocationChange: p,
          onSelectPin: g,
          onInitDone: E,
          onPolygonDrawDone: v,
          "enable-location-selected": b(f),
          "enable-address-search": L.showSearchAddrCtrl,
          "show-tool-bar": L.showToolBar
        }, {
          "prefix-address-search": ae(() => [
            J(L.$slots, "prefix-address-search", {}, void 0, !0)
          ]),
          default: ae(() => [
            J(L.$slots, "default", {}, void 0, !0)
          ]),
          _: 3
        }, 8, ["enable-location-selected", "enable-address-search", "show-tool-bar"])) : te("", !0)
      ])) : te("", !0),
      L.provider == "huawei" ? (j(), X("div", LM, [
        Ee(SM, {
          ref_key: "huaweiMap",
          ref: l,
          onCurLocationChange: p,
          onSelectPin: g,
          onInitDone: E,
          onPolygonDrawDone: v,
          "enable-location-selected": b(f),
          "enable-address-search": L.showSearchAddrCtrl,
          "show-tool-bar": L.showToolBar
        }, {
          "prefix-address-search": ae(() => [
            J(L.$slots, "prefix-address-search", {}, void 0, !0)
          ]),
          default: ae(() => [
            J(L.$slots, "default", {}, void 0, !0)
          ]),
          _: 3
        }, 8, ["enable-location-selected", "enable-address-search", "show-tool-bar"])
      ])) : te("", !0)
    ], 64));
  }
}), DM = /* @__PURE__ */ on(PM, [["__scopeId", "data-v-16b8e0f6"]]);
var kM = {
  name: "zh-cn",
  el: {
    breadcrumb: {
      label: "面包屑"
    },
    colorpicker: {
      confirm: "确定",
      clear: "清空",
      defaultLabel: "颜色选择器",
      description: "当前颜色 {color}，按 Enter 键选择新颜色",
      alphaLabel: "选择透明度的值"
    },
    datepicker: {
      now: "此刻",
      today: "今天",
      cancel: "取消",
      clear: "清空",
      confirm: "确定",
      dateTablePrompt: "使用方向键与 Enter 键可选择日期",
      monthTablePrompt: "使用方向键与 Enter 键可选择月份",
      yearTablePrompt: "使用方向键与 Enter 键可选择年份",
      selectedDate: "已选日期",
      selectDate: "选择日期",
      selectTime: "选择时间",
      startDate: "开始日期",
      startTime: "开始时间",
      endDate: "结束日期",
      endTime: "结束时间",
      prevYear: "前一年",
      nextYear: "后一年",
      prevMonth: "上个月",
      nextMonth: "下个月",
      year: "年",
      month1: "1 月",
      month2: "2 月",
      month3: "3 月",
      month4: "4 月",
      month5: "5 月",
      month6: "6 月",
      month7: "7 月",
      month8: "8 月",
      month9: "9 月",
      month10: "10 月",
      month11: "11 月",
      month12: "12 月",
      weeks: {
        sun: "日",
        mon: "一",
        tue: "二",
        wed: "三",
        thu: "四",
        fri: "五",
        sat: "六"
      },
      weeksFull: {
        sun: "星期日",
        mon: "星期一",
        tue: "星期二",
        wed: "星期三",
        thu: "星期四",
        fri: "星期五",
        sat: "星期六"
      },
      months: {
        jan: "一月",
        feb: "二月",
        mar: "三月",
        apr: "四月",
        may: "五月",
        jun: "六月",
        jul: "七月",
        aug: "八月",
        sep: "九月",
        oct: "十月",
        nov: "十一月",
        dec: "十二月"
      }
    },
    inputNumber: {
      decrease: "减少数值",
      increase: "增加数值"
    },
    select: {
      loading: "加载中",
      noMatch: "无匹配数据",
      noData: "无数据",
      placeholder: "请选择"
    },
    dropdown: {
      toggleDropdown: "切换下拉选项"
    },
    mention: {
      loading: "加载中"
    },
    cascader: {
      noMatch: "无匹配数据",
      loading: "加载中",
      placeholder: "请选择",
      noData: "暂无数据"
    },
    pagination: {
      goto: "前往",
      pagesize: "条/页",
      total: "共 {total} 条",
      pageClassifier: "页",
      page: "页",
      prev: "上一页",
      next: "下一页",
      currentPage: "第 {pager} 页",
      prevPages: "向前 {pager} 页",
      nextPages: "向后 {pager} 页",
      deprecationWarning: "你使用了一些已被废弃的用法，请参考 el-pagination 的官方文档"
    },
    dialog: {
      close: "关闭此对话框"
    },
    drawer: {
      close: "关闭此对话框"
    },
    messagebox: {
      title: "提示",
      confirm: "确定",
      cancel: "取消",
      error: "输入的数据不合法!",
      close: "关闭此对话框"
    },
    upload: {
      deleteTip: "按 Delete 键可删除",
      delete: "删除",
      preview: "查看图片",
      continue: "继续上传"
    },
    slider: {
      defaultLabel: "滑块介于 {min} 至 {max}",
      defaultRangeStartLabel: "选择起始值",
      defaultRangeEndLabel: "选择结束值"
    },
    table: {
      emptyText: "暂无数据",
      confirmFilter: "筛选",
      resetFilter: "重置",
      clearFilter: "全部",
      sumText: "合计"
    },
    tour: {
      next: "下一步",
      previous: "上一步",
      finish: "结束导览"
    },
    tree: {
      emptyText: "暂无数据"
    },
    transfer: {
      noMatch: "无匹配数据",
      noData: "无数据",
      titles: ["列表 1", "列表 2"],
      filterPlaceholder: "请输入搜索内容",
      noCheckedFormat: "共 {total} 项",
      hasCheckedFormat: "已选 {checked}/{total} 项"
    },
    image: {
      error: "加载失败"
    },
    pageHeader: {
      title: "返回"
    },
    popconfirm: {
      confirmButtonText: "确定",
      cancelButtonText: "取消"
    },
    carousel: {
      leftArrow: "上一张幻灯片",
      rightArrow: "下一张幻灯片",
      indicator: "幻灯片切换至索引 {index}"
    }
  }
};
const xM = /* @__PURE__ */ q({
  __name: "BaseComponent",
  setup(e) {
    const { locale: t } = wn();
    return (n, r) => {
      const o = eE;
      return j(), ue(o, {
        locale: b(t) == "en" ? b(ru) : b(kM),
        namespace: "zws-el"
      }, {
        default: ae(() => [
          J(n.$slots, "default")
        ]),
        _: 3
      }, 8, ["locale"]);
    };
  }
});
We() && fu({ namespace: "zws-el" }, void 0, !0);
window.BMapLib || (window.BMapLib = {});
window.BMapLib || (window.BMapLib = {});
const $M = void 0, zM = void 0, VM = /* @__PURE__ */ q({
  __name: "ZMapCtrl",
  emits: ["update:selectedPoint", "selectedPoint", "update:zoom", "polygonDrawDone"],
  setup(e, { expose: t, emit: n }) {
    t({
      closeInfoWindow: a,
      searchAddressByLocation: d,
      setPolygonOptions: i,
      setTrackOptions: s,
      track: l,
      tracking: u,
      clearTrack: f,
      showAreaBound: c
    });
    const { locale: r } = wn(), o = R();
    function a() {
      var m;
      (m = o.value) == null || m.closeInfoWindow();
    }
    function i(m) {
      var y;
      (y = o.value) == null || y.setPolygonOptions(m);
    }
    function s(m) {
      var y;
      (y = o.value) == null || y.setTrackOptions(m);
    }
    function l(m) {
      var y;
      (y = o.value) == null || y.track(m);
    }
    function u(m) {
      var y;
      (y = o.value) == null || y.tracking(m);
    }
    function f() {
      var m;
      (m = o.value) == null || m.clearTrack();
    }
    function c({ coordinate: m }) {
      var y;
      (y = o.value) == null || y.showAreaBound({ coordinate: m });
    }
    async function d(m) {
      var y;
      return (y = o.value) == null ? void 0 : y.searchAddressByLocation(m);
    }
    const h = n, p = (m) => {
      h("selectedPoint", m);
    }, g = (m) => {
      h("update:selectedPoint", m);
    };
    function E(m) {
      h("polygonDrawDone", m);
    }
    const v = D(() => r.value == "en" ? "请输入检索地址" : "Please input searchable address");
    return (m, y) => (j(), ue(xM, null, {
      default: ae(() => [
        Ee(DM, yn(m.$attrs, {
          ref_key: "baiduMap",
          ref: o,
          onSelectedPoint: p,
          "onUpdate:selectedPoint": g,
          onPolygonDrawDone: E,
          "onUpdate:zoom": y[0] || (y[0] = (_) => h("update:zoom", _)),
          searchAddrPlaceholder: v.value
        }), {
          "prefix-address-search": ae(() => [
            J(m.$slots, "prefix-address-search")
          ]),
          default: ae(() => [
            J(m.$slots, "default")
          ]),
          _: 3
        }, 16, ["searchAddrPlaceholder"])
      ]),
      _: 3
    }));
  }
});
export {
  zM as IMPOSSIBLE_LAT,
  $M as IMPOSSIBLE_LNG,
  VM as default
};
